export const countryLookup = {
  "0": {
    "gadm": {
      "name": "Nusa Tenggara Barat",
      "gid": "IDN.20_1"
    },
    "code": "ID-NB"
  },
  "1": {
    "gadm": {
      "name": "Nueva Segovia",
      "gid": "NIC.16_1"
    },
    "code": "NI-NS"
  },
  "2": {
    "gadm": {
      "name": "Manawatu-Wanganui",
      "gid": "NZL.7_1"
    },
    "code": "NZ-MWT"
  },
  "3": {
    "gadm": {
      "name": "Andorra la Vella",
      "gid": "AND.1_1"
    },
    "code": "AD-07"
  },
  "4": {
    "gadm": {
      "name": "Canillo",
      "gid": "AND.2_1"
    },
    "code": "AD-02"
  },
  "5": {
    "gadm": {
      "name": "Encamp",
      "gid": "AND.3_1"
    },
    "code": "AD-03"
  },
  "6": {
    "gadm": {
      "name": "Escaldes-Engordany",
      "gid": "AND.4_1"
    },
    "code": "AD-08"
  },
  "7": {
    "gadm": {
      "name": "La Massana",
      "gid": "AND.5_1"
    },
    "code": "AD-04"
  },
  "8": {
    "gadm": {
      "name": "Ordino",
      "gid": "AND.6_1"
    },
    "code": "AD-05"
  },
  "9": {
    "gadm": {
      "name": "Sant Juli\u00c3\u00a0 de L\u00c3\u00b2ria",
      "gid": "AND.7_1"
    },
    "code": "AD-06"
  },
  "10": {
    "gadm": {
      "name": "Ajman",
      "gid": "ARE.2_1"
    },
    "code": "AE-AJ"
  },
  "11": {
    "gadm": {
      "name": "Abu Dhabi",
      "gid": "ARE.1_1"
    },
    "code": "AE-AZ"
  },
  "12": {
    "gadm": {
      "name": "Dubai",
      "gid": "ARE.3_1"
    },
    "code": "AE-DU"
  },
  "13": {
    "gadm": {
      "name": "Fujairah",
      "gid": "ARE.4_1"
    },
    "code": "AE-FU"
  },
  "14": {
    "gadm": {
      "name": "Ras Al-Khaimah",
      "gid": "ARE.5_1"
    },
    "code": "AE-RK"
  },
  "15": {
    "gadm": {
      "name": "Sharjah",
      "gid": "ARE.6_1"
    },
    "code": "AE-SH"
  },
  "16": {
    "gadm": {
      "name": "Umm al-Qaywayn",
      "gid": "ARE.7_1"
    },
    "code": "AE-UQ"
  },
  "17": {
    "gadm": {
      "name": "Badakhshan",
      "gid": "AFG.1_1"
    },
    "code": "AF-BDS"
  },
  "18": {
    "gadm": {
      "name": "Badghis",
      "gid": "AFG.2_1"
    },
    "code": "AF-BDG"
  },
  "19": {
    "gadm": {
      "name": "Baghlan",
      "gid": "AFG.3_1"
    },
    "code": "AF-BGL"
  },
  "20": {
    "gadm": {
      "name": "Balkh",
      "gid": "AFG.4_1"
    },
    "code": "AF-BAL"
  },
  "21": {
    "gadm": {
      "name": "Bamyan",
      "gid": "AFG.5_1"
    },
    "code": "AF-BAM"
  },
  "22": {
    "gadm": {
      "name": "Daykundi",
      "gid": "AFG.6_1"
    },
    "code": "AF-DAY"
  },
  "23": {
    "gadm": {
      "name": "Farah",
      "gid": "AFG.7_1"
    },
    "code": "AF-FRA"
  },
  "24": {
    "gadm": {
      "name": "Faryab",
      "gid": "AFG.8_1"
    },
    "code": "AF-FYB"
  },
  "25": {
    "gadm": {
      "name": "Ghazni",
      "gid": "AFG.9_1"
    },
    "code": "AF-GHA"
  },
  "26": {
    "gadm": {
      "name": "Ghor",
      "gid": "AFG.10_1"
    },
    "code": "AF-GHO"
  },
  "27": {
    "gadm": {
      "name": "Hilmand",
      "gid": "AFG.11_1"
    },
    "code": "AF-HEL"
  },
  "28": {
    "gadm": {
      "name": "Hirat",
      "gid": "AFG.12_1"
    },
    "code": "AF-HER"
  },
  "29": {
    "gadm": {
      "name": "Jawzjan",
      "gid": "AFG.13_1"
    },
    "code": "AF-JOW"
  },
  "30": {
    "gadm": {
      "name": "Kabul",
      "gid": "AFG.14_1"
    },
    "code": "AF-KAB"
  },
  "31": {
    "gadm": {
      "name": "Kandahar",
      "gid": "AFG.15_1"
    },
    "code": "AF-KAN"
  },
  "32": {
    "gadm": {
      "name": "Kapisa",
      "gid": "AFG.16_1"
    },
    "code": "AF-KAP"
  },
  "33": {
    "gadm": {
      "name": "Khost",
      "gid": "AFG.17_1"
    },
    "code": "AF-KHO"
  },
  "34": {
    "gadm": {
      "name": "Kunar",
      "gid": "AFG.18_1"
    },
    "code": "AF-KNR"
  },
  "35": {
    "gadm": {
      "name": "Kunduz",
      "gid": "AFG.19_1"
    },
    "code": "AF-KDZ"
  },
  "36": {
    "gadm": {
      "name": "Laghman",
      "gid": "AFG.20_1"
    },
    "code": "AF-LAG"
  },
  "37": {
    "gadm": {
      "name": "Logar",
      "gid": "AFG.21_1"
    },
    "code": "AF-LOG"
  },
  "38": {
    "gadm": {
      "name": "Nangarhar",
      "gid": "AFG.22_1"
    },
    "code": "AF-NAN"
  },
  "39": {
    "gadm": {
      "name": "Nimroz",
      "gid": "AFG.23_1"
    },
    "code": "AF-NIM"
  },
  "40": {
    "gadm": {
      "name": "Nuristan",
      "gid": "AFG.24_1"
    },
    "code": "AF-NUR"
  },
  "41": {
    "gadm": {
      "name": "Paktika",
      "gid": "AFG.25_1"
    },
    "code": "AF-PKA"
  },
  "42": {
    "gadm": {
      "name": "Paktya",
      "gid": "AFG.26_1"
    },
    "code": "AF-PIA"
  },
  "43": {
    "gadm": {
      "name": "Panjshir",
      "gid": "AFG.27_1"
    },
    "code": "AF-PAN"
  },
  "44": {
    "gadm": {
      "name": "Parwan",
      "gid": "AFG.28_1"
    },
    "code": "AF-PAR"
  },
  "45": {
    "gadm": {
      "name": "Samangan",
      "gid": "AFG.29_1"
    },
    "code": "AF-SAM"
  },
  "46": {
    "gadm": {
      "name": "Sari Pul",
      "gid": "AFG.30_1"
    },
    "code": "AF-SAR"
  },
  "47": {
    "gadm": {
      "name": "Takhar",
      "gid": "AFG.31_1"
    },
    "code": "AF-TAK"
  },
  "48": {
    "gadm": {
      "name": "Uruzgan",
      "gid": "AFG.32_1"
    },
    "code": "AF-URU"
  },
  "49": {
    "gadm": {
      "name": "Wardak",
      "gid": "AFG.33_1"
    },
    "code": "AF-WAR"
  },
  "50": {
    "gadm": {
      "name": "Zabul",
      "gid": "AFG.34_1"
    },
    "code": "AF-ZAB"
  },
  "51": {
    "gadm": {
      "name": "Barbuda",
      "gid": "ATG.1_1"
    },
    "code": "AG-10"
  },
  "52": {
    "gadm": {
      "name": "Redonda",
      "gid": "ATG.2_1"
    },
    "code": "AG-11"
  },
  "53": {
    "gadm": {
      "name": "Saint George",
      "gid": "ATG.3_1"
    },
    "code": "AG-03"
  },
  "54": {
    "gadm": {
      "name": "Saint John",
      "gid": "ATG.4_1"
    },
    "code": "AG-04"
  },
  "55": {
    "gadm": {
      "name": "Saint Mary",
      "gid": "ATG.5_1"
    },
    "code": "AG-05"
  },
  "56": {
    "gadm": {
      "name": "Saint Paul",
      "gid": "ATG.6_1"
    },
    "code": "AG-06"
  },
  "57": {
    "gadm": {
      "name": "Saint Peter",
      "gid": "ATG.7_1"
    },
    "code": "AG-07"
  },
  "58": {
    "gadm": {
      "name": "Saint Philip",
      "gid": "ATG.8_1"
    },
    "code": "AG-08"
  },
  "59": {
    "gadm": {
      "name": "Berat",
      "gid": "ALB.1_1"
    },
    "code": "AL-01"
  },
  "60": {
    "gadm": {
      "name": "Dib\u00c3\u00abr",
      "gid": "ALB.2_1"
    },
    "code": "AL-09"
  },
  "61": {
    "gadm": {
      "name": "Durr\u00c3\u00abs",
      "gid": "ALB.3_1"
    },
    "code": "AL-02"
  },
  "62": {
    "gadm": {
      "name": "Elbasan",
      "gid": "ALB.4_1"
    },
    "code": "AL-03"
  },
  "63": {
    "gadm": {
      "name": "Fier",
      "gid": "ALB.5_1"
    },
    "code": "AL-04"
  },
  "64": {
    "gadm": {
      "name": "Gjirokast\u00c3\u00abr",
      "gid": "ALB.6_1"
    },
    "code": "AL-05"
  },
  "65": {
    "gadm": {
      "name": "Kor\u00c3\u00a7\u00c3\u00ab",
      "gid": "ALB.7_1"
    },
    "code": "AL-06"
  },
  "66": {
    "gadm": {
      "name": "Kuk\u00c3\u00abs",
      "gid": "ALB.8_1"
    },
    "code": "AL-07"
  },
  "67": {
    "gadm": {
      "name": "Lezh\u00c3\u00ab",
      "gid": "ALB.9_1"
    },
    "code": "AL-08"
  },
  "68": {
    "gadm": {
      "name": "Shkod\u00c3\u00abr",
      "gid": "ALB.10_1"
    },
    "code": "AL-10"
  },
  "69": {
    "gadm": {
      "name": "Tiran\u00c3\u00ab",
      "gid": "ALB.11_1"
    },
    "code": "AL-11"
  },
  "70": {
    "gadm": {
      "name": "Vlor\u00c3\u00ab",
      "gid": "ALB.12_1"
    },
    "code": "AL-12"
  },
  "71": {
    "gadm": {
      "name": "Aragatsotn",
      "gid": "ARM.1_1"
    },
    "code": "AM-AG"
  },
  "72": {
    "gadm": {
      "name": "Ararat",
      "gid": "ARM.2_1"
    },
    "code": "AM-AR"
  },
  "73": {
    "gadm": {
      "name": "Armavir",
      "gid": "ARM.3_1"
    },
    "code": "AM-AV"
  },
  "74": {
    "gadm": {
      "name": "Erevan",
      "gid": "ARM.4_1"
    },
    "code": "AM-ER"
  },
  "75": {
    "gadm": {
      "name": "Gegharkunik",
      "gid": "ARM.5_1"
    },
    "code": "AM-GR"
  },
  "76": {
    "gadm": {
      "name": "Kotayk",
      "gid": "ARM.6_1"
    },
    "code": "AM-KT"
  },
  "77": {
    "gadm": {
      "name": "Lori",
      "gid": "ARM.7_1"
    },
    "code": "AM-LO"
  },
  "78": {
    "gadm": {
      "name": "Shirak",
      "gid": "ARM.8_1"
    },
    "code": "AM-SH"
  },
  "79": {
    "gadm": {
      "name": "Syunik",
      "gid": "ARM.9_1"
    },
    "code": "AM-SU"
  },
  "80": {
    "gadm": {
      "name": "Tavush",
      "gid": "ARM.10_1"
    },
    "code": "AM-TV"
  },
  "81": {
    "gadm": {
      "name": "Vayots Dzor",
      "gid": "ARM.11_1"
    },
    "code": "AM-VD"
  },
  "82": {
    "gadm": {
      "name": "Bengo",
      "gid": "AGO.1_1"
    },
    "code": "AO-BGO"
  },
  "83": {
    "gadm": {
      "name": "Benguela",
      "gid": "AGO.2_1"
    },
    "code": "AO-BGU"
  },
  "84": {
    "gadm": {
      "name": "Bi\u00c3\u00a9",
      "gid": "AGO.3_1"
    },
    "code": "AO-BIE"
  },
  "85": {
    "gadm": {
      "name": "Cabinda",
      "gid": "AGO.4_1"
    },
    "code": "AO-CAB"
  },
  "86": {
    "gadm": {
      "name": "Cuando Cubango",
      "gid": "AGO.5_1"
    },
    "code": "AO-CCU"
  },
  "87": {
    "gadm": {
      "name": "Cuanza Norte",
      "gid": "AGO.6_1"
    },
    "code": "AO-CNO"
  },
  "88": {
    "gadm": {
      "name": "Cuanza Sul",
      "gid": "AGO.7_1"
    },
    "code": "AO-CUS"
  },
  "89": {
    "gadm": {
      "name": "Cunene",
      "gid": "AGO.8_1"
    },
    "code": "AO-CNN"
  },
  "90": {
    "gadm": {
      "name": "Huambo",
      "gid": "AGO.9_1"
    },
    "code": "AO-HUA"
  },
  "91": {
    "gadm": {
      "name": "Hu\u00c3\u00adla",
      "gid": "AGO.10_1"
    },
    "code": "AO-HUI"
  },
  "92": {
    "gadm": {
      "name": "Luanda",
      "gid": "AGO.11_1"
    },
    "code": "AO-LUA"
  },
  "93": {
    "gadm": {
      "name": "Lunda Norte",
      "gid": "AGO.12_1"
    },
    "code": "AO-LNO"
  },
  "94": {
    "gadm": {
      "name": "Lunda Sul",
      "gid": "AGO.13_1"
    },
    "code": "AO-LSU"
  },
  "95": {
    "gadm": {
      "name": "Malanje",
      "gid": "AGO.14_1"
    },
    "code": "AO-MAL"
  },
  "96": {
    "gadm": {
      "name": "Moxico",
      "gid": "AGO.15_1"
    },
    "code": "AO-MOX"
  },
  "97": {
    "gadm": {
      "name": "Namibe",
      "gid": "AGO.16_1"
    },
    "code": "AO-NAM"
  },
  "98": {
    "gadm": {
      "name": "U\u00c3\u00adge",
      "gid": "AGO.17_1"
    },
    "code": "AO-UIG"
  },
  "99": {
    "gadm": {
      "name": "Zaire",
      "gid": "AGO.18_1"
    },
    "code": "AO-ZAI"
  },
  "100": {
    "gadm": {
      "name": "Buenos Aires",
      "gid": "ARG.1_1"
    },
    "code": "AR-B"
  },
  "101": {
    "gadm": {
      "name": "Catamarca",
      "gid": "ARG.2_1"
    },
    "code": "AR-K"
  },
  "102": {
    "gadm": {
      "name": "Chaco",
      "gid": "ARG.3_1"
    },
    "code": "AR-H"
  },
  "103": {
    "gadm": {
      "name": "Chubut",
      "gid": "ARG.4_1"
    },
    "code": "AR-U"
  },
  "104": {
    "gadm": {
      "name": "Ciudad de Buenos Aires",
      "gid": "ARG.5_1"
    },
    "code": "AR-C"
  },
  "105": {
    "gadm": {
      "name": "C\u00c3\u00b3rdoba",
      "gid": "ARG.6_1"
    },
    "code": "AR-X"
  },
  "106": {
    "gadm": {
      "name": "Corrientes",
      "gid": "ARG.7_1"
    },
    "code": "AR-W"
  },
  "107": {
    "gadm": {
      "name": "Entre R\u00c3\u00ados",
      "gid": "ARG.8_1"
    },
    "code": "AR-E"
  },
  "108": {
    "gadm": {
      "name": "Formosa",
      "gid": "ARG.9_1"
    },
    "code": "AR-P"
  },
  "109": {
    "gadm": {
      "name": "Jujuy",
      "gid": "ARG.10_1"
    },
    "code": "AR-Y"
  },
  "110": {
    "gadm": {
      "name": "La Pampa",
      "gid": "ARG.11_1"
    },
    "code": "AR-L"
  },
  "111": {
    "gadm": {
      "name": "La Rioja",
      "gid": "ARG.12_1"
    },
    "code": "AR-F"
  },
  "112": {
    "gadm": {
      "name": "Mendoza",
      "gid": "ARG.13_1"
    },
    "code": "AR-M"
  },
  "113": {
    "gadm": {
      "name": "Misiones",
      "gid": "ARG.14_1"
    },
    "code": "AR-N"
  },
  "114": {
    "gadm": {
      "name": "Neuqu\u00c3\u00a9n",
      "gid": "ARG.15_1"
    },
    "code": "AR-Q"
  },
  "115": {
    "gadm": {
      "name": "R\u00c3\u00ado Negro",
      "gid": "ARG.16_1"
    },
    "code": "AR-R"
  },
  "116": {
    "gadm": {
      "name": "Salta",
      "gid": "ARG.17_1"
    },
    "code": "AR-A"
  },
  "117": {
    "gadm": {
      "name": "San Juan",
      "gid": "ARG.18_1"
    },
    "code": "AR-J"
  },
  "118": {
    "gadm": {
      "name": "San Luis",
      "gid": "ARG.19_1"
    },
    "code": "AR-D"
  },
  "119": {
    "gadm": {
      "name": "Santa Cruz",
      "gid": "ARG.20_1"
    },
    "code": "AR-Z"
  },
  "120": {
    "gadm": {
      "name": "Santa Fe",
      "gid": "ARG.21_1"
    },
    "code": "AR-S"
  },
  "121": {
    "gadm": {
      "name": "Santiago del Estero",
      "gid": "ARG.22_1"
    },
    "code": "AR-G"
  },
  "122": {
    "gadm": {
      "name": "Tierra del Fuego",
      "gid": "ARG.23_1"
    },
    "code": "AR-V"
  },
  "123": {
    "gadm": {
      "name": "Tucum\u00c3\u00a1n",
      "gid": "ARG.24_1"
    },
    "code": "AR-T"
  },
  "124": {
    "gadm": {
      "name": "Australian Capital Territory",
      "gid": "AUS.2_1"
    },
    "code": "AU-ACT"
  },
  "125": {
    "gadm": {
      "name": "New South Wales",
      "gid": "AUS.5_1"
    },
    "code": "AU-NSW"
  },
  "126": {
    "gadm": {
      "name": "Northern Territory",
      "gid": "AUS.6_1"
    },
    "code": "AU-NT"
  },
  "127": {
    "gadm": {
      "name": "Queensland",
      "gid": "AUS.7_1"
    },
    "code": "AU-QLD"
  },
  "128": {
    "gadm": {
      "name": "South Australia",
      "gid": "AUS.8_1"
    },
    "code": "AU-SA"
  },
  "129": {
    "gadm": {
      "name": "Tasmania",
      "gid": "AUS.9_1"
    },
    "code": "AU-TAS"
  },
  "130": {
    "gadm": {
      "name": "Victoria",
      "gid": "AUS.10_1"
    },
    "code": "AU-VIC"
  },
  "131": {
    "gadm": {
      "name": "Western Australia",
      "gid": "AUS.11_1"
    },
    "code": "AU-WA"
  },
  "132": {
    "gadm": {
      "name": "Ashmore and Cartier Islands",
      "gid": "AUS.1_1"
    },
    "code": "AUS.1_1"
  },
  "133": {
    "gadm": {
      "name": "Coral Sea Islands Territory",
      "gid": "AUS.3_1"
    },
    "code": "AUS.3_1"
  },
  "134": {
    "gadm": {
      "name": "Jervis Bay Territory",
      "gid": "AUS.4_1"
    },
    "code": "AUS.4_1"
  },
  "135": {
    "gadm": {
      "name": "Absheron",
      "gid": "AZE.1_1"
    },
    "code": "AZE.1_1"
  },
  "136": {
    "gadm": {
      "name": "Aran",
      "gid": "AZE.2_1"
    },
    "code": "AZE.2_1"
  },
  "137": {
    "gadm": {
      "name": "Daglig-Shirvan",
      "gid": "AZE.3_1"
    },
    "code": "AZE.3_1"
  },
  "138": {
    "gadm": {
      "name": "Ganja-Qazakh",
      "gid": "AZE.4_1"
    },
    "code": "AZE.4_1"
  },
  "139": {
    "gadm": {
      "name": "Kalbajar-Lachin",
      "gid": "AZE.5_1"
    },
    "code": "AZE.5_1"
  },
  "140": {
    "gadm": {
      "name": "Lankaran",
      "gid": "AZE.6_1"
    },
    "code": "AZE.6_1"
  },
  "141": {
    "gadm": {
      "name": "Nakhchivan",
      "gid": "AZE.7_1"
    },
    "code": "AZE.7_1"
  },
  "142": {
    "gadm": {
      "name": "Quba-Khachmaz",
      "gid": "AZE.8_1"
    },
    "code": "AZE.8_1"
  },
  "143": {
    "gadm": {
      "name": "Shaki-Zaqatala",
      "gid": "AZE.9_1"
    },
    "code": "AZE.9_1"
  },
  "144": {
    "gadm": {
      "name": "Yukhari-Karabakh",
      "gid": "AZE.10_1"
    },
    "code": "AZE.10_1"
  },
  "145": {
    "gadm": {
      "name": "Br\u00c3\u201e\u00c2\u008dko",
      "gid": "BIH.1_1"
    },
    "code": "BA-BRC"
  },
  "146": {
    "gadm": {
      "name": "Federacija Bosna i Hercegovina",
      "gid": "BIH.2_1"
    },
    "code": "BA-BIH"
  },
  "147": {
    "gadm": {
      "name": "Repuplika Srpska",
      "gid": "BIH.3_1"
    },
    "code": "BA-SRP"
  },
  "148": {
    "gadm": {
      "name": "Christ Church",
      "gid": "BRB.1_1"
    },
    "code": "BB-01"
  },
  "149": {
    "gadm": {
      "name": "Saint Andrew",
      "gid": "BRB.2_1"
    },
    "code": "BB-02"
  },
  "150": {
    "gadm": {
      "name": "Saint George",
      "gid": "BRB.3_1"
    },
    "code": "BB-03"
  },
  "151": {
    "gadm": {
      "name": "Saint James",
      "gid": "BRB.4_1"
    },
    "code": "BB-04"
  },
  "152": {
    "gadm": {
      "name": "Saint John",
      "gid": "BRB.5_1"
    },
    "code": "BB-05"
  },
  "153": {
    "gadm": {
      "name": "Saint Joseph",
      "gid": "BRB.6_1"
    },
    "code": "BB-06"
  },
  "154": {
    "gadm": {
      "name": "Saint Lucy",
      "gid": "BRB.7_1"
    },
    "code": "BB-07"
  },
  "155": {
    "gadm": {
      "name": "Saint Michael",
      "gid": "BRB.8_1"
    },
    "code": "BB-08"
  },
  "156": {
    "gadm": {
      "name": "Saint Peter",
      "gid": "BRB.9_1"
    },
    "code": "BB-09"
  },
  "157": {
    "gadm": {
      "name": "Saint Philip",
      "gid": "BRB.10_1"
    },
    "code": "BB-10"
  },
  "158": {
    "gadm": {
      "name": "Saint Thomas",
      "gid": "BRB.11_1"
    },
    "code": "BB-11"
  },
  "159": {
    "gadm": {
      "name": "Barisal",
      "gid": "BGD.1_1"
    },
    "code": "BD-A"
  },
  "160": {
    "gadm": {
      "name": "Chittagong",
      "gid": "BGD.2_1"
    },
    "code": "BD-B"
  },
  "161": {
    "gadm": {
      "name": "Dhaka",
      "gid": "BGD.3_1"
    },
    "code": "BD-C"
  },
  "162": {
    "gadm": {
      "name": "Khulna",
      "gid": "BGD.4_1"
    },
    "code": "BD-D"
  },
  "163": {
    "gadm": {
      "name": "Rajshahi",
      "gid": "BGD.5_1"
    },
    "code": "BD-E"
  },
  "164": {
    "gadm": {
      "name": "Rangpur",
      "gid": "BGD.6_1"
    },
    "code": "BD-F"
  },
  "165": {
    "gadm": {
      "name": "Sylhet",
      "gid": "BGD.7_1"
    },
    "code": "BD-G"
  },
  "166": {
    "gadm": {
      "name": "Boucle du Mouhoun",
      "gid": "BFA.1_1"
    },
    "code": "BF-01"
  },
  "167": {
    "gadm": {
      "name": "Cascades",
      "gid": "BFA.2_1"
    },
    "code": "BF-02"
  },
  "168": {
    "gadm": {
      "name": "Centre",
      "gid": "BFA.7_1"
    },
    "code": "BF-03"
  },
  "169": {
    "gadm": {
      "name": "Centre-Est",
      "gid": "BFA.3_1"
    },
    "code": "BF-04"
  },
  "170": {
    "gadm": {
      "name": "Centre-Nord",
      "gid": "BFA.4_1"
    },
    "code": "BF-05"
  },
  "171": {
    "gadm": {
      "name": "Centre-Ouest",
      "gid": "BFA.5_1"
    },
    "code": "BF-06"
  },
  "172": {
    "gadm": {
      "name": "Centre-Sud",
      "gid": "BFA.6_1"
    },
    "code": "BF-07"
  },
  "173": {
    "gadm": {
      "name": "Est",
      "gid": "BFA.8_1"
    },
    "code": "BF-08"
  },
  "174": {
    "gadm": {
      "name": "Haut-Bassins",
      "gid": "BFA.9_1"
    },
    "code": "BF-09"
  },
  "175": {
    "gadm": {
      "name": "Nord",
      "gid": "BFA.10_1"
    },
    "code": "BF-10"
  },
  "176": {
    "gadm": {
      "name": "Plateau-Central",
      "gid": "BFA.11_1"
    },
    "code": "BF-11"
  },
  "177": {
    "gadm": {
      "name": "Sahel",
      "gid": "BFA.12_1"
    },
    "code": "BF-12"
  },
  "178": {
    "gadm": {
      "name": "Sud-Ouest",
      "gid": "BFA.13_1"
    },
    "code": "BF-13"
  },
  "179": {
    "gadm": {
      "name": "Capital",
      "gid": "BHR.1_1"
    },
    "code": "BHR.1_1"
  },
  "180": {
    "gadm": {
      "name": "Southern",
      "gid": "BHR.5_1"
    },
    "code": "BHR.5_1"
  },
  "181": {
    "gadm": {
      "name": "Central",
      "gid": "BHR.2_1"
    },
    "code": "BHR.2_1"
  },
  "182": {
    "gadm": {
      "name": "Northern",
      "gid": "BHR.4_1"
    },
    "code": "BHR.4_1"
  },
  "183": {
    "gadm": {
      "name": "Muharraq",
      "gid": "BHR.3_1"
    },
    "code": "BHR.3_1"
  },
  "184": {
    "gadm": {
      "name": "Bubanza",
      "gid": "BDI.1_1"
    },
    "code": "BI-BB"
  },
  "185": {
    "gadm": {
      "name": "Bujumbura Mairie",
      "gid": "BDI.2_1"
    },
    "code": "BI-BM"
  },
  "186": {
    "gadm": {
      "name": "Bujumbura Rural",
      "gid": "BDI.3_1"
    },
    "code": "BI-BL"
  },
  "187": {
    "gadm": {
      "name": "Bururi",
      "gid": "BDI.4_1"
    },
    "code": "BI-BR"
  },
  "188": {
    "gadm": {
      "name": "Cankuzo",
      "gid": "BDI.5_1"
    },
    "code": "BI-CA"
  },
  "189": {
    "gadm": {
      "name": "Cibitoke",
      "gid": "BDI.6_1"
    },
    "code": "BI-CI"
  },
  "190": {
    "gadm": {
      "name": "Gitega",
      "gid": "BDI.7_1"
    },
    "code": "BI-GI"
  },
  "191": {
    "gadm": {
      "name": "Karuzi",
      "gid": "BDI.8_1"
    },
    "code": "BI-KR"
  },
  "192": {
    "gadm": {
      "name": "Kayanza",
      "gid": "BDI.9_1"
    },
    "code": "BI-KY"
  },
  "193": {
    "gadm": {
      "name": "Kirundo",
      "gid": "BDI.10_1"
    },
    "code": "BI-KI"
  },
  "194": {
    "gadm": {
      "name": "Makamba",
      "gid": "BDI.11_1"
    },
    "code": "BI-MA"
  },
  "195": {
    "gadm": {
      "name": "Muramvya",
      "gid": "BDI.12_1"
    },
    "code": "BI-MU"
  },
  "196": {
    "gadm": {
      "name": "Muyinga",
      "gid": "BDI.13_1"
    },
    "code": "BI-MY"
  },
  "197": {
    "gadm": {
      "name": "Mwaro",
      "gid": "BDI.14_1"
    },
    "code": "BI-MW"
  },
  "198": {
    "gadm": {
      "name": "Ngozi",
      "gid": "BDI.15_1"
    },
    "code": "BI-NG"
  },
  "199": {
    "gadm": {
      "name": "Rutana",
      "gid": "BDI.16_1"
    },
    "code": "BI-RT"
  },
  "200": {
    "gadm": {
      "name": "Ruyigi",
      "gid": "BDI.17_1"
    },
    "code": "BI-RY"
  },
  "201": {
    "gadm": {
      "name": "Alibori",
      "gid": "BEN.1_1"
    },
    "code": "BJ-AL"
  },
  "202": {
    "gadm": {
      "name": "Atakora",
      "gid": "BEN.2_1"
    },
    "code": "BJ-AK"
  },
  "203": {
    "gadm": {
      "name": "Atlantique",
      "gid": "BEN.3_1"
    },
    "code": "BJ-AQ"
  },
  "204": {
    "gadm": {
      "name": "Borgou",
      "gid": "BEN.4_1"
    },
    "code": "BJ-BO"
  },
  "205": {
    "gadm": {
      "name": "Collines",
      "gid": "BEN.5_1"
    },
    "code": "BJ-CO"
  },
  "206": {
    "gadm": {
      "name": "Donga",
      "gid": "BEN.6_1"
    },
    "code": "BJ-KO"
  },
  "207": {
    "gadm": {
      "name": "Kouffo",
      "gid": "BEN.7_1"
    },
    "code": "BJ-DO"
  },
  "208": {
    "gadm": {
      "name": "Littoral",
      "gid": "BEN.8_1"
    },
    "code": "BJ-LI"
  },
  "209": {
    "gadm": {
      "name": "Mono",
      "gid": "BEN.9_1"
    },
    "code": "BJ-MO"
  },
  "210": {
    "gadm": {
      "name": "Ou\u00c3\u00a9m\u00c3\u00a9",
      "gid": "BEN.10_1"
    },
    "code": "BJ-OU"
  },
  "211": {
    "gadm": {
      "name": "Plateau",
      "gid": "BEN.11_1"
    },
    "code": "BJ-PL"
  },
  "212": {
    "gadm": {
      "name": "Zou",
      "gid": "BEN.12_1"
    },
    "code": "BJ-ZO"
  },
  "213": {
    "gadm": {
      "name": "Belait",
      "gid": "BRN.1_1"
    },
    "code": "BN-BE"
  },
  "214": {
    "gadm": {
      "name": "Brunei and Muara",
      "gid": "BRN.2_1"
    },
    "code": "BN-BM"
  },
  "215": {
    "gadm": {
      "name": "Temburong",
      "gid": "BRN.3_1"
    },
    "code": "BN-TE"
  },
  "216": {
    "gadm": {
      "name": "Tutong",
      "gid": "BRN.4_1"
    },
    "code": "BN-TU"
  },
  "217": {
    "gadm": {
      "name": "Chuquisaca",
      "gid": "BOL.1_1"
    },
    "code": "BO-H"
  },
  "218": {
    "gadm": {
      "name": "Cochabamba",
      "gid": "BOL.2_1"
    },
    "code": "BO-C"
  },
  "219": {
    "gadm": {
      "name": "El Beni",
      "gid": "BOL.3_1"
    },
    "code": "BO-B"
  },
  "220": {
    "gadm": {
      "name": "La Paz",
      "gid": "BOL.4_1"
    },
    "code": "BO-L"
  },
  "221": {
    "gadm": {
      "name": "Oruro",
      "gid": "BOL.5_1"
    },
    "code": "BO-O"
  },
  "222": {
    "gadm": {
      "name": "Pando",
      "gid": "BOL.6_1"
    },
    "code": "BO-N"
  },
  "223": {
    "gadm": {
      "name": "Potos\u00c3\u00ad",
      "gid": "BOL.7_1"
    },
    "code": "BO-P"
  },
  "224": {
    "gadm": {
      "name": "Santa Cruz",
      "gid": "BOL.8_1"
    },
    "code": "BO-S"
  },
  "225": {
    "gadm": {
      "name": "Tarija",
      "gid": "BOL.9_1"
    },
    "code": "BO-T"
  },
  "226": {
    "gadm": {
      "name": "Acre",
      "gid": "BRA.1_1"
    },
    "code": "BR-AC"
  },
  "227": {
    "gadm": {
      "name": "Alagoas",
      "gid": "BRA.2_1"
    },
    "code": "BR-AL"
  },
  "228": {
    "gadm": {
      "name": "Amap\u00c3\u00a1",
      "gid": "BRA.3_1"
    },
    "code": "BR-AP"
  },
  "229": {
    "gadm": {
      "name": "Amazonas",
      "gid": "BRA.4_1"
    },
    "code": "BR-AM"
  },
  "230": {
    "gadm": {
      "name": "Bahia",
      "gid": "BRA.5_1"
    },
    "code": "BR-BA"
  },
  "231": {
    "gadm": {
      "name": "Cear\u00c3\u00a1",
      "gid": "BRA.6_1"
    },
    "code": "BR-CE"
  },
  "232": {
    "gadm": {
      "name": "Distrito Federal",
      "gid": "BRA.7_1"
    },
    "code": "BR-DF"
  },
  "233": {
    "gadm": {
      "name": "Esp\u00c3\u00adrito Santo",
      "gid": "BRA.8_1"
    },
    "code": "BR-ES"
  },
  "234": {
    "gadm": {
      "name": "Goi\u00c3\u00a1s",
      "gid": "BRA.9_1"
    },
    "code": "BR-GO"
  },
  "235": {
    "gadm": {
      "name": "Maranh\u00c3\u00a3o",
      "gid": "BRA.10_1"
    },
    "code": "BR-MA"
  },
  "236": {
    "gadm": {
      "name": "Mato Grosso",
      "gid": "BRA.12_1"
    },
    "code": "BR-MT"
  },
  "237": {
    "gadm": {
      "name": "Mato Grosso do Sul",
      "gid": "BRA.11_1"
    },
    "code": "BR-MS"
  },
  "238": {
    "gadm": {
      "name": "Minas Gerais",
      "gid": "BRA.13_1"
    },
    "code": "BR-MG"
  },
  "239": {
    "gadm": {
      "name": "Par\u00c3\u00a1",
      "gid": "BRA.14_1"
    },
    "code": "BR-PA"
  },
  "240": {
    "gadm": {
      "name": "Para\u00c3\u00adba",
      "gid": "BRA.15_1"
    },
    "code": "BR-PB"
  },
  "241": {
    "gadm": {
      "name": "Paran\u00c3\u00a1",
      "gid": "BRA.16_1"
    },
    "code": "BR-PR"
  },
  "242": {
    "gadm": {
      "name": "Pernambuco",
      "gid": "BRA.17_1"
    },
    "code": "BR-PE"
  },
  "243": {
    "gadm": {
      "name": "Piau\u00c3\u00ad",
      "gid": "BRA.18_1"
    },
    "code": "BR-PI"
  },
  "244": {
    "gadm": {
      "name": "Rio de Janeiro",
      "gid": "BRA.19_1"
    },
    "code": "BR-RJ"
  },
  "245": {
    "gadm": {
      "name": "Rio Grande do Norte",
      "gid": "BRA.20_1"
    },
    "code": "BR-RN"
  },
  "246": {
    "gadm": {
      "name": "Rio Grande do Sul",
      "gid": "BRA.21_1"
    },
    "code": "BR-RS"
  },
  "247": {
    "gadm": {
      "name": "Rond\u00c3\u00b4nia",
      "gid": "BRA.22_1"
    },
    "code": "BR-RO"
  },
  "248": {
    "gadm": {
      "name": "Roraima",
      "gid": "BRA.23_1"
    },
    "code": "BR-RR"
  },
  "249": {
    "gadm": {
      "name": "Santa Catarina",
      "gid": "BRA.24_1"
    },
    "code": "BR-SC"
  },
  "250": {
    "gadm": {
      "name": "S\u00c3\u00a3o Paulo",
      "gid": "BRA.25_1"
    },
    "code": "BR-SP"
  },
  "251": {
    "gadm": {
      "name": "Sergipe",
      "gid": "BRA.26_1"
    },
    "code": "BR-SE"
  },
  "252": {
    "gadm": {
      "name": "Tocantins",
      "gid": "BRA.27_1"
    },
    "code": "BR-TO"
  },
  "253": {
    "gadm": {
      "name": "Acklins",
      "gid": "BHS.1_1"
    },
    "code": "BS-AK"
  },
  "254": {
    "gadm": {
      "name": "Berry Islands",
      "gid": "BHS.2_1"
    },
    "code": "BS-BY"
  },
  "255": {
    "gadm": {
      "name": "Biminis",
      "gid": "BHS.3_1"
    },
    "code": "BS-BI"
  },
  "256": {
    "gadm": {
      "name": "Black Point",
      "gid": "BHS.4_1"
    },
    "code": "BS-BP"
  },
  "257": {
    "gadm": {
      "name": "Cat Island",
      "gid": "BHS.5_1"
    },
    "code": "BS-CI"
  },
  "258": {
    "gadm": {
      "name": "Central Abaco",
      "gid": "BHS.6_1"
    },
    "code": "BS-CO"
  },
  "259": {
    "gadm": {
      "name": "Central Andros",
      "gid": "BHS.7_1"
    },
    "code": "BS-CS"
  },
  "260": {
    "gadm": {
      "name": "Central Eleuthera",
      "gid": "BHS.8_1"
    },
    "code": "BS-CE"
  },
  "261": {
    "gadm": {
      "name": "City of Freeport",
      "gid": "BHS.9_1"
    },
    "code": "BS-FP"
  },
  "262": {
    "gadm": {
      "name": "Crooked Island",
      "gid": "BHS.10_1"
    },
    "code": "BS-CK"
  },
  "263": {
    "gadm": {
      "name": "East Grand Bahama",
      "gid": "BHS.11_1"
    },
    "code": "BS-EG"
  },
  "264": {
    "gadm": {
      "name": "Exuma",
      "gid": "BHS.12_1"
    },
    "code": "BS-EX"
  },
  "265": {
    "gadm": {
      "name": "Grand Cay",
      "gid": "BHS.13_1"
    },
    "code": "BS-GC"
  },
  "266": {
    "gadm": {
      "name": "Harbour Island",
      "gid": "BHS.14_1"
    },
    "code": "BS-HI"
  },
  "267": {
    "gadm": {
      "name": "Hope Town",
      "gid": "BHS.15_1"
    },
    "code": "BS-HT"
  },
  "268": {
    "gadm": {
      "name": "Inagua",
      "gid": "BHS.16_1"
    },
    "code": "BS-IN"
  },
  "269": {
    "gadm": {
      "name": "Long Island",
      "gid": "BHS.17_1"
    },
    "code": "BS-LI"
  },
  "270": {
    "gadm": {
      "name": "Mangrove Cay",
      "gid": "BHS.18_1"
    },
    "code": "BS-MC"
  },
  "271": {
    "gadm": {
      "name": "Mayaguana",
      "gid": "BHS.19_1"
    },
    "code": "BS-MG"
  },
  "272": {
    "gadm": {
      "name": "Moore's Island",
      "gid": "BHS.20_1"
    },
    "code": "BS-MI"
  },
  "273": {
    "gadm": {
      "name": "New Providence",
      "gid": "BHS.21_1"
    },
    "code": "BS-NP"
  },
  "274": {
    "gadm": {
      "name": "North Abaco",
      "gid": "BHS.22_1"
    },
    "code": "BS-NO"
  },
  "275": {
    "gadm": {
      "name": "North Andros",
      "gid": "BHS.23_1"
    },
    "code": "BS-NS"
  },
  "276": {
    "gadm": {
      "name": "North Eleuthera",
      "gid": "BHS.24_1"
    },
    "code": "BS-NE"
  },
  "277": {
    "gadm": {
      "name": "Ragged Island",
      "gid": "BHS.25_1"
    },
    "code": "BS-RI"
  },
  "278": {
    "gadm": {
      "name": "Rum Cay",
      "gid": "BHS.26_1"
    },
    "code": "BS-RC"
  },
  "279": {
    "gadm": {
      "name": "San Salvador",
      "gid": "BHS.27_1"
    },
    "code": "BS-SS"
  },
  "280": {
    "gadm": {
      "name": "South Abaco",
      "gid": "BHS.28_1"
    },
    "code": "BS-SO"
  },
  "281": {
    "gadm": {
      "name": "South Andros",
      "gid": "BHS.29_1"
    },
    "code": "BS-SA"
  },
  "282": {
    "gadm": {
      "name": "South Eleuthera",
      "gid": "BHS.30_1"
    },
    "code": "BS-SE"
  },
  "283": {
    "gadm": {
      "name": "Spanish Wells",
      "gid": "BHS.31_1"
    },
    "code": "BS-SW"
  },
  "284": {
    "gadm": {
      "name": "West Grand Bahama",
      "gid": "BHS.32_1"
    },
    "code": "BS-WG"
  },
  "285": {
    "gadm": {
      "name": "Bumthang",
      "gid": "BTN.1_1"
    },
    "code": "BT-33"
  },
  "286": {
    "gadm": {
      "name": "Chhukha",
      "gid": "BTN.2_1"
    },
    "code": "BT-12"
  },
  "287": {
    "gadm": {
      "name": "Dagana",
      "gid": "BTN.3_1"
    },
    "code": "BT-22"
  },
  "288": {
    "gadm": {
      "name": "Gasa",
      "gid": "BTN.4_1"
    },
    "code": "BT-GA"
  },
  "289": {
    "gadm": {
      "name": "Haa",
      "gid": "BTN.5_1"
    },
    "code": "BT-13"
  },
  "290": {
    "gadm": {
      "name": "Lhuentse",
      "gid": "BTN.6_1"
    },
    "code": "BT-44"
  },
  "291": {
    "gadm": {
      "name": "Monggar",
      "gid": "BTN.7_1"
    },
    "code": "BT-42"
  },
  "292": {
    "gadm": {
      "name": "Paro",
      "gid": "BTN.8_1"
    },
    "code": "BT-11"
  },
  "293": {
    "gadm": {
      "name": "Pemagatshel",
      "gid": "BTN.9_1"
    },
    "code": "BT-43"
  },
  "294": {
    "gadm": {
      "name": "Punakha",
      "gid": "BTN.10_1"
    },
    "code": "BT-23"
  },
  "295": {
    "gadm": {
      "name": "Samdrupjongkhar",
      "gid": "BTN.11_1"
    },
    "code": "BT-45"
  },
  "296": {
    "gadm": {
      "name": "Samtse",
      "gid": "BTN.12_1"
    },
    "code": "BT-14"
  },
  "297": {
    "gadm": {
      "name": "Sarpang",
      "gid": "BTN.13_1"
    },
    "code": "BT-31"
  },
  "298": {
    "gadm": {
      "name": "Thimphu",
      "gid": "BTN.14_1"
    },
    "code": "BT-15"
  },
  "299": {
    "gadm": {
      "name": "Trashigang",
      "gid": "BTN.15_1"
    },
    "code": "BT-41"
  },
  "300": {
    "gadm": {
      "name": "Trongsa",
      "gid": "BTN.16_1"
    },
    "code": "BT-32"
  },
  "301": {
    "gadm": {
      "name": "Tsirang",
      "gid": "BTN.17_1"
    },
    "code": "BT-21"
  },
  "302": {
    "gadm": {
      "name": "Wangduephodrang",
      "gid": "BTN.18_1"
    },
    "code": "BT-24"
  },
  "303": {
    "gadm": {
      "name": "Yangtse",
      "gid": "BTN.19_1"
    },
    "code": "BT-TY"
  },
  "304": {
    "gadm": {
      "name": "Zhemgang",
      "gid": "BTN.20_1"
    },
    "code": "BT-34"
  },
  "305": {
    "gadm": {
      "name": "Central",
      "gid": "BWA.1_1"
    },
    "code": "BW-CE"
  },
  "306": {
    "gadm": {
      "name": "Chobe",
      "gid": "BWA.2_1"
    },
    "code": "BW-CH"
  },
  "307": {
    "gadm": {
      "name": "Francistown",
      "gid": "BWA.3_1"
    },
    "code": "BW-FR"
  },
  "308": {
    "gadm": {
      "name": "Gaborone",
      "gid": "BWA.4_1"
    },
    "code": "BW-GA"
  },
  "309": {
    "gadm": {
      "name": "Ghanzi",
      "gid": "BWA.5_1"
    },
    "code": "BW-GH"
  },
  "310": {
    "gadm": {
      "name": "Jwaneng",
      "gid": "BWA.6_1"
    },
    "code": "BW-JW"
  },
  "311": {
    "gadm": {
      "name": "Kgalagadi",
      "gid": "BWA.7_1"
    },
    "code": "BW-KG"
  },
  "312": {
    "gadm": {
      "name": "Kgatleng",
      "gid": "BWA.8_1"
    },
    "code": "BW-KL"
  },
  "313": {
    "gadm": {
      "name": "Kweneng",
      "gid": "BWA.9_1"
    },
    "code": "BW-KW"
  },
  "314": {
    "gadm": {
      "name": "Lobatse",
      "gid": "BWA.10_1"
    },
    "code": "BW-LO"
  },
  "315": {
    "gadm": {
      "name": "North-East",
      "gid": "BWA.11_1"
    },
    "code": "BW-NE"
  },
  "316": {
    "gadm": {
      "name": "North-West",
      "gid": "BWA.12_1"
    },
    "code": "BW-NW"
  },
  "317": {
    "gadm": {
      "name": "Selibe Phikwe",
      "gid": "BWA.13_1"
    },
    "code": "BW-SP"
  },
  "318": {
    "gadm": {
      "name": "South-East",
      "gid": "BWA.14_1"
    },
    "code": "BW-SE"
  },
  "319": {
    "gadm": {
      "name": "Southern",
      "gid": "BWA.15_1"
    },
    "code": "BW-SO"
  },
  "320": {
    "gadm": {
      "name": "Sowa",
      "gid": "BWA.16_1"
    },
    "code": "BW-ST"
  },
  "321": {
    "gadm": {
      "name": "Brest",
      "gid": "BLR.1_1"
    },
    "code": "BY-BR"
  },
  "322": {
    "gadm": {
      "name": "Homyel'",
      "gid": "BLR.2_1"
    },
    "code": "BY-HO"
  },
  "323": {
    "gadm": {
      "name": "Hrodna",
      "gid": "BLR.3_1"
    },
    "code": "BY-HR"
  },
  "324": {
    "gadm": {
      "name": "Mahilyow",
      "gid": "BLR.4_1"
    },
    "code": "BY-MA"
  },
  "325": {
    "gadm": {
      "name": "Minsk",
      "gid": "BLR.5_1"
    },
    "code": "BY-MI"
  },
  "326": {
    "gadm": {
      "name": "Vitsyebsk",
      "gid": "BLR.6_1"
    },
    "code": "BY-VI"
  },
  "327": {
    "gadm": {
      "name": "Belize",
      "gid": "BLZ.1_1"
    },
    "code": "BZ-BZ"
  },
  "328": {
    "gadm": {
      "name": "Cayo",
      "gid": "BLZ.2_1"
    },
    "code": "BZ-CY"
  },
  "329": {
    "gadm": {
      "name": "Corozal",
      "gid": "BLZ.3_1"
    },
    "code": "BZ-CZL"
  },
  "330": {
    "gadm": {
      "name": "Orange Walk",
      "gid": "BLZ.4_1"
    },
    "code": "BZ-OW"
  },
  "331": {
    "gadm": {
      "name": "Stann Creek",
      "gid": "BLZ.5_1"
    },
    "code": "BZ-SC"
  },
  "332": {
    "gadm": {
      "name": "Toledo",
      "gid": "BLZ.6_1"
    },
    "code": "BZ-TOL"
  },
  "333": {
    "gadm": {
      "name": "Alberta",
      "gid": "CAN.1_1"
    },
    "code": "CA-AB"
  },
  "334": {
    "gadm": {
      "name": "British Columbia",
      "gid": "CAN.2_1"
    },
    "code": "CA-BC"
  },
  "335": {
    "gadm": {
      "name": "Manitoba",
      "gid": "CAN.3_1"
    },
    "code": "CA-MB"
  },
  "336": {
    "gadm": {
      "name": "New Brunswick",
      "gid": "CAN.4_1"
    },
    "code": "CA-NB"
  },
  "337": {
    "gadm": {
      "name": "Newfoundland and Labrador",
      "gid": "CAN.5_1"
    },
    "code": "CA-NL"
  },
  "338": {
    "gadm": {
      "name": "Northwest Territories",
      "gid": "CAN.6_1"
    },
    "code": "CA-NT"
  },
  "339": {
    "gadm": {
      "name": "Nova Scotia",
      "gid": "CAN.7_1"
    },
    "code": "CA-NS"
  },
  "340": {
    "gadm": {
      "name": "Nunavut",
      "gid": "CAN.8_1"
    },
    "code": "CA-NU"
  },
  "341": {
    "gadm": {
      "name": "Ontario",
      "gid": "CAN.9_1"
    },
    "code": "CA-ON"
  },
  "342": {
    "gadm": {
      "name": "Prince Edward Island",
      "gid": "CAN.10_1"
    },
    "code": "CA-PE"
  },
  "343": {
    "gadm": {
      "name": "Qu\u00c3\u0192\u00c2\u00a9bec",
      "gid": "CAN.11_1"
    },
    "code": "CA-QC"
  },
  "344": {
    "gadm": {
      "name": "Saskatchewan",
      "gid": "CAN.12_1"
    },
    "code": "CA-SK"
  },
  "345": {
    "gadm": {
      "name": "Yukon",
      "gid": "CAN.13_1"
    },
    "code": "CA-YT"
  },
  "346": {
    "gadm": {
      "name": "Bas-U\u00c3\u00a9l\u00c3\u00a9",
      "gid": "COD.1_1"
    },
    "code": "CD-BU"
  },
  "347": {
    "gadm": {
      "name": "\u00c3\u2030quateur",
      "gid": "COD.2_1"
    },
    "code": "CD-EQ"
  },
  "348": {
    "gadm": {
      "name": "Haut-Katanga",
      "gid": "COD.3_1"
    },
    "code": "CD-HK"
  },
  "349": {
    "gadm": {
      "name": "Haut-Lomami",
      "gid": "COD.4_1"
    },
    "code": "CD-HL"
  },
  "350": {
    "gadm": {
      "name": "Haut-U\u00c3\u00a9l\u00c3\u00a9",
      "gid": "COD.5_1"
    },
    "code": "CD-HU"
  },
  "351": {
    "gadm": {
      "name": "Ituri",
      "gid": "COD.6_1"
    },
    "code": "CD-IT"
  },
  "352": {
    "gadm": {
      "name": "Kasa\u00c3\u00af",
      "gid": "COD.9_1"
    },
    "code": "CD-KS"
  },
  "353": {
    "gadm": {
      "name": "Kasa\u00c3\u00af-Central",
      "gid": "COD.7_1"
    },
    "code": "CD-KC"
  },
  "354": {
    "gadm": {
      "name": "Kasa\u00c3\u00af-Oriental",
      "gid": "COD.8_1"
    },
    "code": "CD-KE"
  },
  "355": {
    "gadm": {
      "name": "Kinshasa",
      "gid": "COD.10_1"
    },
    "code": "CD-KN"
  },
  "356": {
    "gadm": {
      "name": "Kongo-Central",
      "gid": "COD.11_1"
    },
    "code": "CD-BC"
  },
  "357": {
    "gadm": {
      "name": "Kwango",
      "gid": "COD.12_1"
    },
    "code": "CD-KG"
  },
  "358": {
    "gadm": {
      "name": "Kwilu",
      "gid": "COD.13_1"
    },
    "code": "CD-KL"
  },
  "359": {
    "gadm": {
      "name": "Lomami",
      "gid": "COD.14_1"
    },
    "code": "CD-LO"
  },
  "360": {
    "gadm": {
      "name": "Lualaba",
      "gid": "COD.15_1"
    },
    "code": "CD-LU"
  },
  "361": {
    "gadm": {
      "name": "Ma\u00c3\u00af-Ndombe",
      "gid": "COD.16_1"
    },
    "code": "CD-MN"
  },
  "362": {
    "gadm": {
      "name": "Maniema",
      "gid": "COD.17_1"
    },
    "code": "CD-MA"
  },
  "363": {
    "gadm": {
      "name": "Mongala",
      "gid": "COD.18_1"
    },
    "code": "CD-MO"
  },
  "364": {
    "gadm": {
      "name": "Nord-Kivu",
      "gid": "COD.19_1"
    },
    "code": "CD-NK"
  },
  "365": {
    "gadm": {
      "name": "Nord-Ubangi",
      "gid": "COD.20_1"
    },
    "code": "CD-NU"
  },
  "366": {
    "gadm": {
      "name": "Sankuru",
      "gid": "COD.21_1"
    },
    "code": "CD-SA"
  },
  "367": {
    "gadm": {
      "name": "Sud-Kivu",
      "gid": "COD.22_1"
    },
    "code": "CD-SK"
  },
  "368": {
    "gadm": {
      "name": "Sud-Ubangi",
      "gid": "COD.23_1"
    },
    "code": "CD-SU"
  },
  "369": {
    "gadm": {
      "name": "Tanganyika",
      "gid": "COD.24_1"
    },
    "code": "CD-TA"
  },
  "370": {
    "gadm": {
      "name": "Tshopo",
      "gid": "COD.25_1"
    },
    "code": "CD-TO"
  },
  "371": {
    "gadm": {
      "name": "Tshuapa",
      "gid": "COD.26_1"
    },
    "code": "CD-TU"
  },
  "372": {
    "gadm": {
      "name": "Bamingui-Bangoran",
      "gid": "CAF.1_1"
    },
    "code": "CF-BB"
  },
  "373": {
    "gadm": {
      "name": "Bangui",
      "gid": "CAF.2_1"
    },
    "code": "CF-BGF"
  },
  "374": {
    "gadm": {
      "name": "Basse-Kotto",
      "gid": "CAF.3_1"
    },
    "code": "CF-BK"
  },
  "375": {
    "gadm": {
      "name": "Haut-Mbomou",
      "gid": "CAF.4_1"
    },
    "code": "CF-HK"
  },
  "376": {
    "gadm": {
      "name": "Haute-Kotto",
      "gid": "CAF.5_1"
    },
    "code": "CF-HM"
  },
  "377": {
    "gadm": {
      "name": "K\u00c3\u00a9mo",
      "gid": "CAF.6_1"
    },
    "code": "CF-KG"
  },
  "378": {
    "gadm": {
      "name": "Lobaye",
      "gid": "CAF.7_1"
    },
    "code": "CF-LB"
  },
  "379": {
    "gadm": {
      "name": "Mamb\u00c3\u00a9r\u00c3\u00a9-Kad\u00c3\u00a9\u00c3\u00af",
      "gid": "CAF.8_1"
    },
    "code": "CF-HS"
  },
  "380": {
    "gadm": {
      "name": "Mbomou",
      "gid": "CAF.9_1"
    },
    "code": "CF-MB"
  },
  "381": {
    "gadm": {
      "name": "Nana-Gr\u00c3\u00a9bizi",
      "gid": "CAF.10_1"
    },
    "code": "CF-KB"
  },
  "382": {
    "gadm": {
      "name": "Nana-Mamb\u00c3\u00a9r\u00c3\u00a9",
      "gid": "CAF.11_1"
    },
    "code": "CF-NM"
  },
  "383": {
    "gadm": {
      "name": "Ombella-M'Poko",
      "gid": "CAF.12_1"
    },
    "code": "CF-MP"
  },
  "384": {
    "gadm": {
      "name": "Ouaka",
      "gid": "CAF.13_1"
    },
    "code": "CF-UK"
  },
  "385": {
    "gadm": {
      "name": "Ouham",
      "gid": "CAF.15_1"
    },
    "code": "CF-AC"
  },
  "386": {
    "gadm": {
      "name": "Ouham-Pend\u00c3\u00a9",
      "gid": "CAF.14_1"
    },
    "code": "CF-OP"
  },
  "387": {
    "gadm": {
      "name": "Sangha-Mba\u00c3\u00a9r\u00c3\u00a9",
      "gid": "CAF.16_1"
    },
    "code": "CF-SE"
  },
  "388": {
    "gadm": {
      "name": "Vakaga",
      "gid": "CAF.17_1"
    },
    "code": "CF-VK"
  },
  "389": {
    "gadm": {
      "name": "Bouenza",
      "gid": "COG.1_1"
    },
    "code": "CG-11"
  },
  "390": {
    "gadm": {
      "name": "Brazzaville",
      "gid": "COG.2_1"
    },
    "code": "CG-BZV"
  },
  "391": {
    "gadm": {
      "name": "Cuvette",
      "gid": "COG.4_1"
    },
    "code": "CG-8"
  },
  "392": {
    "gadm": {
      "name": "Cuvette-Ouest",
      "gid": "COG.3_1"
    },
    "code": "CG-15"
  },
  "393": {
    "gadm": {
      "name": "Kouilou",
      "gid": "COG.5_1"
    },
    "code": "CG-5"
  },
  "394": {
    "gadm": {
      "name": "L\u00c3\u00a9koumou",
      "gid": "COG.6_1"
    },
    "code": "CG-2"
  },
  "395": {
    "gadm": {
      "name": "Likouala",
      "gid": "COG.7_1"
    },
    "code": "CG-7"
  },
  "396": {
    "gadm": {
      "name": "Niari",
      "gid": "COG.8_1"
    },
    "code": "CG-9"
  },
  "397": {
    "gadm": {
      "name": "Plateaux",
      "gid": "COG.9_1"
    },
    "code": "CG-14"
  },
  "398": {
    "gadm": {
      "name": "Pointe Noire",
      "gid": "COG.10_1"
    },
    "code": "CG-16"
  },
  "399": {
    "gadm": {
      "name": "Pool",
      "gid": "COG.11_1"
    },
    "code": "CG-12"
  },
  "400": {
    "gadm": {
      "name": "Sangha",
      "gid": "COG.12_1"
    },
    "code": "CG-13"
  },
  "401": {
    "gadm": {
      "name": "Aargau",
      "gid": "CHE.1_1"
    },
    "code": "CH-AG"
  },
  "402": {
    "gadm": {
      "name": "Appenzell Ausserrhoden",
      "gid": "CHE.2_1"
    },
    "code": "CH-AR"
  },
  "403": {
    "gadm": {
      "name": "Appenzell Innerrhoden",
      "gid": "CHE.3_1"
    },
    "code": "CH-AI"
  },
  "404": {
    "gadm": {
      "name": "Basel-Landschaft",
      "gid": "CHE.4_1"
    },
    "code": "CH-BL"
  },
  "405": {
    "gadm": {
      "name": "Basel-Stadt",
      "gid": "CHE.5_1"
    },
    "code": "CH-BS"
  },
  "406": {
    "gadm": {
      "name": "Bern",
      "gid": "CHE.6_1"
    },
    "code": "CH-BE"
  },
  "407": {
    "gadm": {
      "name": "Fribourg",
      "gid": "CHE.7_1"
    },
    "code": "CH-FR"
  },
  "408": {
    "gadm": {
      "name": "Gen\u00c3\u00a8ve",
      "gid": "CHE.8_1"
    },
    "code": "CH-GE"
  },
  "409": {
    "gadm": {
      "name": "Glarus",
      "gid": "CHE.9_1"
    },
    "code": "CH-GL"
  },
  "410": {
    "gadm": {
      "name": "Graub\u00c3\u00bcnden",
      "gid": "CHE.10_1"
    },
    "code": "CH-GR"
  },
  "411": {
    "gadm": {
      "name": "Jura",
      "gid": "CHE.11_1"
    },
    "code": "CH-JU"
  },
  "412": {
    "gadm": {
      "name": "Lucerne",
      "gid": "CHE.12_1"
    },
    "code": "CH-LU"
  },
  "413": {
    "gadm": {
      "name": "Neuch\u00c3\u00a2tel",
      "gid": "CHE.13_1"
    },
    "code": "CH-NE"
  },
  "414": {
    "gadm": {
      "name": "Nidwalden",
      "gid": "CHE.14_1"
    },
    "code": "CH-NW"
  },
  "415": {
    "gadm": {
      "name": "Obwalden",
      "gid": "CHE.15_1"
    },
    "code": "CH-OW"
  },
  "416": {
    "gadm": {
      "name": "Sankt Gallen",
      "gid": "CHE.16_1"
    },
    "code": "CH-SG"
  },
  "417": {
    "gadm": {
      "name": "Schaffhausen",
      "gid": "CHE.17_1"
    },
    "code": "CH-SH"
  },
  "418": {
    "gadm": {
      "name": "Schwyz",
      "gid": "CHE.18_1"
    },
    "code": "CH-SZ"
  },
  "419": {
    "gadm": {
      "name": "Solothurn",
      "gid": "CHE.19_1"
    },
    "code": "CH-SO"
  },
  "420": {
    "gadm": {
      "name": "Thurgau",
      "gid": "CHE.20_1"
    },
    "code": "CH-TG"
  },
  "421": {
    "gadm": {
      "name": "Ticino",
      "gid": "CHE.21_1"
    },
    "code": "CH-TI"
  },
  "422": {
    "gadm": {
      "name": "Uri",
      "gid": "CHE.22_1"
    },
    "code": "CH-UR"
  },
  "423": {
    "gadm": {
      "name": "Valais",
      "gid": "CHE.23_1"
    },
    "code": "CH-VS"
  },
  "424": {
    "gadm": {
      "name": "Vaud",
      "gid": "CHE.24_1"
    },
    "code": "CH-VD"
  },
  "425": {
    "gadm": {
      "name": "Zug",
      "gid": "CHE.25_1"
    },
    "code": "CH-ZH"
  },
  "426": {
    "gadm": {
      "name": "Z\u00c3\u00bcrich",
      "gid": "CHE.26_1"
    },
    "code": "CH-ZG"
  },
  "427": {
    "gadm": {
      "name": "Abidjan",
      "gid": "CIV.1_1"
    },
    "code": "CI-AB"
  },
  "428": {
    "gadm": {
      "name": "Bas-Sassandra",
      "gid": "CIV.2_1"
    },
    "code": "CI-BS"
  },
  "429": {
    "gadm": {
      "name": "Como\u00c3\u00a9",
      "gid": "CIV.3_1"
    },
    "code": "CI-CM"
  },
  "430": {
    "gadm": {
      "name": "Dengu\u00c3\u00a9l\u00c3\u00a9",
      "gid": "CIV.4_1"
    },
    "code": "CI-DN"
  },
  "431": {
    "gadm": {
      "name": "G\u00c3\u00b4h-Djiboua",
      "gid": "CIV.5_1"
    },
    "code": "CI-GD"
  },
  "432": {
    "gadm": {
      "name": "Lacs",
      "gid": "CIV.6_1"
    },
    "code": "CI-LC"
  },
  "433": {
    "gadm": {
      "name": "Lagunes",
      "gid": "CIV.7_1"
    },
    "code": "CI-LG"
  },
  "434": {
    "gadm": {
      "name": "Montagnes",
      "gid": "CIV.8_1"
    },
    "code": "CI-MG"
  },
  "435": {
    "gadm": {
      "name": "Sassandra-Marahou\u00c3\u00a9",
      "gid": "CIV.9_1"
    },
    "code": "CI-SM"
  },
  "436": {
    "gadm": {
      "name": "Savanes",
      "gid": "CIV.10_1"
    },
    "code": "CI-SV"
  },
  "437": {
    "gadm": {
      "name": "Vall\u00c3\u00a9e du Bandama",
      "gid": "CIV.11_1"
    },
    "code": "CI-VB"
  },
  "438": {
    "gadm": {
      "name": "Woroba",
      "gid": "CIV.12_1"
    },
    "code": "CI-WR"
  },
  "439": {
    "gadm": {
      "name": "Yamoussoukro",
      "gid": "CIV.13_1"
    },
    "code": "CI-YM"
  },
  "440": {
    "gadm": {
      "name": "Zanzan",
      "gid": "CIV.14_1"
    },
    "code": "CI-ZZ"
  },
  "441": {
    "gadm": {
      "name": "\u00c3\u2018uble",
      "gid": "CHL.13_1"
    },
    "code": "CL-NB"
  },
  "442": {
    "gadm": {
      "name": "Ais\u00c3\u00a9n del General Carlos Iba\u00c3\u00b1ez del Campo",
      "gid": "CHL.1_1"
    },
    "code": "CL-AI"
  },
  "443": {
    "gadm": {
      "name": "Antofagasta",
      "gid": "CHL.2_1"
    },
    "code": "CL-AN"
  },
  "444": {
    "gadm": {
      "name": "La Araucan\u00c3\u00ada",
      "gid": "CHL.3_1"
    },
    "code": "CL-AR"
  },
  "445": {
    "gadm": {
      "name": "Arica y Parinacota",
      "gid": "CHL.4_1"
    },
    "code": "CL-AP"
  },
  "446": {
    "gadm": {
      "name": "Atacama",
      "gid": "CHL.5_1"
    },
    "code": "CL-AT"
  },
  "447": {
    "gadm": {
      "name": "B\u00c3\u00ado-B\u00c3\u00ado",
      "gid": "CHL.6_1"
    },
    "code": "CL-BI"
  },
  "448": {
    "gadm": {
      "name": "Coquimbo",
      "gid": "CHL.7_1"
    },
    "code": "CL-CO"
  },
  "449": {
    "gadm": {
      "name": "Libertador General Bernardo O'Higgins",
      "gid": "CHL.8_1"
    },
    "code": "CL-LI"
  },
  "450": {
    "gadm": {
      "name": "Los Lagos",
      "gid": "CHL.9_1"
    },
    "code": "CL-LL"
  },
  "451": {
    "gadm": {
      "name": "Los R\u00c3\u00ados",
      "gid": "CHL.10_1"
    },
    "code": "CL-LR"
  },
  "452": {
    "gadm": {
      "name": "Magallanes y Ant\u00c3\u00a1rtica Chilena",
      "gid": "CHL.11_1"
    },
    "code": "CL-MA"
  },
  "453": {
    "gadm": {
      "name": "Maule",
      "gid": "CHL.12_1"
    },
    "code": "CL-ML"
  },
  "454": {
    "gadm": {
      "name": "Regi\u00c3\u00b3n Metropolitana de Santiago",
      "gid": "CHL.14_1"
    },
    "code": "CL-RM"
  },
  "455": {
    "gadm": {
      "name": "Tarapac\u00c3\u00a1",
      "gid": "CHL.15_1"
    },
    "code": "CL-TA"
  },
  "456": {
    "gadm": {
      "name": "Valpara\u00c3\u00adso",
      "gid": "CHL.16_1"
    },
    "code": "CL-VS"
  },
  "457": {
    "gadm": {
      "name": "Adamaoua",
      "gid": "CMR.1_1"
    },
    "code": "CM-AD"
  },
  "458": {
    "gadm": {
      "name": "Centre",
      "gid": "CMR.2_1"
    },
    "code": "CM-CE"
  },
  "459": {
    "gadm": {
      "name": "Est",
      "gid": "CMR.3_1"
    },
    "code": "CM-ES"
  },
  "460": {
    "gadm": {
      "name": "Extr\u00c3\u00aame-Nord",
      "gid": "CMR.4_1"
    },
    "code": "CM-EN"
  },
  "461": {
    "gadm": {
      "name": "Littoral",
      "gid": "CMR.5_1"
    },
    "code": "CM-LT"
  },
  "462": {
    "gadm": {
      "name": "Nord",
      "gid": "CMR.7_1"
    },
    "code": "CM-NO"
  },
  "463": {
    "gadm": {
      "name": "Nord-Ouest",
      "gid": "CMR.6_1"
    },
    "code": "CM-NW"
  },
  "464": {
    "gadm": {
      "name": "Ouest",
      "gid": "CMR.8_1"
    },
    "code": "CM-OU"
  },
  "465": {
    "gadm": {
      "name": "Sud",
      "gid": "CMR.10_1"
    },
    "code": "CM-SU"
  },
  "466": {
    "gadm": {
      "name": "Sud-Ouest",
      "gid": "CMR.9_1"
    },
    "code": "CM-SW"
  },
  "467": {
    "gadm": {
      "name": "Anhui",
      "gid": "CHN.1_1"
    },
    "code": "CN-AH"
  },
  "468": {
    "gadm": {
      "name": "Beijing",
      "gid": "CHN.2_1"
    },
    "code": "CN-BJ"
  },
  "469": {
    "gadm": {
      "name": "Chongqing",
      "gid": "CHN.3_1"
    },
    "code": "CN-CQ"
  },
  "470": {
    "gadm": {
      "name": "Fujian",
      "gid": "CHN.4_1"
    },
    "code": "CN-FJ"
  },
  "471": {
    "gadm": {
      "name": "Gansu",
      "gid": "CHN.5_1"
    },
    "code": "CN-GS"
  },
  "472": {
    "gadm": {
      "name": "Guangdong",
      "gid": "CHN.6_1"
    },
    "code": "CN-GD"
  },
  "473": {
    "gadm": {
      "name": "Guangxi",
      "gid": "CHN.7_1"
    },
    "code": "CN-GX"
  },
  "474": {
    "gadm": {
      "name": "Guizhou",
      "gid": "CHN.8_1"
    },
    "code": "CN-GZ"
  },
  "475": {
    "gadm": {
      "name": "Hainan",
      "gid": "CHN.9_1"
    },
    "code": "CN-HI"
  },
  "476": {
    "gadm": {
      "name": "Hebei",
      "gid": "CHN.10_1"
    },
    "code": "CN-HE"
  },
  "477": {
    "gadm": {
      "name": "Heilongjiang",
      "gid": "CHN.11_1"
    },
    "code": "CN-HL"
  },
  "478": {
    "gadm": {
      "name": "Henan",
      "gid": "CHN.12_1"
    },
    "code": "CN-HA"
  },
  "479": {
    "gadm": {
      "name": "Hubei",
      "gid": "CHN.13_1"
    },
    "code": "CN-HB"
  },
  "480": {
    "gadm": {
      "name": "Hunan",
      "gid": "CHN.14_1"
    },
    "code": "CN-HN"
  },
  "481": {
    "gadm": {
      "name": "Jiangsu",
      "gid": "CHN.15_1"
    },
    "code": "CN-JS"
  },
  "482": {
    "gadm": {
      "name": "Jiangxi",
      "gid": "CHN.16_1"
    },
    "code": "CN-JX"
  },
  "483": {
    "gadm": {
      "name": "Jilin",
      "gid": "CHN.17_1"
    },
    "code": "CN-JL"
  },
  "484": {
    "gadm": {
      "name": "Liaoning",
      "gid": "CHN.18_1"
    },
    "code": "CN-LN"
  },
  "485": {
    "gadm": {
      "name": "Nei Mongol",
      "gid": "CHN.19_1"
    },
    "code": "CN-NM"
  },
  "486": {
    "gadm": {
      "name": "Ningxia Hui",
      "gid": "CHN.20_1"
    },
    "code": "CN-NX"
  },
  "487": {
    "gadm": {
      "name": "Qinghai",
      "gid": "CHN.21_1"
    },
    "code": "CN-QH"
  },
  "488": {
    "gadm": {
      "name": "Shaanxi",
      "gid": "CHN.22_1"
    },
    "code": "CN-SN"
  },
  "489": {
    "gadm": {
      "name": "Shandong",
      "gid": "CHN.23_1"
    },
    "code": "CN-SD"
  },
  "490": {
    "gadm": {
      "name": "Shanghai",
      "gid": "CHN.24_1"
    },
    "code": "CN-SH"
  },
  "491": {
    "gadm": {
      "name": "Shanxi",
      "gid": "CHN.25_1"
    },
    "code": "CN-SX"
  },
  "492": {
    "gadm": {
      "name": "Sichuan",
      "gid": "CHN.26_1"
    },
    "code": "CN-SC"
  },
  "493": {
    "gadm": {
      "name": "Tianjin",
      "gid": "CHN.27_1"
    },
    "code": "CN-TJ"
  },
  "494": {
    "gadm": {
      "name": "Xinjiang Uygur",
      "gid": "CHN.28_1"
    },
    "code": "CN-XJ"
  },
  "495": {
    "gadm": {
      "name": "Xizang",
      "gid": "CHN.29_1"
    },
    "code": "CN-XZ"
  },
  "496": {
    "gadm": {
      "name": "Yunnan",
      "gid": "CHN.30_1"
    },
    "code": "CN-YN"
  },
  "497": {
    "gadm": {
      "name": "Zhejiang",
      "gid": "CHN.31_1"
    },
    "code": "CN-ZJ"
  },
  "498": {
    "gadm": {
      "name": "Central and Western",
      "gid": "HKG.1_1"
    },
    "code": "CN-HK"
  },
  "499": {
    "gadm": {
      "name": "Macau",
      "gid": "MAC.2_1"
    },
    "code": "CN-MO"
  },
  "500": {
    "gadm": {
      "name": "Amazonas",
      "gid": "COL.1_1"
    },
    "code": "CO-AMA"
  },
  "501": {
    "gadm": {
      "name": "Antioquia",
      "gid": "COL.2_1"
    },
    "code": "CO-ANT"
  },
  "502": {
    "gadm": {
      "name": "Arauca",
      "gid": "COL.3_1"
    },
    "code": "CO-ARA"
  },
  "503": {
    "gadm": {
      "name": "Atl\u00c3\u00a1ntico",
      "gid": "COL.4_1"
    },
    "code": "CO-ATL"
  },
  "504": {
    "gadm": {
      "name": "Bol\u00c3\u00advar",
      "gid": "COL.5_1"
    },
    "code": "CO-BOL"
  },
  "505": {
    "gadm": {
      "name": "Boyac\u00c3\u00a1",
      "gid": "COL.6_1"
    },
    "code": "CO-BOY"
  },
  "506": {
    "gadm": {
      "name": "Caldas",
      "gid": "COL.7_1"
    },
    "code": "CO-CAL"
  },
  "507": {
    "gadm": {
      "name": "Caquet\u00c3\u00a1",
      "gid": "COL.8_1"
    },
    "code": "CO-CAQ"
  },
  "508": {
    "gadm": {
      "name": "Casanare",
      "gid": "COL.9_1"
    },
    "code": "CO-CAS"
  },
  "509": {
    "gadm": {
      "name": "Cauca",
      "gid": "COL.10_1"
    },
    "code": "CO-CAU"
  },
  "510": {
    "gadm": {
      "name": "Cesar",
      "gid": "COL.11_1"
    },
    "code": "CO-CES"
  },
  "511": {
    "gadm": {
      "name": "Choc\u00c3\u00b3",
      "gid": "COL.12_1"
    },
    "code": "CO-CHO"
  },
  "512": {
    "gadm": {
      "name": "C\u00c3\u00b3rdoba",
      "gid": "COL.13_1"
    },
    "code": "CO-COR"
  },
  "513": {
    "gadm": {
      "name": "Cundinamarca",
      "gid": "COL.14_1"
    },
    "code": "CO-CUN"
  },
  "514": {
    "gadm": {
      "name": "Guain\u00c3\u00ada",
      "gid": "COL.15_1"
    },
    "code": "CO-GUA"
  },
  "515": {
    "gadm": {
      "name": "Guaviare",
      "gid": "COL.16_1"
    },
    "code": "CO-GUV"
  },
  "516": {
    "gadm": {
      "name": "Huila",
      "gid": "COL.17_1"
    },
    "code": "CO-HUI"
  },
  "517": {
    "gadm": {
      "name": "La Guajira",
      "gid": "COL.18_1"
    },
    "code": "CO-LAG"
  },
  "518": {
    "gadm": {
      "name": "Magdalena",
      "gid": "COL.19_1"
    },
    "code": "CO-MAG"
  },
  "519": {
    "gadm": {
      "name": "Meta",
      "gid": "COL.20_1"
    },
    "code": "CO-MET"
  },
  "520": {
    "gadm": {
      "name": "Nari\u00c3\u00b1o",
      "gid": "COL.21_1"
    },
    "code": "CO-NAR"
  },
  "521": {
    "gadm": {
      "name": "Norte de Santander",
      "gid": "COL.22_1"
    },
    "code": "CO-NSA"
  },
  "522": {
    "gadm": {
      "name": "Putumayo",
      "gid": "COL.23_1"
    },
    "code": "CO-PUT"
  },
  "523": {
    "gadm": {
      "name": "Quind\u00c3\u00ado",
      "gid": "COL.24_1"
    },
    "code": "CO-QUI"
  },
  "524": {
    "gadm": {
      "name": "Risaralda",
      "gid": "COL.25_1"
    },
    "code": "CO-RIS"
  },
  "525": {
    "gadm": {
      "name": "San Andr\u00c3\u00a9s y Providencia",
      "gid": "COL.26_1"
    },
    "code": "CO-SAP"
  },
  "526": {
    "gadm": {
      "name": "Santander",
      "gid": "COL.27_1"
    },
    "code": "CO-SAN"
  },
  "527": {
    "gadm": {
      "name": "Sucre",
      "gid": "COL.28_1"
    },
    "code": "CO-SUC"
  },
  "528": {
    "gadm": {
      "name": "Tolima",
      "gid": "COL.29_1"
    },
    "code": "CO-TOL"
  },
  "529": {
    "gadm": {
      "name": "Valle del Cauca",
      "gid": "COL.30_1"
    },
    "code": "CO-VAC"
  },
  "530": {
    "gadm": {
      "name": "Vaup\u00c3\u00a9s",
      "gid": "COL.31_1"
    },
    "code": "CO-VAU"
  },
  "531": {
    "gadm": {
      "name": "Vichada",
      "gid": "COL.32_1"
    },
    "code": "CO-VID"
  },
  "532": {
    "gadm": {
      "name": "Alajuela",
      "gid": "CRI.1_1"
    },
    "code": "CR-A"
  },
  "533": {
    "gadm": {
      "name": "Cartago",
      "gid": "CRI.2_1"
    },
    "code": "CR-C"
  },
  "534": {
    "gadm": {
      "name": "Guanacaste",
      "gid": "CRI.3_1"
    },
    "code": "CR-G"
  },
  "535": {
    "gadm": {
      "name": "Heredia",
      "gid": "CRI.4_1"
    },
    "code": "CR-H"
  },
  "536": {
    "gadm": {
      "name": "Lim\u00c3\u00b3n",
      "gid": "CRI.5_1"
    },
    "code": "CR-L"
  },
  "537": {
    "gadm": {
      "name": "Puntarenas",
      "gid": "CRI.6_1"
    },
    "code": "CR-P"
  },
  "538": {
    "gadm": {
      "name": "San Jos\u00c3\u00a9",
      "gid": "CRI.7_1"
    },
    "code": "CR-SJ"
  },
  "539": {
    "gadm": {
      "name": "Camag\u00c3\u00bcey",
      "gid": "CUB.1_1"
    },
    "code": "CU-09"
  },
  "540": {
    "gadm": {
      "name": "Ciego de \u00c3\u0081vila",
      "gid": "CUB.2_1"
    },
    "code": "CU-08"
  },
  "541": {
    "gadm": {
      "name": "Cienfuegos",
      "gid": "CUB.3_1"
    },
    "code": "CU-06"
  },
  "542": {
    "gadm": {
      "name": "Ciudad de la Habana",
      "gid": "CUB.4_1"
    },
    "code": "CU-03"
  },
  "543": {
    "gadm": {
      "name": "Granma",
      "gid": "CUB.5_1"
    },
    "code": "CU-12"
  },
  "544": {
    "gadm": {
      "name": "Guant\u00c3\u00a1namo",
      "gid": "CUB.6_1"
    },
    "code": "CU-14"
  },
  "545": {
    "gadm": {
      "name": "Holgu\u00c3\u00adn",
      "gid": "CUB.7_1"
    },
    "code": "CU-11"
  },
  "546": {
    "gadm": {
      "name": "Isla de la Juventud",
      "gid": "CUB.8_1"
    },
    "code": "CU-99"
  },
  "547": {
    "gadm": {
      "name": "La Habana",
      "gid": "CUB.9_1"
    },
    "code": "CU-15"
  },
  "548": {
    "gadm": {
      "name": "Las Tunas",
      "gid": "CUB.10_1"
    },
    "code": "CU-10"
  },
  "549": {
    "gadm": {
      "name": "Matanzas",
      "gid": "CUB.11_1"
    },
    "code": "CU-04"
  },
  "550": {
    "gadm": {
      "name": "Mayabeque",
      "gid": "CUB.12_1"
    },
    "code": "CU-16"
  },
  "551": {
    "gadm": {
      "name": "Pinar del R\u00c3\u00ado",
      "gid": "CUB.13_1"
    },
    "code": "CU-01"
  },
  "552": {
    "gadm": {
      "name": "Sancti Sp\u00c3\u00adritus",
      "gid": "CUB.14_1"
    },
    "code": "CU-07"
  },
  "553": {
    "gadm": {
      "name": "Santiago de Cuba",
      "gid": "CUB.15_1"
    },
    "code": "CU-13"
  },
  "554": {
    "gadm": {
      "name": "Villa Clara",
      "gid": "CUB.16_1"
    },
    "code": "CU-05"
  },
  "555": {
    "gadm": {
      "name": "Boa Vista",
      "gid": "CPV.1_1"
    },
    "code": "CV-BV"
  },
  "556": {
    "gadm": {
      "name": "Brava",
      "gid": "CPV.2_1"
    },
    "code": "CV-BR"
  },
  "557": {
    "gadm": {
      "name": "Maio",
      "gid": "CPV.3_1"
    },
    "code": "CV-MA"
  },
  "558": {
    "gadm": {
      "name": "Mosteiros",
      "gid": "CPV.4_1"
    },
    "code": "CV-MO"
  },
  "559": {
    "gadm": {
      "name": "Pa\u00c3\u00bal",
      "gid": "CPV.5_1"
    },
    "code": "CV-PA"
  },
  "560": {
    "gadm": {
      "name": "Porto Novo",
      "gid": "CPV.6_1"
    },
    "code": "CV-PN"
  },
  "561": {
    "gadm": {
      "name": "Praia",
      "gid": "CPV.7_1"
    },
    "code": "CV-PR"
  },
  "562": {
    "gadm": {
      "name": "Ribeira Brava",
      "gid": "CPV.8_1"
    },
    "code": "CV-RB"
  },
  "563": {
    "gadm": {
      "name": "Ribeira Grande",
      "gid": "CPV.9_1"
    },
    "code": "CV-RG"
  },
  "564": {
    "gadm": {
      "name": "Ribeira Grande de Santiago",
      "gid": "CPV.10_1"
    },
    "code": "CV-RS"
  },
  "565": {
    "gadm": {
      "name": "Sal",
      "gid": "CPV.11_1"
    },
    "code": "CV-SL"
  },
  "566": {
    "gadm": {
      "name": "Santa Catarina",
      "gid": "CPV.12_1"
    },
    "code": "CV-CA"
  },
  "567": {
    "gadm": {
      "name": "Santa Catarina do Fogo",
      "gid": "CPV.13_1"
    },
    "code": "CV-CF"
  },
  "568": {
    "gadm": {
      "name": "Santa Cruz",
      "gid": "CPV.14_1"
    },
    "code": "CV-CR"
  },
  "569": {
    "gadm": {
      "name": "S\u00c3\u00a3o Domingos",
      "gid": "CPV.15_1"
    },
    "code": "CV-SD"
  },
  "570": {
    "gadm": {
      "name": "S\u00c3\u00a3o Filipe",
      "gid": "CPV.16_1"
    },
    "code": "CV-SF"
  },
  "571": {
    "gadm": {
      "name": "S\u00c3\u00a3o Louren\u00c3\u00a7o dos \u00c3\u201crg\u00c3\u00a3os",
      "gid": "CPV.17_1"
    },
    "code": "CV-SO"
  },
  "572": {
    "gadm": {
      "name": "S\u00c3\u00a3o Miguel",
      "gid": "CPV.18_1"
    },
    "code": "CV-SM"
  },
  "573": {
    "gadm": {
      "name": "S\u00c3\u00a3o Salvador do Mundo",
      "gid": "CPV.19_1"
    },
    "code": "CV-SS"
  },
  "574": {
    "gadm": {
      "name": "S\u00c3\u00a3o Vicente",
      "gid": "CPV.20_1"
    },
    "code": "CV-SV"
  },
  "575": {
    "gadm": {
      "name": "Tarrafal",
      "gid": "CPV.21_1"
    },
    "code": "CV-TA"
  },
  "576": {
    "gadm": {
      "name": "Tarrafal de S\u00c3\u00a3o Nicolau",
      "gid": "CPV.22_1"
    },
    "code": "CV-TS"
  },
  "577": {
    "gadm": {
      "name": "Ali Sabieh",
      "gid": "DJI.1_1"
    },
    "code": "DJI.1_1"
  },
  "578": {
    "gadm": {
      "name": "Dikhil",
      "gid": "DJI.2_1"
    },
    "code": "DJI.2_1"
  },
  "579": {
    "gadm": {
      "name": "Djibouti",
      "gid": "DJI.3_1"
    },
    "code": "DJI.3_1"
  },
  "580": {
    "gadm": {
      "name": "Tadjourah",
      "gid": "DJI.5_1"
    },
    "code": "DJI.5_1"
  },
  "581": {
    "gadm": {
      "name": "Saint Andrew",
      "gid": "DMA.1_1"
    },
    "code": "DM-02"
  },
  "582": {
    "gadm": {
      "name": "Saint David",
      "gid": "DMA.2_1"
    },
    "code": "DM-03"
  },
  "583": {
    "gadm": {
      "name": "Saint George",
      "gid": "DMA.3_1"
    },
    "code": "DM-04"
  },
  "584": {
    "gadm": {
      "name": "Saint John",
      "gid": "DMA.4_1"
    },
    "code": "DM-05"
  },
  "585": {
    "gadm": {
      "name": "Saint Joseph",
      "gid": "DMA.5_1"
    },
    "code": "DM-06"
  },
  "586": {
    "gadm": {
      "name": "Saint Luke",
      "gid": "DMA.6_1"
    },
    "code": "DM-07"
  },
  "587": {
    "gadm": {
      "name": "Saint Mark",
      "gid": "DMA.7_1"
    },
    "code": "DM-08"
  },
  "588": {
    "gadm": {
      "name": "Saint Patrick",
      "gid": "DMA.8_1"
    },
    "code": "DM-09"
  },
  "589": {
    "gadm": {
      "name": "Saint Paul",
      "gid": "DMA.9_1"
    },
    "code": "DM-10"
  },
  "590": {
    "gadm": {
      "name": "Saint Peter",
      "gid": "DMA.10_1"
    },
    "code": "DM-11"
  },
  "591": {
    "gadm": {
      "name": "Azua",
      "gid": "DOM.1_1"
    },
    "code": "DO-41"
  },
  "592": {
    "gadm": {
      "name": "Duarte",
      "gid": "DOM.6_1"
    },
    "code": "DO-33"
  },
  "593": {
    "gadm": {
      "name": "Dajab\u00c3\u00b3n",
      "gid": "DOM.4_1"
    },
    "code": "DO-34"
  },
  "594": {
    "gadm": {
      "name": "Espaillat",
      "gid": "DOM.8_1"
    },
    "code": "DO-35"
  },
  "595": {
    "gadm": {
      "name": "La Vega",
      "gid": "DOM.14_1"
    },
    "code": "DO-36"
  },
  "596": {
    "gadm": {
      "name": "San Juan",
      "gid": "DOM.26_1"
    },
    "code": "DO-37"
  },
  "597": {
    "gadm": {
      "name": "Bahoruco",
      "gid": "DOM.2_1"
    },
    "code": "DO-38"
  },
  "598": {
    "gadm": {
      "name": "Distrito Nacional",
      "gid": "DOM.5_1"
    },
    "code": "DO-40"
  },
  "599": {
    "gadm": {
      "name": "San Pedro de Macor\u00c3\u00ads",
      "gid": "DOM.27_1"
    },
    "code": "DO-39"
  },
  "600": {
    "gadm": {
      "name": "El Seybo",
      "gid": "DOM.7_1"
    },
    "code": "DO-42"
  },
  "601": {
    "gadm": {
      "name": "Adrar",
      "gid": "DZA.1_1"
    },
    "code": "DZ-01"
  },
  "602": {
    "gadm": {
      "name": "A\u00c3\u00afn Defla",
      "gid": "DZA.2_1"
    },
    "code": "DZ-44"
  },
  "603": {
    "gadm": {
      "name": "A\u00c3\u00afn T\u00c3\u00a9mouchent",
      "gid": "DZA.3_1"
    },
    "code": "DZ-46"
  },
  "604": {
    "gadm": {
      "name": "Alger",
      "gid": "DZA.4_1"
    },
    "code": "DZ-16"
  },
  "605": {
    "gadm": {
      "name": "Annaba",
      "gid": "DZA.5_1"
    },
    "code": "DZ-23"
  },
  "606": {
    "gadm": {
      "name": "Batna",
      "gid": "DZA.6_1"
    },
    "code": "DZ-05"
  },
  "607": {
    "gadm": {
      "name": "B\u00c3\u00a9char",
      "gid": "DZA.7_1"
    },
    "code": "DZ-08"
  },
  "608": {
    "gadm": {
      "name": "B\u00c3\u00a9ja\u00c3\u00afa",
      "gid": "DZA.8_1"
    },
    "code": "DZ-06"
  },
  "609": {
    "gadm": {
      "name": "Biskra",
      "gid": "DZA.9_1"
    },
    "code": "DZ-07"
  },
  "610": {
    "gadm": {
      "name": "Blida",
      "gid": "DZA.10_1"
    },
    "code": "DZ-09"
  },
  "611": {
    "gadm": {
      "name": "Bordj Bou Arr\u00c3\u00a9ridj",
      "gid": "DZA.11_1"
    },
    "code": "DZ-34"
  },
  "612": {
    "gadm": {
      "name": "Bouira",
      "gid": "DZA.12_1"
    },
    "code": "DZ-10"
  },
  "613": {
    "gadm": {
      "name": "Boumerd\u00c3\u00a8s",
      "gid": "DZA.13_1"
    },
    "code": "DZ-35"
  },
  "614": {
    "gadm": {
      "name": "Chlef",
      "gid": "DZA.14_1"
    },
    "code": "DZ-02"
  },
  "615": {
    "gadm": {
      "name": "Constantine",
      "gid": "DZA.15_1"
    },
    "code": "DZ-25"
  },
  "616": {
    "gadm": {
      "name": "Djelfa",
      "gid": "DZA.16_1"
    },
    "code": "DZ-17"
  },
  "617": {
    "gadm": {
      "name": "El Bayadh",
      "gid": "DZA.17_1"
    },
    "code": "DZ-32"
  },
  "618": {
    "gadm": {
      "name": "El Oued",
      "gid": "DZA.18_1"
    },
    "code": "DZ-39"
  },
  "619": {
    "gadm": {
      "name": "El Tarf",
      "gid": "DZA.19_1"
    },
    "code": "DZ-36"
  },
  "620": {
    "gadm": {
      "name": "Gharda\u00c3\u00afa",
      "gid": "DZA.20_1"
    },
    "code": "DZ-47"
  },
  "621": {
    "gadm": {
      "name": "Guelma",
      "gid": "DZA.21_1"
    },
    "code": "DZ-24"
  },
  "622": {
    "gadm": {
      "name": "Illizi",
      "gid": "DZA.22_1"
    },
    "code": "DZ-33"
  },
  "623": {
    "gadm": {
      "name": "Jijel",
      "gid": "DZA.23_1"
    },
    "code": "DZ-18"
  },
  "624": {
    "gadm": {
      "name": "Khenchela",
      "gid": "DZA.24_1"
    },
    "code": "DZ-40"
  },
  "625": {
    "gadm": {
      "name": "Laghouat",
      "gid": "DZA.25_1"
    },
    "code": "DZ-03"
  },
  "626": {
    "gadm": {
      "name": "Mascara",
      "gid": "DZA.27_1"
    },
    "code": "DZ-29"
  },
  "627": {
    "gadm": {
      "name": "M\u00c3\u00a9d\u00c3\u00a9a",
      "gid": "DZA.28_1"
    },
    "code": "DZ-26"
  },
  "628": {
    "gadm": {
      "name": "Mila",
      "gid": "DZA.29_1"
    },
    "code": "DZ-43"
  },
  "629": {
    "gadm": {
      "name": "Mostaganem",
      "gid": "DZA.30_1"
    },
    "code": "DZ-27"
  },
  "630": {
    "gadm": {
      "name": "M'Sila",
      "gid": "DZA.26_1"
    },
    "code": "DZ-28"
  },
  "631": {
    "gadm": {
      "name": "Na\u00c3\u00a2ma",
      "gid": "DZA.31_1"
    },
    "code": "DZ-45"
  },
  "632": {
    "gadm": {
      "name": "Oran",
      "gid": "DZA.32_1"
    },
    "code": "DZ-31"
  },
  "633": {
    "gadm": {
      "name": "Ouargla",
      "gid": "DZA.33_1"
    },
    "code": "DZ-30"
  },
  "634": {
    "gadm": {
      "name": "Oum el Bouaghi",
      "gid": "DZA.34_1"
    },
    "code": "DZ-04"
  },
  "635": {
    "gadm": {
      "name": "Relizane",
      "gid": "DZA.35_1"
    },
    "code": "DZ-48"
  },
  "636": {
    "gadm": {
      "name": "Sa\u00c3\u00afda",
      "gid": "DZA.36_1"
    },
    "code": "DZ-20"
  },
  "637": {
    "gadm": {
      "name": "S\u00c3\u00a9tif",
      "gid": "DZA.37_1"
    },
    "code": "DZ-19"
  },
  "638": {
    "gadm": {
      "name": "Sidi Bel Abb\u00c3\u00a8s",
      "gid": "DZA.38_1"
    },
    "code": "DZ-22"
  },
  "639": {
    "gadm": {
      "name": "Skikda",
      "gid": "DZA.39_1"
    },
    "code": "DZ-21"
  },
  "640": {
    "gadm": {
      "name": "Souk Ahras",
      "gid": "DZA.40_1"
    },
    "code": "DZ-41"
  },
  "641": {
    "gadm": {
      "name": "Tamanghasset",
      "gid": "DZA.41_1"
    },
    "code": "DZ-11"
  },
  "642": {
    "gadm": {
      "name": "T\u00c3\u00a9bessa",
      "gid": "DZA.42_1"
    },
    "code": "DZ-12"
  },
  "643": {
    "gadm": {
      "name": "Tiaret",
      "gid": "DZA.43_1"
    },
    "code": "DZ-14"
  },
  "644": {
    "gadm": {
      "name": "Tindouf",
      "gid": "DZA.44_1"
    },
    "code": "DZ-37"
  },
  "645": {
    "gadm": {
      "name": "Tipaza",
      "gid": "DZA.45_1"
    },
    "code": "DZ-42"
  },
  "646": {
    "gadm": {
      "name": "Tissemsilt",
      "gid": "DZA.46_1"
    },
    "code": "DZ-38"
  },
  "647": {
    "gadm": {
      "name": "Tizi Ouzou",
      "gid": "DZA.47_1"
    },
    "code": "DZ-15"
  },
  "648": {
    "gadm": {
      "name": "Tlemcen",
      "gid": "DZA.48_1"
    },
    "code": "DZ-13"
  },
  "649": {
    "gadm": {
      "name": "Azuay",
      "gid": "ECU.1_1"
    },
    "code": "EC-A"
  },
  "650": {
    "gadm": {
      "name": "Bolivar",
      "gid": "ECU.2_1"
    },
    "code": "EC-B"
  },
  "651": {
    "gadm": {
      "name": "Ca\u00c3\u0192\u00c2\u00b1ar",
      "gid": "ECU.3_1"
    },
    "code": "EC-F"
  },
  "652": {
    "gadm": {
      "name": "Carchi",
      "gid": "ECU.4_1"
    },
    "code": "EC-C"
  },
  "653": {
    "gadm": {
      "name": "Chimborazo",
      "gid": "ECU.5_1"
    },
    "code": "EC-H"
  },
  "654": {
    "gadm": {
      "name": "Cotopaxi",
      "gid": "ECU.6_1"
    },
    "code": "EC-X"
  },
  "655": {
    "gadm": {
      "name": "El Oro",
      "gid": "ECU.7_1"
    },
    "code": "EC-O"
  },
  "656": {
    "gadm": {
      "name": "Esmeraldas",
      "gid": "ECU.8_1"
    },
    "code": "EC-E"
  },
  "657": {
    "gadm": {
      "name": "Gal\u00c3\u0192\u00c2\u00a1pagos",
      "gid": "ECU.9_1"
    },
    "code": "EC-W"
  },
  "658": {
    "gadm": {
      "name": "Guayas",
      "gid": "ECU.10_1"
    },
    "code": "EC-G"
  },
  "659": {
    "gadm": {
      "name": "Imbabura",
      "gid": "ECU.11_1"
    },
    "code": "EC-I"
  },
  "660": {
    "gadm": {
      "name": "Loja",
      "gid": "ECU.12_1"
    },
    "code": "EC-L"
  },
  "661": {
    "gadm": {
      "name": "Los Rios",
      "gid": "ECU.13_1"
    },
    "code": "EC-R"
  },
  "662": {
    "gadm": {
      "name": "Manabi",
      "gid": "ECU.14_1"
    },
    "code": "EC-M"
  },
  "663": {
    "gadm": {
      "name": "Morona Santiago",
      "gid": "ECU.15_1"
    },
    "code": "EC-S"
  },
  "664": {
    "gadm": {
      "name": "Napo",
      "gid": "ECU.16_1"
    },
    "code": "EC-N"
  },
  "665": {
    "gadm": {
      "name": "Orellana",
      "gid": "ECU.17_1"
    },
    "code": "EC-D"
  },
  "666": {
    "gadm": {
      "name": "Pastaza",
      "gid": "ECU.18_1"
    },
    "code": "EC-Y"
  },
  "667": {
    "gadm": {
      "name": "Pichincha",
      "gid": "ECU.19_1"
    },
    "code": "EC-P"
  },
  "668": {
    "gadm": {
      "name": "Santa Elena",
      "gid": "ECU.20_1"
    },
    "code": "EC-SE"
  },
  "669": {
    "gadm": {
      "name": "Santo Domingo de los Tsachilas",
      "gid": "ECU.21_1"
    },
    "code": "EC-SD"
  },
  "670": {
    "gadm": {
      "name": "Sucumbios",
      "gid": "ECU.22_1"
    },
    "code": "EC-U"
  },
  "671": {
    "gadm": {
      "name": "Tungurahua",
      "gid": "ECU.23_1"
    },
    "code": "EC-T"
  },
  "672": {
    "gadm": {
      "name": "Zamora Chinchipe",
      "gid": "ECU.24_1"
    },
    "code": "EC-Z"
  },
  "673": {
    "gadm": {
      "name": "Ad Daqahliyah",
      "gid": "EGY.1_1"
    },
    "code": "EG-DK"
  },
  "674": {
    "gadm": {
      "name": "Al Bahr al Ahmar",
      "gid": "EGY.2_1"
    },
    "code": "EG-BA"
  },
  "675": {
    "gadm": {
      "name": "Al Buhayrah",
      "gid": "EGY.3_1"
    },
    "code": "EG-BH"
  },
  "676": {
    "gadm": {
      "name": "Al Fayyum",
      "gid": "EGY.4_1"
    },
    "code": "EG-FYM"
  },
  "677": {
    "gadm": {
      "name": "Al Gharbiyah",
      "gid": "EGY.5_1"
    },
    "code": "EG-GH"
  },
  "678": {
    "gadm": {
      "name": "Al Iskandariyah",
      "gid": "EGY.6_1"
    },
    "code": "EG-ALX"
  },
  "679": {
    "gadm": {
      "name": "Al Isma`iliyah",
      "gid": "EGY.7_1"
    },
    "code": "EG-IS"
  },
  "680": {
    "gadm": {
      "name": "Al Jizah",
      "gid": "EGY.8_1"
    },
    "code": "EG-GZ"
  },
  "681": {
    "gadm": {
      "name": "Al Minufiyah",
      "gid": "EGY.9_1"
    },
    "code": "EG-MNF"
  },
  "682": {
    "gadm": {
      "name": "Al Minya",
      "gid": "EGY.10_1"
    },
    "code": "EG-MN"
  },
  "683": {
    "gadm": {
      "name": "Al Qahirah",
      "gid": "EGY.11_1"
    },
    "code": "EG-C"
  },
  "684": {
    "gadm": {
      "name": "Al Qalyubiyah",
      "gid": "EGY.12_1"
    },
    "code": "EG-KB"
  },
  "685": {
    "gadm": {
      "name": "Al Uqsur",
      "gid": "EGY.13_1"
    },
    "code": "EG-LX"
  },
  "686": {
    "gadm": {
      "name": "Al Wadi al Jadid",
      "gid": "EGY.14_1"
    },
    "code": "EG-WAD"
  },
  "687": {
    "gadm": {
      "name": "As Suways",
      "gid": "EGY.15_1"
    },
    "code": "EG-SUZ"
  },
  "688": {
    "gadm": {
      "name": "Ash Sharqiyah",
      "gid": "EGY.16_1"
    },
    "code": "EG-SHR"
  },
  "689": {
    "gadm": {
      "name": "Aswan",
      "gid": "EGY.17_1"
    },
    "code": "EG-ASN"
  },
  "690": {
    "gadm": {
      "name": "Asyut",
      "gid": "EGY.18_1"
    },
    "code": "EG-AST"
  },
  "691": {
    "gadm": {
      "name": "Bani Suwayf",
      "gid": "EGY.19_1"
    },
    "code": "EG-BNS"
  },
  "692": {
    "gadm": {
      "name": "Bur Sa`id",
      "gid": "EGY.20_1"
    },
    "code": "EG-PTS"
  },
  "693": {
    "gadm": {
      "name": "Dumyat",
      "gid": "EGY.21_1"
    },
    "code": "EG-DT"
  },
  "694": {
    "gadm": {
      "name": "Janub Sina'",
      "gid": "EGY.22_1"
    },
    "code": "EG-JS"
  },
  "695": {
    "gadm": {
      "name": "Kafr ash Shaykh",
      "gid": "EGY.23_1"
    },
    "code": "EG-KFS"
  },
  "696": {
    "gadm": {
      "name": "Matrouh",
      "gid": "EGY.24_1"
    },
    "code": "EG-MT"
  },
  "697": {
    "gadm": {
      "name": "Qina",
      "gid": "EGY.25_1"
    },
    "code": "EG-KN"
  },
  "698": {
    "gadm": {
      "name": "Shamal Sina'",
      "gid": "EGY.26_1"
    },
    "code": "EG-SIN"
  },
  "699": {
    "gadm": {
      "name": "Suhaj",
      "gid": "EGY.27_1"
    },
    "code": "EG-SHG"
  },
  "700": {
    "gadm": {
      "name": "Anseba",
      "gid": "ERI.1_1"
    },
    "code": "ER-AN"
  },
  "701": {
    "gadm": {
      "name": "Debub",
      "gid": "ERI.2_1"
    },
    "code": "ER-DU"
  },
  "702": {
    "gadm": {
      "name": "Debubawi Keyih Bahri",
      "gid": "ERI.3_1"
    },
    "code": "ER-DK"
  },
  "703": {
    "gadm": {
      "name": "Gash Barka",
      "gid": "ERI.4_1"
    },
    "code": "ER-GB"
  },
  "704": {
    "gadm": {
      "name": "Maekel",
      "gid": "ERI.5_1"
    },
    "code": "ER-MA"
  },
  "705": {
    "gadm": {
      "name": "Semenawi Keyih Bahri",
      "gid": "ERI.6_1"
    },
    "code": "ER-SK"
  },
  "706": {
    "gadm": {
      "name": "Addis Abeba",
      "gid": "ETH.1_1"
    },
    "code": "ET-AA"
  },
  "707": {
    "gadm": {
      "name": "Afar",
      "gid": "ETH.2_1"
    },
    "code": "ET-AF"
  },
  "708": {
    "gadm": {
      "name": "Amhara",
      "gid": "ETH.3_1"
    },
    "code": "ET-AM"
  },
  "709": {
    "gadm": {
      "name": "Benshangul-Gumaz",
      "gid": "ETH.4_1"
    },
    "code": "ET-BE"
  },
  "710": {
    "gadm": {
      "name": "Dire Dawa",
      "gid": "ETH.5_1"
    },
    "code": "ET-DD"
  },
  "711": {
    "gadm": {
      "name": "Gambela Peoples",
      "gid": "ETH.6_1"
    },
    "code": "ET-GA"
  },
  "712": {
    "gadm": {
      "name": "Harari People",
      "gid": "ETH.7_1"
    },
    "code": "ET-HA"
  },
  "713": {
    "gadm": {
      "name": "Oromia",
      "gid": "ETH.8_1"
    },
    "code": "ET-OR"
  },
  "714": {
    "gadm": {
      "name": "Somali",
      "gid": "ETH.9_1"
    },
    "code": "ET-SO"
  },
  "715": {
    "gadm": {
      "name": "Southern Nations, Nationalities and Peoples",
      "gid": "ETH.10_1"
    },
    "code": "ET-SN"
  },
  "716": {
    "gadm": {
      "name": "Tigray",
      "gid": "ETH.11_1"
    },
    "code": "ET-TI"
  },
  "717": {
    "gadm": {
      "name": "Central",
      "gid": "FJI.1_1"
    },
    "code": "FJ-C"
  },
  "718": {
    "gadm": {
      "name": "Eastern",
      "gid": "FJI.2_1"
    },
    "code": "FJ-E"
  },
  "719": {
    "gadm": {
      "name": "Northern",
      "gid": "FJI.3_1"
    },
    "code": "FJ-N"
  },
  "720": {
    "gadm": {
      "name": "Rotuma",
      "gid": "FJI.4_1"
    },
    "code": "FJ-R"
  },
  "721": {
    "gadm": {
      "name": "Western",
      "gid": "FJI.5_1"
    },
    "code": "FJ-W"
  },
  "722": {
    "gadm": {
      "name": "Chuuk",
      "gid": "FSM.1_1"
    },
    "code": "FM-TRK"
  },
  "723": {
    "gadm": {
      "name": "Kosrae",
      "gid": "FSM.2_1"
    },
    "code": "FM-KSA"
  },
  "724": {
    "gadm": {
      "name": "Pohnpei",
      "gid": "FSM.3_1"
    },
    "code": "FM-PNI"
  },
  "725": {
    "gadm": {
      "name": "Yap",
      "gid": "FSM.4_1"
    },
    "code": "FM-YAP"
  },
  "726": {
    "gadm": {
      "name": "Estuaire",
      "gid": "GAB.1_1"
    },
    "code": "GA-1"
  },
  "727": {
    "gadm": {
      "name": "Haut-Ogoou\u00c3\u00a9",
      "gid": "GAB.2_1"
    },
    "code": "GA-2"
  },
  "728": {
    "gadm": {
      "name": "Moyen-Ogoou\u00c3\u00a9",
      "gid": "GAB.3_1"
    },
    "code": "GA-3"
  },
  "729": {
    "gadm": {
      "name": "Ngouni\u00c3\u00a9",
      "gid": "GAB.4_1"
    },
    "code": "GA-4"
  },
  "730": {
    "gadm": {
      "name": "Nyanga",
      "gid": "GAB.5_1"
    },
    "code": "GA-5"
  },
  "731": {
    "gadm": {
      "name": "Ogoou\u00c3\u00a9-Ivindo",
      "gid": "GAB.6_1"
    },
    "code": "GA-6"
  },
  "732": {
    "gadm": {
      "name": "Ogoou\u00c3\u00a9-Lolo",
      "gid": "GAB.7_1"
    },
    "code": "GA-7"
  },
  "733": {
    "gadm": {
      "name": "Ogoou\u00c3\u00a9-Maritime",
      "gid": "GAB.8_1"
    },
    "code": "GA-8"
  },
  "734": {
    "gadm": {
      "name": "Wouleu-Ntem",
      "gid": "GAB.9_1"
    },
    "code": "GA-9"
  },
  "735": {
    "gadm": {
      "name": "England",
      "gid": "GBR.1_1"
    },
    "code": "GBR.1_1"
  },
  "736": {
    "gadm": {
      "name": "Scotland",
      "gid": "GBR.3_1"
    },
    "code": "GBR.3_1"
  },
  "737": {
    "gadm": {
      "name": "Wales",
      "gid": "GBR.4_1"
    },
    "code": "GBR.4_1"
  },
  "738": {
    "gadm": {
      "name": "Northern Ireland",
      "gid": "GBR.2_1"
    },
    "code": "GBR.2_1"
  },
  "739": {
    "gadm": {
      "name": "Carriacou",
      "gid": "GRD.1_1"
    },
    "code": "GD-10"
  },
  "740": {
    "gadm": {
      "name": "Saint Andrew",
      "gid": "GRD.2_1"
    },
    "code": "GD-01"
  },
  "741": {
    "gadm": {
      "name": "Saint David",
      "gid": "GRD.3_1"
    },
    "code": "GD-02"
  },
  "742": {
    "gadm": {
      "name": "Saint George",
      "gid": "GRD.4_1"
    },
    "code": "GD-03"
  },
  "743": {
    "gadm": {
      "name": "Saint John",
      "gid": "GRD.5_1"
    },
    "code": "GD-04"
  },
  "744": {
    "gadm": {
      "name": "Saint Mark",
      "gid": "GRD.6_1"
    },
    "code": "GD-05"
  },
  "745": {
    "gadm": {
      "name": "Saint Patrick",
      "gid": "GRD.7_1"
    },
    "code": "GD-06"
  },
  "746": {
    "gadm": {
      "name": "Abkhazia",
      "gid": "GEO.1_1"
    },
    "code": "GE-AB"
  },
  "747": {
    "gadm": {
      "name": "Ajaria",
      "gid": "GEO.2_1"
    },
    "code": "GE-AJ"
  },
  "748": {
    "gadm": {
      "name": "Guria",
      "gid": "GEO.3_1"
    },
    "code": "GE-GU"
  },
  "749": {
    "gadm": {
      "name": "Imereti",
      "gid": "GEO.4_1"
    },
    "code": "GE-IM"
  },
  "750": {
    "gadm": {
      "name": "Kakheti",
      "gid": "GEO.5_1"
    },
    "code": "GE-KA"
  },
  "751": {
    "gadm": {
      "name": "Kvemo Kartli",
      "gid": "GEO.6_1"
    },
    "code": "GE-KK"
  },
  "752": {
    "gadm": {
      "name": "Mtskheta-Mtianeti",
      "gid": "GEO.7_1"
    },
    "code": "GE-MM"
  },
  "753": {
    "gadm": {
      "name": "Racha-Lechkhumi-Kvemo Svaneti",
      "gid": "GEO.8_1"
    },
    "code": "GE-RL"
  },
  "754": {
    "gadm": {
      "name": "Samegrelo-Zemo Svaneti",
      "gid": "GEO.9_1"
    },
    "code": "GE-SZ"
  },
  "755": {
    "gadm": {
      "name": "Samtskhe-Javakheti",
      "gid": "GEO.10_1"
    },
    "code": "GE-SJ"
  },
  "756": {
    "gadm": {
      "name": "Shida Kartli",
      "gid": "GEO.11_1"
    },
    "code": "GE-SK"
  },
  "757": {
    "gadm": {
      "name": "Tbilisi",
      "gid": "GEO.12_1"
    },
    "code": "GE-TB"
  },
  "758": {
    "gadm": {
      "name": "Ashanti",
      "gid": "GHA.1_1"
    },
    "code": "GHA.1_1"
  },
  "759": {
    "gadm": {
      "name": "Brong Ahafo",
      "gid": "GHA.2_1"
    },
    "code": "GHA.2_1"
  },
  "760": {
    "gadm": {
      "name": "Central",
      "gid": "GHA.3_1"
    },
    "code": "GHA.3_1"
  },
  "761": {
    "gadm": {
      "name": "Eastern",
      "gid": "GHA.4_1"
    },
    "code": "GHA.4_1"
  },
  "762": {
    "gadm": {
      "name": "Greater Accra",
      "gid": "GHA.5_1"
    },
    "code": "GHA.5_1"
  },
  "763": {
    "gadm": {
      "name": "Northern",
      "gid": "GHA.6_1"
    },
    "code": "GHA.6_1"
  },
  "764": {
    "gadm": {
      "name": "Upper East",
      "gid": "GHA.7_1"
    },
    "code": "GHA.7_1"
  },
  "765": {
    "gadm": {
      "name": "Upper West",
      "gid": "GHA.8_1"
    },
    "code": "GHA.8_1"
  },
  "766": {
    "gadm": {
      "name": "Volta",
      "gid": "GHA.9_1"
    },
    "code": "GHA.9_1"
  },
  "767": {
    "gadm": {
      "name": "Western",
      "gid": "GHA.10_1"
    },
    "code": "GHA.10_1"
  },
  "768": {
    "gadm": {
      "name": "Banjul",
      "gid": "GMB.1_1"
    },
    "code": "GM-B"
  },
  "769": {
    "gadm": {
      "name": "Lower River",
      "gid": "GMB.2_1"
    },
    "code": "GM-L"
  },
  "770": {
    "gadm": {
      "name": "Maccarthy Island",
      "gid": "GMB.3_1"
    },
    "code": "GM-M"
  },
  "771": {
    "gadm": {
      "name": "North Bank",
      "gid": "GMB.4_1"
    },
    "code": "GM-N"
  },
  "772": {
    "gadm": {
      "name": "Upper River",
      "gid": "GMB.5_1"
    },
    "code": "GM-U"
  },
  "773": {
    "gadm": {
      "name": "Western",
      "gid": "GMB.6_1"
    },
    "code": "GM-W"
  },
  "774": {
    "gadm": {
      "name": "Bok\u00c3\u00a9",
      "gid": "GIN.1_1"
    },
    "code": "GN-B"
  },
  "775": {
    "gadm": {
      "name": "Conakry",
      "gid": "GIN.2_1"
    },
    "code": "GN-C"
  },
  "776": {
    "gadm": {
      "name": "Faranah",
      "gid": "GIN.3_1"
    },
    "code": "GN-F"
  },
  "777": {
    "gadm": {
      "name": "Kankan",
      "gid": "GIN.4_1"
    },
    "code": "GN-K"
  },
  "778": {
    "gadm": {
      "name": "Kindia",
      "gid": "GIN.5_1"
    },
    "code": "GN-D"
  },
  "779": {
    "gadm": {
      "name": "Lab\u00c3\u00a9",
      "gid": "GIN.6_1"
    },
    "code": "GN-L"
  },
  "780": {
    "gadm": {
      "name": "Mamou",
      "gid": "GIN.7_1"
    },
    "code": "GN-M"
  },
  "781": {
    "gadm": {
      "name": "Nz\u00c3\u00a9r\u00c3\u00a9kor\u00c3\u00a9",
      "gid": "GIN.8_1"
    },
    "code": "GN-N"
  },
  "782": {
    "gadm": {
      "name": "Annob\u00c3\u00b3n",
      "gid": "GNQ.1_1"
    },
    "code": "GQ-I"
  },
  "783": {
    "gadm": {
      "name": "Centro Sur",
      "gid": "GNQ.4_1"
    },
    "code": "GQ-C"
  },
  "784": {
    "gadm": {
      "name": "Alta Verapaz",
      "gid": "GTM.1_1"
    },
    "code": "GT-AV"
  },
  "785": {
    "gadm": {
      "name": "Baja Verapaz",
      "gid": "GTM.2_1"
    },
    "code": "GT-BV"
  },
  "786": {
    "gadm": {
      "name": "Chimaltenango",
      "gid": "GTM.3_1"
    },
    "code": "GT-CM"
  },
  "787": {
    "gadm": {
      "name": "Chiquimula",
      "gid": "GTM.4_1"
    },
    "code": "GT-CQ"
  },
  "788": {
    "gadm": {
      "name": "El Progreso",
      "gid": "GTM.5_1"
    },
    "code": "GT-PR"
  },
  "789": {
    "gadm": {
      "name": "Escuintla",
      "gid": "GTM.6_1"
    },
    "code": "GT-ES"
  },
  "790": {
    "gadm": {
      "name": "Guatemala",
      "gid": "GTM.7_1"
    },
    "code": "GT-GU"
  },
  "791": {
    "gadm": {
      "name": "Huehuetenango",
      "gid": "GTM.8_1"
    },
    "code": "GT-HU"
  },
  "792": {
    "gadm": {
      "name": "Izabal",
      "gid": "GTM.9_1"
    },
    "code": "GT-IZ"
  },
  "793": {
    "gadm": {
      "name": "Jalapa",
      "gid": "GTM.10_1"
    },
    "code": "GT-JA"
  },
  "794": {
    "gadm": {
      "name": "Jutiapa",
      "gid": "GTM.11_1"
    },
    "code": "GT-JU"
  },
  "795": {
    "gadm": {
      "name": "Pet\u00c3\u00a9n",
      "gid": "GTM.12_1"
    },
    "code": "GT-PE"
  },
  "796": {
    "gadm": {
      "name": "Quezaltenango",
      "gid": "GTM.13_1"
    },
    "code": "GT-QZ"
  },
  "797": {
    "gadm": {
      "name": "Quich\u00c3\u00a9",
      "gid": "GTM.14_1"
    },
    "code": "GT-QC"
  },
  "798": {
    "gadm": {
      "name": "Retalhuleu",
      "gid": "GTM.15_1"
    },
    "code": "GT-RE"
  },
  "799": {
    "gadm": {
      "name": "Sacatep\u00c3\u00a9quez",
      "gid": "GTM.16_1"
    },
    "code": "GT-SA"
  },
  "800": {
    "gadm": {
      "name": "San Marcos",
      "gid": "GTM.17_1"
    },
    "code": "GT-SM"
  },
  "801": {
    "gadm": {
      "name": "Santa Rosa",
      "gid": "GTM.18_1"
    },
    "code": "GT-SR"
  },
  "802": {
    "gadm": {
      "name": "Solol\u00c3\u00a1",
      "gid": "GTM.19_1"
    },
    "code": "GT-SO"
  },
  "803": {
    "gadm": {
      "name": "Suchitep\u00c3\u00a9quez",
      "gid": "GTM.20_1"
    },
    "code": "GT-SU"
  },
  "804": {
    "gadm": {
      "name": "Totonicap\u00c3\u00a1n",
      "gid": "GTM.21_1"
    },
    "code": "GT-TO"
  },
  "805": {
    "gadm": {
      "name": "Zacapa",
      "gid": "GTM.22_1"
    },
    "code": "GT-ZA"
  },
  "806": {
    "gadm": {
      "name": "Bafat\u00c3\u00a1",
      "gid": "GNB.1_1"
    },
    "code": "GW-L"
  },
  "807": {
    "gadm": {
      "name": "Biombo",
      "gid": "GNB.2_1"
    },
    "code": "GW-N"
  },
  "808": {
    "gadm": {
      "name": "Bolama",
      "gid": "GNB.4_1"
    },
    "code": "GW-S"
  },
  "809": {
    "gadm": {
      "name": "Barima-Waini",
      "gid": "GUY.1_1"
    },
    "code": "GY-BA"
  },
  "810": {
    "gadm": {
      "name": "Cuyuni-Mazaruni",
      "gid": "GUY.2_1"
    },
    "code": "GY-CU"
  },
  "811": {
    "gadm": {
      "name": "Demerara-Mahaica",
      "gid": "GUY.3_1"
    },
    "code": "GY-DE"
  },
  "812": {
    "gadm": {
      "name": "East Berbice-Corentyne",
      "gid": "GUY.4_1"
    },
    "code": "GY-EB"
  },
  "813": {
    "gadm": {
      "name": "Essequibo Islands-West Demerara",
      "gid": "GUY.5_1"
    },
    "code": "GY-ES"
  },
  "814": {
    "gadm": {
      "name": "Mahaica-Berbice",
      "gid": "GUY.6_1"
    },
    "code": "GY-MA"
  },
  "815": {
    "gadm": {
      "name": "Pomeroon-Supenaam",
      "gid": "GUY.7_1"
    },
    "code": "GY-PM"
  },
  "816": {
    "gadm": {
      "name": "Potaro-Siparuni",
      "gid": "GUY.8_1"
    },
    "code": "GY-PT"
  },
  "817": {
    "gadm": {
      "name": "Upper Demerara-Berbice",
      "gid": "GUY.9_1"
    },
    "code": "GY-UD"
  },
  "818": {
    "gadm": {
      "name": "Upper Takutu-Upper Essequibo",
      "gid": "GUY.10_1"
    },
    "code": "GY-UT"
  },
  "819": {
    "gadm": {
      "name": "Atl\u00c3\u00a1ntida",
      "gid": "HND.1_1"
    },
    "code": "HN-AT"
  },
  "820": {
    "gadm": {
      "name": "Choluteca",
      "gid": "HND.2_1"
    },
    "code": "HN-CH"
  },
  "821": {
    "gadm": {
      "name": "Col\u00c3\u00b3n",
      "gid": "HND.3_1"
    },
    "code": "HN-CL"
  },
  "822": {
    "gadm": {
      "name": "Comayagua",
      "gid": "HND.4_1"
    },
    "code": "HN-CM"
  },
  "823": {
    "gadm": {
      "name": "Cop\u00c3\u00a1n",
      "gid": "HND.5_1"
    },
    "code": "HN-CP"
  },
  "824": {
    "gadm": {
      "name": "Cort\u00c3\u00a9s",
      "gid": "HND.6_1"
    },
    "code": "HN-CR"
  },
  "825": {
    "gadm": {
      "name": "El Para\u00c3\u00adso",
      "gid": "HND.7_1"
    },
    "code": "HN-EP"
  },
  "826": {
    "gadm": {
      "name": "Francisco Moraz\u00c3\u00a1n",
      "gid": "HND.8_1"
    },
    "code": "HN-FM"
  },
  "827": {
    "gadm": {
      "name": "Gracias a Dios",
      "gid": "HND.9_1"
    },
    "code": "HN-GD"
  },
  "828": {
    "gadm": {
      "name": "Intibuc\u00c3\u00a1",
      "gid": "HND.10_1"
    },
    "code": "HN-IN"
  },
  "829": {
    "gadm": {
      "name": "Islas de la Bah\u00c3\u00ada",
      "gid": "HND.11_1"
    },
    "code": "HN-IB"
  },
  "830": {
    "gadm": {
      "name": "La Paz",
      "gid": "HND.12_1"
    },
    "code": "HN-LP"
  },
  "831": {
    "gadm": {
      "name": "Lempira",
      "gid": "HND.13_1"
    },
    "code": "HN-LE"
  },
  "832": {
    "gadm": {
      "name": "Ocotepeque",
      "gid": "HND.14_1"
    },
    "code": "HN-OC"
  },
  "833": {
    "gadm": {
      "name": "Olancho",
      "gid": "HND.15_1"
    },
    "code": "HN-OL"
  },
  "834": {
    "gadm": {
      "name": "Santa B\u00c3\u00a1rbara",
      "gid": "HND.16_1"
    },
    "code": "HN-SB"
  },
  "835": {
    "gadm": {
      "name": "Valle",
      "gid": "HND.17_1"
    },
    "code": "HN-VA"
  },
  "836": {
    "gadm": {
      "name": "Yoro",
      "gid": "HND.18_1"
    },
    "code": "HN-YO"
  },
  "837": {
    "gadm": {
      "name": "Artibonite",
      "gid": "HTI.3_1"
    },
    "code": "HT-AR"
  },
  "838": {
    "gadm": {
      "name": "Centre",
      "gid": "HTI.1_1"
    },
    "code": "HT-CE"
  },
  "839": {
    "gadm": {
      "name": "Grand'Anse",
      "gid": "HTI.2_1"
    },
    "code": "HT-GA"
  },
  "840": {
    "gadm": {
      "name": "Nippes",
      "gid": "HTI.4_1"
    },
    "code": "HT-NI"
  },
  "841": {
    "gadm": {
      "name": "Nord",
      "gid": "HTI.7_1"
    },
    "code": "HT-ND"
  },
  "842": {
    "gadm": {
      "name": "Nord-Est",
      "gid": "HTI.5_1"
    },
    "code": "HT-NE"
  },
  "843": {
    "gadm": {
      "name": "Nord-Ouest",
      "gid": "HTI.6_1"
    },
    "code": "HT-NO"
  },
  "844": {
    "gadm": {
      "name": "Ouest",
      "gid": "HTI.8_1"
    },
    "code": "HT-OU"
  },
  "845": {
    "gadm": {
      "name": "Sud",
      "gid": "HTI.10_1"
    },
    "code": "HT-SD"
  },
  "846": {
    "gadm": {
      "name": "Sud-Est",
      "gid": "HTI.9_1"
    },
    "code": "HT-SE"
  },
  "847": {
    "gadm": {
      "name": "Aceh",
      "gid": "IDN.1_1"
    },
    "code": "ID-AC"
  },
  "848": {
    "gadm": {
      "name": "Bali",
      "gid": "IDN.32_1"
    },
    "code": "ID-BA"
  },
  "849": {
    "gadm": {
      "name": "Bangka-Belitung",
      "gid": "IDN.16_1"
    },
    "code": "ID-BB"
  },
  "850": {
    "gadm": {
      "name": "Banten",
      "gid": "IDN.27_1"
    },
    "code": "ID-BT"
  },
  "851": {
    "gadm": {
      "name": "Bengkulu",
      "gid": "IDN.21_1"
    },
    "code": "ID-BE"
  },
  "852": {
    "gadm": {
      "name": "Gorontalo",
      "gid": "IDN.7_1"
    },
    "code": "ID-GO"
  },
  "853": {
    "gadm": {
      "name": "Irian Jaya Barat",
      "gid": "IDN.15_1"
    },
    "code": "ID-PB"
  },
  "854": {
    "gadm": {
      "name": "Jakarta Raya",
      "gid": "IDN.26_1"
    },
    "code": "ID-JK"
  },
  "855": {
    "gadm": {
      "name": "Jambi",
      "gid": "IDN.14_1"
    },
    "code": "ID-JA"
  },
  "856": {
    "gadm": {
      "name": "Jawa Barat",
      "gid": "IDN.28_1"
    },
    "code": "ID-JB"
  },
  "857": {
    "gadm": {
      "name": "Jawa Tengah",
      "gid": "IDN.29_1"
    },
    "code": "ID-JT"
  },
  "858": {
    "gadm": {
      "name": "Jawa Timur",
      "gid": "IDN.30_1"
    },
    "code": "ID-JI"
  },
  "859": {
    "gadm": {
      "name": "Kalimantan Barat",
      "gid": "IDN.10_1"
    },
    "code": "ID-KB"
  },
  "860": {
    "gadm": {
      "name": "Kalimantan Selatan",
      "gid": "IDN.19_1"
    },
    "code": "ID-KS"
  },
  "861": {
    "gadm": {
      "name": "Kalimantan Tengah",
      "gid": "IDN.13_1"
    },
    "code": "ID-KT"
  },
  "862": {
    "gadm": {
      "name": "Kalimantan Timur",
      "gid": "IDN.8_1"
    },
    "code": "ID-KI"
  },
  "863": {
    "gadm": {
      "name": "Kalimantan Utara",
      "gid": "IDN.3_1"
    },
    "code": "ID-KU"
  },
  "864": {
    "gadm": {
      "name": "Kepulauan Riau",
      "gid": "IDN.2_1"
    },
    "code": "ID-KR"
  },
  "865": {
    "gadm": {
      "name": "Lampung",
      "gid": "IDN.25_1"
    },
    "code": "ID-LA"
  },
  "866": {
    "gadm": {
      "name": "Maluku",
      "gid": "IDN.18_1"
    },
    "code": "ID-MA"
  },
  "867": {
    "gadm": {
      "name": "Maluku Utara",
      "gid": "IDN.6_1"
    },
    "code": "ID-MU"
  },
  "868": {
    "gadm": {
      "name": "Nusa Tenggara Timur",
      "gid": "IDN.33_1"
    },
    "code": "ID-NT"
  },
  "869": {
    "gadm": {
      "name": "Papua",
      "gid": "IDN.24_1"
    },
    "code": "ID-PA"
  },
  "870": {
    "gadm": {
      "name": "Riau",
      "gid": "IDN.9_1"
    },
    "code": "ID-RI"
  },
  "871": {
    "gadm": {
      "name": "Sulawesi Barat",
      "gid": "IDN.17_1"
    },
    "code": "ID-SR"
  },
  "872": {
    "gadm": {
      "name": "Sulawesi Selatan",
      "gid": "IDN.23_1"
    },
    "code": "ID-SN"
  },
  "873": {
    "gadm": {
      "name": "Sulawesi Tengah",
      "gid": "IDN.12_1"
    },
    "code": "ID-ST"
  },
  "874": {
    "gadm": {
      "name": "Sulawesi Tenggara",
      "gid": "IDN.22_1"
    },
    "code": "ID-SG"
  },
  "875": {
    "gadm": {
      "name": "Sulawesi Utara",
      "gid": "IDN.5_1"
    },
    "code": "ID-SA"
  },
  "876": {
    "gadm": {
      "name": "Sumatera Barat",
      "gid": "IDN.11_1"
    },
    "code": "ID-SB"
  },
  "877": {
    "gadm": {
      "name": "Sumatera Selatan",
      "gid": "IDN.20_1"
    },
    "code": "ID-SS"
  },
  "878": {
    "gadm": {
      "name": "Sumatera Utara",
      "gid": "IDN.4_1"
    },
    "code": "ID-SU"
  },
  "879": {
    "gadm": {
      "name": "Yogyakarta",
      "gid": "IDN.31_1"
    },
    "code": "ID-YO"
  },
  "880": {
    "gadm": {
      "name": "Golan",
      "gid": "ISR.1_1"
    },
    "code": "ISR.1_1"
  },
  "881": {
    "gadm": {
      "name": "HaDarom",
      "gid": "ISR.2_1"
    },
    "code": "IL-D"
  },
  "882": {
    "gadm": {
      "name": "Haifa",
      "gid": "ISR.3_1"
    },
    "code": "IL-HA"
  },
  "883": {
    "gadm": {
      "name": "HaMerkaz",
      "gid": "ISR.4_1"
    },
    "code": "IL-M"
  },
  "884": {
    "gadm": {
      "name": "HaZafon",
      "gid": "ISR.5_1"
    },
    "code": "IL-Z"
  },
  "885": {
    "gadm": {
      "name": "Jerusalem",
      "gid": "ISR.6_1"
    },
    "code": "IL-JM"
  },
  "886": {
    "gadm": {
      "name": "Tel Aviv",
      "gid": "ISR.7_1"
    },
    "code": "IL-TA"
  },
  "887": {
    "gadm": {
      "name": "Andaman and Nicobar",
      "gid": "IND.1_1"
    },
    "code": "IN-AN"
  },
  "888": {
    "gadm": {
      "name": "Andhra Pradesh",
      "gid": "IND.2_1"
    },
    "code": "IN-AP"
  },
  "889": {
    "gadm": {
      "name": "Arunachal Pradesh",
      "gid": "IND.3_1"
    },
    "code": "IN-AR"
  },
  "890": {
    "gadm": {
      "name": "Assam",
      "gid": "IND.4_1"
    },
    "code": "IN-AS"
  },
  "891": {
    "gadm": {
      "name": "Bihar",
      "gid": "IND.5_1"
    },
    "code": "IN-BR"
  },
  "892": {
    "gadm": {
      "name": "Chandigarh",
      "gid": "IND.6_1"
    },
    "code": "IN-CH"
  },
  "893": {
    "gadm": {
      "name": "Chhattisgarh",
      "gid": "IND.7_1"
    },
    "code": "IN-CT"
  },
  "894": {
    "gadm": {
      "name": "Dadra and Nagar Haveli",
      "gid": "IND.8_1"
    },
    "code": "IN-DN"
  },
  "895": {
    "gadm": {
      "name": "NCT of Delhi",
      "gid": "IND.25_1"
    },
    "code": "IN-DL"
  },
  "896": {
    "gadm": {
      "name": "Goa",
      "gid": "IND.10_1"
    },
    "code": "IN-GA"
  },
  "897": {
    "gadm": {
      "name": "Gujarat",
      "gid": "IND.11_1"
    },
    "code": "IN-GJ"
  },
  "898": {
    "gadm": {
      "name": "Haryana",
      "gid": "IND.12_1"
    },
    "code": "IN-HR"
  },
  "899": {
    "gadm": {
      "name": "Himachal Pradesh",
      "gid": "IND.13_1"
    },
    "code": "IN-HP"
  },
  "900": {
    "gadm": {
      "name": "Jammu and Kashmir",
      "gid": "IND.14_1"
    },
    "code": "IN-JK"
  },
  "901": {
    "gadm": {
      "name": "Jharkhand",
      "gid": "IND.15_1"
    },
    "code": "IN-JH"
  },
  "902": {
    "gadm": {
      "name": "Karnataka",
      "gid": "IND.16_1"
    },
    "code": "IN-KA"
  },
  "903": {
    "gadm": {
      "name": "Kerala",
      "gid": "IND.17_1"
    },
    "code": "IN-KL"
  },
  "904": {
    "gadm": {
      "name": "Lakshadweep",
      "gid": "IND.18_1"
    },
    "code": "IN-LD"
  },
  "905": {
    "gadm": {
      "name": "Madhya Pradesh",
      "gid": "IND.19_1"
    },
    "code": "IN-MP"
  },
  "906": {
    "gadm": {
      "name": "Maharashtra",
      "gid": "IND.20_1"
    },
    "code": "IN-MH"
  },
  "907": {
    "gadm": {
      "name": "Manipur",
      "gid": "IND.21_1"
    },
    "code": "IN-MN"
  },
  "908": {
    "gadm": {
      "name": "Meghalaya",
      "gid": "IND.22_1"
    },
    "code": "IN-ML"
  },
  "909": {
    "gadm": {
      "name": "Mizoram",
      "gid": "IND.23_1"
    },
    "code": "IN-MZ"
  },
  "910": {
    "gadm": {
      "name": "Nagaland",
      "gid": "IND.24_1"
    },
    "code": "IN-NL"
  },
  "911": {
    "gadm": {
      "name": "Odisha",
      "gid": "IND.26_1"
    },
    "code": "IN-OR"
  },
  "912": {
    "gadm": {
      "name": "Puducherry",
      "gid": "IND.27_1"
    },
    "code": "IN-PY"
  },
  "913": {
    "gadm": {
      "name": "Punjab",
      "gid": "IND.28_1"
    },
    "code": "IN-PB"
  },
  "914": {
    "gadm": {
      "name": "Rajasthan",
      "gid": "IND.29_1"
    },
    "code": "IN-RJ"
  },
  "915": {
    "gadm": {
      "name": "Sikkim",
      "gid": "IND.30_1"
    },
    "code": "IN-SK"
  },
  "916": {
    "gadm": {
      "name": "Tamil Nadu",
      "gid": "IND.31_1"
    },
    "code": "IN-TN"
  },
  "917": {
    "gadm": {
      "name": "Telangana",
      "gid": "IND.32_1"
    },
    "code": "IN-TG"
  },
  "918": {
    "gadm": {
      "name": "Tripura",
      "gid": "IND.33_1"
    },
    "code": "IN-TR"
  },
  "919": {
    "gadm": {
      "name": "Uttar Pradesh",
      "gid": "IND.34_1"
    },
    "code": "IN-UP"
  },
  "920": {
    "gadm": {
      "name": "Uttarakhand",
      "gid": "IND.35_1"
    },
    "code": "IN-UT"
  },
  "921": {
    "gadm": {
      "name": "West Bengal",
      "gid": "IND.36_1"
    },
    "code": "IN-WB"
  },
  "922": {
    "gadm": {
      "name": "Al-Anbar",
      "gid": "IRQ.1_1"
    },
    "code": "IQ-AN"
  },
  "923": {
    "gadm": {
      "name": "Al-Basrah",
      "gid": "IRQ.2_1"
    },
    "code": "IQ-BA"
  },
  "924": {
    "gadm": {
      "name": "Al-Muthannia",
      "gid": "IRQ.3_1"
    },
    "code": "IQ-MU"
  },
  "925": {
    "gadm": {
      "name": "Al-Qadisiyah",
      "gid": "IRQ.4_1"
    },
    "code": "IQ-QA"
  },
  "926": {
    "gadm": {
      "name": "An-Najaf",
      "gid": "IRQ.5_1"
    },
    "code": "IQ-NA"
  },
  "927": {
    "gadm": {
      "name": "Arbil",
      "gid": "IRQ.6_1"
    },
    "code": "IQ-AR"
  },
  "928": {
    "gadm": {
      "name": "As-Sulaymaniyah",
      "gid": "IRQ.7_1"
    },
    "code": "IQ-SU"
  },
  "929": {
    "gadm": {
      "name": "At-Ta'mim",
      "gid": "IRQ.8_1"
    },
    "code": "IQ-KI"
  },
  "930": {
    "gadm": {
      "name": "Babil",
      "gid": "IRQ.9_1"
    },
    "code": "IQ-BB"
  },
  "931": {
    "gadm": {
      "name": "Baghdad",
      "gid": "IRQ.10_1"
    },
    "code": "IQ-BG"
  },
  "932": {
    "gadm": {
      "name": "Dhi-Qar",
      "gid": "IRQ.11_1"
    },
    "code": "IQ-DQ"
  },
  "933": {
    "gadm": {
      "name": "Dihok",
      "gid": "IRQ.12_1"
    },
    "code": "IQ-DA"
  },
  "934": {
    "gadm": {
      "name": "Diyala",
      "gid": "IRQ.13_1"
    },
    "code": "IQ-DI"
  },
  "935": {
    "gadm": {
      "name": "Karbala'",
      "gid": "IRQ.14_1"
    },
    "code": "IQ-KA"
  },
  "936": {
    "gadm": {
      "name": "Maysan",
      "gid": "IRQ.15_1"
    },
    "code": "IQ-MA"
  },
  "937": {
    "gadm": {
      "name": "Ninawa",
      "gid": "IRQ.16_1"
    },
    "code": "IQ-NI"
  },
  "938": {
    "gadm": {
      "name": "Sala ad-Din",
      "gid": "IRQ.17_1"
    },
    "code": "IQ-SD"
  },
  "939": {
    "gadm": {
      "name": "Wasit",
      "gid": "IRQ.18_1"
    },
    "code": "IQ-WA"
  },
  "940": {
    "gadm": {
      "name": "Alborz",
      "gid": "IRN.1_1"
    },
    "code": "IR-32"
  },
  "941": {
    "gadm": {
      "name": "Ardebil",
      "gid": "IRN.2_1"
    },
    "code": "IR-03"
  },
  "942": {
    "gadm": {
      "name": "Bushehr",
      "gid": "IRN.3_1"
    },
    "code": "IR-06"
  },
  "943": {
    "gadm": {
      "name": "Chahar Mahall and Bakhtiari",
      "gid": "IRN.4_1"
    },
    "code": "IR-08"
  },
  "944": {
    "gadm": {
      "name": "East Azarbaijan",
      "gid": "IRN.5_1"
    },
    "code": "IR-01"
  },
  "945": {
    "gadm": {
      "name": "Esfahan",
      "gid": "IRN.6_1"
    },
    "code": "IR-04"
  },
  "946": {
    "gadm": {
      "name": "Fars",
      "gid": "IRN.7_1"
    },
    "code": "IR-14"
  },
  "947": {
    "gadm": {
      "name": "Gilan",
      "gid": "IRN.8_1"
    },
    "code": "IR-19"
  },
  "948": {
    "gadm": {
      "name": "Golestan",
      "gid": "IRN.9_1"
    },
    "code": "IR-27"
  },
  "949": {
    "gadm": {
      "name": "Hamadan",
      "gid": "IRN.10_1"
    },
    "code": "IR-24"
  },
  "950": {
    "gadm": {
      "name": "Hormozgan",
      "gid": "IRN.11_1"
    },
    "code": "IR-23"
  },
  "951": {
    "gadm": {
      "name": "Ilam",
      "gid": "IRN.12_1"
    },
    "code": "IR-05"
  },
  "952": {
    "gadm": {
      "name": "Kerman",
      "gid": "IRN.13_1"
    },
    "code": "IR-15"
  },
  "953": {
    "gadm": {
      "name": "Kermanshah",
      "gid": "IRN.14_1"
    },
    "code": "IR-17"
  },
  "954": {
    "gadm": {
      "name": "Khuzestan",
      "gid": "IRN.15_1"
    },
    "code": "IR-10"
  },
  "955": {
    "gadm": {
      "name": "Kohgiluyeh and Buyer Ahmad",
      "gid": "IRN.16_1"
    },
    "code": "IR-18"
  },
  "956": {
    "gadm": {
      "name": "Kordestan",
      "gid": "IRN.17_1"
    },
    "code": "IR-16"
  },
  "957": {
    "gadm": {
      "name": "Lorestan",
      "gid": "IRN.18_1"
    },
    "code": "IR-20"
  },
  "958": {
    "gadm": {
      "name": "Markazi",
      "gid": "IRN.19_1"
    },
    "code": "IR-22"
  },
  "959": {
    "gadm": {
      "name": "Mazandaran",
      "gid": "IRN.20_1"
    },
    "code": "IR-21"
  },
  "960": {
    "gadm": {
      "name": "North Khorasan",
      "gid": "IRN.21_1"
    },
    "code": "IR-31"
  },
  "961": {
    "gadm": {
      "name": "Qazvin",
      "gid": "IRN.22_1"
    },
    "code": "IR-28"
  },
  "962": {
    "gadm": {
      "name": "Qom",
      "gid": "IRN.23_1"
    },
    "code": "IR-26"
  },
  "963": {
    "gadm": {
      "name": "Razavi Khorasan",
      "gid": "IRN.24_1"
    },
    "code": "IR-30"
  },
  "964": {
    "gadm": {
      "name": "Semnan",
      "gid": "IRN.25_1"
    },
    "code": "IR-12"
  },
  "965": {
    "gadm": {
      "name": "Sistan and Baluchestan",
      "gid": "IRN.26_1"
    },
    "code": "IR-13"
  },
  "966": {
    "gadm": {
      "name": "South Khorasan",
      "gid": "IRN.27_1"
    },
    "code": "IR-29"
  },
  "967": {
    "gadm": {
      "name": "Tehran",
      "gid": "IRN.28_1"
    },
    "code": "IR-07"
  },
  "968": {
    "gadm": {
      "name": "West Azarbaijan",
      "gid": "IRN.29_1"
    },
    "code": "IR-02"
  },
  "969": {
    "gadm": {
      "name": "Yazd",
      "gid": "IRN.30_1"
    },
    "code": "IR-25"
  },
  "970": {
    "gadm": {
      "name": "Zanjan",
      "gid": "IRN.31_1"
    },
    "code": "IR-11"
  },
  "971": {
    "gadm": {
      "name": "Austurland",
      "gid": "ISL.1_1"
    },
    "code": "IS-7"
  },
  "972": {
    "gadm": {
      "name": "H\u00c3\u00a1lshreppur",
      "gid": "ISL.2_1"
    },
    "code": "IS-6"
  },
  "973": {
    "gadm": {
      "name": "H\u00c3\u00b6fu\u00c3\u00b0borgarsv\u00c3\u00a6\u00c3\u00b0i",
      "gid": "ISL.3_1"
    },
    "code": "IS-1"
  },
  "974": {
    "gadm": {
      "name": "Nor\u00c3\u00b0urland vestra",
      "gid": "ISL.4_1"
    },
    "code": "IS-5"
  },
  "975": {
    "gadm": {
      "name": "Su\u00c3\u00b0urland",
      "gid": "ISL.5_1"
    },
    "code": "IS-8"
  },
  "976": {
    "gadm": {
      "name": "Su\u00c3\u00b0urnes",
      "gid": "ISL.6_1"
    },
    "code": "IS-2"
  },
  "977": {
    "gadm": {
      "name": "Vestfir\u00c3\u00b0ir",
      "gid": "ISL.7_1"
    },
    "code": "IS-4"
  },
  "978": {
    "gadm": {
      "name": "Vesturland",
      "gid": "ISL.8_1"
    },
    "code": "IS-3"
  },
  "979": {
    "gadm": {
      "name": "Clarendon",
      "gid": "JAM.1_1"
    },
    "code": "JM-13"
  },
  "980": {
    "gadm": {
      "name": "Hanover",
      "gid": "JAM.2_1"
    },
    "code": "JM-09"
  },
  "981": {
    "gadm": {
      "name": "Kingston",
      "gid": "JAM.3_1"
    },
    "code": "JM-01"
  },
  "982": {
    "gadm": {
      "name": "Manchester",
      "gid": "JAM.4_1"
    },
    "code": "JM-12"
  },
  "983": {
    "gadm": {
      "name": "Portland",
      "gid": "JAM.5_1"
    },
    "code": "JM-04"
  },
  "984": {
    "gadm": {
      "name": "Saint Andrew",
      "gid": "JAM.6_1"
    },
    "code": "JM-02"
  },
  "985": {
    "gadm": {
      "name": "Saint Ann",
      "gid": "JAM.7_1"
    },
    "code": "JM-06"
  },
  "986": {
    "gadm": {
      "name": "Saint Catherine",
      "gid": "JAM.8_1"
    },
    "code": "JM-14"
  },
  "987": {
    "gadm": {
      "name": "Saint Elizabeth",
      "gid": "JAM.9_1"
    },
    "code": "JM-11"
  },
  "988": {
    "gadm": {
      "name": "Saint James",
      "gid": "JAM.10_1"
    },
    "code": "JM-08"
  },
  "989": {
    "gadm": {
      "name": "Saint Mary",
      "gid": "JAM.11_1"
    },
    "code": "JM-05"
  },
  "990": {
    "gadm": {
      "name": "Saint Thomas",
      "gid": "JAM.12_1"
    },
    "code": "JM-03"
  },
  "991": {
    "gadm": {
      "name": "Trelawny",
      "gid": "JAM.13_1"
    },
    "code": "JM-07"
  },
  "992": {
    "gadm": {
      "name": "Westmoreland",
      "gid": "JAM.14_1"
    },
    "code": "JM-10"
  },
  "993": {
    "gadm": {
      "name": "Ajlun",
      "gid": "JOR.1_1"
    },
    "code": "JO-AJ"
  },
  "994": {
    "gadm": {
      "name": "Amman",
      "gid": "JOR.2_1"
    },
    "code": "JO-AM"
  },
  "995": {
    "gadm": {
      "name": "Aqaba",
      "gid": "JOR.3_1"
    },
    "code": "JO-AQ"
  },
  "996": {
    "gadm": {
      "name": "Balqa",
      "gid": "JOR.4_1"
    },
    "code": "JO-BA"
  },
  "997": {
    "gadm": {
      "name": "Irbid",
      "gid": "JOR.5_1"
    },
    "code": "JO-IR"
  },
  "998": {
    "gadm": {
      "name": "Jarash",
      "gid": "JOR.6_1"
    },
    "code": "JO-JA"
  },
  "999": {
    "gadm": {
      "name": "Karak",
      "gid": "JOR.7_1"
    },
    "code": "JO-KA"
  },
  "1000": {
    "gadm": {
      "name": "Ma`an",
      "gid": "JOR.8_1"
    },
    "code": "JO-MN"
  },
  "1001": {
    "gadm": {
      "name": "Madaba",
      "gid": "JOR.9_1"
    },
    "code": "JO-MD"
  },
  "1002": {
    "gadm": {
      "name": "Mafraq",
      "gid": "JOR.10_1"
    },
    "code": "JO-MA"
  },
  "1003": {
    "gadm": {
      "name": "Tafilah",
      "gid": "JOR.11_1"
    },
    "code": "JO-AT"
  },
  "1004": {
    "gadm": {
      "name": "Zarqa",
      "gid": "JOR.12_1"
    },
    "code": "JO-AZ"
  },
  "1005": {
    "gadm": {
      "name": "Aichi",
      "gid": "JPN.1_1"
    },
    "code": "JP-23"
  },
  "1006": {
    "gadm": {
      "name": "Akita",
      "gid": "JPN.2_1"
    },
    "code": "JP-05"
  },
  "1007": {
    "gadm": {
      "name": "Aomori",
      "gid": "JPN.3_1"
    },
    "code": "JP-02"
  },
  "1008": {
    "gadm": {
      "name": "Chiba",
      "gid": "JPN.4_1"
    },
    "code": "JP-12"
  },
  "1009": {
    "gadm": {
      "name": "Ehime",
      "gid": "JPN.5_1"
    },
    "code": "JP-38"
  },
  "1010": {
    "gadm": {
      "name": "Fukui",
      "gid": "JPN.6_1"
    },
    "code": "JP-18"
  },
  "1011": {
    "gadm": {
      "name": "Fukuoka",
      "gid": "JPN.7_1"
    },
    "code": "JP-40"
  },
  "1012": {
    "gadm": {
      "name": "Fukushima",
      "gid": "JPN.8_1"
    },
    "code": "JP-07"
  },
  "1013": {
    "gadm": {
      "name": "Gifu",
      "gid": "JPN.9_1"
    },
    "code": "JP-21"
  },
  "1014": {
    "gadm": {
      "name": "Gunma",
      "gid": "JPN.10_1"
    },
    "code": "JP-10"
  },
  "1015": {
    "gadm": {
      "name": "Hiroshima",
      "gid": "JPN.11_1"
    },
    "code": "JP-34"
  },
  "1016": {
    "gadm": {
      "name": "Hokkaido",
      "gid": "JPN.12_1"
    },
    "code": "JP-01"
  },
  "1017": {
    "gadm": {
      "name": "Hy\u00c3\u2026\u00c2\u008dgo",
      "gid": "JPN.13_1"
    },
    "code": "JP-28"
  },
  "1018": {
    "gadm": {
      "name": "Ibaraki",
      "gid": "JPN.14_1"
    },
    "code": "JP-08"
  },
  "1019": {
    "gadm": {
      "name": "Ishikawa",
      "gid": "JPN.15_1"
    },
    "code": "JP-17"
  },
  "1020": {
    "gadm": {
      "name": "Iwate",
      "gid": "JPN.16_1"
    },
    "code": "JP-03"
  },
  "1021": {
    "gadm": {
      "name": "Kagawa",
      "gid": "JPN.17_1"
    },
    "code": "JP-37"
  },
  "1022": {
    "gadm": {
      "name": "Kagoshima",
      "gid": "JPN.18_1"
    },
    "code": "JP-46"
  },
  "1023": {
    "gadm": {
      "name": "Kanagawa",
      "gid": "JPN.19_1"
    },
    "code": "JP-14"
  },
  "1024": {
    "gadm": {
      "name": "Kochi",
      "gid": "JPN.20_1"
    },
    "code": "JP-39"
  },
  "1025": {
    "gadm": {
      "name": "Kumamoto",
      "gid": "JPN.21_1"
    },
    "code": "JP-43"
  },
  "1026": {
    "gadm": {
      "name": "Kyoto",
      "gid": "JPN.22_1"
    },
    "code": "JP-26"
  },
  "1027": {
    "gadm": {
      "name": "Mie",
      "gid": "JPN.23_1"
    },
    "code": "JP-24"
  },
  "1028": {
    "gadm": {
      "name": "Miyagi",
      "gid": "JPN.24_1"
    },
    "code": "JP-04"
  },
  "1029": {
    "gadm": {
      "name": "Miyazaki",
      "gid": "JPN.25_1"
    },
    "code": "JP-45"
  },
  "1030": {
    "gadm": {
      "name": "Nagano",
      "gid": "JPN.26_1"
    },
    "code": "JP-20"
  },
  "1031": {
    "gadm": {
      "name": "Naoasaki",
      "gid": "JPN.27_1"
    },
    "code": "JP-42"
  },
  "1032": {
    "gadm": {
      "name": "Nara",
      "gid": "JPN.28_1"
    },
    "code": "JP-29"
  },
  "1033": {
    "gadm": {
      "name": "Niigata",
      "gid": "JPN.29_1"
    },
    "code": "JP-15"
  },
  "1034": {
    "gadm": {
      "name": "Oita",
      "gid": "JPN.30_1"
    },
    "code": "JP-44"
  },
  "1035": {
    "gadm": {
      "name": "Okayama",
      "gid": "JPN.31_1"
    },
    "code": "JP-33"
  },
  "1036": {
    "gadm": {
      "name": "Okinawa",
      "gid": "JPN.32_1"
    },
    "code": "JP-47"
  },
  "1037": {
    "gadm": {
      "name": "Osaka",
      "gid": "JPN.33_1"
    },
    "code": "JP-27"
  },
  "1038": {
    "gadm": {
      "name": "Saga",
      "gid": "JPN.34_1"
    },
    "code": "JP-41"
  },
  "1039": {
    "gadm": {
      "name": "Saitama",
      "gid": "JPN.35_1"
    },
    "code": "JP-11"
  },
  "1040": {
    "gadm": {
      "name": "Shiga",
      "gid": "JPN.36_1"
    },
    "code": "JP-25"
  },
  "1041": {
    "gadm": {
      "name": "Shimane",
      "gid": "JPN.37_1"
    },
    "code": "JP-32"
  },
  "1042": {
    "gadm": {
      "name": "Shizuoka",
      "gid": "JPN.38_1"
    },
    "code": "JP-22"
  },
  "1043": {
    "gadm": {
      "name": "Tochigi",
      "gid": "JPN.39_1"
    },
    "code": "JP-09"
  },
  "1044": {
    "gadm": {
      "name": "Tokushima",
      "gid": "JPN.40_1"
    },
    "code": "JP-36"
  },
  "1045": {
    "gadm": {
      "name": "Tokyo",
      "gid": "JPN.41_1"
    },
    "code": "JP-13"
  },
  "1046": {
    "gadm": {
      "name": "Tottori",
      "gid": "JPN.42_1"
    },
    "code": "JP-31"
  },
  "1047": {
    "gadm": {
      "name": "Toyama",
      "gid": "JPN.43_1"
    },
    "code": "JP-16"
  },
  "1048": {
    "gadm": {
      "name": "Wakayama",
      "gid": "JPN.44_1"
    },
    "code": "JP-30"
  },
  "1049": {
    "gadm": {
      "name": "Yamagata",
      "gid": "JPN.45_1"
    },
    "code": "JP-06"
  },
  "1050": {
    "gadm": {
      "name": "Yamaguchi",
      "gid": "JPN.46_1"
    },
    "code": "JP-35"
  },
  "1051": {
    "gadm": {
      "name": "Yamanashi",
      "gid": "JPN.47_1"
    },
    "code": "JP-19"
  },
  "1052": {
    "gadm": {
      "name": "Baringo",
      "gid": "KEN.1_1"
    },
    "code": "KE-01"
  },
  "1053": {
    "gadm": {
      "name": "Bomet",
      "gid": "KEN.2_1"
    },
    "code": "KE-02"
  },
  "1054": {
    "gadm": {
      "name": "Bungoma",
      "gid": "KEN.3_1"
    },
    "code": "KE-03"
  },
  "1055": {
    "gadm": {
      "name": "Busia",
      "gid": "KEN.4_1"
    },
    "code": "KE-04"
  },
  "1056": {
    "gadm": {
      "name": "Elgeyo-Marakwet",
      "gid": "KEN.5_1"
    },
    "code": "KE-05"
  },
  "1057": {
    "gadm": {
      "name": "Embu",
      "gid": "KEN.6_1"
    },
    "code": "KE-06"
  },
  "1058": {
    "gadm": {
      "name": "Garissa",
      "gid": "KEN.7_1"
    },
    "code": "KE-07"
  },
  "1059": {
    "gadm": {
      "name": "Homa Bay",
      "gid": "KEN.8_1"
    },
    "code": "KE-08"
  },
  "1060": {
    "gadm": {
      "name": "Isiolo",
      "gid": "KEN.9_1"
    },
    "code": "KE-09"
  },
  "1061": {
    "gadm": {
      "name": "Kajiado",
      "gid": "KEN.10_1"
    },
    "code": "KE-10"
  },
  "1062": {
    "gadm": {
      "name": "Kakamega",
      "gid": "KEN.11_1"
    },
    "code": "KE-11"
  },
  "1063": {
    "gadm": {
      "name": "Kericho",
      "gid": "KEN.12_1"
    },
    "code": "KE-12"
  },
  "1064": {
    "gadm": {
      "name": "Kiambu",
      "gid": "KEN.13_1"
    },
    "code": "KE-13"
  },
  "1065": {
    "gadm": {
      "name": "Kilifi",
      "gid": "KEN.14_1"
    },
    "code": "KE-14"
  },
  "1066": {
    "gadm": {
      "name": "Kirinyaga",
      "gid": "KEN.15_1"
    },
    "code": "KE-15"
  },
  "1067": {
    "gadm": {
      "name": "Kisii",
      "gid": "KEN.16_1"
    },
    "code": "KE-16"
  },
  "1068": {
    "gadm": {
      "name": "Kisumu",
      "gid": "KEN.17_1"
    },
    "code": "KE-17"
  },
  "1069": {
    "gadm": {
      "name": "Kitui",
      "gid": "KEN.18_1"
    },
    "code": "KE-18"
  },
  "1070": {
    "gadm": {
      "name": "Kwale",
      "gid": "KEN.19_1"
    },
    "code": "KE-19"
  },
  "1071": {
    "gadm": {
      "name": "Laikipia",
      "gid": "KEN.20_1"
    },
    "code": "KE-20"
  },
  "1072": {
    "gadm": {
      "name": "Lamu",
      "gid": "KEN.21_1"
    },
    "code": "KE-21"
  },
  "1073": {
    "gadm": {
      "name": "Machakos",
      "gid": "KEN.22_1"
    },
    "code": "KE-22"
  },
  "1074": {
    "gadm": {
      "name": "Makueni",
      "gid": "KEN.23_1"
    },
    "code": "KE-23"
  },
  "1075": {
    "gadm": {
      "name": "Mandera",
      "gid": "KEN.24_1"
    },
    "code": "KE-24"
  },
  "1076": {
    "gadm": {
      "name": "Marsabit",
      "gid": "KEN.25_1"
    },
    "code": "KE-25"
  },
  "1077": {
    "gadm": {
      "name": "Meru",
      "gid": "KEN.26_1"
    },
    "code": "KE-26"
  },
  "1078": {
    "gadm": {
      "name": "Migori",
      "gid": "KEN.27_1"
    },
    "code": "KE-27"
  },
  "1079": {
    "gadm": {
      "name": "Mombasa",
      "gid": "KEN.28_1"
    },
    "code": "KE-28"
  },
  "1080": {
    "gadm": {
      "name": "Murang'a",
      "gid": "KEN.29_1"
    },
    "code": "KE-29"
  },
  "1081": {
    "gadm": {
      "name": "Nairobi",
      "gid": "KEN.30_1"
    },
    "code": "KE-30"
  },
  "1082": {
    "gadm": {
      "name": "Nakuru",
      "gid": "KEN.31_1"
    },
    "code": "KE-31"
  },
  "1083": {
    "gadm": {
      "name": "Nandi",
      "gid": "KEN.32_1"
    },
    "code": "KE-32"
  },
  "1084": {
    "gadm": {
      "name": "Narok",
      "gid": "KEN.33_1"
    },
    "code": "KE-33"
  },
  "1085": {
    "gadm": {
      "name": "Nyamira",
      "gid": "KEN.34_1"
    },
    "code": "KE-34"
  },
  "1086": {
    "gadm": {
      "name": "Nyandarua",
      "gid": "KEN.35_1"
    },
    "code": "KE-35"
  },
  "1087": {
    "gadm": {
      "name": "Nyeri",
      "gid": "KEN.36_1"
    },
    "code": "KE-36"
  },
  "1088": {
    "gadm": {
      "name": "Samburu",
      "gid": "KEN.37_1"
    },
    "code": "KE-37"
  },
  "1089": {
    "gadm": {
      "name": "Siaya",
      "gid": "KEN.38_1"
    },
    "code": "KE-38"
  },
  "1090": {
    "gadm": {
      "name": "Taita Taveta",
      "gid": "KEN.39_1"
    },
    "code": "KE-39"
  },
  "1091": {
    "gadm": {
      "name": "Tana River",
      "gid": "KEN.40_1"
    },
    "code": "KE-40"
  },
  "1092": {
    "gadm": {
      "name": "Tharaka-Nithi",
      "gid": "KEN.41_1"
    },
    "code": "KE-41"
  },
  "1093": {
    "gadm": {
      "name": "Trans Nzoia",
      "gid": "KEN.42_1"
    },
    "code": "KE-42"
  },
  "1094": {
    "gadm": {
      "name": "Turkana",
      "gid": "KEN.43_1"
    },
    "code": "KE-43"
  },
  "1095": {
    "gadm": {
      "name": "Uasin Gishu",
      "gid": "KEN.44_1"
    },
    "code": "KE-44"
  },
  "1096": {
    "gadm": {
      "name": "Vihiga",
      "gid": "KEN.45_1"
    },
    "code": "KE-45"
  },
  "1097": {
    "gadm": {
      "name": "Wajir",
      "gid": "KEN.46_1"
    },
    "code": "KE-46"
  },
  "1098": {
    "gadm": {
      "name": "West Pokot",
      "gid": "KEN.47_1"
    },
    "code": "KE-47"
  },
  "1099": {
    "gadm": {
      "name": "Batken",
      "gid": "KGZ.1_1"
    },
    "code": "KG-B"
  },
  "1100": {
    "gadm": {
      "name": "Bi\u00c5\u00a1kek",
      "gid": "KGZ.2_1"
    },
    "code": "KG-GB"
  },
  "1101": {
    "gadm": {
      "name": "Ch\u00c3\u00bcy",
      "gid": "KGZ.3_1"
    },
    "code": "KG-C"
  },
  "1102": {
    "gadm": {
      "name": "Jalal-Abad",
      "gid": "KGZ.4_1"
    },
    "code": "KG-J"
  },
  "1103": {
    "gadm": {
      "name": "Naryn",
      "gid": "KGZ.5_1"
    },
    "code": "KG-N"
  },
  "1104": {
    "gadm": {
      "name": "Osh",
      "gid": "KGZ.7_1"
    },
    "code": "KG-O"
  },
  "1105": {
    "gadm": {
      "name": "Osh (city)",
      "gid": "KGZ.6_1"
    },
    "code": "KG-GO"
  },
  "1106": {
    "gadm": {
      "name": "Talas",
      "gid": "KGZ.8_1"
    },
    "code": "KG-T"
  },
  "1107": {
    "gadm": {
      "name": "Ysyk-K\u00c3\u00b6l",
      "gid": "KGZ.9_1"
    },
    "code": "KG-Y"
  },
  "1108": {
    "gadm": {
      "name": "B\u00c3\u00a2nt\u00c3\u00a9ay M\u00c3\u00a9anchey",
      "gid": "KHM.1_1"
    },
    "code": "KH-1"
  },
  "1109": {
    "gadm": {
      "name": "Batd\u00c3\u00a2mb\u00c3\u00a2ng",
      "gid": "KHM.2_1"
    },
    "code": "KH-2"
  },
  "1110": {
    "gadm": {
      "name": "K\u00c3\u00a2mp\u00c3\u00b3ng Cham",
      "gid": "KHM.3_1"
    },
    "code": "KH-3"
  },
  "1111": {
    "gadm": {
      "name": "K\u00c3\u00a2mp\u00c3\u00b3ng Chhnang",
      "gid": "KHM.4_1"
    },
    "code": "KH-4"
  },
  "1112": {
    "gadm": {
      "name": "K\u00c3\u00a2mp\u00c3\u00b3ng Sp\u00c5\u201c",
      "gid": "KHM.5_1"
    },
    "code": "KH-5"
  },
  "1113": {
    "gadm": {
      "name": "K\u00c3\u00a2mp\u00c3\u00b3ng Thum",
      "gid": "KHM.6_1"
    },
    "code": "KH-6"
  },
  "1114": {
    "gadm": {
      "name": "K\u00c3\u00a2mp\u00c3\u00b4t",
      "gid": "KHM.7_1"
    },
    "code": "KH-7"
  },
  "1115": {
    "gadm": {
      "name": "K\u00c3\u00a2ndal",
      "gid": "KHM.8_1"
    },
    "code": "KH-8"
  },
  "1116": {
    "gadm": {
      "name": "Ka\u00c3\u00b4h Kong",
      "gid": "KHM.9_1"
    },
    "code": "KH-9"
  },
  "1117": {
    "gadm": {
      "name": "Kep",
      "gid": "KHM.10_1"
    },
    "code": "KH-23"
  },
  "1118": {
    "gadm": {
      "name": "Kr\u00c3\u00a2ch\u00c3\u00a9h",
      "gid": "KHM.11_1"
    },
    "code": "KH-10"
  },
  "1119": {
    "gadm": {
      "name": "Krong Pailin",
      "gid": "KHM.12_1"
    },
    "code": "KH-24"
  },
  "1120": {
    "gadm": {
      "name": "Krong Preah Sihanouk",
      "gid": "KHM.13_1"
    },
    "code": "KH-18"
  },
  "1121": {
    "gadm": {
      "name": "M\u00c3\u00b4nd\u00c3\u00b3l Kiri",
      "gid": "KHM.14_1"
    },
    "code": "KH-11"
  },
  "1122": {
    "gadm": {
      "name": "Otdar Mean Chey",
      "gid": "KHM.15_1"
    },
    "code": "KH-22"
  },
  "1123": {
    "gadm": {
      "name": "Phnom Penh",
      "gid": "KHM.16_1"
    },
    "code": "KH-12"
  },
  "1124": {
    "gadm": {
      "name": "Pouthisat",
      "gid": "KHM.17_1"
    },
    "code": "KH-15"
  },
  "1125": {
    "gadm": {
      "name": "Preah Vih\u00c3\u00a9ar",
      "gid": "KHM.18_1"
    },
    "code": "KH-13"
  },
  "1126": {
    "gadm": {
      "name": "Prey V\u00c3\u00aang",
      "gid": "KHM.19_1"
    },
    "code": "KH-14"
  },
  "1127": {
    "gadm": {
      "name": "R\u00c3\u00b4t\u00c3\u00a2n\u00c3\u00b4kiri",
      "gid": "KHM.20_1"
    },
    "code": "KH-16"
  },
  "1128": {
    "gadm": {
      "name": "Siemr\u00c3\u00a9ab",
      "gid": "KHM.21_1"
    },
    "code": "KH-17"
  },
  "1129": {
    "gadm": {
      "name": "St\u00c5\u201cng Tr\u00c3\u00aang",
      "gid": "KHM.22_1"
    },
    "code": "KH-19"
  },
  "1130": {
    "gadm": {
      "name": "Svay Rieng",
      "gid": "KHM.23_1"
    },
    "code": "KH-20"
  },
  "1131": {
    "gadm": {
      "name": "Tak\u00c3\u00aav",
      "gid": "KHM.24_1"
    },
    "code": "KH-21"
  },
  "1132": {
    "gadm": {
      "name": "Tbong Khmum",
      "gid": "KHM.25_1"
    },
    "code": "KH-25"
  },
  "1133": {
    "gadm": {
      "name": "Mwali",
      "gid": "COM.1_1"
    },
    "code": "KM-M"
  },
  "1134": {
    "gadm": {
      "name": "Njaz\u00c3\u00addja",
      "gid": "COM.2_1"
    },
    "code": "KM-G"
  },
  "1135": {
    "gadm": {
      "name": "Nzwani",
      "gid": "COM.3_1"
    },
    "code": "KM-A"
  },
  "1136": {
    "gadm": {
      "name": "Saint George Gingerland",
      "gid": "KNA.4_1"
    },
    "code": "KN"
  },
  "1137": {
    "gadm": {
      "name": "Christ Church Nichola Town",
      "gid": "KNA.1_1"
    },
    "code": "KN-K"
  },
  "1138": {
    "gadm": {
      "name": "Ras\u00c5\u008fn",
      "gid": "PRK.12_1"
    },
    "code": "KP-11"
  },
  "1139": {
    "gadm": {
      "name": "Hamgy\u00c5\u008fng-bukto",
      "gid": "PRK.2_1"
    },
    "code": "KP-09"
  },
  "1140": {
    "gadm": {
      "name": "Hamgy\u00c5\u008fng-namdo",
      "gid": "PRK.3_1"
    },
    "code": "KP-08"
  },
  "1141": {
    "gadm": {
      "name": "Ryanggang",
      "gid": "PRK.13_1"
    },
    "code": "KP-10"
  },
  "1142": {
    "gadm": {
      "name": "Chagang-do",
      "gid": "PRK.1_1"
    },
    "code": "KP-04"
  },
  "1143": {
    "gadm": {
      "name": "P'y\u00c5\u008fngan-bukto",
      "gid": "PRK.9_1"
    },
    "code": "KP-03"
  },
  "1144": {
    "gadm": {
      "name": "P'y\u00c5\u008fngan-namdo",
      "gid": "PRK.10_1"
    },
    "code": "KP-02"
  },
  "1145": {
    "gadm": {
      "name": "P'y\u00c5\u008fngyang",
      "gid": "PRK.11_1"
    },
    "code": "KP-01"
  },
  "1146": {
    "gadm": {
      "name": "Kangw\u00c5\u008fn-do",
      "gid": "PRK.7_1"
    },
    "code": "KP-07"
  },
  "1147": {
    "gadm": {
      "name": "Hwanghae-bukto",
      "gid": "PRK.4_1"
    },
    "code": "KP-06"
  },
  "1148": {
    "gadm": {
      "name": "Hwanghae-namdo",
      "gid": "PRK.5_1"
    },
    "code": "KP-05"
  },
  "1149": {
    "gadm": {
      "name": "Busan",
      "gid": "KOR.1_1"
    },
    "code": "KR-26"
  },
  "1150": {
    "gadm": {
      "name": "Chungcheongbuk-do",
      "gid": "KOR.2_1"
    },
    "code": "KR-43"
  },
  "1151": {
    "gadm": {
      "name": "Chungcheongnam-do",
      "gid": "KOR.3_1"
    },
    "code": "KR-44"
  },
  "1152": {
    "gadm": {
      "name": "Daegu",
      "gid": "KOR.4_1"
    },
    "code": "KR-27"
  },
  "1153": {
    "gadm": {
      "name": "Daejeon",
      "gid": "KOR.5_1"
    },
    "code": "KR-30"
  },
  "1154": {
    "gadm": {
      "name": "Gangwon-do",
      "gid": "KOR.6_1"
    },
    "code": "KR-42"
  },
  "1155": {
    "gadm": {
      "name": "Gwangju",
      "gid": "KOR.7_1"
    },
    "code": "KR-29"
  },
  "1156": {
    "gadm": {
      "name": "Gyeonggi-do",
      "gid": "KOR.8_1"
    },
    "code": "KR-41"
  },
  "1157": {
    "gadm": {
      "name": "Gyeongsangbuk-do",
      "gid": "KOR.9_1"
    },
    "code": "KR-47"
  },
  "1158": {
    "gadm": {
      "name": "Gyeongsangnam-do",
      "gid": "KOR.10_1"
    },
    "code": "KR-48"
  },
  "1159": {
    "gadm": {
      "name": "Incheon",
      "gid": "KOR.11_1"
    },
    "code": "KR-28"
  },
  "1160": {
    "gadm": {
      "name": "Jeju",
      "gid": "KOR.12_1"
    },
    "code": "KR-49"
  },
  "1161": {
    "gadm": {
      "name": "Jeollabuk-do",
      "gid": "KOR.13_1"
    },
    "code": "KR-45"
  },
  "1162": {
    "gadm": {
      "name": "Jeollanam-do",
      "gid": "KOR.14_1"
    },
    "code": "KR-46"
  },
  "1163": {
    "gadm": {
      "name": "Sejong",
      "gid": "KOR.15_1"
    },
    "code": "KR-50"
  },
  "1164": {
    "gadm": {
      "name": "Seoul",
      "gid": "KOR.16_1"
    },
    "code": "KR-11"
  },
  "1165": {
    "gadm": {
      "name": "Ulsan",
      "gid": "KOR.17_1"
    },
    "code": "KR-31"
  },
  "1166": {
    "gadm": {
      "name": "Al Ahmadi",
      "gid": "KWT.1_1"
    },
    "code": "KW-AH"
  },
  "1167": {
    "gadm": {
      "name": "Al Farwaniyah",
      "gid": "KWT.2_1"
    },
    "code": "KW-FA"
  },
  "1168": {
    "gadm": {
      "name": "Al Jahrah",
      "gid": "KWT.3_1"
    },
    "code": "KW-JA"
  },
  "1169": {
    "gadm": {
      "name": "Al Kuwayt",
      "gid": "KWT.4_1"
    },
    "code": "KW-KU"
  },
  "1170": {
    "gadm": {
      "name": "Hawalli",
      "gid": "KWT.5_1"
    },
    "code": "KW-HA"
  },
  "1171": {
    "gadm": {
      "name": "Mubarak Al-Kabeer",
      "gid": "KWT.6_1"
    },
    "code": "KW-MU"
  },
  "1172": {
    "gadm": {
      "name": "Almaty",
      "gid": "KAZ.1_1"
    },
    "code": "KZ-ALM"
  },
  "1173": {
    "gadm": {
      "name": "Aqmola",
      "gid": "KAZ.2_1"
    },
    "code": "KZ-AKM"
  },
  "1174": {
    "gadm": {
      "name": "Aqt\u00c3\u00b6be",
      "gid": "KAZ.3_1"
    },
    "code": "KZ-AKT"
  },
  "1175": {
    "gadm": {
      "name": "Atyrau",
      "gid": "KAZ.4_1"
    },
    "code": "KZ-ATY"
  },
  "1176": {
    "gadm": {
      "name": "East Kazakhstan",
      "gid": "KAZ.5_1"
    },
    "code": "KZ-VOS"
  },
  "1177": {
    "gadm": {
      "name": "Mangghystau",
      "gid": "KAZ.6_1"
    },
    "code": "KZ-MAN"
  },
  "1178": {
    "gadm": {
      "name": "North Kazakhstan",
      "gid": "KAZ.7_1"
    },
    "code": "KZ-SEV"
  },
  "1179": {
    "gadm": {
      "name": "Pavlodar",
      "gid": "KAZ.8_1"
    },
    "code": "KZ-PAV"
  },
  "1180": {
    "gadm": {
      "name": "Qaraghandy",
      "gid": "KAZ.9_1"
    },
    "code": "KZ-KAR"
  },
  "1181": {
    "gadm": {
      "name": "Qostanay",
      "gid": "KAZ.10_1"
    },
    "code": "KZ-KUS"
  },
  "1182": {
    "gadm": {
      "name": "Qyzylorda",
      "gid": "KAZ.11_1"
    },
    "code": "KZ-KZY"
  },
  "1183": {
    "gadm": {
      "name": "South Kazakhstan",
      "gid": "KAZ.12_1"
    },
    "code": "KZ-YUZ"
  },
  "1184": {
    "gadm": {
      "name": "West Kazakhstan",
      "gid": "KAZ.13_1"
    },
    "code": "KZ-ZAP"
  },
  "1185": {
    "gadm": {
      "name": "Zhambyl",
      "gid": "KAZ.14_1"
    },
    "code": "KZ-ZHA"
  },
  "1186": {
    "gadm": {
      "name": "Attapu",
      "gid": "LAO.1_1"
    },
    "code": "LA-AT"
  },
  "1187": {
    "gadm": {
      "name": "Bokeo",
      "gid": "LAO.2_1"
    },
    "code": "LA-BK"
  },
  "1188": {
    "gadm": {
      "name": "Bolikhamxai",
      "gid": "LAO.3_1"
    },
    "code": "LA-BL"
  },
  "1189": {
    "gadm": {
      "name": "Champasak",
      "gid": "LAO.4_1"
    },
    "code": "LA-CH"
  },
  "1190": {
    "gadm": {
      "name": "Houaphan",
      "gid": "LAO.5_1"
    },
    "code": "LA-HO"
  },
  "1191": {
    "gadm": {
      "name": "Khammouan",
      "gid": "LAO.6_1"
    },
    "code": "LA-KH"
  },
  "1192": {
    "gadm": {
      "name": "Louang Namtha",
      "gid": "LAO.7_1"
    },
    "code": "LA-LM"
  },
  "1193": {
    "gadm": {
      "name": "Louangphrabang",
      "gid": "LAO.8_1"
    },
    "code": "LA-LP"
  },
  "1194": {
    "gadm": {
      "name": "Oud\u00c3\u00b4mxai",
      "gid": "LAO.9_1"
    },
    "code": "LA-OU"
  },
  "1195": {
    "gadm": {
      "name": "Ph\u00c3\u00b4ngsali",
      "gid": "LAO.10_1"
    },
    "code": "LA-PH"
  },
  "1196": {
    "gadm": {
      "name": "Saravan",
      "gid": "LAO.11_1"
    },
    "code": "LA-SL"
  },
  "1197": {
    "gadm": {
      "name": "Savannakh\u00c3\u00a9t",
      "gid": "LAO.12_1"
    },
    "code": "LA-SV"
  },
  "1198": {
    "gadm": {
      "name": "Vientiane",
      "gid": "LAO.14_1"
    },
    "code": "LA-VI"
  },
  "1199": {
    "gadm": {
      "name": "Vientiane [prefecture]",
      "gid": "LAO.13_1"
    },
    "code": "LA-VT"
  },
  "1200": {
    "gadm": {
      "name": "Xaignabouri",
      "gid": "LAO.15_1"
    },
    "code": "LA-XA"
  },
  "1201": {
    "gadm": {
      "name": "Xais\u00c3\u00b4mboun",
      "gid": "LAO.16_1"
    },
    "code": "LA-XS"
  },
  "1202": {
    "gadm": {
      "name": "X\u00c3\u00a9kong",
      "gid": "LAO.17_1"
    },
    "code": "LA-XE"
  },
  "1203": {
    "gadm": {
      "name": "Xiangkhoang",
      "gid": "LAO.18_1"
    },
    "code": "LA-XI"
  },
  "1204": {
    "gadm": {
      "name": "Akkar",
      "gid": "LBN.1_1"
    },
    "code": "LB-AK"
  },
  "1205": {
    "gadm": {
      "name": "Baalbak - Hermel",
      "gid": "LBN.2_1"
    },
    "code": "LB-BH"
  },
  "1206": {
    "gadm": {
      "name": "Beirut",
      "gid": "LBN.3_1"
    },
    "code": "LB-BA"
  },
  "1207": {
    "gadm": {
      "name": "Bekaa",
      "gid": "LBN.4_1"
    },
    "code": "LB-BI"
  },
  "1208": {
    "gadm": {
      "name": "Mount Lebanon",
      "gid": "LBN.5_1"
    },
    "code": "LB-JL"
  },
  "1209": {
    "gadm": {
      "name": "Nabatiyeh",
      "gid": "LBN.6_1"
    },
    "code": "LB-NA"
  },
  "1210": {
    "gadm": {
      "name": "North",
      "gid": "LBN.7_1"
    },
    "code": "LB-AS"
  },
  "1211": {
    "gadm": {
      "name": "South",
      "gid": "LBN.8_1"
    },
    "code": "LB-JA"
  },
  "1212": {
    "gadm": {
      "name": "Anse-la-Raye",
      "gid": "LCA.1_1"
    },
    "code": "LC-01"
  },
  "1213": {
    "gadm": {
      "name": "Canaries",
      "gid": "LCA.2_1"
    },
    "code": "LC-12"
  },
  "1214": {
    "gadm": {
      "name": "Castries",
      "gid": "LCA.3_1"
    },
    "code": "LC-02"
  },
  "1215": {
    "gadm": {
      "name": "Choiseul",
      "gid": "LCA.4_1"
    },
    "code": "LC-03"
  },
  "1216": {
    "gadm": {
      "name": "Dennery",
      "gid": "LCA.5_1"
    },
    "code": "LC-05"
  },
  "1217": {
    "gadm": {
      "name": "Gros Islet",
      "gid": "LCA.6_1"
    },
    "code": "LC-06"
  },
  "1218": {
    "gadm": {
      "name": "Laborie",
      "gid": "LCA.7_1"
    },
    "code": "LC-07"
  },
  "1219": {
    "gadm": {
      "name": "Micoud",
      "gid": "LCA.8_1"
    },
    "code": "LC-08"
  },
  "1220": {
    "gadm": {
      "name": "Soufri\u00c3\u00a8re",
      "gid": "LCA.9_1"
    },
    "code": "LC-10"
  },
  "1221": {
    "gadm": {
      "name": "Vieux Fort",
      "gid": "LCA.10_1"
    },
    "code": "LC-11"
  },
  "1222": {
    "gadm": {
      "name": "Balzers",
      "gid": "LIE.1_1"
    },
    "code": "LI-01"
  },
  "1223": {
    "gadm": {
      "name": "Eschen",
      "gid": "LIE.2_1"
    },
    "code": "LI-02"
  },
  "1224": {
    "gadm": {
      "name": "Gamprin",
      "gid": "LIE.3_1"
    },
    "code": "LI-03"
  },
  "1225": {
    "gadm": {
      "name": "Mauren",
      "gid": "LIE.4_1"
    },
    "code": "LI-04"
  },
  "1226": {
    "gadm": {
      "name": "Planken",
      "gid": "LIE.5_1"
    },
    "code": "LI-05"
  },
  "1227": {
    "gadm": {
      "name": "Ruggell",
      "gid": "LIE.6_1"
    },
    "code": "LI-06"
  },
  "1228": {
    "gadm": {
      "name": "Schaan",
      "gid": "LIE.7_1"
    },
    "code": "LI-07"
  },
  "1229": {
    "gadm": {
      "name": "Schellenberg",
      "gid": "LIE.8_1"
    },
    "code": "LI-08"
  },
  "1230": {
    "gadm": {
      "name": "Triesen",
      "gid": "LIE.9_1"
    },
    "code": "LI-09"
  },
  "1231": {
    "gadm": {
      "name": "Triesenberg",
      "gid": "LIE.10_1"
    },
    "code": "LI-10"
  },
  "1232": {
    "gadm": {
      "name": "Valduz",
      "gid": "LIE.11_1"
    },
    "code": "LI-11"
  },
  "1233": {
    "gadm": {
      "name": "Kalutara",
      "gid": "LKA.10_1"
    },
    "code": "LK-1"
  },
  "1234": {
    "gadm": {
      "name": "Trincomalee",
      "gid": "LKA.24_1"
    },
    "code": "LK-5"
  },
  "1235": {
    "gadm": {
      "name": "Anuradhapura",
      "gid": "LKA.2_1"
    },
    "code": "LK-7"
  },
  "1236": {
    "gadm": {
      "name": "Kegalle",
      "gid": "LKA.12_1"
    },
    "code": "LK-9"
  },
  "1237": {
    "gadm": {
      "name": "Badulla",
      "gid": "LKA.3_1"
    },
    "code": "LK-8"
  },
  "1238": {
    "gadm": {
      "name": "Kandy",
      "gid": "LKA.11_1"
    },
    "code": "LK-2"
  },
  "1239": {
    "gadm": {
      "name": "Galle",
      "gid": "LKA.6_1"
    },
    "code": "LK-3"
  },
  "1240": {
    "gadm": {
      "name": "Kurunegala",
      "gid": "LKA.14_1"
    },
    "code": "LK-6"
  },
  "1241": {
    "gadm": {
      "name": "Jaffna",
      "gid": "LKA.9_1"
    },
    "code": "LK-4"
  },
  "1242": {
    "gadm": {
      "name": "Bomi",
      "gid": "LBR.1_1"
    },
    "code": "LR-BM"
  },
  "1243": {
    "gadm": {
      "name": "Bong",
      "gid": "LBR.2_1"
    },
    "code": "LR-BG"
  },
  "1244": {
    "gadm": {
      "name": "Gbapolu",
      "gid": "LBR.3_1"
    },
    "code": "LR-GP"
  },
  "1245": {
    "gadm": {
      "name": "Grand Cape Mount",
      "gid": "LBR.4_1"
    },
    "code": "LR-CM"
  },
  "1246": {
    "gadm": {
      "name": "GrandBassa",
      "gid": "LBR.5_1"
    },
    "code": "LR-GB"
  },
  "1247": {
    "gadm": {
      "name": "GrandGedeh",
      "gid": "LBR.6_1"
    },
    "code": "LR-GG"
  },
  "1248": {
    "gadm": {
      "name": "GrandKru",
      "gid": "LBR.7_1"
    },
    "code": "LR-GK"
  },
  "1249": {
    "gadm": {
      "name": "Lofa",
      "gid": "LBR.8_1"
    },
    "code": "LR-LO"
  },
  "1250": {
    "gadm": {
      "name": "Margibi",
      "gid": "LBR.9_1"
    },
    "code": "LR-MG"
  },
  "1251": {
    "gadm": {
      "name": "Maryland",
      "gid": "LBR.10_1"
    },
    "code": "LR-MY"
  },
  "1252": {
    "gadm": {
      "name": "Montserrado",
      "gid": "LBR.11_1"
    },
    "code": "LR-MO"
  },
  "1253": {
    "gadm": {
      "name": "Nimba",
      "gid": "LBR.12_1"
    },
    "code": "LR-NI"
  },
  "1254": {
    "gadm": {
      "name": "River Cess",
      "gid": "LBR.13_1"
    },
    "code": "LR-RI"
  },
  "1255": {
    "gadm": {
      "name": "River Gee",
      "gid": "LBR.14_1"
    },
    "code": "LR-RG"
  },
  "1256": {
    "gadm": {
      "name": "Sinoe",
      "gid": "LBR.15_1"
    },
    "code": "LR-SI"
  },
  "1257": {
    "gadm": {
      "name": "Berea",
      "gid": "LSO.1_1"
    },
    "code": "LS-D"
  },
  "1258": {
    "gadm": {
      "name": "Butha-Buthe",
      "gid": "LSO.2_1"
    },
    "code": "LS-B"
  },
  "1259": {
    "gadm": {
      "name": "Leribe",
      "gid": "LSO.3_1"
    },
    "code": "LS-C"
  },
  "1260": {
    "gadm": {
      "name": "Mafeteng",
      "gid": "LSO.4_1"
    },
    "code": "LS-E"
  },
  "1261": {
    "gadm": {
      "name": "Maseru",
      "gid": "LSO.5_1"
    },
    "code": "LS-A"
  },
  "1262": {
    "gadm": {
      "name": "Mohale's Hoek",
      "gid": "LSO.6_1"
    },
    "code": "LS-F"
  },
  "1263": {
    "gadm": {
      "name": "Mokhotlong",
      "gid": "LSO.7_1"
    },
    "code": "LS-J"
  },
  "1264": {
    "gadm": {
      "name": "Qacha's Nek",
      "gid": "LSO.8_1"
    },
    "code": "LS-H"
  },
  "1265": {
    "gadm": {
      "name": "Quthing",
      "gid": "LSO.9_1"
    },
    "code": "LS-G"
  },
  "1266": {
    "gadm": {
      "name": "Thaba-Tseka",
      "gid": "LSO.10_1"
    },
    "code": "LS-K"
  },
  "1267": {
    "gadm": {
      "name": "Al Butnan",
      "gid": "LBY.1_1"
    },
    "code": "LY-BU"
  },
  "1268": {
    "gadm": {
      "name": "Al Jabal al Akhdar",
      "gid": "LBY.2_1"
    },
    "code": "LY-JA"
  },
  "1269": {
    "gadm": {
      "name": "Al Jabal al Gharbi",
      "gid": "LBY.3_1"
    },
    "code": "LY-JG"
  },
  "1270": {
    "gadm": {
      "name": "Al Jifarah",
      "gid": "LBY.4_1"
    },
    "code": "LY-JI"
  },
  "1271": {
    "gadm": {
      "name": "Al Jufrah",
      "gid": "LBY.5_1"
    },
    "code": "LY-JU"
  },
  "1272": {
    "gadm": {
      "name": "Al Kufrah",
      "gid": "LBY.6_1"
    },
    "code": "LY-KF"
  },
  "1273": {
    "gadm": {
      "name": "Al Marj",
      "gid": "LBY.7_1"
    },
    "code": "LY-MJ"
  },
  "1274": {
    "gadm": {
      "name": "Al Marqab",
      "gid": "LBY.8_1"
    },
    "code": "LY-MB"
  },
  "1275": {
    "gadm": {
      "name": "Al Wahat",
      "gid": "LBY.9_1"
    },
    "code": "LY-WA"
  },
  "1276": {
    "gadm": {
      "name": "An Nuqat al Khams",
      "gid": "LBY.10_1"
    },
    "code": "LY-NQ"
  },
  "1277": {
    "gadm": {
      "name": "Az Zawiyah",
      "gid": "LBY.11_1"
    },
    "code": "LY-ZA"
  },
  "1278": {
    "gadm": {
      "name": "Benghazi",
      "gid": "LBY.12_1"
    },
    "code": "LY-BA"
  },
  "1279": {
    "gadm": {
      "name": "Darnah",
      "gid": "LBY.13_1"
    },
    "code": "LY-DR"
  },
  "1280": {
    "gadm": {
      "name": "Ghat",
      "gid": "LBY.14_1"
    },
    "code": "LY-GT"
  },
  "1281": {
    "gadm": {
      "name": "Misratah",
      "gid": "LBY.15_1"
    },
    "code": "LY-MI"
  },
  "1282": {
    "gadm": {
      "name": "Murzuq",
      "gid": "LBY.16_1"
    },
    "code": "LY-MQ"
  },
  "1283": {
    "gadm": {
      "name": "Nalut",
      "gid": "LBY.17_1"
    },
    "code": "LY-NL"
  },
  "1284": {
    "gadm": {
      "name": "Sabha",
      "gid": "LBY.18_1"
    },
    "code": "LY-SB"
  },
  "1285": {
    "gadm": {
      "name": "Surt",
      "gid": "LBY.19_1"
    },
    "code": "LY-SR"
  },
  "1286": {
    "gadm": {
      "name": "Tripoli",
      "gid": "LBY.20_1"
    },
    "code": "LY-TB"
  },
  "1287": {
    "gadm": {
      "name": "Wadi al Hayat",
      "gid": "LBY.21_1"
    },
    "code": "LY-WD"
  },
  "1288": {
    "gadm": {
      "name": "Wadi ash Shati'",
      "gid": "LBY.22_1"
    },
    "code": "LY-WS"
  },
  "1289": {
    "gadm": {
      "name": "Chaouia - Ouardigha",
      "gid": "MAR.1_1"
    },
    "code": "MAR.1_1"
  },
  "1290": {
    "gadm": {
      "name": "Doukkala - Abda",
      "gid": "MAR.2_1"
    },
    "code": "MAR.2_1"
  },
  "1291": {
    "gadm": {
      "name": "F\u00c3\u00a8s - Boulemane",
      "gid": "MAR.3_1"
    },
    "code": "MAR.3_1"
  },
  "1292": {
    "gadm": {
      "name": "Gharb - Chrarda - B\u00c3\u00a9ni Hssen",
      "gid": "MAR.4_1"
    },
    "code": "MAR.4_1"
  },
  "1293": {
    "gadm": {
      "name": "Grand Casablanca",
      "gid": "MAR.5_1"
    },
    "code": "MAR.5_1"
  },
  "1294": {
    "gadm": {
      "name": "Guelmim - Es-Semara",
      "gid": "MAR.6_1"
    },
    "code": "MAR.6_1"
  },
  "1295": {
    "gadm": {
      "name": "La\u00c3\u00a2youne - Boujdour - Sakia El Hamra",
      "gid": "MAR.7_1"
    },
    "code": "MAR.7_1"
  },
  "1296": {
    "gadm": {
      "name": "Marrakech - Tensift - Al Haouz",
      "gid": "MAR.8_1"
    },
    "code": "MAR.8_1"
  },
  "1297": {
    "gadm": {
      "name": "Mekn\u00c3\u00a8s - Tafilalet",
      "gid": "MAR.9_1"
    },
    "code": "MAR.9_1"
  },
  "1298": {
    "gadm": {
      "name": "Oriental",
      "gid": "MAR.10_1"
    },
    "code": "MAR.10_1"
  },
  "1299": {
    "gadm": {
      "name": "Rabat - Sal\u00c3\u00a9 - Zemmour - Zaer",
      "gid": "MAR.11_1"
    },
    "code": "MAR.11_1"
  },
  "1300": {
    "gadm": {
      "name": "Souss - Massa - Dra\u00c3\u00a2",
      "gid": "MAR.12_1"
    },
    "code": "MAR.12_1"
  },
  "1301": {
    "gadm": {
      "name": "Tadla - Azilal",
      "gid": "MAR.13_1"
    },
    "code": "MAR.13_1"
  },
  "1302": {
    "gadm": {
      "name": "Tanger - T\u00c3\u00a9touan",
      "gid": "MAR.14_1"
    },
    "code": "MAR.14_1"
  },
  "1303": {
    "gadm": {
      "name": "Taza - Al Hoceima - Taounate",
      "gid": "MAR.15_1"
    },
    "code": "MAR.15_1"
  },
  "1304": {
    "gadm": {
      "name": "Anenii Noi",
      "gid": "MDA.1_1"
    },
    "code": "MD-AN"
  },
  "1305": {
    "gadm": {
      "name": "B\u00c4\u0192l\u00c5\u00a3i",
      "gid": "MDA.2_1"
    },
    "code": "MD-BA"
  },
  "1306": {
    "gadm": {
      "name": "Basarabeasca",
      "gid": "MDA.3_1"
    },
    "code": "MD-BS"
  },
  "1307": {
    "gadm": {
      "name": "Bender",
      "gid": "MDA.4_1"
    },
    "code": "MD-BD"
  },
  "1308": {
    "gadm": {
      "name": "Briceni",
      "gid": "MDA.5_1"
    },
    "code": "MD-BR"
  },
  "1309": {
    "gadm": {
      "name": "Cahul",
      "gid": "MDA.6_1"
    },
    "code": "MD-CA"
  },
  "1310": {
    "gadm": {
      "name": "Calarasi",
      "gid": "MDA.7_1"
    },
    "code": "MD-CL"
  },
  "1311": {
    "gadm": {
      "name": "Cantemir",
      "gid": "MDA.8_1"
    },
    "code": "MD-CT"
  },
  "1312": {
    "gadm": {
      "name": "Causeni",
      "gid": "MDA.9_1"
    },
    "code": "MD-CS"
  },
  "1313": {
    "gadm": {
      "name": "Chi\u00c5\u0178in\u00c4\u0192u",
      "gid": "MDA.10_1"
    },
    "code": "MD-CU"
  },
  "1314": {
    "gadm": {
      "name": "Cimi\u00c5\u0178lia",
      "gid": "MDA.11_1"
    },
    "code": "MD-CM"
  },
  "1315": {
    "gadm": {
      "name": "Criuleni",
      "gid": "MDA.12_1"
    },
    "code": "MD-CR"
  },
  "1316": {
    "gadm": {
      "name": "Donduseni",
      "gid": "MDA.13_1"
    },
    "code": "MD-DO"
  },
  "1317": {
    "gadm": {
      "name": "Drochia",
      "gid": "MDA.14_1"
    },
    "code": "MD-DR"
  },
  "1318": {
    "gadm": {
      "name": "Dub\u00c4\u0192sari",
      "gid": "MDA.15_1"
    },
    "code": "MD-DU"
  },
  "1319": {
    "gadm": {
      "name": "Edine\u00c5\u00a3",
      "gid": "MDA.16_1"
    },
    "code": "MD-ED"
  },
  "1320": {
    "gadm": {
      "name": "F\u00c4\u0192le\u00c5\u0178ti",
      "gid": "MDA.17_1"
    },
    "code": "MD-FA"
  },
  "1321": {
    "gadm": {
      "name": "Flore\u00c5\u0178ti",
      "gid": "MDA.18_1"
    },
    "code": "MD-FL"
  },
  "1322": {
    "gadm": {
      "name": "G\u00c4\u0192g\u00c4\u0192uzia",
      "gid": "MDA.19_1"
    },
    "code": "MD-GA"
  },
  "1323": {
    "gadm": {
      "name": "Glodeni",
      "gid": "MDA.20_1"
    },
    "code": "MD-GL"
  },
  "1324": {
    "gadm": {
      "name": "H\u00c3\u00aencesti",
      "gid": "MDA.21_1"
    },
    "code": "MD-HI"
  },
  "1325": {
    "gadm": {
      "name": "Ialoveni",
      "gid": "MDA.22_1"
    },
    "code": "MD-IA"
  },
  "1326": {
    "gadm": {
      "name": "Leova",
      "gid": "MDA.23_1"
    },
    "code": "MD-LE"
  },
  "1327": {
    "gadm": {
      "name": "Nisporeni",
      "gid": "MDA.24_1"
    },
    "code": "MD-NI"
  },
  "1328": {
    "gadm": {
      "name": "Ocni\u00c5\u00a3a",
      "gid": "MDA.25_1"
    },
    "code": "MD-OC"
  },
  "1329": {
    "gadm": {
      "name": "Orhei",
      "gid": "MDA.26_1"
    },
    "code": "MD-OR"
  },
  "1330": {
    "gadm": {
      "name": "Rezina",
      "gid": "MDA.27_1"
    },
    "code": "MD-RE"
  },
  "1331": {
    "gadm": {
      "name": "R\u00c3\u00ae\u00c5\u0178cani",
      "gid": "MDA.28_1"
    },
    "code": "MD-RI"
  },
  "1332": {
    "gadm": {
      "name": "S\u00c3\u00aengerei",
      "gid": "MDA.29_1"
    },
    "code": "MD-SI"
  },
  "1333": {
    "gadm": {
      "name": "\u00c5\u017eold\u00c4\u0192ne\u00c5\u0178ti",
      "gid": "MDA.30_1"
    },
    "code": "MD-SD"
  },
  "1334": {
    "gadm": {
      "name": "Soroca",
      "gid": "MDA.31_1"
    },
    "code": "MD-SO"
  },
  "1335": {
    "gadm": {
      "name": "\u00c5\u017etefan Voda",
      "gid": "MDA.32_1"
    },
    "code": "MD-SV"
  },
  "1336": {
    "gadm": {
      "name": "Str\u00c4\u0192\u00c5\u0178eni",
      "gid": "MDA.33_1"
    },
    "code": "MD-ST"
  },
  "1337": {
    "gadm": {
      "name": "Taraclia",
      "gid": "MDA.34_1"
    },
    "code": "MD-TA"
  },
  "1338": {
    "gadm": {
      "name": "Telene\u00c5\u0178ti",
      "gid": "MDA.35_1"
    },
    "code": "MD-TE"
  },
  "1339": {
    "gadm": {
      "name": "Transnistria",
      "gid": "MDA.36_1"
    },
    "code": "MD-SN"
  },
  "1340": {
    "gadm": {
      "name": "Ungheni",
      "gid": "MDA.37_1"
    },
    "code": "MD-UN"
  },
  "1341": {
    "gadm": {
      "name": "Andrijevica",
      "gid": "MNE.1_1"
    },
    "code": "ME-01"
  },
  "1342": {
    "gadm": {
      "name": "Bar",
      "gid": "MNE.2_1"
    },
    "code": "ME-02"
  },
  "1343": {
    "gadm": {
      "name": "Berane",
      "gid": "MNE.3_1"
    },
    "code": "ME-03"
  },
  "1344": {
    "gadm": {
      "name": "Bijelo Polje",
      "gid": "MNE.4_1"
    },
    "code": "ME-04"
  },
  "1345": {
    "gadm": {
      "name": "Budva",
      "gid": "MNE.5_1"
    },
    "code": "ME-05"
  },
  "1346": {
    "gadm": {
      "name": "Cetinje",
      "gid": "MNE.6_1"
    },
    "code": "ME-06"
  },
  "1347": {
    "gadm": {
      "name": "Danilovgrad",
      "gid": "MNE.7_1"
    },
    "code": "ME-07"
  },
  "1348": {
    "gadm": {
      "name": "Herceg Novi",
      "gid": "MNE.8_1"
    },
    "code": "ME-08"
  },
  "1349": {
    "gadm": {
      "name": "Kola\u00c5\u00a1in",
      "gid": "MNE.9_1"
    },
    "code": "ME-09"
  },
  "1350": {
    "gadm": {
      "name": "Kotor",
      "gid": "MNE.10_1"
    },
    "code": "ME-10"
  },
  "1351": {
    "gadm": {
      "name": "Mojkovac",
      "gid": "MNE.11_1"
    },
    "code": "ME-11"
  },
  "1352": {
    "gadm": {
      "name": "Nik\u00c5\u00a1ic",
      "gid": "MNE.12_1"
    },
    "code": "ME-12"
  },
  "1353": {
    "gadm": {
      "name": "Plav",
      "gid": "MNE.13_1"
    },
    "code": "ME-13"
  },
  "1354": {
    "gadm": {
      "name": "Pljevlja",
      "gid": "MNE.14_1"
    },
    "code": "ME-14"
  },
  "1355": {
    "gadm": {
      "name": "Plu\u00c5\u00beine",
      "gid": "MNE.15_1"
    },
    "code": "ME-15"
  },
  "1356": {
    "gadm": {
      "name": "Podgorica",
      "gid": "MNE.16_1"
    },
    "code": "ME-16"
  },
  "1357": {
    "gadm": {
      "name": "Ro\u00c5\u00beaje",
      "gid": "MNE.17_1"
    },
    "code": "ME-17"
  },
  "1358": {
    "gadm": {
      "name": "\u00c5\u00a0avnik",
      "gid": "MNE.18_1"
    },
    "code": "ME-18"
  },
  "1359": {
    "gadm": {
      "name": "Tivat",
      "gid": "MNE.19_1"
    },
    "code": "ME-19"
  },
  "1360": {
    "gadm": {
      "name": "Ulcinj",
      "gid": "MNE.20_1"
    },
    "code": "ME-20"
  },
  "1361": {
    "gadm": {
      "name": "\u00c5\u00bdabljak",
      "gid": "MNE.21_1"
    },
    "code": "ME-21"
  },
  "1362": {
    "gadm": {
      "name": "Antananarivo",
      "gid": "MDG.1_1"
    },
    "code": "MG-T"
  },
  "1363": {
    "gadm": {
      "name": "Antsiranana",
      "gid": "MDG.2_1"
    },
    "code": "MG-D"
  },
  "1364": {
    "gadm": {
      "name": "Fianarantsoa",
      "gid": "MDG.3_1"
    },
    "code": "MG-F"
  },
  "1365": {
    "gadm": {
      "name": "Mahajanga",
      "gid": "MDG.4_1"
    },
    "code": "MG-M"
  },
  "1366": {
    "gadm": {
      "name": "Toamasina",
      "gid": "MDG.5_1"
    },
    "code": "MG-A"
  },
  "1367": {
    "gadm": {
      "name": "Toliary",
      "gid": "MDG.6_1"
    },
    "code": "MG-U"
  },
  "1368": {
    "gadm": {
      "name": "Aerodrom",
      "gid": "MKD.1_1"
    },
    "code": "MK-801"
  },
  "1369": {
    "gadm": {
      "name": "Aracinovo",
      "gid": "MKD.2_1"
    },
    "code": "MK-802"
  },
  "1370": {
    "gadm": {
      "name": "Berovo",
      "gid": "MKD.3_1"
    },
    "code": "MK-201"
  },
  "1371": {
    "gadm": {
      "name": "Bitola",
      "gid": "MKD.4_1"
    },
    "code": "MK-501"
  },
  "1372": {
    "gadm": {
      "name": "Bogdanci",
      "gid": "MKD.5_1"
    },
    "code": "MK-401"
  },
  "1373": {
    "gadm": {
      "name": "Bogovinje",
      "gid": "MKD.6_1"
    },
    "code": "MK-601"
  },
  "1374": {
    "gadm": {
      "name": "Bosilovo",
      "gid": "MKD.7_1"
    },
    "code": "MK-402"
  },
  "1375": {
    "gadm": {
      "name": "Brvenica",
      "gid": "MKD.8_1"
    },
    "code": "MK-602"
  },
  "1376": {
    "gadm": {
      "name": "Butel",
      "gid": "MKD.9_1"
    },
    "code": "MK-803"
  },
  "1377": {
    "gadm": {
      "name": "\u00c4\u0152air",
      "gid": "MKD.10_1"
    },
    "code": "MK-815"
  },
  "1378": {
    "gadm": {
      "name": "\u00c4\u0152a\u00c5\u00a1ka",
      "gid": "MKD.11_1"
    },
    "code": "MK-109"
  },
  "1379": {
    "gadm": {
      "name": "Centar",
      "gid": "MKD.12_1"
    },
    "code": "MK-814"
  },
  "1380": {
    "gadm": {
      "name": "Centar \u00c5\u00beupa",
      "gid": "MKD.13_1"
    },
    "code": "MK-313"
  },
  "1381": {
    "gadm": {
      "name": "\u00c4\u0152e\u00c5\u00a1inovo-Oble\u00c5\u00a1evo",
      "gid": "MKD.14_1"
    },
    "code": "MK-210"
  },
  "1382": {
    "gadm": {
      "name": "\u00c4\u0152u\u00c4\u008der Sandevo",
      "gid": "MKD.15_1"
    },
    "code": "MK-816"
  },
  "1383": {
    "gadm": {
      "name": "Debar",
      "gid": "MKD.16_1"
    },
    "code": "MK-303"
  },
  "1384": {
    "gadm": {
      "name": "Debarca",
      "gid": "MKD.17_1"
    },
    "code": "MK-304"
  },
  "1385": {
    "gadm": {
      "name": "Del\u00c4\u008devo",
      "gid": "MKD.18_1"
    },
    "code": "MK-203"
  },
  "1386": {
    "gadm": {
      "name": "Demir Hisar",
      "gid": "MKD.19_1"
    },
    "code": "MK-502"
  },
  "1387": {
    "gadm": {
      "name": "Demir Kapija",
      "gid": "MKD.20_1"
    },
    "code": "MK-103"
  },
  "1388": {
    "gadm": {
      "name": "Star Dojran",
      "gid": "MKD.65_1"
    },
    "code": "MK-406"
  },
  "1389": {
    "gadm": {
      "name": "Dolneni",
      "gid": "MKD.21_1"
    },
    "code": "MK-503"
  },
  "1390": {
    "gadm": {
      "name": "Gazi Baba",
      "gid": "MKD.23_1"
    },
    "code": "MK-804"
  },
  "1391": {
    "gadm": {
      "name": "Gevgelija",
      "gid": "MKD.24_1"
    },
    "code": "MK-405"
  },
  "1392": {
    "gadm": {
      "name": "Gjor\u00c4\u008de Petrov",
      "gid": "MKD.25_1"
    },
    "code": "MK-805"
  },
  "1393": {
    "gadm": {
      "name": "Gostivar",
      "gid": "MKD.26_1"
    },
    "code": "MK-604"
  },
  "1394": {
    "gadm": {
      "name": "Gradsko",
      "gid": "MKD.27_1"
    },
    "code": "MK-102"
  },
  "1395": {
    "gadm": {
      "name": "Ilinden",
      "gid": "MKD.28_1"
    },
    "code": "MK-807"
  },
  "1396": {
    "gadm": {
      "name": "Jegunovtse",
      "gid": "MKD.29_1"
    },
    "code": "MK-606"
  },
  "1397": {
    "gadm": {
      "name": "Karbinci",
      "gid": "MKD.30_1"
    },
    "code": "MK-205"
  },
  "1398": {
    "gadm": {
      "name": "Karpo\u00c5\u00a1",
      "gid": "MKD.31_1"
    },
    "code": "MK-808"
  },
  "1399": {
    "gadm": {
      "name": "Kavadartsi",
      "gid": "MKD.32_1"
    },
    "code": "MK-104"
  },
  "1400": {
    "gadm": {
      "name": "Ki\u00c4\u008devo",
      "gid": "MKD.33_1"
    },
    "code": "MK-307"
  },
  "1401": {
    "gadm": {
      "name": "Kisela Voda",
      "gid": "MKD.34_1"
    },
    "code": "MK-809"
  },
  "1402": {
    "gadm": {
      "name": "Ko\u00c4\u008dani",
      "gid": "MKD.35_1"
    },
    "code": "MK-206"
  },
  "1403": {
    "gadm": {
      "name": "Kon\u00c4\u008de",
      "gid": "MKD.36_1"
    },
    "code": "MK-407"
  },
  "1404": {
    "gadm": {
      "name": "Kratovo",
      "gid": "MKD.37_1"
    },
    "code": "MK-701"
  },
  "1405": {
    "gadm": {
      "name": "Kriva Palanka",
      "gid": "MKD.38_1"
    },
    "code": "MK-702"
  },
  "1406": {
    "gadm": {
      "name": "Krivoga\u00c5\u00a1tani",
      "gid": "MKD.39_1"
    },
    "code": "MK-504"
  },
  "1407": {
    "gadm": {
      "name": "Kru\u00c5\u00a1evo",
      "gid": "MKD.40_1"
    },
    "code": "MK-505"
  },
  "1408": {
    "gadm": {
      "name": "Kumanovo",
      "gid": "MKD.41_1"
    },
    "code": "MK-703"
  },
  "1409": {
    "gadm": {
      "name": "Lipkovo",
      "gid": "MKD.43_1"
    },
    "code": "MK-704"
  },
  "1410": {
    "gadm": {
      "name": "Lozovo",
      "gid": "MKD.44_1"
    },
    "code": "MK-105"
  },
  "1411": {
    "gadm": {
      "name": "Makedonska Kamenica",
      "gid": "MKD.45_1"
    },
    "code": "MK-207"
  },
  "1412": {
    "gadm": {
      "name": "Makedonski Brod",
      "gid": "MKD.46_1"
    },
    "code": "MK-308"
  },
  "1413": {
    "gadm": {
      "name": "Mavrovo and Rostu\u00c5\u00a1a",
      "gid": "MKD.47_1"
    },
    "code": "MK-607"
  },
  "1414": {
    "gadm": {
      "name": "Mogila",
      "gid": "MKD.48_1"
    },
    "code": "MK-506"
  },
  "1415": {
    "gadm": {
      "name": "Negotino",
      "gid": "MKD.49_1"
    },
    "code": "MK-106"
  },
  "1416": {
    "gadm": {
      "name": "Novatsi",
      "gid": "MKD.50_1"
    },
    "code": "MK-507"
  },
  "1417": {
    "gadm": {
      "name": "Novo Selo",
      "gid": "MKD.51_1"
    },
    "code": "MK-408"
  },
  "1418": {
    "gadm": {
      "name": "Ohrid",
      "gid": "MKD.52_1"
    },
    "code": "MK-310"
  },
  "1419": {
    "gadm": {
      "name": "Peh\u00c4\u008devo",
      "gid": "MKD.54_1"
    },
    "code": "MK-208"
  },
  "1420": {
    "gadm": {
      "name": "Petrovec",
      "gid": "MKD.55_1"
    },
    "code": "MK-810"
  },
  "1421": {
    "gadm": {
      "name": "Plasnica",
      "gid": "MKD.56_1"
    },
    "code": "MK-311"
  },
  "1422": {
    "gadm": {
      "name": "Prilep",
      "gid": "MKD.57_1"
    },
    "code": "MK-508"
  },
  "1423": {
    "gadm": {
      "name": "Probi\u00c5\u00a1tip",
      "gid": "MKD.58_1"
    },
    "code": "MK-209"
  },
  "1424": {
    "gadm": {
      "name": "Radovi\u00c5\u00a1",
      "gid": "MKD.59_1"
    },
    "code": "MK-409"
  },
  "1425": {
    "gadm": {
      "name": "Rankovce",
      "gid": "MKD.60_1"
    },
    "code": "MK-705"
  },
  "1426": {
    "gadm": {
      "name": "Resen",
      "gid": "MKD.61_1"
    },
    "code": "MK-509"
  },
  "1427": {
    "gadm": {
      "name": "Rosoman",
      "gid": "MKD.62_1"
    },
    "code": "MK-107"
  },
  "1428": {
    "gadm": {
      "name": "Saraj",
      "gid": "MKD.63_1"
    },
    "code": "MK-811"
  },
  "1429": {
    "gadm": {
      "name": "Sopi\u00c5\u00a1te",
      "gid": "MKD.64_1"
    },
    "code": "MK-812"
  },
  "1430": {
    "gadm": {
      "name": "Staro Nagori\u00c4\u008dane",
      "gid": "MKD.66_1"
    },
    "code": "MK-706"
  },
  "1431": {
    "gadm": {
      "name": "\u00c5\u00a0tip",
      "gid": "MKD.67_1"
    },
    "code": "MK-211"
  },
  "1432": {
    "gadm": {
      "name": "Struga",
      "gid": "MKD.68_1"
    },
    "code": "MK-312"
  },
  "1433": {
    "gadm": {
      "name": "Strumitsa",
      "gid": "MKD.69_1"
    },
    "code": "MK-410"
  },
  "1434": {
    "gadm": {
      "name": "Studeni\u00c4\u008dani",
      "gid": "MKD.70_1"
    },
    "code": "MK-813"
  },
  "1435": {
    "gadm": {
      "name": "\u00c5\u00a0uto Orizari",
      "gid": "MKD.71_1"
    },
    "code": "MK-817"
  },
  "1436": {
    "gadm": {
      "name": "Sveti Nikole",
      "gid": "MKD.72_1"
    },
    "code": "MK-108"
  },
  "1437": {
    "gadm": {
      "name": "Tearce",
      "gid": "MKD.73_1"
    },
    "code": "MK-608"
  },
  "1438": {
    "gadm": {
      "name": "Tetovo",
      "gid": "MKD.74_1"
    },
    "code": "MK-609"
  },
  "1439": {
    "gadm": {
      "name": "Valandovo",
      "gid": "MKD.75_1"
    },
    "code": "MK-403"
  },
  "1440": {
    "gadm": {
      "name": "Vasilevo",
      "gid": "MKD.76_1"
    },
    "code": "MK-404"
  },
  "1441": {
    "gadm": {
      "name": "Veles",
      "gid": "MKD.77_1"
    },
    "code": "MK-101"
  },
  "1442": {
    "gadm": {
      "name": "Vev\u00c4\u008dani",
      "gid": "MKD.78_1"
    },
    "code": "MK-301"
  },
  "1443": {
    "gadm": {
      "name": "Vinitsa",
      "gid": "MKD.79_1"
    },
    "code": "MK-202"
  },
  "1444": {
    "gadm": {
      "name": "Zelenikovo",
      "gid": "MKD.83_1"
    },
    "code": "MK-806"
  },
  "1445": {
    "gadm": {
      "name": "\u00c5\u00bdelino",
      "gid": "MKD.84_1"
    },
    "code": "MK-605"
  },
  "1446": {
    "gadm": {
      "name": "Zrnovci",
      "gid": "MKD.85_1"
    },
    "code": "MK-204"
  },
  "1447": {
    "gadm": {
      "name": "Vrap\u00c4\u008di\u00c5\u00a1te",
      "gid": "MKD.81_1"
    },
    "code": "MK-603"
  },
  "1448": {
    "gadm": {
      "name": "Bamako",
      "gid": "MLI.1_1"
    },
    "code": "ML-BKO"
  },
  "1449": {
    "gadm": {
      "name": "Gao",
      "gid": "MLI.2_1"
    },
    "code": "ML-7"
  },
  "1450": {
    "gadm": {
      "name": "Kayes",
      "gid": "MLI.3_1"
    },
    "code": "ML-1"
  },
  "1451": {
    "gadm": {
      "name": "Kidal",
      "gid": "MLI.4_1"
    },
    "code": "ML-8"
  },
  "1452": {
    "gadm": {
      "name": "Koulikoro",
      "gid": "MLI.5_1"
    },
    "code": "ML-2"
  },
  "1453": {
    "gadm": {
      "name": "Mopti",
      "gid": "MLI.6_1"
    },
    "code": "ML-5"
  },
  "1454": {
    "gadm": {
      "name": "S\u00c3\u00a9gou",
      "gid": "MLI.7_1"
    },
    "code": "ML-4"
  },
  "1455": {
    "gadm": {
      "name": "Sikasso",
      "gid": "MLI.8_1"
    },
    "code": "ML-3"
  },
  "1456": {
    "gadm": {
      "name": "Timbuktu",
      "gid": "MLI.9_1"
    },
    "code": "ML-6"
  },
  "1457": {
    "gadm": {
      "name": "Ayeyarwady",
      "gid": "MMR.1_1"
    },
    "code": "MM-07"
  },
  "1458": {
    "gadm": {
      "name": "Bago",
      "gid": "MMR.2_1"
    },
    "code": "MM-02"
  },
  "1459": {
    "gadm": {
      "name": "Chin",
      "gid": "MMR.3_1"
    },
    "code": "MM-14"
  },
  "1460": {
    "gadm": {
      "name": "Kachin",
      "gid": "MMR.4_1"
    },
    "code": "MM-11"
  },
  "1461": {
    "gadm": {
      "name": "Kayah",
      "gid": "MMR.5_1"
    },
    "code": "MM-12"
  },
  "1462": {
    "gadm": {
      "name": "Kayin",
      "gid": "MMR.6_1"
    },
    "code": "MM-13"
  },
  "1463": {
    "gadm": {
      "name": "Magway",
      "gid": "MMR.7_1"
    },
    "code": "MM-03"
  },
  "1464": {
    "gadm": {
      "name": "Mandalay",
      "gid": "MMR.8_1"
    },
    "code": "MM-04"
  },
  "1465": {
    "gadm": {
      "name": "Mon",
      "gid": "MMR.9_1"
    },
    "code": "MM-15"
  },
  "1466": {
    "gadm": {
      "name": "Naypyitaw",
      "gid": "MMR.10_1"
    },
    "code": "MM-18"
  },
  "1467": {
    "gadm": {
      "name": "Rakhine",
      "gid": "MMR.11_1"
    },
    "code": "MM-16"
  },
  "1468": {
    "gadm": {
      "name": "Sagaing",
      "gid": "MMR.12_1"
    },
    "code": "MM-01"
  },
  "1469": {
    "gadm": {
      "name": "Shan",
      "gid": "MMR.13_1"
    },
    "code": "MM-17"
  },
  "1470": {
    "gadm": {
      "name": "Tanintharyi",
      "gid": "MMR.14_1"
    },
    "code": "MM-05"
  },
  "1471": {
    "gadm": {
      "name": "Yangon",
      "gid": "MMR.15_1"
    },
    "code": "MM-06"
  },
  "1472": {
    "gadm": {
      "name": "Arhangay",
      "gid": "MNG.1_1"
    },
    "code": "MN-073"
  },
  "1473": {
    "gadm": {
      "name": "Bayan-\u00c3\u2013lgiy",
      "gid": "MNG.2_1"
    },
    "code": "MN-069"
  },
  "1474": {
    "gadm": {
      "name": "Bayanhongor",
      "gid": "MNG.3_1"
    },
    "code": "MN-071"
  },
  "1475": {
    "gadm": {
      "name": "Bulgan",
      "gid": "MNG.4_1"
    },
    "code": "MN-067"
  },
  "1476": {
    "gadm": {
      "name": "Darhan-Uul",
      "gid": "MNG.5_1"
    },
    "code": "MN-037"
  },
  "1477": {
    "gadm": {
      "name": "Dornod",
      "gid": "MNG.6_1"
    },
    "code": "MN-061"
  },
  "1478": {
    "gadm": {
      "name": "Dornogovi",
      "gid": "MNG.7_1"
    },
    "code": "MN-063"
  },
  "1479": {
    "gadm": {
      "name": "Dundgovi",
      "gid": "MNG.8_1"
    },
    "code": "MN-059"
  },
  "1480": {
    "gadm": {
      "name": "Dzavhan",
      "gid": "MNG.9_1"
    },
    "code": "MN-057"
  },
  "1481": {
    "gadm": {
      "name": "Govi-Altay",
      "gid": "MNG.10_1"
    },
    "code": "MN-065"
  },
  "1482": {
    "gadm": {
      "name": "Govis\u00c3\u00bcmber",
      "gid": "MNG.11_1"
    },
    "code": "MN-064"
  },
  "1483": {
    "gadm": {
      "name": "Hentiy",
      "gid": "MNG.12_1"
    },
    "code": "MN-039"
  },
  "1484": {
    "gadm": {
      "name": "Hovd",
      "gid": "MNG.13_1"
    },
    "code": "MN-043"
  },
  "1485": {
    "gadm": {
      "name": "H\u00c3\u00b6vsg\u00c3\u00b6l",
      "gid": "MNG.14_1"
    },
    "code": "MN-041"
  },
  "1486": {
    "gadm": {
      "name": "\u00c3\u2013mn\u00c3\u00b6govi",
      "gid": "MNG.15_1"
    },
    "code": "MN-053"
  },
  "1487": {
    "gadm": {
      "name": "Orhon",
      "gid": "MNG.16_1"
    },
    "code": "MN-035"
  },
  "1488": {
    "gadm": {
      "name": "\u00c3\u2013v\u00c3\u00b6rhangay",
      "gid": "MNG.17_1"
    },
    "code": "MN-055"
  },
  "1489": {
    "gadm": {
      "name": "Selenge",
      "gid": "MNG.18_1"
    },
    "code": "MN-049"
  },
  "1490": {
    "gadm": {
      "name": "S\u00c3\u00bchbaatar",
      "gid": "MNG.19_1"
    },
    "code": "MN-051"
  },
  "1491": {
    "gadm": {
      "name": "T\u00c3\u00b6v",
      "gid": "MNG.20_1"
    },
    "code": "MN-047"
  },
  "1492": {
    "gadm": {
      "name": "Ulaanbaatar",
      "gid": "MNG.21_1"
    },
    "code": "MN-1"
  },
  "1493": {
    "gadm": {
      "name": "Uvs",
      "gid": "MNG.22_1"
    },
    "code": "MN-046"
  },
  "1494": {
    "gadm": {
      "name": "Adrar",
      "gid": "MRT.1_1"
    },
    "code": "MR-07"
  },
  "1495": {
    "gadm": {
      "name": "Assaba",
      "gid": "MRT.2_1"
    },
    "code": "MR-03"
  },
  "1496": {
    "gadm": {
      "name": "Brakna",
      "gid": "MRT.3_1"
    },
    "code": "MR-05"
  },
  "1497": {
    "gadm": {
      "name": "Dakhlet Nouadhibou",
      "gid": "MRT.4_1"
    },
    "code": "MR-08"
  },
  "1498": {
    "gadm": {
      "name": "Gorgol",
      "gid": "MRT.5_1"
    },
    "code": "MR-04"
  },
  "1499": {
    "gadm": {
      "name": "Guidimaka",
      "gid": "MRT.6_1"
    },
    "code": "MR-10"
  },
  "1500": {
    "gadm": {
      "name": "Hodh ech Chargui",
      "gid": "MRT.7_1"
    },
    "code": "MR-01"
  },
  "1501": {
    "gadm": {
      "name": "Hodh el Gharbi",
      "gid": "MRT.8_1"
    },
    "code": "MR-02"
  },
  "1502": {
    "gadm": {
      "name": "Inchiri",
      "gid": "MRT.9_1"
    },
    "code": "MR-12"
  },
  "1503": {
    "gadm": {
      "name": "Nouakchott",
      "gid": "MRT.10_1"
    },
    "code": "MR-13"
  },
  "1504": {
    "gadm": {
      "name": "Tagant",
      "gid": "MRT.11_1"
    },
    "code": "MR-09"
  },
  "1505": {
    "gadm": {
      "name": "Tiris Zemmour",
      "gid": "MRT.12_1"
    },
    "code": "MR-11"
  },
  "1506": {
    "gadm": {
      "name": "Trarza",
      "gid": "MRT.13_1"
    },
    "code": "MR-06"
  },
  "1507": {
    "gadm": {
      "name": "Agalega Islands",
      "gid": "MUS.1_1"
    },
    "code": "MU-AG"
  },
  "1508": {
    "gadm": {
      "name": "Black River",
      "gid": "MUS.2_1"
    },
    "code": "MU-BL"
  },
  "1509": {
    "gadm": {
      "name": "Flacq",
      "gid": "MUS.3_1"
    },
    "code": "MU-FL"
  },
  "1510": {
    "gadm": {
      "name": "Grand Port",
      "gid": "MUS.4_1"
    },
    "code": "MU-GP"
  },
  "1511": {
    "gadm": {
      "name": "Moka",
      "gid": "MUS.5_1"
    },
    "code": "MU-MO"
  },
  "1512": {
    "gadm": {
      "name": "Pamplemousses",
      "gid": "MUS.6_1"
    },
    "code": "MU-PA"
  },
  "1513": {
    "gadm": {
      "name": "Plaines Wilhems",
      "gid": "MUS.7_1"
    },
    "code": "MU-PW"
  },
  "1514": {
    "gadm": {
      "name": "Port Louis",
      "gid": "MUS.8_1"
    },
    "code": "MU-PL"
  },
  "1515": {
    "gadm": {
      "name": "Rivi\u00c3\u00a8re du Rempart",
      "gid": "MUS.9_1"
    },
    "code": "MU-RR"
  },
  "1516": {
    "gadm": {
      "name": "Rodriguez",
      "gid": "MUS.10_1"
    },
    "code": "MU-RO"
  },
  "1517": {
    "gadm": {
      "name": "Saint Brandon",
      "gid": "MUS.11_1"
    },
    "code": "MU-CC"
  },
  "1518": {
    "gadm": {
      "name": "Savanne",
      "gid": "MUS.12_1"
    },
    "code": "MU-SA"
  },
  "1519": {
    "gadm": {
      "name": "Balaka",
      "gid": "MWI.1_1"
    },
    "code": "MW-S"
  },
  "1520": {
    "gadm": {
      "name": "Dedza",
      "gid": "MWI.6_1"
    },
    "code": "MW-C"
  },
  "1521": {
    "gadm": {
      "name": "Karonga",
      "gid": "MWI.8_1"
    },
    "code": "MW-N"
  },
  "1522": {
    "gadm": {
      "name": "Aguascalientes",
      "gid": "MEX.1_1"
    },
    "code": "MX-AGU"
  },
  "1523": {
    "gadm": {
      "name": "Baja California",
      "gid": "MEX.3_1"
    },
    "code": "MX-BCN"
  },
  "1524": {
    "gadm": {
      "name": "Baja California Sur",
      "gid": "MEX.2_1"
    },
    "code": "MX-BCS"
  },
  "1525": {
    "gadm": {
      "name": "Campeche",
      "gid": "MEX.4_1"
    },
    "code": "MX-CAM"
  },
  "1526": {
    "gadm": {
      "name": "Chiapas",
      "gid": "MEX.5_1"
    },
    "code": "MX-CHP"
  },
  "1527": {
    "gadm": {
      "name": "Chihuahua",
      "gid": "MEX.6_1"
    },
    "code": "MX-CHH"
  },
  "1528": {
    "gadm": {
      "name": "Coahuila",
      "gid": "MEX.7_1"
    },
    "code": "MX-COA"
  },
  "1529": {
    "gadm": {
      "name": "Colima",
      "gid": "MEX.8_1"
    },
    "code": "MX-COL"
  },
  "1530": {
    "gadm": {
      "name": "Distrito Federal",
      "gid": "MEX.9_1"
    },
    "code": "MX-CMX"
  },
  "1531": {
    "gadm": {
      "name": "Durango",
      "gid": "MEX.10_1"
    },
    "code": "MX-DUR"
  },
  "1532": {
    "gadm": {
      "name": "Guanajuato",
      "gid": "MEX.11_1"
    },
    "code": "MX-GUA"
  },
  "1533": {
    "gadm": {
      "name": "Guerrero",
      "gid": "MEX.12_1"
    },
    "code": "MX-GRO"
  },
  "1534": {
    "gadm": {
      "name": "Hidalgo",
      "gid": "MEX.13_1"
    },
    "code": "MX-HID"
  },
  "1535": {
    "gadm": {
      "name": "Jalisco",
      "gid": "MEX.14_1"
    },
    "code": "MX-JAL"
  },
  "1536": {
    "gadm": {
      "name": "M\u00c3\u00a9xico",
      "gid": "MEX.15_1"
    },
    "code": "MX-MEX"
  },
  "1537": {
    "gadm": {
      "name": "Michoac\u00c3\u00a1n",
      "gid": "MEX.16_1"
    },
    "code": "MX-MIC"
  },
  "1538": {
    "gadm": {
      "name": "Morelos",
      "gid": "MEX.17_1"
    },
    "code": "MX-MOR"
  },
  "1539": {
    "gadm": {
      "name": "Nayarit",
      "gid": "MEX.18_1"
    },
    "code": "MX-NAY"
  },
  "1540": {
    "gadm": {
      "name": "Nuevo Le\u00c3\u00b3n",
      "gid": "MEX.19_1"
    },
    "code": "MX-NLE"
  },
  "1541": {
    "gadm": {
      "name": "Oaxaca",
      "gid": "MEX.20_1"
    },
    "code": "MX-OAX"
  },
  "1542": {
    "gadm": {
      "name": "Puebla",
      "gid": "MEX.21_1"
    },
    "code": "MX-PUE"
  },
  "1543": {
    "gadm": {
      "name": "Quer\u00c3\u00a9taro",
      "gid": "MEX.22_1"
    },
    "code": "MX-QUE"
  },
  "1544": {
    "gadm": {
      "name": "Quintana Roo",
      "gid": "MEX.23_1"
    },
    "code": "MX-ROO"
  },
  "1545": {
    "gadm": {
      "name": "San Luis Potos\u00c3\u00ad",
      "gid": "MEX.24_1"
    },
    "code": "MX-SLP"
  },
  "1546": {
    "gadm": {
      "name": "Sinaloa",
      "gid": "MEX.25_1"
    },
    "code": "MX-SIN"
  },
  "1547": {
    "gadm": {
      "name": "Sonora",
      "gid": "MEX.26_1"
    },
    "code": "MX-SON"
  },
  "1548": {
    "gadm": {
      "name": "Tabasco",
      "gid": "MEX.27_1"
    },
    "code": "MX-TAB"
  },
  "1549": {
    "gadm": {
      "name": "Tamaulipas",
      "gid": "MEX.28_1"
    },
    "code": "MX-TAM"
  },
  "1550": {
    "gadm": {
      "name": "Tlaxcala",
      "gid": "MEX.29_1"
    },
    "code": "MX-TLA"
  },
  "1551": {
    "gadm": {
      "name": "Veracruz",
      "gid": "MEX.30_1"
    },
    "code": "MX-VER"
  },
  "1552": {
    "gadm": {
      "name": "Yucat\u00c3\u00a1n",
      "gid": "MEX.31_1"
    },
    "code": "MX-YUC"
  },
  "1553": {
    "gadm": {
      "name": "Zacatecas",
      "gid": "MEX.32_1"
    },
    "code": "MX-ZAC"
  },
  "1554": {
    "gadm": {
      "name": "Johor",
      "gid": "MYS.1_1"
    },
    "code": "MY-01"
  },
  "1555": {
    "gadm": {
      "name": "Kedah",
      "gid": "MYS.2_1"
    },
    "code": "MY-02"
  },
  "1556": {
    "gadm": {
      "name": "Kelantan",
      "gid": "MYS.3_1"
    },
    "code": "MY-03"
  },
  "1557": {
    "gadm": {
      "name": "Kuala Lumpur",
      "gid": "MYS.4_1"
    },
    "code": "MY-14"
  },
  "1558": {
    "gadm": {
      "name": "Labuan",
      "gid": "MYS.5_1"
    },
    "code": "MY-15"
  },
  "1559": {
    "gadm": {
      "name": "Melaka",
      "gid": "MYS.6_1"
    },
    "code": "MY-04"
  },
  "1560": {
    "gadm": {
      "name": "Negeri Sembilan",
      "gid": "MYS.7_1"
    },
    "code": "MY-05"
  },
  "1561": {
    "gadm": {
      "name": "Pahang",
      "gid": "MYS.8_1"
    },
    "code": "MY-06"
  },
  "1562": {
    "gadm": {
      "name": "Perak",
      "gid": "MYS.9_1"
    },
    "code": "MY-08"
  },
  "1563": {
    "gadm": {
      "name": "Perlis",
      "gid": "MYS.10_1"
    },
    "code": "MY-09"
  },
  "1564": {
    "gadm": {
      "name": "Pulau Pinang",
      "gid": "MYS.11_1"
    },
    "code": "MY-07"
  },
  "1565": {
    "gadm": {
      "name": "Putrajaya",
      "gid": "MYS.12_1"
    },
    "code": "MY-16"
  },
  "1566": {
    "gadm": {
      "name": "Sabah",
      "gid": "MYS.13_1"
    },
    "code": "MY-12"
  },
  "1567": {
    "gadm": {
      "name": "Sarawak",
      "gid": "MYS.14_1"
    },
    "code": "MY-13"
  },
  "1568": {
    "gadm": {
      "name": "Selangor",
      "gid": "MYS.15_1"
    },
    "code": "MY-10"
  },
  "1569": {
    "gadm": {
      "name": "Trengganu",
      "gid": "MYS.16_1"
    },
    "code": "MY-11"
  },
  "1570": {
    "gadm": {
      "name": "Cabo Delgado",
      "gid": "MOZ.1_1"
    },
    "code": "MZ-P"
  },
  "1571": {
    "gadm": {
      "name": "Gaza",
      "gid": "MOZ.2_1"
    },
    "code": "MZ-G"
  },
  "1572": {
    "gadm": {
      "name": "Inhambane",
      "gid": "MOZ.3_1"
    },
    "code": "MZ-I"
  },
  "1573": {
    "gadm": {
      "name": "Manica",
      "gid": "MOZ.4_1"
    },
    "code": "MZ-B"
  },
  "1574": {
    "gadm": {
      "name": "Maputo",
      "gid": "MOZ.6_1"
    },
    "code": "MZ-MPM"
  },
  "1575": {
    "gadm": {
      "name": "Maputo City",
      "gid": "MOZ.5_1"
    },
    "code": "MZ-L"
  },
  "1576": {
    "gadm": {
      "name": "Nampula",
      "gid": "MOZ.7_1"
    },
    "code": "MZ-N"
  },
  "1577": {
    "gadm": {
      "name": "Nassa",
      "gid": "MOZ.8_1"
    },
    "code": "MZ-A"
  },
  "1578": {
    "gadm": {
      "name": "Sofala",
      "gid": "MOZ.9_1"
    },
    "code": "MZ-S"
  },
  "1579": {
    "gadm": {
      "name": "Tete",
      "gid": "MOZ.10_1"
    },
    "code": "MZ-T"
  },
  "1580": {
    "gadm": {
      "name": "Zambezia",
      "gid": "MOZ.11_1"
    },
    "code": "MZ-Q"
  },
  "1581": {
    "gadm": {
      "name": "Erongo",
      "gid": "NAM.2_1"
    },
    "code": "NA-ER"
  },
  "1582": {
    "gadm": {
      "name": "Hardap",
      "gid": "NAM.3_1"
    },
    "code": "NA-HA"
  },
  "1583": {
    "gadm": {
      "name": "Karas",
      "gid": "NAM.1_1"
    },
    "code": "NA-KA"
  },
  "1584": {
    "gadm": {
      "name": "Kavango",
      "gid": "NAM.4_1"
    },
    "code": "NA-K"
  },
  "1585": {
    "gadm": {
      "name": "Khomas",
      "gid": "NAM.5_1"
    },
    "code": "NA-KH"
  },
  "1586": {
    "gadm": {
      "name": "Kunene",
      "gid": "NAM.6_1"
    },
    "code": "NA-KU"
  },
  "1587": {
    "gadm": {
      "name": "Ohangwena",
      "gid": "NAM.7_1"
    },
    "code": "NA-OW"
  },
  "1588": {
    "gadm": {
      "name": "Omaheke",
      "gid": "NAM.8_1"
    },
    "code": "NA-OH"
  },
  "1589": {
    "gadm": {
      "name": "Omusati",
      "gid": "NAM.9_1"
    },
    "code": "NA-OS"
  },
  "1590": {
    "gadm": {
      "name": "Oshana",
      "gid": "NAM.10_1"
    },
    "code": "NA-ON"
  },
  "1591": {
    "gadm": {
      "name": "Oshikoto",
      "gid": "NAM.11_1"
    },
    "code": "NA-OT"
  },
  "1592": {
    "gadm": {
      "name": "Otjozondjupa",
      "gid": "NAM.12_1"
    },
    "code": "NA-OD"
  },
  "1593": {
    "gadm": {
      "name": "Zambezi",
      "gid": "NAM.13_1"
    },
    "code": "NA-CA"
  },
  "1594": {
    "gadm": {
      "name": "Agadez",
      "gid": "NER.1_1"
    },
    "code": "NE-1"
  },
  "1595": {
    "gadm": {
      "name": "Diffa",
      "gid": "NER.2_1"
    },
    "code": "NE-2"
  },
  "1596": {
    "gadm": {
      "name": "Dosso",
      "gid": "NER.3_1"
    },
    "code": "NE-3"
  },
  "1597": {
    "gadm": {
      "name": "Maradi",
      "gid": "NER.4_1"
    },
    "code": "NE-4"
  },
  "1598": {
    "gadm": {
      "name": "Niamey",
      "gid": "NER.5_1"
    },
    "code": "NE-8"
  },
  "1599": {
    "gadm": {
      "name": "Tahoua",
      "gid": "NER.6_1"
    },
    "code": "NE-5"
  },
  "1600": {
    "gadm": {
      "name": "Tillab\u00c3\u00a9ry",
      "gid": "NER.7_1"
    },
    "code": "NE-6"
  },
  "1601": {
    "gadm": {
      "name": "Zinder",
      "gid": "NER.8_1"
    },
    "code": "NE-7"
  },
  "1602": {
    "gadm": {
      "name": "Abia",
      "gid": "NGA.1_1"
    },
    "code": "NG-AB"
  },
  "1603": {
    "gadm": {
      "name": "Adamawa",
      "gid": "NGA.2_1"
    },
    "code": "NG-AD"
  },
  "1604": {
    "gadm": {
      "name": "Akwa Ibom",
      "gid": "NGA.3_1"
    },
    "code": "NG-AK"
  },
  "1605": {
    "gadm": {
      "name": "Anambra",
      "gid": "NGA.4_1"
    },
    "code": "NG-AN"
  },
  "1606": {
    "gadm": {
      "name": "Bauchi",
      "gid": "NGA.5_1"
    },
    "code": "NG-BA"
  },
  "1607": {
    "gadm": {
      "name": "Bayelsa",
      "gid": "NGA.6_1"
    },
    "code": "NG-BY"
  },
  "1608": {
    "gadm": {
      "name": "Benue",
      "gid": "NGA.7_1"
    },
    "code": "NG-BE"
  },
  "1609": {
    "gadm": {
      "name": "Borno",
      "gid": "NGA.8_1"
    },
    "code": "NG-BO"
  },
  "1610": {
    "gadm": {
      "name": "Cross River",
      "gid": "NGA.9_1"
    },
    "code": "NG-CR"
  },
  "1611": {
    "gadm": {
      "name": "Delta",
      "gid": "NGA.10_1"
    },
    "code": "NG-DE"
  },
  "1612": {
    "gadm": {
      "name": "Ebonyi",
      "gid": "NGA.11_1"
    },
    "code": "NG-EB"
  },
  "1613": {
    "gadm": {
      "name": "Edo",
      "gid": "NGA.12_1"
    },
    "code": "NG-ED"
  },
  "1614": {
    "gadm": {
      "name": "Ekiti",
      "gid": "NGA.13_1"
    },
    "code": "NG-EK"
  },
  "1615": {
    "gadm": {
      "name": "Enugu",
      "gid": "NGA.14_1"
    },
    "code": "NG-EN"
  },
  "1616": {
    "gadm": {
      "name": "Federal Capital Territory",
      "gid": "NGA.15_1"
    },
    "code": "NG-FC"
  },
  "1617": {
    "gadm": {
      "name": "Gombe",
      "gid": "NGA.16_1"
    },
    "code": "NG-GO"
  },
  "1618": {
    "gadm": {
      "name": "Imo",
      "gid": "NGA.17_1"
    },
    "code": "NG-IM"
  },
  "1619": {
    "gadm": {
      "name": "Jigawa",
      "gid": "NGA.18_1"
    },
    "code": "NG-JI"
  },
  "1620": {
    "gadm": {
      "name": "Kaduna",
      "gid": "NGA.19_1"
    },
    "code": "NG-KD"
  },
  "1621": {
    "gadm": {
      "name": "Kano",
      "gid": "NGA.20_1"
    },
    "code": "NG-KN"
  },
  "1622": {
    "gadm": {
      "name": "Katsina",
      "gid": "NGA.21_1"
    },
    "code": "NG-KT"
  },
  "1623": {
    "gadm": {
      "name": "Kebbi",
      "gid": "NGA.22_1"
    },
    "code": "NG-KE"
  },
  "1624": {
    "gadm": {
      "name": "Kogi",
      "gid": "NGA.23_1"
    },
    "code": "NG-KO"
  },
  "1625": {
    "gadm": {
      "name": "Kwara",
      "gid": "NGA.24_1"
    },
    "code": "NG-KW"
  },
  "1626": {
    "gadm": {
      "name": "Lagos",
      "gid": "NGA.25_1"
    },
    "code": "NG-LA"
  },
  "1627": {
    "gadm": {
      "name": "Nassarawa",
      "gid": "NGA.26_1"
    },
    "code": "NG-NA"
  },
  "1628": {
    "gadm": {
      "name": "Niger",
      "gid": "NGA.27_1"
    },
    "code": "NG-NI"
  },
  "1629": {
    "gadm": {
      "name": "Ogun",
      "gid": "NGA.28_1"
    },
    "code": "NG-OG"
  },
  "1630": {
    "gadm": {
      "name": "Ondo",
      "gid": "NGA.29_1"
    },
    "code": "NG-ON"
  },
  "1631": {
    "gadm": {
      "name": "Osun",
      "gid": "NGA.30_1"
    },
    "code": "NG-OS"
  },
  "1632": {
    "gadm": {
      "name": "Oyo",
      "gid": "NGA.31_1"
    },
    "code": "NG-OY"
  },
  "1633": {
    "gadm": {
      "name": "Plateau",
      "gid": "NGA.32_1"
    },
    "code": "NG-PL"
  },
  "1634": {
    "gadm": {
      "name": "Rivers",
      "gid": "NGA.33_1"
    },
    "code": "NG-RI"
  },
  "1635": {
    "gadm": {
      "name": "Sokoto",
      "gid": "NGA.34_1"
    },
    "code": "NG-SO"
  },
  "1636": {
    "gadm": {
      "name": "Taraba",
      "gid": "NGA.35_1"
    },
    "code": "NG-TA"
  },
  "1637": {
    "gadm": {
      "name": "Yobe",
      "gid": "NGA.36_1"
    },
    "code": "NG-YO"
  },
  "1638": {
    "gadm": {
      "name": "Zamfara",
      "gid": "NGA.37_1"
    },
    "code": "NG-ZA"
  },
  "1639": {
    "gadm": {
      "name": "Atl\u00c3\u00a1ntico Norte",
      "gid": "NIC.1_1"
    },
    "code": "NI-AN"
  },
  "1640": {
    "gadm": {
      "name": "Atl\u00c3\u00a1ntico Sur",
      "gid": "NIC.2_1"
    },
    "code": "NI-AS"
  },
  "1641": {
    "gadm": {
      "name": "Boaco",
      "gid": "NIC.9_1"
    },
    "code": "NI-BO"
  },
  "1642": {
    "gadm": {
      "name": "Carazo",
      "gid": "NIC.15_1"
    },
    "code": "NI-CA"
  },
  "1643": {
    "gadm": {
      "name": "Chinandega",
      "gid": "NIC.7_1"
    },
    "code": "NI-CI"
  },
  "1644": {
    "gadm": {
      "name": "Chontales",
      "gid": "NIC.12_1"
    },
    "code": "NI-CO"
  },
  "1645": {
    "gadm": {
      "name": "Estel\u00c3\u00ad",
      "gid": "NIC.5_1"
    },
    "code": "NI-ES"
  },
  "1646": {
    "gadm": {
      "name": "Granada",
      "gid": "NIC.14_1"
    },
    "code": "NI-GR"
  },
  "1647": {
    "gadm": {
      "name": "Jinotega",
      "gid": "NIC.3_1"
    },
    "code": "NI-JI"
  },
  "1648": {
    "gadm": {
      "name": "Le\u00c3\u00b3n",
      "gid": "NIC.8_1"
    },
    "code": "NI-LE"
  },
  "1649": {
    "gadm": {
      "name": "Madriz",
      "gid": "NIC.4_1"
    },
    "code": "NI-MD"
  },
  "1650": {
    "gadm": {
      "name": "Managua",
      "gid": "NIC.11_1"
    },
    "code": "NI-MN"
  },
  "1651": {
    "gadm": {
      "name": "Masaya",
      "gid": "NIC.13_1"
    },
    "code": "NI-MS"
  },
  "1652": {
    "gadm": {
      "name": "Matagalpa",
      "gid": "NIC.6_1"
    },
    "code": "NI-MT"
  },
  "1653": {
    "gadm": {
      "name": "Rivas",
      "gid": "NIC.18_1"
    },
    "code": "NI-SRI"
  },
  "1654": {
    "gadm": {
      "name": "R\u00c3\u00ado San Juan",
      "gid": "NIC.17_1"
    },
    "code": "NI-SJ"
  },
  "1655": {
    "gadm": {
      "name": "Akershus",
      "gid": "NOR.1_1"
    },
    "code": "NO-02"
  },
  "1656": {
    "gadm": {
      "name": "\u00c3\u0192stfold",
      "gid": "NOR.2_1"
    },
    "code": "NO-01"
  },
  "1657": {
    "gadm": {
      "name": "Aust-Agder",
      "gid": "NOR.3_1"
    },
    "code": "NO-09"
  },
  "1658": {
    "gadm": {
      "name": "Buskerud",
      "gid": "NOR.4_1"
    },
    "code": "NO-06"
  },
  "1659": {
    "gadm": {
      "name": "Finnmark",
      "gid": "NOR.5_1"
    },
    "code": "NO-20"
  },
  "1660": {
    "gadm": {
      "name": "Hedmark",
      "gid": "NOR.6_1"
    },
    "code": "NO-04"
  },
  "1661": {
    "gadm": {
      "name": "Hordaland",
      "gid": "NOR.7_1"
    },
    "code": "NO-12"
  },
  "1662": {
    "gadm": {
      "name": "M\u00c3\u00b8re og Romsdal",
      "gid": "NOR.8_1"
    },
    "code": "NO-15"
  },
  "1663": {
    "gadm": {
      "name": "Nordland",
      "gid": "NOR.10_1"
    },
    "code": "NO-18"
  },
  "1664": {
    "gadm": {
      "name": "Oppland",
      "gid": "NOR.11_1"
    },
    "code": "NO-05"
  },
  "1665": {
    "gadm": {
      "name": "Oslo",
      "gid": "NOR.12_1"
    },
    "code": "NO-03"
  },
  "1666": {
    "gadm": {
      "name": "Rogaland",
      "gid": "NOR.13_1"
    },
    "code": "NO-11"
  },
  "1667": {
    "gadm": {
      "name": "Sogn og Fjordane",
      "gid": "NOR.14_1"
    },
    "code": "NO-14"
  },
  "1668": {
    "gadm": {
      "name": "Telemark",
      "gid": "NOR.16_1"
    },
    "code": "NO-08"
  },
  "1669": {
    "gadm": {
      "name": "Troms",
      "gid": "NOR.17_1"
    },
    "code": "NO-19"
  },
  "1670": {
    "gadm": {
      "name": "Vest-Agder",
      "gid": "NOR.18_1"
    },
    "code": "NO-10"
  },
  "1671": {
    "gadm": {
      "name": "Vestfold",
      "gid": "NOR.19_1"
    },
    "code": "NO-07"
  },
  "1672": {
    "gadm": {
      "name": "Nord-Tr\u00c3\u00b8ndelag",
      "gid": "NOR.9_1"
    },
    "code": "NO-50"
  },
  "1673": {
    "gadm": {
      "name": "Mid-Western",
      "gid": "NPL.4_1"
    },
    "code": "NPL.4_1"
  },
  "1674": {
    "gadm": {
      "name": "West",
      "gid": "NPL.5_1"
    },
    "code": "NPL.5_1"
  },
  "1675": {
    "gadm": {
      "name": "Far-Western",
      "gid": "NPL.3_1"
    },
    "code": "NPL.3_1"
  },
  "1676": {
    "gadm": {
      "name": "Central",
      "gid": "NPL.1_1"
    },
    "code": "NPL.1_1"
  },
  "1677": {
    "gadm": {
      "name": "East",
      "gid": "NPL.2_1"
    },
    "code": "NPL.2_1"
  },
  "1678": {
    "gadm": {
      "name": "Aiwo",
      "gid": "NRU.1_1"
    },
    "code": "NR-01"
  },
  "1679": {
    "gadm": {
      "name": "Anabar",
      "gid": "NRU.2_1"
    },
    "code": "NR-02"
  },
  "1680": {
    "gadm": {
      "name": "Anetan",
      "gid": "NRU.3_1"
    },
    "code": "NR-03"
  },
  "1681": {
    "gadm": {
      "name": "Anibare",
      "gid": "NRU.4_1"
    },
    "code": "NR-04"
  },
  "1682": {
    "gadm": {
      "name": "Baiti",
      "gid": "NRU.5_1"
    },
    "code": "NR-05"
  },
  "1683": {
    "gadm": {
      "name": "Boe",
      "gid": "NRU.6_1"
    },
    "code": "NR-06"
  },
  "1684": {
    "gadm": {
      "name": "Buada",
      "gid": "NRU.7_1"
    },
    "code": "NR-07"
  },
  "1685": {
    "gadm": {
      "name": "Denigomodu",
      "gid": "NRU.8_1"
    },
    "code": "NR-08"
  },
  "1686": {
    "gadm": {
      "name": "Ewa",
      "gid": "NRU.9_1"
    },
    "code": "NR-09"
  },
  "1687": {
    "gadm": {
      "name": "Ijuw",
      "gid": "NRU.10_1"
    },
    "code": "NR-10"
  },
  "1688": {
    "gadm": {
      "name": "Meneng",
      "gid": "NRU.11_1"
    },
    "code": "NR-11"
  },
  "1689": {
    "gadm": {
      "name": "Nibok",
      "gid": "NRU.12_1"
    },
    "code": "NR-12"
  },
  "1690": {
    "gadm": {
      "name": "Uaboe",
      "gid": "NRU.13_1"
    },
    "code": "NR-13"
  },
  "1691": {
    "gadm": {
      "name": "Yaren",
      "gid": "NRU.14_1"
    },
    "code": "NR-14"
  },
  "1692": {
    "gadm": {
      "name": "Auckland",
      "gid": "NZL.2_1"
    },
    "code": "NZ-AUK"
  },
  "1693": {
    "gadm": {
      "name": "Bay of Plenty",
      "gid": "NZL.4_1"
    },
    "code": "NZ-BOP"
  },
  "1694": {
    "gadm": {
      "name": "Canterbury",
      "gid": "NZL.13_1"
    },
    "code": "NZ-CAN"
  },
  "1695": {
    "gadm": {
      "name": "Chatham Islands",
      "gid": "NZL.14_1"
    },
    "code": "NZ-CIT"
  },
  "1696": {
    "gadm": {
      "name": "Gisborne",
      "gid": "NZL.5_1"
    },
    "code": "NZ-GIS"
  },
  "1697": {
    "gadm": {
      "name": "Hawke's Bay",
      "gid": "NZL.7_1"
    },
    "code": "NZ-HKB"
  },
  "1698": {
    "gadm": {
      "name": "Marlborough",
      "gid": "NZL.11_1"
    },
    "code": "NZ-MBH"
  },
  "1699": {
    "gadm": {
      "name": "Nelson",
      "gid": "NZL.10_1"
    },
    "code": "NZ-TAS"
  },
  "1700": {
    "gadm": {
      "name": "Northland",
      "gid": "NZL.1_1"
    },
    "code": "NZ-NTL"
  },
  "1701": {
    "gadm": {
      "name": "Otago",
      "gid": "NZL.15_1"
    },
    "code": "NZ-OTA"
  },
  "1702": {
    "gadm": {
      "name": "Southland",
      "gid": "NZL.16_1"
    },
    "code": "NZ-STL"
  },
  "1703": {
    "gadm": {
      "name": "Taranaki",
      "gid": "NZL.6_1"
    },
    "code": "NZ-TKI"
  },
  "1704": {
    "gadm": {
      "name": "Waikato",
      "gid": "NZL.3_1"
    },
    "code": "NZ-WKO"
  },
  "1705": {
    "gadm": {
      "name": "Wellington",
      "gid": "NZL.9_1"
    },
    "code": "NZ-WGN"
  },
  "1706": {
    "gadm": {
      "name": "West Coast",
      "gid": "NZL.12_1"
    },
    "code": "NZ-WTC"
  },
  "1707": {
    "gadm": {
      "name": "Ad Dakhliyah",
      "gid": "OMN.1_1"
    },
    "code": "OM-DA"
  },
  "1708": {
    "gadm": {
      "name": "Al Batinah North",
      "gid": "OMN.2_1"
    },
    "code": "OM-BS"
  },
  "1709": {
    "gadm": {
      "name": "Al Batinah South",
      "gid": "OMN.3_1"
    },
    "code": "OM-BJ"
  },
  "1710": {
    "gadm": {
      "name": "Al Buraymi",
      "gid": "OMN.4_1"
    },
    "code": "OM-BU"
  },
  "1711": {
    "gadm": {
      "name": "Al Dhahira",
      "gid": "OMN.5_1"
    },
    "code": "OM-ZA"
  },
  "1712": {
    "gadm": {
      "name": "Al Wusta",
      "gid": "OMN.6_1"
    },
    "code": "OM-WU"
  },
  "1713": {
    "gadm": {
      "name": "Ash Sharqiyah North",
      "gid": "OMN.7_1"
    },
    "code": "OM-SS"
  },
  "1714": {
    "gadm": {
      "name": "Ash Sharqiyah South",
      "gid": "OMN.8_1"
    },
    "code": "OM-SJ"
  },
  "1715": {
    "gadm": {
      "name": "Dhofar",
      "gid": "OMN.9_1"
    },
    "code": "OM-ZU"
  },
  "1716": {
    "gadm": {
      "name": "Musandam",
      "gid": "OMN.10_1"
    },
    "code": "OM-MU"
  },
  "1717": {
    "gadm": {
      "name": "Muscat",
      "gid": "OMN.11_1"
    },
    "code": "OM-MA"
  },
  "1718": {
    "gadm": {
      "name": "Bocas del Toro",
      "gid": "PAN.1_1"
    },
    "code": "PA-1"
  },
  "1719": {
    "gadm": {
      "name": "Chiriqu\u00c3\u00ad",
      "gid": "PAN.2_1"
    },
    "code": "PA-4"
  },
  "1720": {
    "gadm": {
      "name": "Cocl\u00c3\u00a9",
      "gid": "PAN.3_1"
    },
    "code": "PA-2"
  },
  "1721": {
    "gadm": {
      "name": "Col\u00c3\u00b3n",
      "gid": "PAN.4_1"
    },
    "code": "PA-3"
  },
  "1722": {
    "gadm": {
      "name": "Dari\u00c3\u00a9n",
      "gid": "PAN.5_1"
    },
    "code": "PA-5"
  },
  "1723": {
    "gadm": {
      "name": "Ember\u00c3\u00a1",
      "gid": "PAN.6_1"
    },
    "code": "PA-EM"
  },
  "1724": {
    "gadm": {
      "name": "Herrera",
      "gid": "PAN.7_1"
    },
    "code": "PA-6"
  },
  "1725": {
    "gadm": {
      "name": "Kuna Yala",
      "gid": "PAN.8_1"
    },
    "code": "PA-HY"
  },
  "1726": {
    "gadm": {
      "name": "Los Santos",
      "gid": "PAN.9_1"
    },
    "code": "PA-7"
  },
  "1727": {
    "gadm": {
      "name": "Ng\u00c3\u00b6be Bugl\u00c3\u00a9",
      "gid": "PAN.10_1"
    },
    "code": "PA-NB"
  },
  "1728": {
    "gadm": {
      "name": "Panam\u00c3\u00a1",
      "gid": "PAN.12_1"
    },
    "code": "PA-8"
  },
  "1729": {
    "gadm": {
      "name": "Panam\u00c3\u00a1 Oeste",
      "gid": "PAN.11_1"
    },
    "code": "PA-10"
  },
  "1730": {
    "gadm": {
      "name": "Veraguas",
      "gid": "PAN.13_1"
    },
    "code": "PA-9"
  },
  "1731": {
    "gadm": {
      "name": "Amazonas",
      "gid": "PER.1_1"
    },
    "code": "PE-AMA"
  },
  "1732": {
    "gadm": {
      "name": "Ancash",
      "gid": "PER.2_1"
    },
    "code": "PE-ANC"
  },
  "1733": {
    "gadm": {
      "name": "Apur\u00c3\u00admac",
      "gid": "PER.3_1"
    },
    "code": "PE-APU"
  },
  "1734": {
    "gadm": {
      "name": "Arequipa",
      "gid": "PER.4_1"
    },
    "code": "PE-ARE"
  },
  "1735": {
    "gadm": {
      "name": "Ayacucho",
      "gid": "PER.5_1"
    },
    "code": "PE-AYA"
  },
  "1736": {
    "gadm": {
      "name": "Cajamarca",
      "gid": "PER.6_1"
    },
    "code": "PE-CAJ"
  },
  "1737": {
    "gadm": {
      "name": "Callao",
      "gid": "PER.7_1"
    },
    "code": "PE-CAL"
  },
  "1738": {
    "gadm": {
      "name": "Cusco",
      "gid": "PER.8_1"
    },
    "code": "PE-CUS"
  },
  "1739": {
    "gadm": {
      "name": "Huancavelica",
      "gid": "PER.9_1"
    },
    "code": "PE-HUV"
  },
  "1740": {
    "gadm": {
      "name": "Hu\u00c3\u00a1nuco",
      "gid": "PER.10_1"
    },
    "code": "PE-HUC"
  },
  "1741": {
    "gadm": {
      "name": "Ica",
      "gid": "PER.11_1"
    },
    "code": "PE-ICA"
  },
  "1742": {
    "gadm": {
      "name": "Jun\u00c3\u00adn",
      "gid": "PER.12_1"
    },
    "code": "PE-JUN"
  },
  "1743": {
    "gadm": {
      "name": "La Libertad",
      "gid": "PER.13_1"
    },
    "code": "PE-LAL"
  },
  "1744": {
    "gadm": {
      "name": "Lambayeque",
      "gid": "PER.14_1"
    },
    "code": "PE-LAM"
  },
  "1745": {
    "gadm": {
      "name": "Lima",
      "gid": "PER.16_1"
    },
    "code": "PE-LMA"
  },
  "1746": {
    "gadm": {
      "name": "Lima Province",
      "gid": "PER.15_1"
    },
    "code": "PE-LIM"
  },
  "1747": {
    "gadm": {
      "name": "Loreto",
      "gid": "PER.17_1"
    },
    "code": "PE-LOR"
  },
  "1748": {
    "gadm": {
      "name": "Madre de Dios",
      "gid": "PER.18_1"
    },
    "code": "PE-MDD"
  },
  "1749": {
    "gadm": {
      "name": "Moquegua",
      "gid": "PER.19_1"
    },
    "code": "PE-MOQ"
  },
  "1750": {
    "gadm": {
      "name": "Pasco",
      "gid": "PER.20_1"
    },
    "code": "PE-PAS"
  },
  "1751": {
    "gadm": {
      "name": "Piura",
      "gid": "PER.21_1"
    },
    "code": "PE-PIU"
  },
  "1752": {
    "gadm": {
      "name": "Puno",
      "gid": "PER.22_1"
    },
    "code": "PE-PUN"
  },
  "1753": {
    "gadm": {
      "name": "San Mart\u00c3\u00adn",
      "gid": "PER.23_1"
    },
    "code": "PE-SAM"
  },
  "1754": {
    "gadm": {
      "name": "Tacna",
      "gid": "PER.24_1"
    },
    "code": "PE-TAC"
  },
  "1755": {
    "gadm": {
      "name": "Tumbes",
      "gid": "PER.25_1"
    },
    "code": "PE-TUM"
  },
  "1756": {
    "gadm": {
      "name": "Ucayali",
      "gid": "PER.26_1"
    },
    "code": "PE-UCA"
  },
  "1757": {
    "gadm": {
      "name": "Bougainville",
      "gid": "PNG.1_1"
    },
    "code": "PG-NSB"
  },
  "1758": {
    "gadm": {
      "name": "Central",
      "gid": "PNG.2_1"
    },
    "code": "PG-CPM"
  },
  "1759": {
    "gadm": {
      "name": "Chimbu",
      "gid": "PNG.3_1"
    },
    "code": "PG-CPK"
  },
  "1760": {
    "gadm": {
      "name": "East New Britain",
      "gid": "PNG.4_1"
    },
    "code": "PG-EBR"
  },
  "1761": {
    "gadm": {
      "name": "East Sepik",
      "gid": "PNG.5_1"
    },
    "code": "PG-ESW"
  },
  "1762": {
    "gadm": {
      "name": "Eastern Highlands",
      "gid": "PNG.6_1"
    },
    "code": "PG-EHG"
  },
  "1763": {
    "gadm": {
      "name": "Enga",
      "gid": "PNG.7_1"
    },
    "code": "PG-EPW"
  },
  "1764": {
    "gadm": {
      "name": "Gulf",
      "gid": "PNG.8_1"
    },
    "code": "PG-GPK"
  },
  "1765": {
    "gadm": {
      "name": "Hela",
      "gid": "PNG.9_1"
    },
    "code": "PG-HLA"
  },
  "1766": {
    "gadm": {
      "name": "Jiwaka",
      "gid": "PNG.10_1"
    },
    "code": "PG-JWK"
  },
  "1767": {
    "gadm": {
      "name": "Madang",
      "gid": "PNG.11_1"
    },
    "code": "PG-MPM"
  },
  "1768": {
    "gadm": {
      "name": "Manus",
      "gid": "PNG.12_1"
    },
    "code": "PG-MRL"
  },
  "1769": {
    "gadm": {
      "name": "Milne Bay",
      "gid": "PNG.13_1"
    },
    "code": "PG-MBA"
  },
  "1770": {
    "gadm": {
      "name": "Morobe",
      "gid": "PNG.14_1"
    },
    "code": "PG-MPL"
  },
  "1771": {
    "gadm": {
      "name": "National Capital District",
      "gid": "PNG.15_1"
    },
    "code": "PG-NCD"
  },
  "1772": {
    "gadm": {
      "name": "New Ireland",
      "gid": "PNG.16_1"
    },
    "code": "PG-NIK"
  },
  "1773": {
    "gadm": {
      "name": "Oro",
      "gid": "PNG.17_1"
    },
    "code": "PG-NPP"
  },
  "1774": {
    "gadm": {
      "name": "Sandaun",
      "gid": "PNG.18_1"
    },
    "code": "PG-SHM"
  },
  "1775": {
    "gadm": {
      "name": "Southern Highlands",
      "gid": "PNG.19_1"
    },
    "code": "PG-WBK"
  },
  "1776": {
    "gadm": {
      "name": "West New Britain",
      "gid": "PNG.20_1"
    },
    "code": "PG-SAN"
  },
  "1777": {
    "gadm": {
      "name": "Western",
      "gid": "PNG.22_1"
    },
    "code": "PG-WPD"
  },
  "1778": {
    "gadm": {
      "name": "Western Highlands",
      "gid": "PNG.21_1"
    },
    "code": "PG-WHM"
  },
  "1779": {
    "gadm": {
      "name": "Cagayan",
      "gid": "PHL.18_1"
    },
    "code": "PH-02"
  },
  "1780": {
    "gadm": {
      "name": "Rizal",
      "gid": "PHL.64_1"
    },
    "code": "PH-40"
  },
  "1781": {
    "gadm": {
      "name": "Davao del Norte",
      "gid": "PHL.27_1"
    },
    "code": "PH-11"
  },
  "1782": {
    "gadm": {
      "name": "Bukidnon",
      "gid": "PHL.16_1"
    },
    "code": "PH-10"
  },
  "1783": {
    "gadm": {
      "name": "Basilan",
      "gid": "PHL.9_1"
    },
    "code": "PH-14"
  },
  "1784": {
    "gadm": {
      "name": "Ilocos Norte",
      "gid": "PHL.34_1"
    },
    "code": "PH-01"
  },
  "1785": {
    "gadm": {
      "name": "Antique",
      "gid": "PHL.6_1"
    },
    "code": "PH-06"
  },
  "1786": {
    "gadm": {
      "name": "Samar",
      "gid": "PHL.66_1"
    },
    "code": "PH-08"
  },
  "1787": {
    "gadm": {
      "name": "Negros Oriental",
      "gid": "PHL.52_1"
    },
    "code": "PH-07"
  },
  "1788": {
    "gadm": {
      "name": "Occidental Mindoro",
      "gid": "PHL.57_1"
    },
    "code": "PH-41"
  },
  "1789": {
    "gadm": {
      "name": "Zamboanga del Norte",
      "gid": "PHL.79_1"
    },
    "code": "PH-09"
  },
  "1790": {
    "gadm": {
      "name": "North Cotabato",
      "gid": "PHL.53_1"
    },
    "code": "PH-12"
  },
  "1791": {
    "gadm": {
      "name": "Metropolitan Manila",
      "gid": "PHL.47_1"
    },
    "code": "PH-00"
  },
  "1792": {
    "gadm": {
      "name": "Bataan",
      "gid": "PHL.10_1"
    },
    "code": "PH-03"
  },
  "1793": {
    "gadm": {
      "name": "Albay",
      "gid": "PHL.5_1"
    },
    "code": "PH-05"
  },
  "1794": {
    "gadm": {
      "name": "Surigao del Norte",
      "gid": "PHL.74_1"
    },
    "code": "PH-13"
  },
  "1795": {
    "gadm": {
      "name": "Apayao",
      "gid": "PHL.7_1"
    },
    "code": "PH-15"
  },
  "1796": {
    "gadm": {
      "name": "Azad Kashmir",
      "gid": "PAK.1_1"
    },
    "code": "PK-JK"
  },
  "1797": {
    "gadm": {
      "name": "Baluchistan",
      "gid": "PAK.2_1"
    },
    "code": "PK-BA"
  },
  "1798": {
    "gadm": {
      "name": "F.C.T.",
      "gid": "PAK.4_1"
    },
    "code": "PK-IS"
  },
  "1799": {
    "gadm": {
      "name": "N.W.F.P.",
      "gid": "PAK.5_1"
    },
    "code": "PK-KP"
  },
  "1800": {
    "gadm": {
      "name": "Northern Areas",
      "gid": "PAK.6_1"
    },
    "code": "PK-GB"
  },
  "1801": {
    "gadm": {
      "name": "Punjab",
      "gid": "PAK.7_1"
    },
    "code": "PK-PB"
  },
  "1802": {
    "gadm": {
      "name": "Sind",
      "gid": "PAK.8_1"
    },
    "code": "PK-SD"
  },
  "1803": {
    "gadm": {
      "name": "West Bank",
      "gid": "PSE.2_1"
    },
    "code": "PSE.2_1"
  },
  "1804": {
    "gadm": {
      "name": "Gaza",
      "gid": "PSE.1_1"
    },
    "code": "PSE.1_1"
  },
  "1805": {
    "gadm": {
      "name": "Aimeliik",
      "gid": "PLW.1_1"
    },
    "code": "PW-002"
  },
  "1806": {
    "gadm": {
      "name": "Airai",
      "gid": "PLW.2_1"
    },
    "code": "PW-004"
  },
  "1807": {
    "gadm": {
      "name": "Angaur",
      "gid": "PLW.3_1"
    },
    "code": "PW-010"
  },
  "1808": {
    "gadm": {
      "name": "Hatohobei",
      "gid": "PLW.4_1"
    },
    "code": "PW-050"
  },
  "1809": {
    "gadm": {
      "name": "Kayangel",
      "gid": "PLW.5_1"
    },
    "code": "PW-100"
  },
  "1810": {
    "gadm": {
      "name": "Koror",
      "gid": "PLW.6_1"
    },
    "code": "PW-150"
  },
  "1811": {
    "gadm": {
      "name": "Melekeok",
      "gid": "PLW.7_1"
    },
    "code": "PW-212"
  },
  "1812": {
    "gadm": {
      "name": "Ngaraard",
      "gid": "PLW.8_1"
    },
    "code": "PW-214"
  },
  "1813": {
    "gadm": {
      "name": "Ngarchelong",
      "gid": "PLW.9_1"
    },
    "code": "PW-218"
  },
  "1814": {
    "gadm": {
      "name": "Ngardmau",
      "gid": "PLW.10_1"
    },
    "code": "PW-222"
  },
  "1815": {
    "gadm": {
      "name": "Ngatpang",
      "gid": "PLW.11_1"
    },
    "code": "PW-224"
  },
  "1816": {
    "gadm": {
      "name": "Ngchesar",
      "gid": "PLW.12_1"
    },
    "code": "PW-226"
  },
  "1817": {
    "gadm": {
      "name": "Ngeremlengui",
      "gid": "PLW.13_1"
    },
    "code": "PW-227"
  },
  "1818": {
    "gadm": {
      "name": "Ngiwal",
      "gid": "PLW.14_1"
    },
    "code": "PW-228"
  },
  "1819": {
    "gadm": {
      "name": "Peleliu",
      "gid": "PLW.15_1"
    },
    "code": "PW-350"
  },
  "1820": {
    "gadm": {
      "name": "Sonsorol",
      "gid": "PLW.16_1"
    },
    "code": "PW-370"
  },
  "1821": {
    "gadm": {
      "name": "Alto Paraguay",
      "gid": "PRY.1_1"
    },
    "code": "PY-16"
  },
  "1822": {
    "gadm": {
      "name": "Alto Paran\u00c3\u00a1",
      "gid": "PRY.2_1"
    },
    "code": "PY-10"
  },
  "1823": {
    "gadm": {
      "name": "Amambay",
      "gid": "PRY.3_1"
    },
    "code": "PY-13"
  },
  "1824": {
    "gadm": {
      "name": "Asunci\u00c3\u00b3n",
      "gid": "PRY.4_1"
    },
    "code": "PY-ASU"
  },
  "1825": {
    "gadm": {
      "name": "Boquer\u00c3\u00b3n",
      "gid": "PRY.5_1"
    },
    "code": "PY-19"
  },
  "1826": {
    "gadm": {
      "name": "Caaguaz\u00c3\u00ba",
      "gid": "PRY.6_1"
    },
    "code": "PY-5"
  },
  "1827": {
    "gadm": {
      "name": "Caazap\u00c3\u00a1",
      "gid": "PRY.7_1"
    },
    "code": "PY-6"
  },
  "1828": {
    "gadm": {
      "name": "Canindey\u00c3\u00ba",
      "gid": "PRY.8_1"
    },
    "code": "PY-14"
  },
  "1829": {
    "gadm": {
      "name": "Central",
      "gid": "PRY.9_1"
    },
    "code": "PY-11"
  },
  "1830": {
    "gadm": {
      "name": "Concepci\u00c3\u00b3n",
      "gid": "PRY.10_1"
    },
    "code": "PY-1"
  },
  "1831": {
    "gadm": {
      "name": "Cordillera",
      "gid": "PRY.11_1"
    },
    "code": "PY-3"
  },
  "1832": {
    "gadm": {
      "name": "Guair\u00c3\u00a1",
      "gid": "PRY.12_1"
    },
    "code": "PY-4"
  },
  "1833": {
    "gadm": {
      "name": "Itap\u00c3\u00baa",
      "gid": "PRY.13_1"
    },
    "code": "PY-7"
  },
  "1834": {
    "gadm": {
      "name": "Misiones",
      "gid": "PRY.14_1"
    },
    "code": "PY-8"
  },
  "1835": {
    "gadm": {
      "name": "\u00c3\u2018eembuc\u00c3\u00ba",
      "gid": "PRY.15_1"
    },
    "code": "PY-12"
  },
  "1836": {
    "gadm": {
      "name": "Paraguar\u00c3\u00ad",
      "gid": "PRY.16_1"
    },
    "code": "PY-9"
  },
  "1837": {
    "gadm": {
      "name": "Presidente Hayes",
      "gid": "PRY.17_1"
    },
    "code": "PY-15"
  },
  "1838": {
    "gadm": {
      "name": "San Pedro",
      "gid": "PRY.18_1"
    },
    "code": "PY-2"
  },
  "1839": {
    "gadm": {
      "name": "Ad Dawhah",
      "gid": "QAT.1_1"
    },
    "code": "QA-DA"
  },
  "1840": {
    "gadm": {
      "name": "Al Daayen",
      "gid": "QAT.2_1"
    },
    "code": "QA-ZA"
  },
  "1841": {
    "gadm": {
      "name": "Al Khor",
      "gid": "QAT.3_1"
    },
    "code": "QA-KH"
  },
  "1842": {
    "gadm": {
      "name": "Al Wakrah",
      "gid": "QAT.4_1"
    },
    "code": "QA-WA"
  },
  "1843": {
    "gadm": {
      "name": "Madinat ash Shamal",
      "gid": "QAT.6_1"
    },
    "code": "QA-MS"
  },
  "1844": {
    "gadm": {
      "name": "Umm Salal",
      "gid": "QAT.7_1"
    },
    "code": "QA-US"
  },
  "1845": {
    "gadm": {
      "name": "Ar Rayyan",
      "gid": "QAT.5_1"
    },
    "code": "QA-RA"
  },
  "1846": {
    "gadm": {
      "name": "Borski",
      "gid": "SRB.1_1"
    },
    "code": "RS-14"
  },
  "1847": {
    "gadm": {
      "name": "Brani\u00c4\u008devski",
      "gid": "SRB.2_1"
    },
    "code": "RS-11"
  },
  "1848": {
    "gadm": {
      "name": "Grad Beograd",
      "gid": "SRB.3_1"
    },
    "code": "RS-00"
  },
  "1849": {
    "gadm": {
      "name": "Jablani\u00c4\u008dki",
      "gid": "SRB.4_1"
    },
    "code": "RS-23"
  },
  "1850": {
    "gadm": {
      "name": "Ju\u00c5\u00beno-Ba\u00c4\u008dki",
      "gid": "SRB.5_1"
    },
    "code": "RS-06"
  },
  "1851": {
    "gadm": {
      "name": "Ju\u00c5\u00beno-Banatski",
      "gid": "SRB.6_1"
    },
    "code": "RS-04"
  },
  "1852": {
    "gadm": {
      "name": "Kolubarski",
      "gid": "SRB.7_1"
    },
    "code": "RS-09"
  },
  "1853": {
    "gadm": {
      "name": "Ma\u00c4\u008dvanski",
      "gid": "SRB.8_1"
    },
    "code": "RS-08"
  },
  "1854": {
    "gadm": {
      "name": "Moravi\u00c4\u008dki",
      "gid": "SRB.9_1"
    },
    "code": "RS-17"
  },
  "1855": {
    "gadm": {
      "name": "Ni\u00c5\u00a1avski",
      "gid": "SRB.10_1"
    },
    "code": "RS-20"
  },
  "1856": {
    "gadm": {
      "name": "P\u00c4\u008dinjski",
      "gid": "SRB.11_1"
    },
    "code": "RS-24"
  },
  "1857": {
    "gadm": {
      "name": "Pirotski",
      "gid": "SRB.12_1"
    },
    "code": "RS-22"
  },
  "1858": {
    "gadm": {
      "name": "Podunavski",
      "gid": "SRB.13_1"
    },
    "code": "RS-10"
  },
  "1859": {
    "gadm": {
      "name": "Pomoravski",
      "gid": "SRB.14_1"
    },
    "code": "RS-13"
  },
  "1860": {
    "gadm": {
      "name": "Rasinski",
      "gid": "SRB.15_1"
    },
    "code": "RS-19"
  },
  "1861": {
    "gadm": {
      "name": "Ra\u00c5\u00a1ki",
      "gid": "SRB.16_1"
    },
    "code": "RS-18"
  },
  "1862": {
    "gadm": {
      "name": "Severno-Ba\u00c4\u008dki",
      "gid": "SRB.17_1"
    },
    "code": "RS-01"
  },
  "1863": {
    "gadm": {
      "name": "Severno-Banatski",
      "gid": "SRB.18_1"
    },
    "code": "RS-03"
  },
  "1864": {
    "gadm": {
      "name": "Srednje-Banatski",
      "gid": "SRB.19_1"
    },
    "code": "RS-02"
  },
  "1865": {
    "gadm": {
      "name": "Sremski",
      "gid": "SRB.20_1"
    },
    "code": "RS-07"
  },
  "1866": {
    "gadm": {
      "name": "\u00c5\u00a0umadijski",
      "gid": "SRB.21_1"
    },
    "code": "RS-12"
  },
  "1867": {
    "gadm": {
      "name": "Topli\u00c4\u008dki",
      "gid": "SRB.22_1"
    },
    "code": "RS-21"
  },
  "1868": {
    "gadm": {
      "name": "Zaje\u00c4\u008darski",
      "gid": "SRB.23_1"
    },
    "code": "RS-15"
  },
  "1869": {
    "gadm": {
      "name": "Zapadno-Ba\u00c4\u008dki",
      "gid": "SRB.24_1"
    },
    "code": "RS-05"
  },
  "1870": {
    "gadm": {
      "name": "Zlatiborski",
      "gid": "SRB.25_1"
    },
    "code": "RS-16"
  },
  "1871": {
    "gadm": {
      "name": "Adygey",
      "gid": "RUS.1_1"
    },
    "code": "RU-AD"
  },
  "1872": {
    "gadm": {
      "name": "Altay",
      "gid": "RUS.2_1"
    },
    "code": "RU-AL"
  },
  "1873": {
    "gadm": {
      "name": "Amur",
      "gid": "RUS.3_1"
    },
    "code": "RU-AMU"
  },
  "1874": {
    "gadm": {
      "name": "Arkhangel'sk",
      "gid": "RUS.4_1"
    },
    "code": "RU-ARK"
  },
  "1875": {
    "gadm": {
      "name": "Astrakhan'",
      "gid": "RUS.5_1"
    },
    "code": "RU-AST"
  },
  "1876": {
    "gadm": {
      "name": "Bashkortostan",
      "gid": "RUS.6_1"
    },
    "code": "RU-BA"
  },
  "1877": {
    "gadm": {
      "name": "Belgorod",
      "gid": "RUS.7_1"
    },
    "code": "RU-BEL"
  },
  "1878": {
    "gadm": {
      "name": "Bryansk",
      "gid": "RUS.8_1"
    },
    "code": "RU-BRY"
  },
  "1879": {
    "gadm": {
      "name": "Buryat",
      "gid": "RUS.9_1"
    },
    "code": "RU-BU"
  },
  "1880": {
    "gadm": {
      "name": "Chechnya",
      "gid": "RUS.10_1"
    },
    "code": "RU-CE"
  },
  "1881": {
    "gadm": {
      "name": "Chelyabinsk",
      "gid": "RUS.11_1"
    },
    "code": "RU-CHE"
  },
  "1882": {
    "gadm": {
      "name": "Chukot",
      "gid": "RUS.12_1"
    },
    "code": "RU-CHU"
  },
  "1883": {
    "gadm": {
      "name": "Chuvash",
      "gid": "RUS.13_1"
    },
    "code": "RU-CU"
  },
  "1884": {
    "gadm": {
      "name": "City of St. Petersburg",
      "gid": "RUS.14_1"
    },
    "code": "RU-SPE"
  },
  "1885": {
    "gadm": {
      "name": "Dagestan",
      "gid": "RUS.15_1"
    },
    "code": "RU-DA"
  },
  "1886": {
    "gadm": {
      "name": "Ingush",
      "gid": "RUS.17_1"
    },
    "code": "RU-IN"
  },
  "1887": {
    "gadm": {
      "name": "Irkutsk",
      "gid": "RUS.18_1"
    },
    "code": "RU-IRK"
  },
  "1888": {
    "gadm": {
      "name": "Ivanovo",
      "gid": "RUS.19_1"
    },
    "code": "RU-IVA"
  },
  "1889": {
    "gadm": {
      "name": "Kabardin-Balkar",
      "gid": "RUS.20_1"
    },
    "code": "RU-KB"
  },
  "1890": {
    "gadm": {
      "name": "Kaliningrad",
      "gid": "RUS.21_1"
    },
    "code": "RU-KGD"
  },
  "1891": {
    "gadm": {
      "name": "Kalmyk",
      "gid": "RUS.22_1"
    },
    "code": "RU-KL"
  },
  "1892": {
    "gadm": {
      "name": "Kaluga",
      "gid": "RUS.23_1"
    },
    "code": "RU-KLU"
  },
  "1893": {
    "gadm": {
      "name": "Kamchatka",
      "gid": "RUS.24_1"
    },
    "code": "RU-KAM"
  },
  "1894": {
    "gadm": {
      "name": "Karachay-Cherkess",
      "gid": "RUS.25_1"
    },
    "code": "RU-KC"
  },
  "1895": {
    "gadm": {
      "name": "Karelia",
      "gid": "RUS.26_1"
    },
    "code": "RU-KR"
  },
  "1896": {
    "gadm": {
      "name": "Kemerovo",
      "gid": "RUS.27_1"
    },
    "code": "RU-KEM"
  },
  "1897": {
    "gadm": {
      "name": "Khabarovsk",
      "gid": "RUS.28_1"
    },
    "code": "RU-KHA"
  },
  "1898": {
    "gadm": {
      "name": "Khakass",
      "gid": "RUS.29_1"
    },
    "code": "RU-KK"
  },
  "1899": {
    "gadm": {
      "name": "Khanty-Mansiy",
      "gid": "RUS.30_1"
    },
    "code": "RU-KHM"
  },
  "1900": {
    "gadm": {
      "name": "Kirov",
      "gid": "RUS.31_1"
    },
    "code": "RU-KIR"
  },
  "1901": {
    "gadm": {
      "name": "Komi",
      "gid": "RUS.32_1"
    },
    "code": "RU-KO"
  },
  "1902": {
    "gadm": {
      "name": "Kostroma",
      "gid": "RUS.33_1"
    },
    "code": "RU-KOS"
  },
  "1903": {
    "gadm": {
      "name": "Krasnodar",
      "gid": "RUS.34_1"
    },
    "code": "RU-KDA"
  },
  "1904": {
    "gadm": {
      "name": "Krasnoyarsk",
      "gid": "RUS.35_1"
    },
    "code": "RU-KYA"
  },
  "1905": {
    "gadm": {
      "name": "Kurgan",
      "gid": "RUS.36_1"
    },
    "code": "RU-KGN"
  },
  "1906": {
    "gadm": {
      "name": "Kursk",
      "gid": "RUS.37_1"
    },
    "code": "RU-KRS"
  },
  "1907": {
    "gadm": {
      "name": "Leningrad",
      "gid": "RUS.38_1"
    },
    "code": "RU-LEN"
  },
  "1908": {
    "gadm": {
      "name": "Lipetsk",
      "gid": "RUS.39_1"
    },
    "code": "RU-LIP"
  },
  "1909": {
    "gadm": {
      "name": "Maga Buryatdan",
      "gid": "RUS.40_1"
    },
    "code": "RU-MAG"
  },
  "1910": {
    "gadm": {
      "name": "Mariy-El",
      "gid": "RUS.41_1"
    },
    "code": "RU-ME"
  },
  "1911": {
    "gadm": {
      "name": "Mordovia",
      "gid": "RUS.42_1"
    },
    "code": "RU-MO"
  },
  "1912": {
    "gadm": {
      "name": "Moscow City",
      "gid": "RUS.43_1"
    },
    "code": "RU-MOS"
  },
  "1913": {
    "gadm": {
      "name": "Moskva",
      "gid": "RUS.44_1"
    },
    "code": "RU-MOW"
  },
  "1914": {
    "gadm": {
      "name": "Murmansk",
      "gid": "RUS.45_1"
    },
    "code": "RU-MUR"
  },
  "1915": {
    "gadm": {
      "name": "Nenets",
      "gid": "RUS.46_1"
    },
    "code": "RU-NEN"
  },
  "1916": {
    "gadm": {
      "name": "Nizhegorod",
      "gid": "RUS.47_1"
    },
    "code": "RU-NIZ"
  },
  "1917": {
    "gadm": {
      "name": "North Ossetia",
      "gid": "RUS.48_1"
    },
    "code": "RU-SE"
  },
  "1918": {
    "gadm": {
      "name": "Novgorod",
      "gid": "RUS.49_1"
    },
    "code": "RU-NGR"
  },
  "1919": {
    "gadm": {
      "name": "Novosibirsk",
      "gid": "RUS.50_1"
    },
    "code": "RU-NVS"
  },
  "1920": {
    "gadm": {
      "name": "Omsk",
      "gid": "RUS.51_1"
    },
    "code": "RU-OMS"
  },
  "1921": {
    "gadm": {
      "name": "Orel",
      "gid": "RUS.52_1"
    },
    "code": "RU-ORL"
  },
  "1922": {
    "gadm": {
      "name": "Orenburg",
      "gid": "RUS.53_1"
    },
    "code": "RU-ORE"
  },
  "1923": {
    "gadm": {
      "name": "Penza",
      "gid": "RUS.54_1"
    },
    "code": "RU-PNZ"
  },
  "1924": {
    "gadm": {
      "name": "Perm'",
      "gid": "RUS.55_1"
    },
    "code": "RU-PER"
  },
  "1925": {
    "gadm": {
      "name": "Primor'ye",
      "gid": "RUS.56_1"
    },
    "code": "RU-PRI"
  },
  "1926": {
    "gadm": {
      "name": "Pskov",
      "gid": "RUS.57_1"
    },
    "code": "RU-PSK"
  },
  "1927": {
    "gadm": {
      "name": "Rostov",
      "gid": "RUS.58_1"
    },
    "code": "RU-ROS"
  },
  "1928": {
    "gadm": {
      "name": "Ryazan'",
      "gid": "RUS.59_1"
    },
    "code": "RU-RYA"
  },
  "1929": {
    "gadm": {
      "name": "Sakha",
      "gid": "RUS.60_1"
    },
    "code": "RU-SA"
  },
  "1930": {
    "gadm": {
      "name": "Sakhalin",
      "gid": "RUS.61_1"
    },
    "code": "RU-SAK"
  },
  "1931": {
    "gadm": {
      "name": "Samara",
      "gid": "RUS.62_1"
    },
    "code": "RU-SAM"
  },
  "1932": {
    "gadm": {
      "name": "Saratov",
      "gid": "RUS.63_1"
    },
    "code": "RU-SAR"
  },
  "1933": {
    "gadm": {
      "name": "Smolensk",
      "gid": "RUS.64_1"
    },
    "code": "RU-SMO"
  },
  "1934": {
    "gadm": {
      "name": "Stavropol'",
      "gid": "RUS.65_1"
    },
    "code": "RU-STA"
  },
  "1935": {
    "gadm": {
      "name": "Sverdlovsk",
      "gid": "RUS.66_1"
    },
    "code": "RU-SVE"
  },
  "1936": {
    "gadm": {
      "name": "Tambov",
      "gid": "RUS.67_1"
    },
    "code": "RU-TAM"
  },
  "1937": {
    "gadm": {
      "name": "Tatarstan",
      "gid": "RUS.68_1"
    },
    "code": "RU-TA"
  },
  "1938": {
    "gadm": {
      "name": "Tomsk",
      "gid": "RUS.69_1"
    },
    "code": "RU-TOM"
  },
  "1939": {
    "gadm": {
      "name": "Tula",
      "gid": "RUS.70_1"
    },
    "code": "RU-TUL"
  },
  "1940": {
    "gadm": {
      "name": "Tuva",
      "gid": "RUS.71_1"
    },
    "code": "RU-TY"
  },
  "1941": {
    "gadm": {
      "name": "Tver'",
      "gid": "RUS.72_1"
    },
    "code": "RU-TVE"
  },
  "1942": {
    "gadm": {
      "name": "Tyumen'",
      "gid": "RUS.73_1"
    },
    "code": "RU-TYU"
  },
  "1943": {
    "gadm": {
      "name": "Udmurt",
      "gid": "RUS.74_1"
    },
    "code": "RU-UD"
  },
  "1944": {
    "gadm": {
      "name": "Ul'yanovsk",
      "gid": "RUS.75_1"
    },
    "code": "RU-ULY"
  },
  "1945": {
    "gadm": {
      "name": "Vladimir",
      "gid": "RUS.76_1"
    },
    "code": "RU-VLA"
  },
  "1946": {
    "gadm": {
      "name": "Volgograd",
      "gid": "RUS.77_1"
    },
    "code": "RU-VGG"
  },
  "1947": {
    "gadm": {
      "name": "Vologda",
      "gid": "RUS.78_1"
    },
    "code": "RU-VLG"
  },
  "1948": {
    "gadm": {
      "name": "Voronezh",
      "gid": "RUS.79_1"
    },
    "code": "RU-VOR"
  },
  "1949": {
    "gadm": {
      "name": "Yaroslavl'",
      "gid": "RUS.81_1"
    },
    "code": "RU-YAR"
  },
  "1950": {
    "gadm": {
      "name": "Yevrey",
      "gid": "RUS.82_1"
    },
    "code": "RU-YEV"
  },
  "1951": {
    "gadm": {
      "name": "Zabaykal'ye",
      "gid": "RUS.83_1"
    },
    "code": "RU-ZAB"
  },
  "1952": {
    "gadm": {
      "name": "Amajyaruguru",
      "gid": "RWA.1_1"
    },
    "code": "RW-03"
  },
  "1953": {
    "gadm": {
      "name": "Amajyepfo",
      "gid": "RWA.2_1"
    },
    "code": "RW-05"
  },
  "1954": {
    "gadm": {
      "name": "Iburasirazuba",
      "gid": "RWA.3_1"
    },
    "code": "RW-02"
  },
  "1955": {
    "gadm": {
      "name": "Iburengerazuba",
      "gid": "RWA.4_1"
    },
    "code": "RW-04"
  },
  "1956": {
    "gadm": {
      "name": "Umujyi wa Kigali",
      "gid": "RWA.5_1"
    },
    "code": "RW-01"
  },
  "1957": {
    "gadm": {
      "name": "Asir",
      "gid": "SAU.1_1"
    },
    "code": "SA-14"
  },
  "1958": {
    "gadm": {
      "name": "Al Bahah",
      "gid": "SAU.2_1"
    },
    "code": "SA-11"
  },
  "1959": {
    "gadm": {
      "name": "Al Hudud ash Shamaliyah",
      "gid": "SAU.3_1"
    },
    "code": "SA-08"
  },
  "1960": {
    "gadm": {
      "name": "Al Jawf",
      "gid": "SAU.4_1"
    },
    "code": "SA-12"
  },
  "1961": {
    "gadm": {
      "name": "Al Madinah",
      "gid": "SAU.5_1"
    },
    "code": "SA-03"
  },
  "1962": {
    "gadm": {
      "name": "Al Quassim",
      "gid": "SAU.6_1"
    },
    "code": "SA-05"
  },
  "1963": {
    "gadm": {
      "name": "Ar Riyad",
      "gid": "SAU.7_1"
    },
    "code": "SA-01"
  },
  "1964": {
    "gadm": {
      "name": "Ash Sharqiyah",
      "gid": "SAU.8_1"
    },
    "code": "SA-04"
  },
  "1965": {
    "gadm": {
      "name": "Ha'il",
      "gid": "SAU.9_1"
    },
    "code": "SA-06"
  },
  "1966": {
    "gadm": {
      "name": "Jizan",
      "gid": "SAU.10_1"
    },
    "code": "SA-09"
  },
  "1967": {
    "gadm": {
      "name": "Makkah",
      "gid": "SAU.11_1"
    },
    "code": "SA-02"
  },
  "1968": {
    "gadm": {
      "name": "Najran",
      "gid": "SAU.12_1"
    },
    "code": "SA-10"
  },
  "1969": {
    "gadm": {
      "name": "Tabuk",
      "gid": "SAU.13_1"
    },
    "code": "SA-07"
  },
  "1970": {
    "gadm": {
      "name": "Honiara",
      "gid": "SLB.4_1"
    },
    "code": "SB-CT"
  },
  "1971": {
    "gadm": {
      "name": "Central",
      "gid": "SLB.1_1"
    },
    "code": "SB-CE"
  },
  "1972": {
    "gadm": {
      "name": "Choiseul",
      "gid": "SLB.2_1"
    },
    "code": "SB-CH"
  },
  "1973": {
    "gadm": {
      "name": "Guadalcanal",
      "gid": "SLB.3_1"
    },
    "code": "SB-GU"
  },
  "1974": {
    "gadm": {
      "name": "Isabel",
      "gid": "SLB.5_1"
    },
    "code": "SB-IS"
  },
  "1975": {
    "gadm": {
      "name": "Makira Ulawa",
      "gid": "SLB.6_1"
    },
    "code": "SB-MK"
  },
  "1976": {
    "gadm": {
      "name": "Malaita",
      "gid": "SLB.7_1"
    },
    "code": "SB-ML"
  },
  "1977": {
    "gadm": {
      "name": "Rennell and Bellona",
      "gid": "SLB.8_1"
    },
    "code": "SB-RB"
  },
  "1978": {
    "gadm": {
      "name": "Temotu",
      "gid": "SLB.9_1"
    },
    "code": "SB-TE"
  },
  "1979": {
    "gadm": {
      "name": "Western",
      "gid": "SLB.10_1"
    },
    "code": "SB-WE"
  },
  "1980": {
    "gadm": {
      "name": "Anse aux Pins",
      "gid": "SYC.1_1"
    },
    "code": "SC-01"
  },
  "1981": {
    "gadm": {
      "name": "Anse Boileau",
      "gid": "SYC.2_1"
    },
    "code": "SC-02"
  },
  "1982": {
    "gadm": {
      "name": "Anse \u00c3\u2030toile",
      "gid": "SYC.3_1"
    },
    "code": "SC-03"
  },
  "1983": {
    "gadm": {
      "name": "Anse Royale",
      "gid": "SYC.4_1"
    },
    "code": "SC-05"
  },
  "1984": {
    "gadm": {
      "name": "Au Cap",
      "gid": "SYC.5_1"
    },
    "code": "SC-04"
  },
  "1985": {
    "gadm": {
      "name": "Baie Lazare",
      "gid": "SYC.6_1"
    },
    "code": "SC-06"
  },
  "1986": {
    "gadm": {
      "name": "Baie Sainte Anne",
      "gid": "SYC.7_1"
    },
    "code": "SC-07"
  },
  "1987": {
    "gadm": {
      "name": "Beau Vallon",
      "gid": "SYC.8_1"
    },
    "code": "SC-08"
  },
  "1988": {
    "gadm": {
      "name": "Bel Air",
      "gid": "SYC.9_1"
    },
    "code": "SC-09"
  },
  "1989": {
    "gadm": {
      "name": "Belombre",
      "gid": "SYC.10_1"
    },
    "code": "SC-10"
  },
  "1990": {
    "gadm": {
      "name": "Cascade",
      "gid": "SYC.11_1"
    },
    "code": "SC-11"
  },
  "1991": {
    "gadm": {
      "name": "English River",
      "gid": "SYC.12_1"
    },
    "code": "SC-16"
  },
  "1992": {
    "gadm": {
      "name": "Glacis",
      "gid": "SYC.13_1"
    },
    "code": "SC-12"
  },
  "1993": {
    "gadm": {
      "name": "Grand' Anse",
      "gid": "SYC.14_1"
    },
    "code": "SC-13"
  },
  "1994": {
    "gadm": {
      "name": "Grand'Anse Praslin",
      "gid": "SYC.15_1"
    },
    "code": "SC-14"
  },
  "1995": {
    "gadm": {
      "name": "La Digue and Inner Islands",
      "gid": "SYC.16_1"
    },
    "code": "SC-15"
  },
  "1996": {
    "gadm": {
      "name": "Les Mamelles",
      "gid": "SYC.17_1"
    },
    "code": "SC-24"
  },
  "1997": {
    "gadm": {
      "name": "Mont Buxton",
      "gid": "SYC.18_1"
    },
    "code": "SC-17"
  },
  "1998": {
    "gadm": {
      "name": "Mont Fleuri",
      "gid": "SYC.19_1"
    },
    "code": "SC-18"
  },
  "1999": {
    "gadm": {
      "name": "Outer Islands",
      "gid": "SYC.20_1"
    },
    "code": "SYC.20_1"
  },
  "2000": {
    "gadm": {
      "name": "Plaisance",
      "gid": "SYC.21_1"
    },
    "code": "SC-19"
  },
  "2001": {
    "gadm": {
      "name": "Pointe La Rue",
      "gid": "SYC.22_1"
    },
    "code": "SC-20"
  },
  "2002": {
    "gadm": {
      "name": "Port Glaud",
      "gid": "SYC.23_1"
    },
    "code": "SC-21"
  },
  "2003": {
    "gadm": {
      "name": "Roche Ca\u00c3\u00afman",
      "gid": "SYC.24_1"
    },
    "code": "SC-25"
  },
  "2004": {
    "gadm": {
      "name": "Saint Louis",
      "gid": "SYC.25_1"
    },
    "code": "SC-22"
  },
  "2005": {
    "gadm": {
      "name": "Takamaka",
      "gid": "SYC.26_1"
    },
    "code": "SC-23"
  },
  "2006": {
    "gadm": {
      "name": "Al Jazirah",
      "gid": "SDN.1_1"
    },
    "code": "SD-GZ"
  },
  "2007": {
    "gadm": {
      "name": "Al Qadarif",
      "gid": "SDN.2_1"
    },
    "code": "SD-GD"
  },
  "2008": {
    "gadm": {
      "name": "Blue Nile",
      "gid": "SDN.3_1"
    },
    "code": "SD-NB"
  },
  "2009": {
    "gadm": {
      "name": "Central Darfur",
      "gid": "SDN.4_1"
    },
    "code": "SD-DC"
  },
  "2010": {
    "gadm": {
      "name": "East Darfur",
      "gid": "SDN.5_1"
    },
    "code": "SD-DE"
  },
  "2011": {
    "gadm": {
      "name": "Kassala",
      "gid": "SDN.6_1"
    },
    "code": "SD-KA"
  },
  "2012": {
    "gadm": {
      "name": "Khartoum",
      "gid": "SDN.7_1"
    },
    "code": "SD-KH"
  },
  "2013": {
    "gadm": {
      "name": "North Darfur",
      "gid": "SDN.8_1"
    },
    "code": "SD-DN"
  },
  "2014": {
    "gadm": {
      "name": "North Kurdufan",
      "gid": "SDN.9_1"
    },
    "code": "SD-KN"
  },
  "2015": {
    "gadm": {
      "name": "Northern",
      "gid": "SDN.10_1"
    },
    "code": "SD-NO"
  },
  "2016": {
    "gadm": {
      "name": "Red Sea",
      "gid": "SDN.11_1"
    },
    "code": "SD-RS"
  },
  "2017": {
    "gadm": {
      "name": "River Nile",
      "gid": "SDN.12_1"
    },
    "code": "SD-NR"
  },
  "2018": {
    "gadm": {
      "name": "Sennar",
      "gid": "SDN.13_1"
    },
    "code": "SD-SI"
  },
  "2019": {
    "gadm": {
      "name": "South Darfur",
      "gid": "SDN.14_1"
    },
    "code": "SD-DS"
  },
  "2020": {
    "gadm": {
      "name": "South Kurdufan",
      "gid": "SDN.15_1"
    },
    "code": "SD-KS"
  },
  "2021": {
    "gadm": {
      "name": "West Darfur",
      "gid": "SDN.16_1"
    },
    "code": "SD-DW"
  },
  "2022": {
    "gadm": {
      "name": "West Kurdufan",
      "gid": "SDN.17_1"
    },
    "code": "SD-GK"
  },
  "2023": {
    "gadm": {
      "name": "White Nile",
      "gid": "SDN.18_1"
    },
    "code": "SD-NW"
  },
  "2024": {
    "gadm": {
      "name": "Central",
      "gid": "SGP.1_1"
    },
    "code": "SGP.1_1"
  },
  "2025": {
    "gadm": {
      "name": "East",
      "gid": "SGP.2_1"
    },
    "code": "SGP.2_1"
  },
  "2026": {
    "gadm": {
      "name": "North",
      "gid": "SGP.3_1"
    },
    "code": "SGP.3_1"
  },
  "2027": {
    "gadm": {
      "name": "North-East",
      "gid": "SGP.4_1"
    },
    "code": "SGP.4_1"
  },
  "2028": {
    "gadm": {
      "name": "West",
      "gid": "SGP.5_1"
    },
    "code": "SGP.5_1"
  },
  "2029": {
    "gadm": {
      "name": "Ascension",
      "gid": "SHN.1_1"
    },
    "code": "SH-AC"
  },
  "2030": {
    "gadm": {
      "name": "Saint Helena",
      "gid": "SHN.2_1"
    },
    "code": "SH-HL"
  },
  "2031": {
    "gadm": {
      "name": "Tristan da Cunha",
      "gid": "SHN.3_1"
    },
    "code": "SH-TA"
  },
  "2032": {
    "gadm": {
      "name": "Eastern",
      "gid": "SLE.1_1"
    },
    "code": "SL-E"
  },
  "2033": {
    "gadm": {
      "name": "Northern",
      "gid": "SLE.2_1"
    },
    "code": "SL-N"
  },
  "2034": {
    "gadm": {
      "name": "Southern",
      "gid": "SLE.3_1"
    },
    "code": "SL-NW"
  },
  "2035": {
    "gadm": {
      "name": "Western",
      "gid": "SLE.4_1"
    },
    "code": "SL-S"
  },
  "2036": {
    "gadm": {
      "name": "Acquaviva",
      "gid": "SMR.1_1"
    },
    "code": "SM-01"
  },
  "2037": {
    "gadm": {
      "name": "Borgo Maggiore",
      "gid": "SMR.2_1"
    },
    "code": "SM-06"
  },
  "2038": {
    "gadm": {
      "name": "Chiesanuova",
      "gid": "SMR.3_1"
    },
    "code": "SM-02"
  },
  "2039": {
    "gadm": {
      "name": "Domagnano",
      "gid": "SMR.4_1"
    },
    "code": "SM-03"
  },
  "2040": {
    "gadm": {
      "name": "Faetano",
      "gid": "SMR.5_1"
    },
    "code": "SM-04"
  },
  "2041": {
    "gadm": {
      "name": "Fiorentino",
      "gid": "SMR.6_1"
    },
    "code": "SM-05"
  },
  "2042": {
    "gadm": {
      "name": "Montegiardino",
      "gid": "SMR.7_1"
    },
    "code": "SM-08"
  },
  "2043": {
    "gadm": {
      "name": "San Marino",
      "gid": "SMR.8_1"
    },
    "code": "SM-07"
  },
  "2044": {
    "gadm": {
      "name": "Serravalle",
      "gid": "SMR.9_1"
    },
    "code": "SM-09"
  },
  "2045": {
    "gadm": {
      "name": "Dakar",
      "gid": "SEN.1_1"
    },
    "code": "SN-DK"
  },
  "2046": {
    "gadm": {
      "name": "Diourbel",
      "gid": "SEN.2_1"
    },
    "code": "SN-DB"
  },
  "2047": {
    "gadm": {
      "name": "Fatick",
      "gid": "SEN.3_1"
    },
    "code": "SN-FK"
  },
  "2048": {
    "gadm": {
      "name": "Kaffrine",
      "gid": "SEN.4_1"
    },
    "code": "SN-KA"
  },
  "2049": {
    "gadm": {
      "name": "Kaolack",
      "gid": "SEN.5_1"
    },
    "code": "SN-KL"
  },
  "2050": {
    "gadm": {
      "name": "K\u00c3\u00a9dougou",
      "gid": "SEN.6_1"
    },
    "code": "SN-KE"
  },
  "2051": {
    "gadm": {
      "name": "Kolda",
      "gid": "SEN.7_1"
    },
    "code": "SN-KD"
  },
  "2052": {
    "gadm": {
      "name": "Louga",
      "gid": "SEN.8_1"
    },
    "code": "SN-LG"
  },
  "2053": {
    "gadm": {
      "name": "Matam",
      "gid": "SEN.9_1"
    },
    "code": "SN-MT"
  },
  "2054": {
    "gadm": {
      "name": "Saint-Louis",
      "gid": "SEN.10_1"
    },
    "code": "SN-SL"
  },
  "2055": {
    "gadm": {
      "name": "S\u00c3\u00a9dhiou",
      "gid": "SEN.11_1"
    },
    "code": "SN-SE"
  },
  "2056": {
    "gadm": {
      "name": "Tambacounda",
      "gid": "SEN.12_1"
    },
    "code": "SN-TC"
  },
  "2057": {
    "gadm": {
      "name": "Thi\u00c3\u00a8s",
      "gid": "SEN.13_1"
    },
    "code": "SN-TH"
  },
  "2058": {
    "gadm": {
      "name": "Ziguinchor",
      "gid": "SEN.14_1"
    },
    "code": "SN-ZG"
  },
  "2059": {
    "gadm": {
      "name": "Awdal",
      "gid": "SOM.1_1"
    },
    "code": "SO-AW"
  },
  "2060": {
    "gadm": {
      "name": "Bakool",
      "gid": "SOM.2_1"
    },
    "code": "SO-BK"
  },
  "2061": {
    "gadm": {
      "name": "Banaadir",
      "gid": "SOM.3_1"
    },
    "code": "SO-BN"
  },
  "2062": {
    "gadm": {
      "name": "Bari",
      "gid": "SOM.4_1"
    },
    "code": "SO-BR"
  },
  "2063": {
    "gadm": {
      "name": "Bay",
      "gid": "SOM.5_1"
    },
    "code": "SO-BY"
  },
  "2064": {
    "gadm": {
      "name": "Galguduud",
      "gid": "SOM.6_1"
    },
    "code": "SO-GA"
  },
  "2065": {
    "gadm": {
      "name": "Gedo",
      "gid": "SOM.7_1"
    },
    "code": "SO-GE"
  },
  "2066": {
    "gadm": {
      "name": "Hiiraan",
      "gid": "SOM.8_1"
    },
    "code": "SO-HI"
  },
  "2067": {
    "gadm": {
      "name": "Jubbada Dhexe",
      "gid": "SOM.9_1"
    },
    "code": "SO-JD"
  },
  "2068": {
    "gadm": {
      "name": "Jubbada Hoose",
      "gid": "SOM.10_1"
    },
    "code": "SO-JH"
  },
  "2069": {
    "gadm": {
      "name": "Mudug",
      "gid": "SOM.11_1"
    },
    "code": "SO-MU"
  },
  "2070": {
    "gadm": {
      "name": "Nugaal",
      "gid": "SOM.12_1"
    },
    "code": "SO-NU"
  },
  "2071": {
    "gadm": {
      "name": "Sanaag",
      "gid": "SOM.13_1"
    },
    "code": "SO-SA"
  },
  "2072": {
    "gadm": {
      "name": "Shabeellaha Dhexe",
      "gid": "SOM.14_1"
    },
    "code": "SO-SD"
  },
  "2073": {
    "gadm": {
      "name": "Shabeellaha Hoose",
      "gid": "SOM.15_1"
    },
    "code": "SO-SH"
  },
  "2074": {
    "gadm": {
      "name": "Sool",
      "gid": "SOM.16_1"
    },
    "code": "SO-SO"
  },
  "2075": {
    "gadm": {
      "name": "Togdheer",
      "gid": "SOM.17_1"
    },
    "code": "SO-TO"
  },
  "2076": {
    "gadm": {
      "name": "Woqooyi Galbeed",
      "gid": "SOM.18_1"
    },
    "code": "SO-WO"
  },
  "2077": {
    "gadm": {
      "name": "Brokopondo",
      "gid": "SUR.1_1"
    },
    "code": "SR-BR"
  },
  "2078": {
    "gadm": {
      "name": "Commewijne",
      "gid": "SUR.2_1"
    },
    "code": "SR-CM"
  },
  "2079": {
    "gadm": {
      "name": "Coronie",
      "gid": "SUR.3_1"
    },
    "code": "SR-CR"
  },
  "2080": {
    "gadm": {
      "name": "Marowijne",
      "gid": "SUR.4_1"
    },
    "code": "SR-MA"
  },
  "2081": {
    "gadm": {
      "name": "Nickerie",
      "gid": "SUR.5_1"
    },
    "code": "SR-NI"
  },
  "2082": {
    "gadm": {
      "name": "Para",
      "gid": "SUR.6_1"
    },
    "code": "SR-PR"
  },
  "2083": {
    "gadm": {
      "name": "Paramaribo",
      "gid": "SUR.7_1"
    },
    "code": "SR-PM"
  },
  "2084": {
    "gadm": {
      "name": "Saramacca",
      "gid": "SUR.8_1"
    },
    "code": "SR-SA"
  },
  "2085": {
    "gadm": {
      "name": "Sipaliwini",
      "gid": "SUR.9_1"
    },
    "code": "SR-SI"
  },
  "2086": {
    "gadm": {
      "name": "Wanica",
      "gid": "SUR.10_1"
    },
    "code": "SR-WA"
  },
  "2087": {
    "gadm": {
      "name": "Central Equatoria",
      "gid": "SSD.1_1"
    },
    "code": "SS-EC"
  },
  "2088": {
    "gadm": {
      "name": "Eastern Equatoria",
      "gid": "SSD.2_1"
    },
    "code": "SS-EE"
  },
  "2089": {
    "gadm": {
      "name": "Jungoli",
      "gid": "SSD.3_1"
    },
    "code": "SS-JG"
  },
  "2090": {
    "gadm": {
      "name": "Lakes",
      "gid": "SSD.4_1"
    },
    "code": "SS-LK"
  },
  "2091": {
    "gadm": {
      "name": "North Bahr-al-Ghazal",
      "gid": "SSD.5_1"
    },
    "code": "SS-BN"
  },
  "2092": {
    "gadm": {
      "name": "Unity",
      "gid": "SSD.6_1"
    },
    "code": "SS-UY"
  },
  "2093": {
    "gadm": {
      "name": "Upper Nile",
      "gid": "SSD.7_1"
    },
    "code": "SS-NU"
  },
  "2094": {
    "gadm": {
      "name": "Warap",
      "gid": "SSD.8_1"
    },
    "code": "SS-WR"
  },
  "2095": {
    "gadm": {
      "name": "West Bahr-al-Ghazal",
      "gid": "SSD.9_1"
    },
    "code": "SS-BW"
  },
  "2096": {
    "gadm": {
      "name": "West Equatoria",
      "gid": "SSD.10_1"
    },
    "code": "SS-EW"
  },
  "2097": {
    "gadm": {
      "name": "Pr\u00c3\u00adncipe",
      "gid": "STP.1_1"
    },
    "code": "ST-P"
  },
  "2098": {
    "gadm": {
      "name": "S\u00c3\u00a3o Tom\u00c3\u00a9",
      "gid": "STP.2_1"
    },
    "code": "ST-S"
  },
  "2099": {
    "gadm": {
      "name": "Ahuachap\u00c3\u00a1n",
      "gid": "SLV.1_1"
    },
    "code": "SV-AH"
  },
  "2100": {
    "gadm": {
      "name": "Caba\u00c3\u00b1as",
      "gid": "SLV.2_1"
    },
    "code": "SV-CA"
  },
  "2101": {
    "gadm": {
      "name": "Chalatenango",
      "gid": "SLV.3_1"
    },
    "code": "SV-CH"
  },
  "2102": {
    "gadm": {
      "name": "Cuscatl\u00c3\u00a1n",
      "gid": "SLV.4_1"
    },
    "code": "SV-CU"
  },
  "2103": {
    "gadm": {
      "name": "La Libertad",
      "gid": "SLV.5_1"
    },
    "code": "SV-LI"
  },
  "2104": {
    "gadm": {
      "name": "La Paz",
      "gid": "SLV.6_1"
    },
    "code": "SV-PA"
  },
  "2105": {
    "gadm": {
      "name": "La Uni\u00c3\u00b3n",
      "gid": "SLV.7_1"
    },
    "code": "SV-UN"
  },
  "2106": {
    "gadm": {
      "name": "Moraz\u00c3\u00a1n",
      "gid": "SLV.8_1"
    },
    "code": "SV-MO"
  },
  "2107": {
    "gadm": {
      "name": "San Miguel",
      "gid": "SLV.9_1"
    },
    "code": "SV-SM"
  },
  "2108": {
    "gadm": {
      "name": "San Salvador",
      "gid": "SLV.10_1"
    },
    "code": "SV-SS"
  },
  "2109": {
    "gadm": {
      "name": "San Vicente",
      "gid": "SLV.11_1"
    },
    "code": "SV-SV"
  },
  "2110": {
    "gadm": {
      "name": "Santa Ana",
      "gid": "SLV.12_1"
    },
    "code": "SV-SA"
  },
  "2111": {
    "gadm": {
      "name": "Sonsonate",
      "gid": "SLV.13_1"
    },
    "code": "SV-SO"
  },
  "2112": {
    "gadm": {
      "name": "Usulut\u00c3\u00a1n",
      "gid": "SLV.14_1"
    },
    "code": "SV-US"
  },
  "2113": {
    "gadm": {
      "name": "Al \u00e1\u00b8\u00a4asakah",
      "gid": "SYR.1_1"
    },
    "code": "SY-HA"
  },
  "2114": {
    "gadm": {
      "name": "Aleppo",
      "gid": "SYR.2_1"
    },
    "code": "SY-HL"
  },
  "2115": {
    "gadm": {
      "name": "Ar Raqqah",
      "gid": "SYR.3_1"
    },
    "code": "SY-RA"
  },
  "2116": {
    "gadm": {
      "name": "As Suwayda'",
      "gid": "SYR.4_1"
    },
    "code": "SY-SU"
  },
  "2117": {
    "gadm": {
      "name": "Damascus",
      "gid": "SYR.5_1"
    },
    "code": "SY-DI"
  },
  "2118": {
    "gadm": {
      "name": "Dar`a",
      "gid": "SYR.6_1"
    },
    "code": "SY-DR"
  },
  "2119": {
    "gadm": {
      "name": "Dayr Az Zawr",
      "gid": "SYR.7_1"
    },
    "code": "SY-DY"
  },
  "2120": {
    "gadm": {
      "name": "Hamah",
      "gid": "SYR.8_1"
    },
    "code": "SY-HM"
  },
  "2121": {
    "gadm": {
      "name": "Hims",
      "gid": "SYR.9_1"
    },
    "code": "SY-HI"
  },
  "2122": {
    "gadm": {
      "name": "Idlib",
      "gid": "SYR.10_1"
    },
    "code": "SY-ID"
  },
  "2123": {
    "gadm": {
      "name": "Lattakia",
      "gid": "SYR.11_1"
    },
    "code": "SY-LA"
  },
  "2124": {
    "gadm": {
      "name": "Quneitra",
      "gid": "SYR.12_1"
    },
    "code": "SY-QU"
  },
  "2125": {
    "gadm": {
      "name": "Rif Dimashq",
      "gid": "SYR.13_1"
    },
    "code": "SY-RD"
  },
  "2126": {
    "gadm": {
      "name": "Tartus",
      "gid": "SYR.14_1"
    },
    "code": "SY-TA"
  },
  "2127": {
    "gadm": {
      "name": "Hhohho",
      "gid": "SWZ.1_1"
    },
    "code": "SZ-HH"
  },
  "2128": {
    "gadm": {
      "name": "Lubombo",
      "gid": "SWZ.2_1"
    },
    "code": "SZ-LU"
  },
  "2129": {
    "gadm": {
      "name": "Manzini",
      "gid": "SWZ.3_1"
    },
    "code": "SZ-MA"
  },
  "2130": {
    "gadm": {
      "name": "Shiselweni",
      "gid": "SWZ.4_1"
    },
    "code": "SZ-SH"
  },
  "2131": {
    "gadm": {
      "name": "Barh el Ghazel",
      "gid": "TCD.1_1"
    },
    "code": "TD-BG"
  },
  "2132": {
    "gadm": {
      "name": "Batha",
      "gid": "TCD.2_1"
    },
    "code": "TD-BA"
  },
  "2133": {
    "gadm": {
      "name": "Borkou",
      "gid": "TCD.3_1"
    },
    "code": "TD-BO"
  },
  "2134": {
    "gadm": {
      "name": "Chari-Baguirmi",
      "gid": "TCD.4_1"
    },
    "code": "TD-CB"
  },
  "2135": {
    "gadm": {
      "name": "Ennedi Est",
      "gid": "TCD.5_1"
    },
    "code": "TD-EE"
  },
  "2136": {
    "gadm": {
      "name": "Ennedi Ouest",
      "gid": "TCD.6_1"
    },
    "code": "TD-EO"
  },
  "2137": {
    "gadm": {
      "name": "Gu\u00c3\u00a9ra",
      "gid": "TCD.7_1"
    },
    "code": "TD-GR"
  },
  "2138": {
    "gadm": {
      "name": "Hadjer-Lamis",
      "gid": "TCD.8_1"
    },
    "code": "TD-HL"
  },
  "2139": {
    "gadm": {
      "name": "Kanem",
      "gid": "TCD.9_1"
    },
    "code": "TD-KA"
  },
  "2140": {
    "gadm": {
      "name": "Lac",
      "gid": "TCD.10_1"
    },
    "code": "TD-LC"
  },
  "2141": {
    "gadm": {
      "name": "Logone Occidental",
      "gid": "TCD.11_1"
    },
    "code": "TD-LO"
  },
  "2142": {
    "gadm": {
      "name": "Logone Oriental",
      "gid": "TCD.12_1"
    },
    "code": "TD-LR"
  },
  "2143": {
    "gadm": {
      "name": "Mandoul",
      "gid": "TCD.13_1"
    },
    "code": "TD-MA"
  },
  "2144": {
    "gadm": {
      "name": "Mayo-Kebbi Est",
      "gid": "TCD.14_1"
    },
    "code": "TD-ME"
  },
  "2145": {
    "gadm": {
      "name": "Mayo-Kebbi Ouest",
      "gid": "TCD.15_1"
    },
    "code": "TD-MO"
  },
  "2146": {
    "gadm": {
      "name": "Moyen-Chari",
      "gid": "TCD.16_1"
    },
    "code": "TD-MC"
  },
  "2147": {
    "gadm": {
      "name": "Ouadda\u00c3\u00af",
      "gid": "TCD.17_1"
    },
    "code": "TD-OD"
  },
  "2148": {
    "gadm": {
      "name": "Salamat",
      "gid": "TCD.18_1"
    },
    "code": "TD-SA"
  },
  "2149": {
    "gadm": {
      "name": "Sila",
      "gid": "TCD.19_1"
    },
    "code": "TD-SI"
  },
  "2150": {
    "gadm": {
      "name": "Tandjil\u00c3\u00a9",
      "gid": "TCD.20_1"
    },
    "code": "TD-TA"
  },
  "2151": {
    "gadm": {
      "name": "Tibesti",
      "gid": "TCD.21_1"
    },
    "code": "TD-TI"
  },
  "2152": {
    "gadm": {
      "name": "Ville de N'Djamena",
      "gid": "TCD.22_1"
    },
    "code": "TD-ND"
  },
  "2153": {
    "gadm": {
      "name": "Wadi Fira",
      "gid": "TCD.23_1"
    },
    "code": "TD-WF"
  },
  "2154": {
    "gadm": {
      "name": "Centre",
      "gid": "TGO.1_1"
    },
    "code": "TG-C"
  },
  "2155": {
    "gadm": {
      "name": "Kara",
      "gid": "TGO.2_1"
    },
    "code": "TG-K"
  },
  "2156": {
    "gadm": {
      "name": "Maritime",
      "gid": "TGO.3_1"
    },
    "code": "TG-M"
  },
  "2157": {
    "gadm": {
      "name": "Plateaux",
      "gid": "TGO.4_1"
    },
    "code": "TG-P"
  },
  "2158": {
    "gadm": {
      "name": "Savanes",
      "gid": "TGO.5_1"
    },
    "code": "TG-S"
  },
  "2159": {
    "gadm": {
      "name": "Amnat Charoen",
      "gid": "THA.1_1"
    },
    "code": "TH-37"
  },
  "2160": {
    "gadm": {
      "name": "Ang Thong",
      "gid": "THA.2_1"
    },
    "code": "TH-15"
  },
  "2161": {
    "gadm": {
      "name": "Bangkok Metropolis",
      "gid": "THA.3_1"
    },
    "code": "TH-10"
  },
  "2162": {
    "gadm": {
      "name": "Bueng Kan",
      "gid": "THA.4_1"
    },
    "code": "TH-38"
  },
  "2163": {
    "gadm": {
      "name": "Buri Ram",
      "gid": "THA.5_1"
    },
    "code": "TH-31"
  },
  "2164": {
    "gadm": {
      "name": "Chachoengsao",
      "gid": "THA.6_1"
    },
    "code": "TH-24"
  },
  "2165": {
    "gadm": {
      "name": "Chai Nat",
      "gid": "THA.7_1"
    },
    "code": "TH-18"
  },
  "2166": {
    "gadm": {
      "name": "Chaiyaphum",
      "gid": "THA.8_1"
    },
    "code": "TH-36"
  },
  "2167": {
    "gadm": {
      "name": "Chanthaburi",
      "gid": "THA.9_1"
    },
    "code": "TH-22"
  },
  "2168": {
    "gadm": {
      "name": "Chiang Mai",
      "gid": "THA.10_1"
    },
    "code": "TH-50"
  },
  "2169": {
    "gadm": {
      "name": "Chiang Rai",
      "gid": "THA.11_1"
    },
    "code": "TH-57"
  },
  "2170": {
    "gadm": {
      "name": "Chon Buri",
      "gid": "THA.12_1"
    },
    "code": "TH-20"
  },
  "2171": {
    "gadm": {
      "name": "Chumphon",
      "gid": "THA.13_1"
    },
    "code": "TH-86"
  },
  "2172": {
    "gadm": {
      "name": "Kalasin",
      "gid": "THA.14_1"
    },
    "code": "TH-46"
  },
  "2173": {
    "gadm": {
      "name": "Kamphaeng Phet",
      "gid": "THA.15_1"
    },
    "code": "TH-62"
  },
  "2174": {
    "gadm": {
      "name": "Kanchanaburi",
      "gid": "THA.16_1"
    },
    "code": "TH-71"
  },
  "2175": {
    "gadm": {
      "name": "Khon Kaen",
      "gid": "THA.17_1"
    },
    "code": "TH-40"
  },
  "2176": {
    "gadm": {
      "name": "Krabi",
      "gid": "THA.18_1"
    },
    "code": "TH-81"
  },
  "2177": {
    "gadm": {
      "name": "Lampang",
      "gid": "THA.19_1"
    },
    "code": "TH-52"
  },
  "2178": {
    "gadm": {
      "name": "Lamphun",
      "gid": "THA.20_1"
    },
    "code": "TH-51"
  },
  "2179": {
    "gadm": {
      "name": "Loei",
      "gid": "THA.21_1"
    },
    "code": "TH-42"
  },
  "2180": {
    "gadm": {
      "name": "Lop Buri",
      "gid": "THA.22_1"
    },
    "code": "TH-16"
  },
  "2181": {
    "gadm": {
      "name": "Mae Hong Son",
      "gid": "THA.23_1"
    },
    "code": "TH-58"
  },
  "2182": {
    "gadm": {
      "name": "Maha Sarakham",
      "gid": "THA.24_1"
    },
    "code": "TH-44"
  },
  "2183": {
    "gadm": {
      "name": "Mukdahan",
      "gid": "THA.25_1"
    },
    "code": "TH-49"
  },
  "2184": {
    "gadm": {
      "name": "Nakhon Nayok",
      "gid": "THA.26_1"
    },
    "code": "TH-26"
  },
  "2185": {
    "gadm": {
      "name": "Nakhon Pathom",
      "gid": "THA.27_1"
    },
    "code": "TH-73"
  },
  "2186": {
    "gadm": {
      "name": "Nakhon Phanom",
      "gid": "THA.28_1"
    },
    "code": "TH-48"
  },
  "2187": {
    "gadm": {
      "name": "Nakhon Ratchasima",
      "gid": "THA.29_1"
    },
    "code": "TH-30"
  },
  "2188": {
    "gadm": {
      "name": "Nakhon Sawan",
      "gid": "THA.30_1"
    },
    "code": "TH-60"
  },
  "2189": {
    "gadm": {
      "name": "Nakhon Si Thammarat",
      "gid": "THA.31_1"
    },
    "code": "TH-80"
  },
  "2190": {
    "gadm": {
      "name": "Nan",
      "gid": "THA.32_1"
    },
    "code": "TH-55"
  },
  "2191": {
    "gadm": {
      "name": "Narathiwat",
      "gid": "THA.33_1"
    },
    "code": "TH-96"
  },
  "2192": {
    "gadm": {
      "name": "Nong Bua Lam Phu",
      "gid": "THA.34_1"
    },
    "code": "TH-39"
  },
  "2193": {
    "gadm": {
      "name": "Nong Khai",
      "gid": "THA.35_1"
    },
    "code": "TH-43"
  },
  "2194": {
    "gadm": {
      "name": "Nonthaburi",
      "gid": "THA.36_1"
    },
    "code": "TH-12"
  },
  "2195": {
    "gadm": {
      "name": "Pathum Thani",
      "gid": "THA.37_1"
    },
    "code": "TH-13"
  },
  "2196": {
    "gadm": {
      "name": "Pattani",
      "gid": "THA.38_1"
    },
    "code": "TH-94"
  },
  "2197": {
    "gadm": {
      "name": "Phangnga",
      "gid": "THA.39_1"
    },
    "code": "TH-82"
  },
  "2198": {
    "gadm": {
      "name": "Phatthalung",
      "gid": "THA.40_1"
    },
    "code": "TH-93"
  },
  "2199": {
    "gadm": {
      "name": "Phayao",
      "gid": "THA.41_1"
    },
    "code": "TH-56"
  },
  "2200": {
    "gadm": {
      "name": "Phetchabun",
      "gid": "THA.42_1"
    },
    "code": "TH-67"
  },
  "2201": {
    "gadm": {
      "name": "Phetchaburi",
      "gid": "THA.43_1"
    },
    "code": "TH-76"
  },
  "2202": {
    "gadm": {
      "name": "Phichit",
      "gid": "THA.44_1"
    },
    "code": "TH-66"
  },
  "2203": {
    "gadm": {
      "name": "Phitsanulok",
      "gid": "THA.45_1"
    },
    "code": "TH-65"
  },
  "2204": {
    "gadm": {
      "name": "Phra Nakhon Si Ayutthaya",
      "gid": "THA.46_1"
    },
    "code": "TH-14"
  },
  "2205": {
    "gadm": {
      "name": "Phrae",
      "gid": "THA.47_1"
    },
    "code": "TH-54"
  },
  "2206": {
    "gadm": {
      "name": "Phuket",
      "gid": "THA.48_1"
    },
    "code": "TH-83"
  },
  "2207": {
    "gadm": {
      "name": "Prachin Buri",
      "gid": "THA.49_1"
    },
    "code": "TH-25"
  },
  "2208": {
    "gadm": {
      "name": "Prachuap Khiri Khan",
      "gid": "THA.50_1"
    },
    "code": "TH-77"
  },
  "2209": {
    "gadm": {
      "name": "Ranong",
      "gid": "THA.51_1"
    },
    "code": "TH-85"
  },
  "2210": {
    "gadm": {
      "name": "Ratchaburi",
      "gid": "THA.52_1"
    },
    "code": "TH-70"
  },
  "2211": {
    "gadm": {
      "name": "Rayong",
      "gid": "THA.53_1"
    },
    "code": "TH-21"
  },
  "2212": {
    "gadm": {
      "name": "Roi Et",
      "gid": "THA.54_1"
    },
    "code": "TH-45"
  },
  "2213": {
    "gadm": {
      "name": "Sa Kaeo",
      "gid": "THA.55_1"
    },
    "code": "TH-27"
  },
  "2214": {
    "gadm": {
      "name": "Sakon Nakhon",
      "gid": "THA.56_1"
    },
    "code": "TH-47"
  },
  "2215": {
    "gadm": {
      "name": "Samut Prakan",
      "gid": "THA.57_1"
    },
    "code": "TH-11"
  },
  "2216": {
    "gadm": {
      "name": "Samut Sakhon",
      "gid": "THA.58_1"
    },
    "code": "TH-74"
  },
  "2217": {
    "gadm": {
      "name": "Samut Songkhram",
      "gid": "THA.59_1"
    },
    "code": "TH-75"
  },
  "2218": {
    "gadm": {
      "name": "Saraburi",
      "gid": "THA.60_1"
    },
    "code": "TH-19"
  },
  "2219": {
    "gadm": {
      "name": "Satun",
      "gid": "THA.61_1"
    },
    "code": "TH-91"
  },
  "2220": {
    "gadm": {
      "name": "Si Sa Ket",
      "gid": "THA.62_1"
    },
    "code": "TH-33"
  },
  "2221": {
    "gadm": {
      "name": "Sing Buri",
      "gid": "THA.63_1"
    },
    "code": "TH-17"
  },
  "2222": {
    "gadm": {
      "name": "Songkhla",
      "gid": "THA.64_1"
    },
    "code": "TH-90"
  },
  "2223": {
    "gadm": {
      "name": "Sukhothai",
      "gid": "THA.65_1"
    },
    "code": "TH-64"
  },
  "2224": {
    "gadm": {
      "name": "Suphan Buri",
      "gid": "THA.66_1"
    },
    "code": "TH-72"
  },
  "2225": {
    "gadm": {
      "name": "Surat Thani",
      "gid": "THA.67_1"
    },
    "code": "TH-84"
  },
  "2226": {
    "gadm": {
      "name": "Surin",
      "gid": "THA.68_1"
    },
    "code": "TH-32"
  },
  "2227": {
    "gadm": {
      "name": "Tak",
      "gid": "THA.69_1"
    },
    "code": "TH-63"
  },
  "2228": {
    "gadm": {
      "name": "Trang",
      "gid": "THA.70_1"
    },
    "code": "TH-92"
  },
  "2229": {
    "gadm": {
      "name": "Trat",
      "gid": "THA.71_1"
    },
    "code": "TH-23"
  },
  "2230": {
    "gadm": {
      "name": "Ubon Ratchathani",
      "gid": "THA.72_1"
    },
    "code": "TH-34"
  },
  "2231": {
    "gadm": {
      "name": "Udon Thani",
      "gid": "THA.73_1"
    },
    "code": "TH-41"
  },
  "2232": {
    "gadm": {
      "name": "Uthai Thani",
      "gid": "THA.74_1"
    },
    "code": "TH-61"
  },
  "2233": {
    "gadm": {
      "name": "Uttaradit",
      "gid": "THA.75_1"
    },
    "code": "TH-53"
  },
  "2234": {
    "gadm": {
      "name": "Yala",
      "gid": "THA.76_1"
    },
    "code": "TH-95"
  },
  "2235": {
    "gadm": {
      "name": "Yasothon",
      "gid": "THA.77_1"
    },
    "code": "TH-35"
  },
  "2236": {
    "gadm": {
      "name": "Aileu",
      "gid": "TLS.1_1"
    },
    "code": "TL-AL"
  },
  "2237": {
    "gadm": {
      "name": "Ainaro",
      "gid": "TLS.2_1"
    },
    "code": "TL-AN"
  },
  "2238": {
    "gadm": {
      "name": "Ambeno",
      "gid": "TLS.3_1"
    },
    "code": "TL-OE"
  },
  "2239": {
    "gadm": {
      "name": "Baucau",
      "gid": "TLS.4_1"
    },
    "code": "TL-BA"
  },
  "2240": {
    "gadm": {
      "name": "Bobonaro",
      "gid": "TLS.5_1"
    },
    "code": "TL-BO"
  },
  "2241": {
    "gadm": {
      "name": "Covalima",
      "gid": "TLS.6_1"
    },
    "code": "TL-CO"
  },
  "2242": {
    "gadm": {
      "name": "Dili",
      "gid": "TLS.7_1"
    },
    "code": "TL-DI"
  },
  "2243": {
    "gadm": {
      "name": "Ermera",
      "gid": "TLS.8_1"
    },
    "code": "TL-ER"
  },
  "2244": {
    "gadm": {
      "name": "Laut\u00c3\u00a9m",
      "gid": "TLS.9_1"
    },
    "code": "TL-LA"
  },
  "2245": {
    "gadm": {
      "name": "Liqui\u00c3\u00a7\u00c3\u00a1",
      "gid": "TLS.10_1"
    },
    "code": "TL-LI"
  },
  "2246": {
    "gadm": {
      "name": "Manatuto",
      "gid": "TLS.11_1"
    },
    "code": "TL-MT"
  },
  "2247": {
    "gadm": {
      "name": "Manufahi",
      "gid": "TLS.12_1"
    },
    "code": "TL-MF"
  },
  "2248": {
    "gadm": {
      "name": "Viqueque",
      "gid": "TLS.13_1"
    },
    "code": "TL-VI"
  },
  "2249": {
    "gadm": {
      "name": "Ahal",
      "gid": "TKM.1_1"
    },
    "code": "TM-A"
  },
  "2250": {
    "gadm": {
      "name": "A\u00c5\u0178gabat",
      "gid": "TKM.2_1"
    },
    "code": "TM-S"
  },
  "2251": {
    "gadm": {
      "name": "Balkan",
      "gid": "TKM.3_1"
    },
    "code": "TM-B"
  },
  "2252": {
    "gadm": {
      "name": "Chardzhou",
      "gid": "TKM.4_1"
    },
    "code": "TM-L"
  },
  "2253": {
    "gadm": {
      "name": "Mary",
      "gid": "TKM.5_1"
    },
    "code": "TM-M"
  },
  "2254": {
    "gadm": {
      "name": "Tashauz",
      "gid": "TKM.6_1"
    },
    "code": "TM-D"
  },
  "2255": {
    "gadm": {
      "name": "Ariana",
      "gid": "TUN.1_1"
    },
    "code": "TN-12"
  },
  "2256": {
    "gadm": {
      "name": "B\u00c3\u00a9ja",
      "gid": "TUN.2_1"
    },
    "code": "TN-31"
  },
  "2257": {
    "gadm": {
      "name": "Ben Arous (Tunis Sud)",
      "gid": "TUN.3_1"
    },
    "code": "TN-13"
  },
  "2258": {
    "gadm": {
      "name": "Bizerte",
      "gid": "TUN.4_1"
    },
    "code": "TN-23"
  },
  "2259": {
    "gadm": {
      "name": "Gab\u00c3\u00a8s",
      "gid": "TUN.5_1"
    },
    "code": "TN-81"
  },
  "2260": {
    "gadm": {
      "name": "Gafsa",
      "gid": "TUN.6_1"
    },
    "code": "TN-71"
  },
  "2261": {
    "gadm": {
      "name": "Jendouba",
      "gid": "TUN.7_1"
    },
    "code": "TN-32"
  },
  "2262": {
    "gadm": {
      "name": "Kairouan",
      "gid": "TUN.8_1"
    },
    "code": "TN-41"
  },
  "2263": {
    "gadm": {
      "name": "Kass\u00c3\u00a9rine",
      "gid": "TUN.9_1"
    },
    "code": "TN-42"
  },
  "2264": {
    "gadm": {
      "name": "Kebili",
      "gid": "TUN.10_1"
    },
    "code": "TN-73"
  },
  "2265": {
    "gadm": {
      "name": "Le Kef",
      "gid": "TUN.11_1"
    },
    "code": "TN-33"
  },
  "2266": {
    "gadm": {
      "name": "Mahdia",
      "gid": "TUN.12_1"
    },
    "code": "TN-53"
  },
  "2267": {
    "gadm": {
      "name": "Manubah",
      "gid": "TUN.13_1"
    },
    "code": "TN-14"
  },
  "2268": {
    "gadm": {
      "name": "M\u00c3\u00a9denine",
      "gid": "TUN.14_1"
    },
    "code": "TN-82"
  },
  "2269": {
    "gadm": {
      "name": "Monastir",
      "gid": "TUN.15_1"
    },
    "code": "TN-52"
  },
  "2270": {
    "gadm": {
      "name": "Nabeul",
      "gid": "TUN.16_1"
    },
    "code": "TN-21"
  },
  "2271": {
    "gadm": {
      "name": "Sfax",
      "gid": "TUN.17_1"
    },
    "code": "TN-61"
  },
  "2272": {
    "gadm": {
      "name": "Sidi Bou Zid",
      "gid": "TUN.18_1"
    },
    "code": "TN-43"
  },
  "2273": {
    "gadm": {
      "name": "Siliana",
      "gid": "TUN.19_1"
    },
    "code": "TN-34"
  },
  "2274": {
    "gadm": {
      "name": "Sousse",
      "gid": "TUN.20_1"
    },
    "code": "TN-51"
  },
  "2275": {
    "gadm": {
      "name": "Tataouine",
      "gid": "TUN.21_1"
    },
    "code": "TN-83"
  },
  "2276": {
    "gadm": {
      "name": "Tozeur",
      "gid": "TUN.22_1"
    },
    "code": "TN-72"
  },
  "2277": {
    "gadm": {
      "name": "Tunis",
      "gid": "TUN.23_1"
    },
    "code": "TN-11"
  },
  "2278": {
    "gadm": {
      "name": "Zaghouan",
      "gid": "TUN.24_1"
    },
    "code": "TN-22"
  },
  "2279": {
    "gadm": {
      "name": "'Eua",
      "gid": "TON.1_1"
    },
    "code": "TO-01"
  },
  "2280": {
    "gadm": {
      "name": "Ha'apai",
      "gid": "TON.2_1"
    },
    "code": "TO-02"
  },
  "2281": {
    "gadm": {
      "name": "Niuas",
      "gid": "TON.3_1"
    },
    "code": "TO-03"
  },
  "2282": {
    "gadm": {
      "name": "Tongatapu",
      "gid": "TON.4_1"
    },
    "code": "TO-04"
  },
  "2283": {
    "gadm": {
      "name": "Vava'u",
      "gid": "TON.5_1"
    },
    "code": "TO-05"
  },
  "2284": {
    "gadm": {
      "name": "Adana",
      "gid": "TUR.1_1"
    },
    "code": "TR-01"
  },
  "2285": {
    "gadm": {
      "name": "Adiyaman",
      "gid": "TUR.2_1"
    },
    "code": "TR-02"
  },
  "2286": {
    "gadm": {
      "name": "Afyon",
      "gid": "TUR.3_1"
    },
    "code": "TR-03"
  },
  "2287": {
    "gadm": {
      "name": "Agri",
      "gid": "TUR.4_1"
    },
    "code": "TR-04"
  },
  "2288": {
    "gadm": {
      "name": "Aksaray",
      "gid": "TUR.5_1"
    },
    "code": "TR-68"
  },
  "2289": {
    "gadm": {
      "name": "Amasya",
      "gid": "TUR.6_1"
    },
    "code": "TR-05"
  },
  "2290": {
    "gadm": {
      "name": "Ankara",
      "gid": "TUR.7_1"
    },
    "code": "TR-06"
  },
  "2291": {
    "gadm": {
      "name": "Antalya",
      "gid": "TUR.8_1"
    },
    "code": "TR-07"
  },
  "2292": {
    "gadm": {
      "name": "Ardahan",
      "gid": "TUR.9_1"
    },
    "code": "TR-75"
  },
  "2293": {
    "gadm": {
      "name": "Artvin",
      "gid": "TUR.10_1"
    },
    "code": "TR-08"
  },
  "2294": {
    "gadm": {
      "name": "Aydin",
      "gid": "TUR.11_1"
    },
    "code": "TR-09"
  },
  "2295": {
    "gadm": {
      "name": "Balikesir",
      "gid": "TUR.12_1"
    },
    "code": "TR-10"
  },
  "2296": {
    "gadm": {
      "name": "Bart\u00c4\u00b1n",
      "gid": "TUR.13_1"
    },
    "code": "TR-74"
  },
  "2297": {
    "gadm": {
      "name": "Batman",
      "gid": "TUR.14_1"
    },
    "code": "TR-72"
  },
  "2298": {
    "gadm": {
      "name": "Bayburt",
      "gid": "TUR.15_1"
    },
    "code": "TR-69"
  },
  "2299": {
    "gadm": {
      "name": "Bilecik",
      "gid": "TUR.16_1"
    },
    "code": "TR-11"
  },
  "2300": {
    "gadm": {
      "name": "Bing\u00c3\u00b6l",
      "gid": "TUR.17_1"
    },
    "code": "TR-12"
  },
  "2301": {
    "gadm": {
      "name": "Bitlis",
      "gid": "TUR.18_1"
    },
    "code": "TR-13"
  },
  "2302": {
    "gadm": {
      "name": "Bolu",
      "gid": "TUR.19_1"
    },
    "code": "TR-14"
  },
  "2303": {
    "gadm": {
      "name": "Burdur",
      "gid": "TUR.20_1"
    },
    "code": "TR-15"
  },
  "2304": {
    "gadm": {
      "name": "Bursa",
      "gid": "TUR.21_1"
    },
    "code": "TR-16"
  },
  "2305": {
    "gadm": {
      "name": "\u00c3\u2021anakkale",
      "gid": "TUR.22_1"
    },
    "code": "TR-17"
  },
  "2306": {
    "gadm": {
      "name": "\u00c3\u2021ankiri",
      "gid": "TUR.23_1"
    },
    "code": "TR-18"
  },
  "2307": {
    "gadm": {
      "name": "\u00c3\u2021orum",
      "gid": "TUR.24_1"
    },
    "code": "TR-19"
  },
  "2308": {
    "gadm": {
      "name": "Denizli",
      "gid": "TUR.25_1"
    },
    "code": "TR-20"
  },
  "2309": {
    "gadm": {
      "name": "Diyarbakir",
      "gid": "TUR.26_1"
    },
    "code": "TR-21"
  },
  "2310": {
    "gadm": {
      "name": "D\u00c3\u00bczce",
      "gid": "TUR.27_1"
    },
    "code": "TR-81"
  },
  "2311": {
    "gadm": {
      "name": "Edirne",
      "gid": "TUR.28_1"
    },
    "code": "TR-22"
  },
  "2312": {
    "gadm": {
      "name": "Elaz\u00c4\u00b1\u00c4\u0178",
      "gid": "TUR.29_1"
    },
    "code": "TR-23"
  },
  "2313": {
    "gadm": {
      "name": "Erzincan",
      "gid": "TUR.30_1"
    },
    "code": "TR-24"
  },
  "2314": {
    "gadm": {
      "name": "Erzurum",
      "gid": "TUR.31_1"
    },
    "code": "TR-25"
  },
  "2315": {
    "gadm": {
      "name": "Eskisehir",
      "gid": "TUR.32_1"
    },
    "code": "TR-26"
  },
  "2316": {
    "gadm": {
      "name": "Gaziantep",
      "gid": "TUR.33_1"
    },
    "code": "TR-27"
  },
  "2317": {
    "gadm": {
      "name": "Giresun",
      "gid": "TUR.34_1"
    },
    "code": "TR-28"
  },
  "2318": {
    "gadm": {
      "name": "G\u00c3\u00bcm\u00c3\u00bcshane",
      "gid": "TUR.35_1"
    },
    "code": "TR-29"
  },
  "2319": {
    "gadm": {
      "name": "Hakkari",
      "gid": "TUR.36_1"
    },
    "code": "TR-30"
  },
  "2320": {
    "gadm": {
      "name": "Hatay",
      "gid": "TUR.37_1"
    },
    "code": "TR-31"
  },
  "2321": {
    "gadm": {
      "name": "I\u00c4\u0178d\u00c4\u00b1r",
      "gid": "TUR.38_1"
    },
    "code": "TR-76"
  },
  "2322": {
    "gadm": {
      "name": "Isparta",
      "gid": "TUR.39_1"
    },
    "code": "TR-32"
  },
  "2323": {
    "gadm": {
      "name": "Istanbul",
      "gid": "TUR.40_1"
    },
    "code": "TR-34"
  },
  "2324": {
    "gadm": {
      "name": "Izmir",
      "gid": "TUR.41_1"
    },
    "code": "TR-35"
  },
  "2325": {
    "gadm": {
      "name": "K. Maras",
      "gid": "TUR.42_1"
    },
    "code": "TR-46"
  },
  "2326": {
    "gadm": {
      "name": "Karab\u00c3\u00bck",
      "gid": "TUR.43_1"
    },
    "code": "TR-78"
  },
  "2327": {
    "gadm": {
      "name": "Karaman",
      "gid": "TUR.44_1"
    },
    "code": "TR-70"
  },
  "2328": {
    "gadm": {
      "name": "Kars",
      "gid": "TUR.45_1"
    },
    "code": "TR-36"
  },
  "2329": {
    "gadm": {
      "name": "Kastamonu",
      "gid": "TUR.46_1"
    },
    "code": "TR-37"
  },
  "2330": {
    "gadm": {
      "name": "Kayseri",
      "gid": "TUR.47_1"
    },
    "code": "TR-38"
  },
  "2331": {
    "gadm": {
      "name": "Kilis",
      "gid": "TUR.48_1"
    },
    "code": "TR-79"
  },
  "2332": {
    "gadm": {
      "name": "Kinkkale",
      "gid": "TUR.49_1"
    },
    "code": "TR-71"
  },
  "2333": {
    "gadm": {
      "name": "Kirklareli",
      "gid": "TUR.50_1"
    },
    "code": "TR-39"
  },
  "2334": {
    "gadm": {
      "name": "Kirsehir",
      "gid": "TUR.51_1"
    },
    "code": "TR-40"
  },
  "2335": {
    "gadm": {
      "name": "Kocaeli",
      "gid": "TUR.52_1"
    },
    "code": "TR-41"
  },
  "2336": {
    "gadm": {
      "name": "Konya",
      "gid": "TUR.53_1"
    },
    "code": "TR-42"
  },
  "2337": {
    "gadm": {
      "name": "K\u00c3\u00bctahya",
      "gid": "TUR.54_1"
    },
    "code": "TR-43"
  },
  "2338": {
    "gadm": {
      "name": "Malatya",
      "gid": "TUR.55_1"
    },
    "code": "TR-44"
  },
  "2339": {
    "gadm": {
      "name": "Manisa",
      "gid": "TUR.56_1"
    },
    "code": "TR-45"
  },
  "2340": {
    "gadm": {
      "name": "Mardin",
      "gid": "TUR.57_1"
    },
    "code": "TR-47"
  },
  "2341": {
    "gadm": {
      "name": "Mersin",
      "gid": "TUR.58_1"
    },
    "code": "TR-33"
  },
  "2342": {
    "gadm": {
      "name": "Mugla",
      "gid": "TUR.59_1"
    },
    "code": "TR-48"
  },
  "2343": {
    "gadm": {
      "name": "Mus",
      "gid": "TUR.60_1"
    },
    "code": "TR-49"
  },
  "2344": {
    "gadm": {
      "name": "Nevsehir",
      "gid": "TUR.61_1"
    },
    "code": "TR-50"
  },
  "2345": {
    "gadm": {
      "name": "Nigde",
      "gid": "TUR.62_1"
    },
    "code": "TR-51"
  },
  "2346": {
    "gadm": {
      "name": "Ordu",
      "gid": "TUR.63_1"
    },
    "code": "TR-52"
  },
  "2347": {
    "gadm": {
      "name": "Osmaniye",
      "gid": "TUR.64_1"
    },
    "code": "TR-80"
  },
  "2348": {
    "gadm": {
      "name": "Rize",
      "gid": "TUR.65_1"
    },
    "code": "TR-53"
  },
  "2349": {
    "gadm": {
      "name": "Sakarya",
      "gid": "TUR.66_1"
    },
    "code": "TR-54"
  },
  "2350": {
    "gadm": {
      "name": "Samsun",
      "gid": "TUR.67_1"
    },
    "code": "TR-55"
  },
  "2351": {
    "gadm": {
      "name": "Sanliurfa",
      "gid": "TUR.68_1"
    },
    "code": "TR-63"
  },
  "2352": {
    "gadm": {
      "name": "Siirt",
      "gid": "TUR.69_1"
    },
    "code": "TR-56"
  },
  "2353": {
    "gadm": {
      "name": "Sinop",
      "gid": "TUR.70_1"
    },
    "code": "TR-57"
  },
  "2354": {
    "gadm": {
      "name": "Sirnak",
      "gid": "TUR.71_1"
    },
    "code": "TR-73"
  },
  "2355": {
    "gadm": {
      "name": "Sivas",
      "gid": "TUR.72_1"
    },
    "code": "TR-58"
  },
  "2356": {
    "gadm": {
      "name": "Tekirdag",
      "gid": "TUR.73_1"
    },
    "code": "TR-59"
  },
  "2357": {
    "gadm": {
      "name": "Tokat",
      "gid": "TUR.74_1"
    },
    "code": "TR-60"
  },
  "2358": {
    "gadm": {
      "name": "Trabzon",
      "gid": "TUR.75_1"
    },
    "code": "TR-61"
  },
  "2359": {
    "gadm": {
      "name": "Tunceli",
      "gid": "TUR.76_1"
    },
    "code": "TR-62"
  },
  "2360": {
    "gadm": {
      "name": "Usak",
      "gid": "TUR.77_1"
    },
    "code": "TR-64"
  },
  "2361": {
    "gadm": {
      "name": "Van",
      "gid": "TUR.78_1"
    },
    "code": "TR-65"
  },
  "2362": {
    "gadm": {
      "name": "Yalova",
      "gid": "TUR.79_1"
    },
    "code": "TR-77"
  },
  "2363": {
    "gadm": {
      "name": "Yozgat",
      "gid": "TUR.80_1"
    },
    "code": "TR-66"
  },
  "2364": {
    "gadm": {
      "name": "Zinguldak",
      "gid": "TUR.81_1"
    },
    "code": "TR-67"
  },
  "2365": {
    "gadm": {
      "name": "Arima",
      "gid": "TTO.1_1"
    },
    "code": "TT-ARI"
  },
  "2366": {
    "gadm": {
      "name": "Chaguanas",
      "gid": "TTO.2_1"
    },
    "code": "TT-CHA"
  },
  "2367": {
    "gadm": {
      "name": "Couva-Tabaquite-Talparo",
      "gid": "TTO.3_1"
    },
    "code": "TT-CTT"
  },
  "2368": {
    "gadm": {
      "name": "Diego Martin",
      "gid": "TTO.4_1"
    },
    "code": "TT-DMN"
  },
  "2369": {
    "gadm": {
      "name": "Mayaro/Rio Claro",
      "gid": "TTO.5_1"
    },
    "code": "TT-MRC"
  },
  "2370": {
    "gadm": {
      "name": "Penal-Debe",
      "gid": "TTO.6_1"
    },
    "code": "TT-PED"
  },
  "2371": {
    "gadm": {
      "name": "Point Fortin",
      "gid": "TTO.7_1"
    },
    "code": "TT-PTF"
  },
  "2372": {
    "gadm": {
      "name": "Port of Spain",
      "gid": "TTO.8_1"
    },
    "code": "TT-POS"
  },
  "2373": {
    "gadm": {
      "name": "Princes Town",
      "gid": "TTO.9_1"
    },
    "code": "TT-PRT"
  },
  "2374": {
    "gadm": {
      "name": "San Fernando",
      "gid": "TTO.10_1"
    },
    "code": "TT-SFO"
  },
  "2375": {
    "gadm": {
      "name": "San Juan-Laventille",
      "gid": "TTO.11_1"
    },
    "code": "TT-SJL"
  },
  "2376": {
    "gadm": {
      "name": "Sangre Grande",
      "gid": "TTO.12_1"
    },
    "code": "TT-SGE"
  },
  "2377": {
    "gadm": {
      "name": "Siparia",
      "gid": "TTO.13_1"
    },
    "code": "TT-SIP"
  },
  "2378": {
    "gadm": {
      "name": "Tobago",
      "gid": "TTO.14_1"
    },
    "code": "TT-TOB"
  },
  "2379": {
    "gadm": {
      "name": "Tunapuna/Piarco",
      "gid": "TTO.15_1"
    },
    "code": "TT-TUP"
  },
  "2380": {
    "gadm": {
      "name": "Funafuti",
      "gid": "TUV.1_1"
    },
    "code": "TV-FUN"
  },
  "2381": {
    "gadm": {
      "name": "Nanumanga",
      "gid": "TUV.2_1"
    },
    "code": "TV-NMG"
  },
  "2382": {
    "gadm": {
      "name": "Nanumea",
      "gid": "TUV.3_1"
    },
    "code": "TV-NMA"
  },
  "2383": {
    "gadm": {
      "name": "Niutao",
      "gid": "TUV.5_1"
    },
    "code": "TV-NIT"
  },
  "2384": {
    "gadm": {
      "name": "Nui",
      "gid": "TUV.6_1"
    },
    "code": "TV-NUI"
  },
  "2385": {
    "gadm": {
      "name": "Nukufetau",
      "gid": "TUV.7_1"
    },
    "code": "TV-NKF"
  },
  "2386": {
    "gadm": {
      "name": "Nukulaelae",
      "gid": "TUV.8_1"
    },
    "code": "TV-NKL"
  },
  "2387": {
    "gadm": {
      "name": "Vaitupu",
      "gid": "TUV.9_1"
    },
    "code": "TV-VAI"
  },
  "2388": {
    "gadm": {
      "name": "Tainan",
      "gid": "TWN.5_1"
    },
    "code": "TWN.5_1"
  },
  "2389": {
    "gadm": {
      "name": "Taiwan",
      "gid": "TWN.7_1"
    },
    "code": "TWN.7_1"
  },
  "2390": {
    "gadm": {
      "name": "Fujian",
      "gid": "TWN.1_1"
    },
    "code": "TWN.1_1"
  },
  "2391": {
    "gadm": {
      "name": "Taichung",
      "gid": "TWN.4_1"
    },
    "code": "TWN.4_1"
  },
  "2392": {
    "gadm": {
      "name": "Taipei",
      "gid": "TWN.6_1"
    },
    "code": "TWN.6_1"
  },
  "2393": {
    "gadm": {
      "name": "Kaohsiung",
      "gid": "TWN.2_1"
    },
    "code": "TWN.2_1"
  },
  "2394": {
    "gadm": {
      "name": "New Taipei",
      "gid": "TWN.3_1"
    },
    "code": "TWN.3_1"
  },
  "2395": {
    "gadm": {
      "name": "Arusha",
      "gid": "TZA.1_1"
    },
    "code": "TZ-01"
  },
  "2396": {
    "gadm": {
      "name": "Dar es Salaam",
      "gid": "TZA.2_1"
    },
    "code": "TZ-02"
  },
  "2397": {
    "gadm": {
      "name": "Dodoma",
      "gid": "TZA.3_1"
    },
    "code": "TZ-03"
  },
  "2398": {
    "gadm": {
      "name": "Geita",
      "gid": "TZA.4_1"
    },
    "code": "TZ-27"
  },
  "2399": {
    "gadm": {
      "name": "Iringa",
      "gid": "TZA.5_1"
    },
    "code": "TZ-04"
  },
  "2400": {
    "gadm": {
      "name": "Kagera",
      "gid": "TZA.6_1"
    },
    "code": "TZ-05"
  },
  "2401": {
    "gadm": {
      "name": "Katavi",
      "gid": "TZA.7_1"
    },
    "code": "TZ-28"
  },
  "2402": {
    "gadm": {
      "name": "Kigoma",
      "gid": "TZA.8_1"
    },
    "code": "TZ-08"
  },
  "2403": {
    "gadm": {
      "name": "Kilimanjaro",
      "gid": "TZA.9_1"
    },
    "code": "TZ-09"
  },
  "2404": {
    "gadm": {
      "name": "Lindi",
      "gid": "TZA.10_1"
    },
    "code": "TZ-12"
  },
  "2405": {
    "gadm": {
      "name": "Manyara",
      "gid": "TZA.11_1"
    },
    "code": "TZ-26"
  },
  "2406": {
    "gadm": {
      "name": "Mara",
      "gid": "TZA.12_1"
    },
    "code": "TZ-13"
  },
  "2407": {
    "gadm": {
      "name": "Mbeya",
      "gid": "TZA.13_1"
    },
    "code": "TZ-14"
  },
  "2408": {
    "gadm": {
      "name": "Morogoro",
      "gid": "TZA.14_1"
    },
    "code": "TZ-16"
  },
  "2409": {
    "gadm": {
      "name": "Mtwara",
      "gid": "TZA.15_1"
    },
    "code": "TZ-17"
  },
  "2410": {
    "gadm": {
      "name": "Mwanza",
      "gid": "TZA.16_1"
    },
    "code": "TZ-18"
  },
  "2411": {
    "gadm": {
      "name": "Njombe",
      "gid": "TZA.17_1"
    },
    "code": "TZ-29"
  },
  "2412": {
    "gadm": {
      "name": "Pemba North",
      "gid": "TZA.18_1"
    },
    "code": "TZ-06"
  },
  "2413": {
    "gadm": {
      "name": "Pemba South",
      "gid": "TZA.19_1"
    },
    "code": "TZ-10"
  },
  "2414": {
    "gadm": {
      "name": "Pwani",
      "gid": "TZA.20_1"
    },
    "code": "TZ-19"
  },
  "2415": {
    "gadm": {
      "name": "Rukwa",
      "gid": "TZA.21_1"
    },
    "code": "TZ-20"
  },
  "2416": {
    "gadm": {
      "name": "Ruvuma",
      "gid": "TZA.22_1"
    },
    "code": "TZ-21"
  },
  "2417": {
    "gadm": {
      "name": "Shinyanga",
      "gid": "TZA.23_1"
    },
    "code": "TZ-22"
  },
  "2418": {
    "gadm": {
      "name": "Simiyu",
      "gid": "TZA.24_1"
    },
    "code": "TZ-30"
  },
  "2419": {
    "gadm": {
      "name": "Singida",
      "gid": "TZA.25_1"
    },
    "code": "TZ-23"
  },
  "2420": {
    "gadm": {
      "name": "Tabora",
      "gid": "TZA.26_1"
    },
    "code": "TZ-24"
  },
  "2421": {
    "gadm": {
      "name": "Tanga",
      "gid": "TZA.27_1"
    },
    "code": "TZ-25"
  },
  "2422": {
    "gadm": {
      "name": "Zanzibar North",
      "gid": "TZA.28_1"
    },
    "code": "TZ-07"
  },
  "2423": {
    "gadm": {
      "name": "Zanzibar South and Central",
      "gid": "TZA.29_1"
    },
    "code": "TZ-11"
  },
  "2424": {
    "gadm": {
      "name": "Zanzibar West",
      "gid": "TZA.30_1"
    },
    "code": "TZ-15"
  },
  "2425": {
    "gadm": {
      "name": "Crimea",
      "gid": "UKR.4_1"
    },
    "code": "UA-43"
  },
  "2426": {
    "gadm": {
      "name": "Cherkasy",
      "gid": "UKR.1_1"
    },
    "code": "UA-71"
  },
  "2427": {
    "gadm": {
      "name": "Chernihiv",
      "gid": "UKR.2_1"
    },
    "code": "UA-74"
  },
  "2428": {
    "gadm": {
      "name": "Chernivtsi",
      "gid": "UKR.3_1"
    },
    "code": "UA-77"
  },
  "2429": {
    "gadm": {
      "name": "Dnipropetrovs'k",
      "gid": "UKR.5_1"
    },
    "code": "UA-12"
  },
  "2430": {
    "gadm": {
      "name": "Donets'k",
      "gid": "UKR.6_1"
    },
    "code": "UA-14"
  },
  "2431": {
    "gadm": {
      "name": "Ivano-Frankivs'k",
      "gid": "UKR.7_1"
    },
    "code": "UA-26"
  },
  "2432": {
    "gadm": {
      "name": "Kharkiv",
      "gid": "UKR.8_1"
    },
    "code": "UA-63"
  },
  "2433": {
    "gadm": {
      "name": "Kherson",
      "gid": "UKR.9_1"
    },
    "code": "UA-65"
  },
  "2434": {
    "gadm": {
      "name": "Khmel'nyts'kyy",
      "gid": "UKR.10_1"
    },
    "code": "UA-68"
  },
  "2435": {
    "gadm": {
      "name": "Kiev",
      "gid": "UKR.12_1"
    },
    "code": "UA-35"
  },
  "2436": {
    "gadm": {
      "name": "Kiev City",
      "gid": "UKR.11_1"
    },
    "code": "UA-30"
  },
  "2437": {
    "gadm": {
      "name": "Kirovohrad",
      "gid": "UKR.13_1"
    },
    "code": "UA-32"
  },
  "2438": {
    "gadm": {
      "name": "Luhans'k",
      "gid": "UKR.15_1"
    },
    "code": "UA-09"
  },
  "2439": {
    "gadm": {
      "name": "L'viv",
      "gid": "UKR.14_1"
    },
    "code": "UA-46"
  },
  "2440": {
    "gadm": {
      "name": "Mykolayiv",
      "gid": "UKR.16_1"
    },
    "code": "UA-48"
  },
  "2441": {
    "gadm": {
      "name": "Odessa",
      "gid": "UKR.17_1"
    },
    "code": "UA-51"
  },
  "2442": {
    "gadm": {
      "name": "Poltava",
      "gid": "UKR.18_1"
    },
    "code": "UA-53"
  },
  "2443": {
    "gadm": {
      "name": "Rivne",
      "gid": "UKR.19_1"
    },
    "code": "UA-56"
  },
  "2444": {
    "gadm": {
      "name": "Sevastopol'",
      "gid": "UKR.20_1"
    },
    "code": "UA-40"
  },
  "2445": {
    "gadm": {
      "name": "Sumy",
      "gid": "UKR.21_1"
    },
    "code": "UA-59"
  },
  "2446": {
    "gadm": {
      "name": "Ternopil'",
      "gid": "UKR.22_1"
    },
    "code": "UA-61"
  },
  "2447": {
    "gadm": {
      "name": "Transcarpathia",
      "gid": "UKR.23_1"
    },
    "code": "UA-05"
  },
  "2448": {
    "gadm": {
      "name": "Vinnytsya",
      "gid": "UKR.24_1"
    },
    "code": "UA-07"
  },
  "2449": {
    "gadm": {
      "name": "Volyn",
      "gid": "UKR.25_1"
    },
    "code": "UA-21"
  },
  "2450": {
    "gadm": {
      "name": "Zaporizhzhya",
      "gid": "UKR.26_1"
    },
    "code": "UA-23"
  },
  "2451": {
    "gadm": {
      "name": "Zhytomyr",
      "gid": "UKR.27_1"
    },
    "code": "UA-18"
  },
  "2452": {
    "gadm": {
      "name": "Kayunga",
      "gid": "UGA.23_1"
    },
    "code": "UG-C"
  },
  "2453": {
    "gadm": {
      "name": "Masindi",
      "gid": "UGA.36_1"
    },
    "code": "UG-W"
  },
  "2454": {
    "gadm": {
      "name": "Katakwi",
      "gid": "UGA.22_1"
    },
    "code": "UG-E"
  },
  "2455": {
    "gadm": {
      "name": "Adjumani",
      "gid": "UGA.1_1"
    },
    "code": "UG-N"
  },
  "2456": {
    "gadm": {
      "name": "Alabama",
      "gid": "USA.1_1"
    },
    "code": "US-AL"
  },
  "2457": {
    "gadm": {
      "name": "Alaska",
      "gid": "USA.2_1"
    },
    "code": "US-AK"
  },
  "2458": {
    "gadm": {
      "name": "Arizona",
      "gid": "USA.3_1"
    },
    "code": "US-AZ"
  },
  "2459": {
    "gadm": {
      "name": "Arkansas",
      "gid": "USA.4_1"
    },
    "code": "US-AR"
  },
  "2460": {
    "gadm": {
      "name": "California",
      "gid": "USA.5_1"
    },
    "code": "US-CA"
  },
  "2461": {
    "gadm": {
      "name": "Colorado",
      "gid": "USA.6_1"
    },
    "code": "US-CO"
  },
  "2462": {
    "gadm": {
      "name": "Connecticut",
      "gid": "USA.7_1"
    },
    "code": "US-CT"
  },
  "2463": {
    "gadm": {
      "name": "Delaware",
      "gid": "USA.8_1"
    },
    "code": "US-DE"
  },
  "2464": {
    "gadm": {
      "name": "District of Columbia",
      "gid": "USA.9_1"
    },
    "code": "US-DC"
  },
  "2465": {
    "gadm": {
      "name": "Florida",
      "gid": "USA.10_1"
    },
    "code": "US-FL"
  },
  "2466": {
    "gadm": {
      "name": "Georgia",
      "gid": "USA.11_1"
    },
    "code": "US-GA"
  },
  "2467": {
    "gadm": {
      "name": "Hawaii",
      "gid": "USA.12_1"
    },
    "code": "US-HI"
  },
  "2468": {
    "gadm": {
      "name": "Idaho",
      "gid": "USA.13_1"
    },
    "code": "US-ID"
  },
  "2469": {
    "gadm": {
      "name": "Illinois",
      "gid": "USA.14_1"
    },
    "code": "US-IL"
  },
  "2470": {
    "gadm": {
      "name": "Indiana",
      "gid": "USA.15_1"
    },
    "code": "US-IN"
  },
  "2471": {
    "gadm": {
      "name": "Iowa",
      "gid": "USA.16_1"
    },
    "code": "US-IA"
  },
  "2472": {
    "gadm": {
      "name": "Kansas",
      "gid": "USA.17_1"
    },
    "code": "US-KS"
  },
  "2473": {
    "gadm": {
      "name": "Kentucky",
      "gid": "USA.18_1"
    },
    "code": "US-KY"
  },
  "2474": {
    "gadm": {
      "name": "Louisiana",
      "gid": "USA.19_1"
    },
    "code": "US-LA"
  },
  "2475": {
    "gadm": {
      "name": "Maine",
      "gid": "USA.20_1"
    },
    "code": "US-ME"
  },
  "2476": {
    "gadm": {
      "name": "Maryland",
      "gid": "USA.21_1"
    },
    "code": "US-MD"
  },
  "2477": {
    "gadm": {
      "name": "Massachusetts",
      "gid": "USA.22_1"
    },
    "code": "US-MA"
  },
  "2478": {
    "gadm": {
      "name": "Michigan",
      "gid": "USA.23_1"
    },
    "code": "US-MI"
  },
  "2479": {
    "gadm": {
      "name": "Minnesota",
      "gid": "USA.24_1"
    },
    "code": "US-MN"
  },
  "2480": {
    "gadm": {
      "name": "Mississippi",
      "gid": "USA.25_1"
    },
    "code": "US-MS"
  },
  "2481": {
    "gadm": {
      "name": "Missouri",
      "gid": "USA.26_1"
    },
    "code": "US-MO"
  },
  "2482": {
    "gadm": {
      "name": "Montana",
      "gid": "USA.27_1"
    },
    "code": "US-MT"
  },
  "2483": {
    "gadm": {
      "name": "Nebraska",
      "gid": "USA.28_1"
    },
    "code": "US-NE"
  },
  "2484": {
    "gadm": {
      "name": "Nevada",
      "gid": "USA.29_1"
    },
    "code": "US-NV"
  },
  "2485": {
    "gadm": {
      "name": "New Hampshire",
      "gid": "USA.30_1"
    },
    "code": "US-NH"
  },
  "2486": {
    "gadm": {
      "name": "New Jersey",
      "gid": "USA.31_1"
    },
    "code": "US-NJ"
  },
  "2487": {
    "gadm": {
      "name": "New Mexico",
      "gid": "USA.32_1"
    },
    "code": "US-NM"
  },
  "2488": {
    "gadm": {
      "name": "New York",
      "gid": "USA.33_1"
    },
    "code": "US-NY"
  },
  "2489": {
    "gadm": {
      "name": "North Carolina",
      "gid": "USA.34_1"
    },
    "code": "US-NC"
  },
  "2490": {
    "gadm": {
      "name": "North Dakota",
      "gid": "USA.35_1"
    },
    "code": "US-ND"
  },
  "2491": {
    "gadm": {
      "name": "Ohio",
      "gid": "USA.36_1"
    },
    "code": "US-OH"
  },
  "2492": {
    "gadm": {
      "name": "Oklahoma",
      "gid": "USA.37_1"
    },
    "code": "US-OK"
  },
  "2493": {
    "gadm": {
      "name": "Oregon",
      "gid": "USA.38_1"
    },
    "code": "US-OR"
  },
  "2494": {
    "gadm": {
      "name": "Pennsylvania",
      "gid": "USA.39_1"
    },
    "code": "US-PA"
  },
  "2495": {
    "gadm": {
      "name": "Rhode Island",
      "gid": "USA.40_1"
    },
    "code": "US-RI"
  },
  "2496": {
    "gadm": {
      "name": "South Carolina",
      "gid": "USA.41_1"
    },
    "code": "US-SC"
  },
  "2497": {
    "gadm": {
      "name": "South Dakota",
      "gid": "USA.42_1"
    },
    "code": "US-SD"
  },
  "2498": {
    "gadm": {
      "name": "Tennessee",
      "gid": "USA.43_1"
    },
    "code": "US-TN"
  },
  "2499": {
    "gadm": {
      "name": "Texas",
      "gid": "USA.44_1"
    },
    "code": "US-TX"
  },
  "2500": {
    "gadm": {
      "name": "Utah",
      "gid": "USA.45_1"
    },
    "code": "US-UT"
  },
  "2501": {
    "gadm": {
      "name": "Vermont",
      "gid": "USA.46_1"
    },
    "code": "US-VT"
  },
  "2502": {
    "gadm": {
      "name": "Virginia",
      "gid": "USA.47_1"
    },
    "code": "US-VA"
  },
  "2503": {
    "gadm": {
      "name": "Washington",
      "gid": "USA.48_1"
    },
    "code": "US-WA"
  },
  "2504": {
    "gadm": {
      "name": "West Virginia",
      "gid": "USA.49_1"
    },
    "code": "US-WV"
  },
  "2505": {
    "gadm": {
      "name": "Wisconsin",
      "gid": "USA.50_1"
    },
    "code": "US-WI"
  },
  "2506": {
    "gadm": {
      "name": "Wyoming",
      "gid": "USA.51_1"
    },
    "code": "US-WY"
  },
  "2507": {
    "gadm": {
      "name": "Bayam\u00c3\u00b3n",
      "gid": "PRI.11_1"
    },
    "code": "US-PR"
  },
  "2508": {
    "gadm": {
      "name": "Saint Thomas",
      "gid": "VIR.3_1"
    },
    "code": "US-VI"
  },
  "2509": {
    "gadm": {
      "name": "Artigas",
      "gid": "URY.1_1"
    },
    "code": "UY-AR"
  },
  "2510": {
    "gadm": {
      "name": "Canelones",
      "gid": "URY.2_1"
    },
    "code": "UY-CA"
  },
  "2511": {
    "gadm": {
      "name": "Cerro Largo",
      "gid": "URY.3_1"
    },
    "code": "UY-CL"
  },
  "2512": {
    "gadm": {
      "name": "Colonia",
      "gid": "URY.4_1"
    },
    "code": "UY-CO"
  },
  "2513": {
    "gadm": {
      "name": "Durazno",
      "gid": "URY.5_1"
    },
    "code": "UY-DU"
  },
  "2514": {
    "gadm": {
      "name": "Flores",
      "gid": "URY.6_1"
    },
    "code": "UY-FS"
  },
  "2515": {
    "gadm": {
      "name": "Florida",
      "gid": "URY.7_1"
    },
    "code": "UY-FD"
  },
  "2516": {
    "gadm": {
      "name": "Lavalleja",
      "gid": "URY.8_1"
    },
    "code": "UY-LA"
  },
  "2517": {
    "gadm": {
      "name": "Maldonado",
      "gid": "URY.9_1"
    },
    "code": "UY-MA"
  },
  "2518": {
    "gadm": {
      "name": "Montevideo",
      "gid": "URY.10_1"
    },
    "code": "UY-MO"
  },
  "2519": {
    "gadm": {
      "name": "Paysand\u00c3\u00ba",
      "gid": "URY.11_1"
    },
    "code": "UY-PA"
  },
  "2520": {
    "gadm": {
      "name": "R\u00c3\u00ado Negro",
      "gid": "URY.12_1"
    },
    "code": "UY-RN"
  },
  "2521": {
    "gadm": {
      "name": "Rivera",
      "gid": "URY.13_1"
    },
    "code": "UY-RV"
  },
  "2522": {
    "gadm": {
      "name": "Rocha",
      "gid": "URY.14_1"
    },
    "code": "UY-RO"
  },
  "2523": {
    "gadm": {
      "name": "Salto",
      "gid": "URY.15_1"
    },
    "code": "UY-SA"
  },
  "2524": {
    "gadm": {
      "name": "San Jos\u00c3\u00a9",
      "gid": "URY.16_1"
    },
    "code": "UY-SJ"
  },
  "2525": {
    "gadm": {
      "name": "Soriano",
      "gid": "URY.17_1"
    },
    "code": "UY-SO"
  },
  "2526": {
    "gadm": {
      "name": "Tacuaremb\u00c3\u00b3",
      "gid": "URY.18_1"
    },
    "code": "UY-TA"
  },
  "2527": {
    "gadm": {
      "name": "Treinta y Tres",
      "gid": "URY.19_1"
    },
    "code": "UY-TT"
  },
  "2528": {
    "gadm": {
      "name": "Andijon",
      "gid": "UZB.1_1"
    },
    "code": "UZ-AN"
  },
  "2529": {
    "gadm": {
      "name": "Bukhoro",
      "gid": "UZB.2_1"
    },
    "code": "UZ-BU"
  },
  "2530": {
    "gadm": {
      "name": "Ferghana",
      "gid": "UZB.3_1"
    },
    "code": "UZ-FA"
  },
  "2531": {
    "gadm": {
      "name": "Jizzakh",
      "gid": "UZB.4_1"
    },
    "code": "UZ-JI"
  },
  "2532": {
    "gadm": {
      "name": "Karakalpakstan (republic)",
      "gid": "UZB.5_1"
    },
    "code": "UZ-QR"
  },
  "2533": {
    "gadm": {
      "name": "Kashkadarya",
      "gid": "UZB.6_1"
    },
    "code": "UZ-QA"
  },
  "2534": {
    "gadm": {
      "name": "Khorezm",
      "gid": "UZB.7_1"
    },
    "code": "UZ-XO"
  },
  "2535": {
    "gadm": {
      "name": "Namangan",
      "gid": "UZB.8_1"
    },
    "code": "UZ-NG"
  },
  "2536": {
    "gadm": {
      "name": "Navoi",
      "gid": "UZB.9_1"
    },
    "code": "UZ-NW"
  },
  "2537": {
    "gadm": {
      "name": "Samarkand",
      "gid": "UZB.10_1"
    },
    "code": "UZ-SA"
  },
  "2538": {
    "gadm": {
      "name": "Sirdaryo",
      "gid": "UZB.11_1"
    },
    "code": "UZ-SI"
  },
  "2539": {
    "gadm": {
      "name": "Surkhandarya",
      "gid": "UZB.12_1"
    },
    "code": "UZ-SU"
  },
  "2540": {
    "gadm": {
      "name": "Tashkent",
      "gid": "UZB.14_1"
    },
    "code": "UZ-TO"
  },
  "2541": {
    "gadm": {
      "name": "Tashkent City",
      "gid": "UZB.13_1"
    },
    "code": "UZ-TK"
  },
  "2542": {
    "gadm": {
      "name": "Charlotte",
      "gid": "VCT.1_1"
    },
    "code": "VC-01"
  },
  "2543": {
    "gadm": {
      "name": "Grenadines",
      "gid": "VCT.2_1"
    },
    "code": "VC-06"
  },
  "2544": {
    "gadm": {
      "name": "Saint Andrew",
      "gid": "VCT.3_1"
    },
    "code": "VC-02"
  },
  "2545": {
    "gadm": {
      "name": "Saint David",
      "gid": "VCT.4_1"
    },
    "code": "VC-03"
  },
  "2546": {
    "gadm": {
      "name": "Saint George",
      "gid": "VCT.5_1"
    },
    "code": "VC-04"
  },
  "2547": {
    "gadm": {
      "name": "Saint Patrick",
      "gid": "VCT.6_1"
    },
    "code": "VC-05"
  },
  "2548": {
    "gadm": {
      "name": "Amazonas",
      "gid": "VEN.1_1"
    },
    "code": "VE-Z"
  },
  "2549": {
    "gadm": {
      "name": "Anzo\u00c3\u00a1tegui",
      "gid": "VEN.2_1"
    },
    "code": "VE-B"
  },
  "2550": {
    "gadm": {
      "name": "Apure",
      "gid": "VEN.3_1"
    },
    "code": "VE-C"
  },
  "2551": {
    "gadm": {
      "name": "Aragua",
      "gid": "VEN.4_1"
    },
    "code": "VE-D"
  },
  "2552": {
    "gadm": {
      "name": "Barinas",
      "gid": "VEN.5_1"
    },
    "code": "VE-E"
  },
  "2553": {
    "gadm": {
      "name": "Bol\u00c3\u00advar",
      "gid": "VEN.6_1"
    },
    "code": "VE-F"
  },
  "2554": {
    "gadm": {
      "name": "Carabobo",
      "gid": "VEN.7_1"
    },
    "code": "VE-G"
  },
  "2555": {
    "gadm": {
      "name": "Cojedes",
      "gid": "VEN.8_1"
    },
    "code": "VE-H"
  },
  "2556": {
    "gadm": {
      "name": "Delta Amacuro",
      "gid": "VEN.9_1"
    },
    "code": "VE-Y"
  },
  "2557": {
    "gadm": {
      "name": "Dependencias Federales",
      "gid": "VEN.10_1"
    },
    "code": "VE-W"
  },
  "2558": {
    "gadm": {
      "name": "Distrito Capital",
      "gid": "VEN.11_1"
    },
    "code": "VE-A"
  },
  "2559": {
    "gadm": {
      "name": "Falc\u00c3\u00b3n",
      "gid": "VEN.12_1"
    },
    "code": "VE-I"
  },
  "2560": {
    "gadm": {
      "name": "Gu\u00c3\u00a1rico",
      "gid": "VEN.13_1"
    },
    "code": "VE-J"
  },
  "2561": {
    "gadm": {
      "name": "Lara",
      "gid": "VEN.14_1"
    },
    "code": "VE-K"
  },
  "2562": {
    "gadm": {
      "name": "M\u00c3\u00a9rida",
      "gid": "VEN.15_1"
    },
    "code": "VE-L"
  },
  "2563": {
    "gadm": {
      "name": "Miranda",
      "gid": "VEN.16_1"
    },
    "code": "VE-M"
  },
  "2564": {
    "gadm": {
      "name": "Monagas",
      "gid": "VEN.17_1"
    },
    "code": "VE-N"
  },
  "2565": {
    "gadm": {
      "name": "Nueva Esparta",
      "gid": "VEN.18_1"
    },
    "code": "VE-O"
  },
  "2566": {
    "gadm": {
      "name": "Portuguesa",
      "gid": "VEN.19_1"
    },
    "code": "VE-P"
  },
  "2567": {
    "gadm": {
      "name": "Sucre",
      "gid": "VEN.20_1"
    },
    "code": "VE-R"
  },
  "2568": {
    "gadm": {
      "name": "T\u00c3\u00a1chira",
      "gid": "VEN.21_1"
    },
    "code": "VE-S"
  },
  "2569": {
    "gadm": {
      "name": "Trujillo",
      "gid": "VEN.22_1"
    },
    "code": "VE-T"
  },
  "2570": {
    "gadm": {
      "name": "Vargas",
      "gid": "VEN.23_1"
    },
    "code": "VE-X"
  },
  "2571": {
    "gadm": {
      "name": "Yaracuy",
      "gid": "VEN.24_1"
    },
    "code": "VE-U"
  },
  "2572": {
    "gadm": {
      "name": "Zulia",
      "gid": "VEN.25_1"
    },
    "code": "VE-V"
  },
  "2573": {
    "gadm": {
      "name": "An Giang",
      "gid": "VNM.1_1"
    },
    "code": "VN-44"
  },
  "2574": {
    "gadm": {
      "name": "B\u00c3\u00a0 R\u00e1\u00bb\u2039a - V\u00c5\u00a9ng T\u00c3\u00a0u",
      "gid": "VNM.7_1"
    },
    "code": "VN-43"
  },
  "2575": {
    "gadm": {
      "name": "B\u00e1\u00ba\u00afc Giang",
      "gid": "VNM.3_1"
    },
    "code": "VN-54"
  },
  "2576": {
    "gadm": {
      "name": "B\u00e1\u00ba\u00afc K\u00e1\u00ba\u00a1n",
      "gid": "VNM.4_1"
    },
    "code": "VN-53"
  },
  "2577": {
    "gadm": {
      "name": "B\u00e1\u00ba\u00a1c Li\u00c3\u00aau",
      "gid": "VNM.2_1"
    },
    "code": "VN-55"
  },
  "2578": {
    "gadm": {
      "name": "B\u00e1\u00ba\u00afc Ninh",
      "gid": "VNM.5_1"
    },
    "code": "VN-56"
  },
  "2579": {
    "gadm": {
      "name": "B\u00e1\u00ba\u00bfn Tre",
      "gid": "VNM.6_1"
    },
    "code": "VN-50"
  },
  "2580": {
    "gadm": {
      "name": "B\u00c3\u00acnh \u00c4\u0090\u00e1\u00bb\u2039nh",
      "gid": "VNM.8_1"
    },
    "code": "VN-31"
  },
  "2581": {
    "gadm": {
      "name": "B\u00c3\u00acnh D\u00c6\u00b0\u00c6\u00a1ng",
      "gid": "VNM.9_1"
    },
    "code": "VN-57"
  },
  "2582": {
    "gadm": {
      "name": "B\u00c3\u00acnh Ph\u00c6\u00b0\u00e1\u00bb\u203ac",
      "gid": "VNM.10_1"
    },
    "code": "VN-58"
  },
  "2583": {
    "gadm": {
      "name": "B\u00c3\u00acnh Thu\u00e1\u00ba\u00adn",
      "gid": "VNM.11_1"
    },
    "code": "VN-40"
  },
  "2584": {
    "gadm": {
      "name": "C\u00c3\u00a0 Mau",
      "gid": "VNM.13_1"
    },
    "code": "VN-59"
  },
  "2585": {
    "gadm": {
      "name": "C\u00e1\u00ba\u00a7n Th\u00c6\u00a1",
      "gid": "VNM.12_1"
    },
    "code": "VN-CT"
  },
  "2586": {
    "gadm": {
      "name": "Cao B\u00e1\u00ba\u00b1ng",
      "gid": "VNM.14_1"
    },
    "code": "VN-04"
  },
  "2587": {
    "gadm": {
      "name": "\u00c4\u0090\u00c3\u00a0 N\u00e1\u00ba\u00b5ng",
      "gid": "VNM.19_1"
    },
    "code": "VN-DN"
  },
  "2588": {
    "gadm": {
      "name": "\u00c4\u0090\u00e1\u00ba\u00afk L\u00e1\u00ba\u00afk",
      "gid": "VNM.15_1"
    },
    "code": "VN-33"
  },
  "2589": {
    "gadm": {
      "name": "\u00c4\u0090\u00e1\u00ba\u00afk N\u00c3\u00b4ng",
      "gid": "VNM.16_1"
    },
    "code": "VN-72"
  },
  "2590": {
    "gadm": {
      "name": "\u00c4\u0090i\u00e1\u00bb\u2021n Bi\u00c3\u00aan",
      "gid": "VNM.20_1"
    },
    "code": "VN-71"
  },
  "2591": {
    "gadm": {
      "name": "\u00c4\u0090\u00e1\u00bb\u201cng Nai",
      "gid": "VNM.17_1"
    },
    "code": "VN-39"
  },
  "2592": {
    "gadm": {
      "name": "\u00c4\u0090\u00e1\u00bb\u201cng Th\u00c3\u00a1p",
      "gid": "VNM.18_1"
    },
    "code": "VN-45"
  },
  "2593": {
    "gadm": {
      "name": "Gia Lai",
      "gid": "VNM.21_1"
    },
    "code": "VN-30"
  },
  "2594": {
    "gadm": {
      "name": "H\u00c3\u00a0 Giang",
      "gid": "VNM.26_1"
    },
    "code": "VN-03"
  },
  "2595": {
    "gadm": {
      "name": "H\u00c3\u00a0 Nam",
      "gid": "VNM.28_1"
    },
    "code": "VN-63"
  },
  "2596": {
    "gadm": {
      "name": "H\u00c3\u00a0 N\u00e1\u00bb\u2122i",
      "gid": "VNM.27_1"
    },
    "code": "VN-HN"
  },
  "2597": {
    "gadm": {
      "name": "H\u00c3\u00a0 T\u00c4\u00a9nh",
      "gid": "VNM.29_1"
    },
    "code": "VN-23"
  },
  "2598": {
    "gadm": {
      "name": "H\u00e1\u00ba\u00a3i D\u00c6\u00b0\u00c6\u00a1ng",
      "gid": "VNM.22_1"
    },
    "code": "VN-61"
  },
  "2599": {
    "gadm": {
      "name": "H\u00e1\u00ba\u00a3i Ph\u00c3\u00b2ng",
      "gid": "VNM.23_1"
    },
    "code": "VN-HP"
  },
  "2600": {
    "gadm": {
      "name": "H\u00e1\u00ba\u00adu Giang",
      "gid": "VNM.24_1"
    },
    "code": "VN-73"
  },
  "2601": {
    "gadm": {
      "name": "H\u00e1\u00bb\u201c Ch\u00c3\u00ad Minh",
      "gid": "VNM.25_1"
    },
    "code": "VN-SG"
  },
  "2602": {
    "gadm": {
      "name": "Ho\u00c3\u00a0 B\u00c3\u00acnh",
      "gid": "VNM.30_1"
    },
    "code": "VN-14"
  },
  "2603": {
    "gadm": {
      "name": "H\u00c6\u00b0ng Y\u00c3\u00aan",
      "gid": "VNM.31_1"
    },
    "code": "VN-66"
  },
  "2604": {
    "gadm": {
      "name": "Kh\u00c3\u00a1nh H\u00c3\u00b2a",
      "gid": "VNM.32_1"
    },
    "code": "VN-34"
  },
  "2605": {
    "gadm": {
      "name": "Ki\u00c3\u00aan Giang",
      "gid": "VNM.33_1"
    },
    "code": "VN-47"
  },
  "2606": {
    "gadm": {
      "name": "Kon Tum",
      "gid": "VNM.34_1"
    },
    "code": "VN-28"
  },
  "2607": {
    "gadm": {
      "name": "Lai Ch\u00c3\u00a2u",
      "gid": "VNM.36_1"
    },
    "code": "VN-01"
  },
  "2608": {
    "gadm": {
      "name": "L\u00c3\u00a2m \u00c4\u0090\u00e1\u00bb\u201cng",
      "gid": "VNM.37_1"
    },
    "code": "VN-35"
  },
  "2609": {
    "gadm": {
      "name": "L\u00e1\u00ba\u00a1ng S\u00c6\u00a1n",
      "gid": "VNM.35_1"
    },
    "code": "VN-09"
  },
  "2610": {
    "gadm": {
      "name": "L\u00c3\u00a0o Cai",
      "gid": "VNM.38_1"
    },
    "code": "VN-02"
  },
  "2611": {
    "gadm": {
      "name": "Long An",
      "gid": "VNM.39_1"
    },
    "code": "VN-41"
  },
  "2612": {
    "gadm": {
      "name": "Nam \u00c4\u0090\u00e1\u00bb\u2039nh",
      "gid": "VNM.40_1"
    },
    "code": "VN-67"
  },
  "2613": {
    "gadm": {
      "name": "Ngh\u00e1\u00bb\u2021 An",
      "gid": "VNM.41_1"
    },
    "code": "VN-22"
  },
  "2614": {
    "gadm": {
      "name": "Ninh B\u00c3\u00acnh",
      "gid": "VNM.42_1"
    },
    "code": "VN-18"
  },
  "2615": {
    "gadm": {
      "name": "Ninh Thu\u00e1\u00ba\u00adn",
      "gid": "VNM.43_1"
    },
    "code": "VN-36"
  },
  "2616": {
    "gadm": {
      "name": "Ph\u00c3\u00ba Th\u00e1\u00bb\u008d",
      "gid": "VNM.44_1"
    },
    "code": "VN-68"
  },
  "2617": {
    "gadm": {
      "name": "Ph\u00c3\u00ba Y\u00c3\u00aan",
      "gid": "VNM.45_1"
    },
    "code": "VN-32"
  },
  "2618": {
    "gadm": {
      "name": "Qu\u00e1\u00ba\u00a3ng B\u00c3\u00acnh",
      "gid": "VNM.46_1"
    },
    "code": "VN-24"
  },
  "2619": {
    "gadm": {
      "name": "Qu\u00e1\u00ba\u00a3ng Nam",
      "gid": "VNM.47_1"
    },
    "code": "VN-27"
  },
  "2620": {
    "gadm": {
      "name": "Qu\u00e1\u00ba\u00a3ng Ng\u00c3\u00a3i",
      "gid": "VNM.48_1"
    },
    "code": "VN-29"
  },
  "2621": {
    "gadm": {
      "name": "Qu\u00e1\u00ba\u00a3ng Ninh",
      "gid": "VNM.49_1"
    },
    "code": "VN-13"
  },
  "2622": {
    "gadm": {
      "name": "Qu\u00e1\u00ba\u00a3ng Tr\u00e1\u00bb\u2039",
      "gid": "VNM.50_1"
    },
    "code": "VN-25"
  },
  "2623": {
    "gadm": {
      "name": "S\u00c3\u00b3c Tr\u00c4\u0192ng",
      "gid": "VNM.51_1"
    },
    "code": "VN-52"
  },
  "2624": {
    "gadm": {
      "name": "S\u00c6\u00a1n La",
      "gid": "VNM.52_1"
    },
    "code": "VN-05"
  },
  "2625": {
    "gadm": {
      "name": "T\u00c3\u00a2y Ninh",
      "gid": "VNM.53_1"
    },
    "code": "VN-37"
  },
  "2626": {
    "gadm": {
      "name": "Th\u00c3\u00a1i B\u00c3\u00acnh",
      "gid": "VNM.55_1"
    },
    "code": "VN-20"
  },
  "2627": {
    "gadm": {
      "name": "Th\u00c3\u00a1i Nguy\u00c3\u00aan",
      "gid": "VNM.56_1"
    },
    "code": "VN-69"
  },
  "2628": {
    "gadm": {
      "name": "Thanh H\u00c3\u00b3a",
      "gid": "VNM.57_1"
    },
    "code": "VN-21"
  },
  "2629": {
    "gadm": {
      "name": "Th\u00e1\u00bb\u00aba Thi\u00c3\u00aan Hu\u00e1\u00ba\u00bf",
      "gid": "VNM.54_1"
    },
    "code": "VN-26"
  },
  "2630": {
    "gadm": {
      "name": "Ti\u00e1\u00bb\u0081n Giang",
      "gid": "VNM.58_1"
    },
    "code": "VN-46"
  },
  "2631": {
    "gadm": {
      "name": "Tr\u00c3\u00a0 Vinh",
      "gid": "VNM.59_1"
    },
    "code": "VN-51"
  },
  "2632": {
    "gadm": {
      "name": "Tuy\u00c3\u00aan Quang",
      "gid": "VNM.60_1"
    },
    "code": "VN-07"
  },
  "2633": {
    "gadm": {
      "name": "V\u00c4\u00a9nh Long",
      "gid": "VNM.61_1"
    },
    "code": "VN-49"
  },
  "2634": {
    "gadm": {
      "name": "V\u00c4\u00a9nh Ph\u00c3\u00bac",
      "gid": "VNM.62_1"
    },
    "code": "VN-70"
  },
  "2635": {
    "gadm": {
      "name": "Y\u00c3\u00aan B\u00c3\u00a1i",
      "gid": "VNM.63_1"
    },
    "code": "VN-06"
  },
  "2636": {
    "gadm": {
      "name": "Malampa",
      "gid": "VUT.1_1"
    },
    "code": "VU-MAP"
  },
  "2637": {
    "gadm": {
      "name": "Penama",
      "gid": "VUT.2_1"
    },
    "code": "VU-PAM"
  },
  "2638": {
    "gadm": {
      "name": "Sanma",
      "gid": "VUT.3_1"
    },
    "code": "VU-SAM"
  },
  "2639": {
    "gadm": {
      "name": "Shefa",
      "gid": "VUT.4_1"
    },
    "code": "VU-SEE"
  },
  "2640": {
    "gadm": {
      "name": "Tafea",
      "gid": "VUT.5_1"
    },
    "code": "VU-TAE"
  },
  "2641": {
    "gadm": {
      "name": "Torba",
      "gid": "VUT.6_1"
    },
    "code": "VU-TOB"
  },
  "2642": {
    "gadm": {
      "name": "A'ana",
      "gid": "WSM.1_1"
    },
    "code": "WS-AA"
  },
  "2643": {
    "gadm": {
      "name": "Aiga-i-le-Tai",
      "gid": "WSM.2_1"
    },
    "code": "WS-AL"
  },
  "2644": {
    "gadm": {
      "name": "Atua",
      "gid": "WSM.3_1"
    },
    "code": "WS-AT"
  },
  "2645": {
    "gadm": {
      "name": "Fa'asaleleaga",
      "gid": "WSM.4_1"
    },
    "code": "WS-FA"
  },
  "2646": {
    "gadm": {
      "name": "Gaga'emauga",
      "gid": "WSM.5_1"
    },
    "code": "WS-GE"
  },
  "2647": {
    "gadm": {
      "name": "Gagaifomauga",
      "gid": "WSM.6_1"
    },
    "code": "WS-GI"
  },
  "2648": {
    "gadm": {
      "name": "Palauli",
      "gid": "WSM.7_1"
    },
    "code": "WS-PA"
  },
  "2649": {
    "gadm": {
      "name": "Satupa'itea",
      "gid": "WSM.8_1"
    },
    "code": "WS-SA"
  },
  "2650": {
    "gadm": {
      "name": "Tuamasaga",
      "gid": "WSM.9_1"
    },
    "code": "WS-TU"
  },
  "2651": {
    "gadm": {
      "name": "Va'a-o-Fonoti",
      "gid": "WSM.10_1"
    },
    "code": "WS-VF"
  },
  "2652": {
    "gadm": {
      "name": "Vaisigano",
      "gid": "WSM.11_1"
    },
    "code": "WS-VS"
  },
  "2653": {
    "gadm": {
      "name": "`Adan",
      "gid": "YEM.1_1"
    },
    "code": "YE-AD"
  },
  "2654": {
    "gadm": {
      "name": "Abyan",
      "gid": "YEM.2_1"
    },
    "code": "YE-AB"
  },
  "2655": {
    "gadm": {
      "name": "Al Bayda'",
      "gid": "YEM.3_1"
    },
    "code": "YE-BA"
  },
  "2656": {
    "gadm": {
      "name": "Al Dali'",
      "gid": "YEM.4_1"
    },
    "code": "YE-DA"
  },
  "2657": {
    "gadm": {
      "name": "Al Hudaydah",
      "gid": "YEM.5_1"
    },
    "code": "YE-HU"
  },
  "2658": {
    "gadm": {
      "name": "Al Jawf",
      "gid": "YEM.6_1"
    },
    "code": "YE-JA"
  },
  "2659": {
    "gadm": {
      "name": "Al Mahrah",
      "gid": "YEM.7_1"
    },
    "code": "YE-MR"
  },
  "2660": {
    "gadm": {
      "name": "Al Mahwit",
      "gid": "YEM.8_1"
    },
    "code": "YE-MW"
  },
  "2661": {
    "gadm": {
      "name": "Amanat Al Asimah",
      "gid": "YEM.9_1"
    },
    "code": "YE-SA"
  },
  "2662": {
    "gadm": {
      "name": "Amran",
      "gid": "YEM.10_1"
    },
    "code": "YE-AM"
  },
  "2663": {
    "gadm": {
      "name": "Dhamar",
      "gid": "YEM.11_1"
    },
    "code": "YE-DH"
  },
  "2664": {
    "gadm": {
      "name": "Hadramawt",
      "gid": "YEM.12_1"
    },
    "code": "YE-HD"
  },
  "2665": {
    "gadm": {
      "name": "Hajjah",
      "gid": "YEM.13_1"
    },
    "code": "YE-HJ"
  },
  "2666": {
    "gadm": {
      "name": "Ibb",
      "gid": "YEM.14_1"
    },
    "code": "YE-IB"
  },
  "2667": {
    "gadm": {
      "name": "Lahij",
      "gid": "YEM.15_1"
    },
    "code": "YE-LA"
  },
  "2668": {
    "gadm": {
      "name": "Ma'rib",
      "gid": "YEM.16_1"
    },
    "code": "YE-MA"
  },
  "2669": {
    "gadm": {
      "name": "Raymah",
      "gid": "YEM.17_1"
    },
    "code": "YE-RA"
  },
  "2670": {
    "gadm": {
      "name": "Sa`dah",
      "gid": "YEM.18_1"
    },
    "code": "YE-SD"
  },
  "2671": {
    "gadm": {
      "name": "San`a'",
      "gid": "YEM.19_1"
    },
    "code": "YE-SN"
  },
  "2672": {
    "gadm": {
      "name": "Shabwah",
      "gid": "YEM.20_1"
    },
    "code": "YE-SH"
  },
  "2673": {
    "gadm": {
      "name": "Ta`izz",
      "gid": "YEM.21_1"
    },
    "code": "YE-TA"
  },
  "2674": {
    "gadm": {
      "name": "Eastern Cape",
      "gid": "ZAF.1_1"
    },
    "code": "ZA-EC"
  },
  "2675": {
    "gadm": {
      "name": "Free State",
      "gid": "ZAF.2_1"
    },
    "code": "ZA-FS"
  },
  "2676": {
    "gadm": {
      "name": "Gauteng",
      "gid": "ZAF.3_1"
    },
    "code": "ZA-GP"
  },
  "2677": {
    "gadm": {
      "name": "KwaZulu-Natal",
      "gid": "ZAF.4_1"
    },
    "code": "ZA-KZN"
  },
  "2678": {
    "gadm": {
      "name": "Limpopo",
      "gid": "ZAF.5_1"
    },
    "code": "ZA-LP"
  },
  "2679": {
    "gadm": {
      "name": "Mpumalanga",
      "gid": "ZAF.6_1"
    },
    "code": "ZA-MP"
  },
  "2680": {
    "gadm": {
      "name": "North West",
      "gid": "ZAF.7_1"
    },
    "code": "ZA-NW"
  },
  "2681": {
    "gadm": {
      "name": "Northern Cape",
      "gid": "ZAF.8_1"
    },
    "code": "ZA-NC"
  },
  "2682": {
    "gadm": {
      "name": "Western Cape",
      "gid": "ZAF.9_1"
    },
    "code": "ZA-WC"
  },
  "2683": {
    "gadm": {
      "name": "Central",
      "gid": "ZMB.1_1"
    },
    "code": "ZM-02"
  },
  "2684": {
    "gadm": {
      "name": "Copperbelt",
      "gid": "ZMB.2_1"
    },
    "code": "ZM-08"
  },
  "2685": {
    "gadm": {
      "name": "Eastern",
      "gid": "ZMB.3_1"
    },
    "code": "ZM-03"
  },
  "2686": {
    "gadm": {
      "name": "Luapula",
      "gid": "ZMB.4_1"
    },
    "code": "ZM-04"
  },
  "2687": {
    "gadm": {
      "name": "Lusaka",
      "gid": "ZMB.5_1"
    },
    "code": "ZM-09"
  },
  "2688": {
    "gadm": {
      "name": "Muchinga",
      "gid": "ZMB.6_1"
    },
    "code": "ZM-10"
  },
  "2689": {
    "gadm": {
      "name": "Northern",
      "gid": "ZMB.8_1"
    },
    "code": "ZM-05"
  },
  "2690": {
    "gadm": {
      "name": "North-Western",
      "gid": "ZMB.7_1"
    },
    "code": "ZM-06"
  },
  "2691": {
    "gadm": {
      "name": "Southern",
      "gid": "ZMB.9_1"
    },
    "code": "ZM-07"
  },
  "2692": {
    "gadm": {
      "name": "Western",
      "gid": "ZMB.10_1"
    },
    "code": "ZM-01"
  },
  "2693": {
    "gadm": {
      "name": "Bulawayo",
      "gid": "ZWE.1_1"
    },
    "code": "ZW-BU"
  },
  "2694": {
    "gadm": {
      "name": "Harare",
      "gid": "ZWE.2_1"
    },
    "code": "ZW-HA"
  },
  "2695": {
    "gadm": {
      "name": "Manicaland",
      "gid": "ZWE.3_1"
    },
    "code": "ZW-MA"
  },
  "2696": {
    "gadm": {
      "name": "Mashonaland Central",
      "gid": "ZWE.4_1"
    },
    "code": "ZW-MC"
  },
  "2697": {
    "gadm": {
      "name": "Mashonaland East",
      "gid": "ZWE.5_1"
    },
    "code": "ZW-ME"
  },
  "2698": {
    "gadm": {
      "name": "Mashonaland West",
      "gid": "ZWE.6_1"
    },
    "code": "ZW-MW"
  },
  "2699": {
    "gadm": {
      "name": "Masvingo",
      "gid": "ZWE.7_1"
    },
    "code": "ZW-MV"
  },
  "2700": {
    "gadm": {
      "name": "Matabeleland North",
      "gid": "ZWE.8_1"
    },
    "code": "ZW-MN"
  },
  "2701": {
    "gadm": {
      "name": "Matabeleland South",
      "gid": "ZWE.9_1"
    },
    "code": "ZW-MS"
  },
  "2702": {
    "gadm": {
      "name": "Midlands",
      "gid": "ZWE.10_1"
    },
    "code": "ZW-MI"
  },
  "2703": {
    "gadm": {
      "name": "Boujdour",
      "gid": "ESH.1_1"
    },
    "code": "ESH.1_1"
  },
  "2704": {
    "gadm": {
      "name": "Es Semara",
      "gid": "ESH.2_1"
    },
    "code": "ESH.2_1"
  },
  "2705": {
    "gadm": {
      "name": "Laayoune",
      "gid": "ESH.3_1"
    },
    "code": "ESH.3_1"
  },
  "2706": {
    "gadm": {
      "name": "Oued el Dahab",
      "gid": "ESH.4_1"
    },
    "code": "ESH.4_1"
  },
  "2707": {
    "gadm": {
      "name": "\u00c4\u0090akovica",
      "gid": "XKO.1_1"
    },
    "code": "XKO.1_1"
  },
  "2708": {
    "gadm": {
      "name": "Gnjilane",
      "gid": "XKO.2_1"
    },
    "code": "XKO.2_1"
  },
  "2709": {
    "gadm": {
      "name": "Kosovska Mitrovica",
      "gid": "XKO.3_1"
    },
    "code": "XKO.3_1"
  },
  "2710": {
    "gadm": {
      "name": "Pe\u00c4\u2021ki",
      "gid": "XKO.4_1"
    },
    "code": "XKO.4_1"
  },
  "2711": {
    "gadm": {
      "name": "Pristina",
      "gid": "XKO.5_1"
    },
    "code": "XKO.5_1"
  },
  "2712": {
    "gadm": {
      "name": "Prizren",
      "gid": "XKO.6_1"
    },
    "code": "XKO.6_1"
  },
  "2713": {
    "gadm": {
      "name": "Uro\u00c5\u00a1evac",
      "gid": "XKO.7_1"
    },
    "code": "XKO.7_1"
  },
  "2714": {
    "gadm": {
      "name": "Dushanbe",
      "gid": "TJK.1_1"
    },
    "code": "TJK.1_1"
  },
  "2715": {
    "gadm": {
      "name": "Gorno-Badakhshan",
      "gid": "TJK.2_1"
    },
    "code": "TJK.2_1"
  },
  "2716": {
    "gadm": {
      "name": "Khatlon",
      "gid": "TJK.3_1"
    },
    "code": "TJK.3_1"
  },
  "2717": {
    "gadm": {
      "name": "Leninabad",
      "gid": "TJK.4_1"
    },
    "code": "TJK.4_1"
  },
  "2718": {
    "gadm": {
      "name": "Tadzhikistan Territories",
      "gid": "TJK.5_1"
    },
    "code": "TJK.5_1"
  },
  "2719": {
    "gadm": {
      "name": "Saint Peter",
      "gid": "MSR.3_1"
    },
    "code": "MS"
  },
  "2720": {
    "gadm": {
      "name": "Grand Turk",
      "gid": "TCA.1_1"
    },
    "code": "TC"
  },
  "2721": {
    "gadm": {
      "name": "George Town",
      "gid": "CYM.4_1"
    },
    "code": "KY"
  },
  "2722": {
    "gadm": {
      "name": "Devonshire",
      "gid": "BMU.1_1"
    },
    "code": "BM"
  },
  "2723": {
    "gadm": {
      "name": "Anegada",
      "gid": "VGB.1_1"
    },
    "code": "VG"
  },
  "2724": {
    "gadm": {
      "name": "Br\u00e4nd\u00f6",
      "gid": "ALA.1_1"
    },
    "code": "AX.BR"
  },
  "2725": {
    "gadm": {
      "name": "Ecker\u00f6",
      "gid": "ALA.2_1"
    },
    "code": "AX.EC"
  },
  "2726": {
    "gadm": {
      "name": "Finstr\u00f6m",
      "gid": "ALA.3_1"
    },
    "code": "AX.FN"
  },
  "2727": {
    "gadm": {
      "name": "F\u00f6gl\u00f6",
      "gid": "ALA.4_1"
    },
    "code": "AX.FG"
  },
  "2728": {
    "gadm": {
      "name": "Geta",
      "gid": "ALA.5_1"
    },
    "code": "AX.GT"
  },
  "2729": {
    "gadm": {
      "name": "Hammarland",
      "gid": "ALA.6_1"
    },
    "code": "AX.HM"
  },
  "2730": {
    "gadm": {
      "name": "Jomala",
      "gid": "ALA.7_1"
    },
    "code": "AX.JM"
  },
  "2731": {
    "gadm": {
      "name": "K\u00f6kar",
      "gid": "ALA.8_1"
    },
    "code": "AX.KK"
  },
  "2732": {
    "gadm": {
      "name": "Kumlinge",
      "gid": "ALA.9_1"
    },
    "code": "AX.KM"
  },
  "2733": {
    "gadm": {
      "name": "Lemland",
      "gid": "ALA.10_1"
    },
    "code": "AX.LE"
  },
  "2734": {
    "gadm": {
      "name": "Lumparland",
      "gid": "ALA.11_1"
    },
    "code": "AX.LU"
  },
  "2735": {
    "gadm": {
      "name": "Mariehamn",
      "gid": "ALA.12_1"
    },
    "code": "AX.MH"
  },
  "2736": {
    "gadm": {
      "name": "Saltvik",
      "gid": "ALA.13_1"
    },
    "code": "AX.SV"
  },
  "2737": {
    "gadm": {
      "name": "Sottunga",
      "gid": "ALA.14_1"
    },
    "code": "AX.ST"
  },
  "2738": {
    "gadm": {
      "name": "Sund",
      "gid": "ALA.15_1"
    },
    "code": "AX.SD"
  },
  "2739": {
    "gadm": {
      "name": "V\u00e5rd\u00f6",
      "gid": "ALA.16_1"
    },
    "code": "AX.VR"
  },
  "2740": {
    "gadm": {
      "name": "Eastern",
      "gid": "ASM.1_1"
    },
    "code": "AS.ET"
  },
  "2741": {
    "gadm": {
      "name": "Manu'a",
      "gid": "ASM.2_1"
    },
    "code": "AS.MA"
  },
  "2742": {
    "gadm": {
      "name": "Unorganized",
      "gid": "ASM.3_1"
    },
    "code": "AS.UU"
  },
  "2743": {
    "gadm": {
      "name": "Western",
      "gid": "ASM.4_1"
    },
    "code": "AS.WT"
  },
  "2744": {
    "gadm": {
      "name": "\u00celes Crozet",
      "gid": "ATF.1_1"
    },
    "code": "TF.CR"
  },
  "2745": {
    "gadm": {
      "name": "\u00celes \u00c9parses",
      "gid": "ATF.2_1"
    },
    "code": null
  },
  "2746": {
    "gadm": {
      "name": "\u00celes Saint Paul et Amsterdam",
      "gid": "ATF.3_1"
    },
    "code": "TF.AS"
  },
  "2747": {
    "gadm": {
      "name": "Kerguelen",
      "gid": "ATF.4_1"
    },
    "code": "TF.KG"
  },
  "2748": {
    "gadm": {
      "name": "Burgenland",
      "gid": "AUT.1_1"
    },
    "code": "AT.BU"
  },
  "2749": {
    "gadm": {
      "name": "K\u00e4rnten",
      "gid": "AUT.2_1"
    },
    "code": "AT.KA"
  },
  "2750": {
    "gadm": {
      "name": "Nieder\u00f6sterreich",
      "gid": "AUT.3_1"
    },
    "code": "AT.NO"
  },
  "2751": {
    "gadm": {
      "name": "Ober\u00f6sterreich",
      "gid": "AUT.4_1"
    },
    "code": "AT.OO"
  },
  "2752": {
    "gadm": {
      "name": "Salzburg",
      "gid": "AUT.5_1"
    },
    "code": "AT.SZ"
  },
  "2753": {
    "gadm": {
      "name": "Steiermark",
      "gid": "AUT.6_1"
    },
    "code": "AT.ST"
  },
  "2754": {
    "gadm": {
      "name": "Tirol",
      "gid": "AUT.7_1"
    },
    "code": "AT.TR"
  },
  "2755": {
    "gadm": {
      "name": "Vorarlberg",
      "gid": "AUT.8_1"
    },
    "code": "AT.VO"
  },
  "2756": {
    "gadm": {
      "name": "Wien",
      "gid": "AUT.9_1"
    },
    "code": "AT.WI"
  },
  "2757": {
    "gadm": {
      "name": "Bruxelles",
      "gid": "BEL.1_1"
    },
    "code": null
  },
  "2758": {
    "gadm": {
      "name": "Vlaanderen",
      "gid": "BEL.2_1"
    },
    "code": null
  },
  "2759": {
    "gadm": {
      "name": "Wallonie",
      "gid": "BEL.3_1"
    },
    "code": null
  },
  "2760": {
    "gadm": {
      "name": "Bonaire",
      "gid": "BES.1_1"
    },
    "code": null
  },
  "2761": {
    "gadm": {
      "name": "Saba",
      "gid": "BES.2_1"
    },
    "code": null
  },
  "2762": {
    "gadm": {
      "name": "Sint Eustatius",
      "gid": "BES.3_1"
    },
    "code": null
  },
  "2763": {
    "gadm": {
      "name": "Blagoevgrad",
      "gid": "BGR.1_1"
    },
    "code": "BG.BL"
  },
  "2764": {
    "gadm": {
      "name": "Burgas",
      "gid": "BGR.2_1"
    },
    "code": "BG.BR"
  },
  "2765": {
    "gadm": {
      "name": "Dobrich",
      "gid": "BGR.3_1"
    },
    "code": "BG.DO"
  },
  "2766": {
    "gadm": {
      "name": "Gabrovo",
      "gid": "BGR.4_1"
    },
    "code": "BG.GB"
  },
  "2767": {
    "gadm": {
      "name": "Grad Sofiya",
      "gid": "BGR.5_1"
    },
    "code": "BG.SG"
  },
  "2768": {
    "gadm": {
      "name": "Haskovo",
      "gid": "BGR.6_1"
    },
    "code": "BG.KK"
  },
  "2769": {
    "gadm": {
      "name": "Kardzhali",
      "gid": "BGR.7_1"
    },
    "code": "BG.KZ"
  },
  "2770": {
    "gadm": {
      "name": "Kyustendil",
      "gid": "BGR.8_1"
    },
    "code": "BG.KY"
  },
  "2771": {
    "gadm": {
      "name": "Lovech",
      "gid": "BGR.9_1"
    },
    "code": "BG.LV"
  },
  "2772": {
    "gadm": {
      "name": "Montana",
      "gid": "BGR.10_1"
    },
    "code": "BG.MT"
  },
  "2773": {
    "gadm": {
      "name": "Pazardzhik",
      "gid": "BGR.11_1"
    },
    "code": "BG.PZ"
  },
  "2774": {
    "gadm": {
      "name": "Pernik",
      "gid": "BGR.12_1"
    },
    "code": "BG.PN"
  },
  "2775": {
    "gadm": {
      "name": "Pleven",
      "gid": "BGR.13_1"
    },
    "code": "BG.PV"
  },
  "2776": {
    "gadm": {
      "name": "Plovdiv",
      "gid": "BGR.14_1"
    },
    "code": "BG.PD"
  },
  "2777": {
    "gadm": {
      "name": "Razgrad",
      "gid": "BGR.15_1"
    },
    "code": "BG.RG"
  },
  "2778": {
    "gadm": {
      "name": "Ruse",
      "gid": "BGR.16_1"
    },
    "code": "BG.RS"
  },
  "2779": {
    "gadm": {
      "name": "Shumen",
      "gid": "BGR.17_1"
    },
    "code": "BG.SH"
  },
  "2780": {
    "gadm": {
      "name": "Silistra",
      "gid": "BGR.18_1"
    },
    "code": "BG.SI"
  },
  "2781": {
    "gadm": {
      "name": "Sliven",
      "gid": "BGR.19_1"
    },
    "code": "BG.SL"
  },
  "2782": {
    "gadm": {
      "name": "Smolyan",
      "gid": "BGR.20_1"
    },
    "code": "BG.SM"
  },
  "2783": {
    "gadm": {
      "name": "Sofia",
      "gid": "BGR.21_1"
    },
    "code": "BG.SF"
  },
  "2784": {
    "gadm": {
      "name": "Stara Zagora",
      "gid": "BGR.22_1"
    },
    "code": "BG.SZ"
  },
  "2785": {
    "gadm": {
      "name": "Targovishte",
      "gid": "BGR.23_1"
    },
    "code": "BG.TU"
  },
  "2786": {
    "gadm": {
      "name": "Varna",
      "gid": "BGR.24_1"
    },
    "code": "BG.VN"
  },
  "2787": {
    "gadm": {
      "name": "Veliko Tarnovo",
      "gid": "BGR.25_1"
    },
    "code": "BG.VT"
  },
  "2788": {
    "gadm": {
      "name": "Vidin",
      "gid": "BGR.26_1"
    },
    "code": "BG.VD"
  },
  "2789": {
    "gadm": {
      "name": "Vratsa",
      "gid": "BGR.27_1"
    },
    "code": "BG.VR"
  },
  "2790": {
    "gadm": {
      "name": "Yambol",
      "gid": "BGR.28_1"
    },
    "code": "BG.YA"
  },
  "2791": {
    "gadm": {
      "name": "Famagusta",
      "gid": "CYP.1_1"
    },
    "code": "CY.FA"
  },
  "2792": {
    "gadm": {
      "name": "Larnaca",
      "gid": "CYP.2_1"
    },
    "code": "CY.LA"
  },
  "2793": {
    "gadm": {
      "name": "Limassol",
      "gid": "CYP.3_1"
    },
    "code": "CY.LI"
  },
  "2794": {
    "gadm": {
      "name": "Nicosia",
      "gid": "CYP.4_1"
    },
    "code": "CY.NI"
  },
  "2795": {
    "gadm": {
      "name": "Paphos",
      "gid": "CYP.5_1"
    },
    "code": "CY.PA"
  },
  "2796": {
    "gadm": {
      "name": "Jiho\u010desk\u00fd",
      "gid": "CZE.1_1"
    },
    "code": "CZ.CK"
  },
  "2797": {
    "gadm": {
      "name": "Jihomoravsk\u00fd",
      "gid": "CZE.2_1"
    },
    "code": "CZ.BK"
  },
  "2798": {
    "gadm": {
      "name": "Karlovarsk\u00fd",
      "gid": "CZE.3_1"
    },
    "code": "CZ.KK"
  },
  "2799": {
    "gadm": {
      "name": "Kraj Vyso\u010dina",
      "gid": "CZE.4_1"
    },
    "code": "CZ.JK"
  },
  "2800": {
    "gadm": {
      "name": "Kr\u00e1lov\u00e9hradeck\u00fd",
      "gid": "CZE.5_1"
    },
    "code": "CZ.HK"
  },
  "2801": {
    "gadm": {
      "name": "Libereck\u00fd",
      "gid": "CZE.6_1"
    },
    "code": "CZ.LK"
  },
  "2802": {
    "gadm": {
      "name": "Moravskoslezsk\u00fd",
      "gid": "CZE.7_1"
    },
    "code": "CZ.VK"
  },
  "2803": {
    "gadm": {
      "name": "Olomouck\u00fd",
      "gid": "CZE.8_1"
    },
    "code": "CZ.OK"
  },
  "2804": {
    "gadm": {
      "name": "Pardubick\u00fd",
      "gid": "CZE.9_1"
    },
    "code": "CZ.EK"
  },
  "2805": {
    "gadm": {
      "name": "Plze\u0148sk\u00fd",
      "gid": "CZE.10_1"
    },
    "code": "CZ.PK"
  },
  "2806": {
    "gadm": {
      "name": "Prague",
      "gid": "CZE.11_1"
    },
    "code": "CZ.SK"
  },
  "2807": {
    "gadm": {
      "name": "St\u0159edo\u010desk\u00fd",
      "gid": "CZE.12_1"
    },
    "code": "CZ.SK"
  },
  "2808": {
    "gadm": {
      "name": "\u00dasteck\u00fd",
      "gid": "CZE.13_1"
    },
    "code": "CZ.UK"
  },
  "2809": {
    "gadm": {
      "name": "Zl\u00ednsk\u00fd",
      "gid": "CZE.14_1"
    },
    "code": "CZ.ZK"
  },
  "2810": {
    "gadm": {
      "name": "Baden-W\u00fcrttemberg",
      "gid": "DEU.1_1"
    },
    "code": "DE.BW"
  },
  "2811": {
    "gadm": {
      "name": "Bayern",
      "gid": "DEU.2_1"
    },
    "code": "DE.BY"
  },
  "2812": {
    "gadm": {
      "name": "Berlin",
      "gid": "DEU.3_1"
    },
    "code": "DE.BE"
  },
  "2813": {
    "gadm": {
      "name": "Brandenburg",
      "gid": "DEU.4_1"
    },
    "code": "DE.BR"
  },
  "2814": {
    "gadm": {
      "name": "Bremen",
      "gid": "DEU.5_1"
    },
    "code": "DE.HB"
  },
  "2815": {
    "gadm": {
      "name": "Hamburg",
      "gid": "DEU.6_1"
    },
    "code": "DE.HH"
  },
  "2816": {
    "gadm": {
      "name": "Hessen",
      "gid": "DEU.7_1"
    },
    "code": "DE.HE"
  },
  "2817": {
    "gadm": {
      "name": "Mecklenburg-Vorpommern",
      "gid": "DEU.8_1"
    },
    "code": "DE.MV"
  },
  "2818": {
    "gadm": {
      "name": "Niedersachsen",
      "gid": "DEU.9_1"
    },
    "code": "DE.NI"
  },
  "2819": {
    "gadm": {
      "name": "Nordrhein-Westfalen",
      "gid": "DEU.10_1"
    },
    "code": "DE.NW"
  },
  "2820": {
    "gadm": {
      "name": "Rheinland-Pfalz",
      "gid": "DEU.11_1"
    },
    "code": "DE.RP"
  },
  "2821": {
    "gadm": {
      "name": "Saarland",
      "gid": "DEU.12_1"
    },
    "code": "DE.SL"
  },
  "2822": {
    "gadm": {
      "name": "Sachsen",
      "gid": "DEU.14_1"
    },
    "code": "DE.SN"
  },
  "2823": {
    "gadm": {
      "name": "Sachsen-Anhalt",
      "gid": "DEU.13_1"
    },
    "code": "DE.ST"
  },
  "2824": {
    "gadm": {
      "name": "Schleswig-Holstein",
      "gid": "DEU.15_1"
    },
    "code": "DE.SH"
  },
  "2825": {
    "gadm": {
      "name": "Th\u00fcringen",
      "gid": "DEU.16_1"
    },
    "code": "DE.TH"
  },
  "2826": {
    "gadm": {
      "name": "Hovedstaden",
      "gid": "DNK.1_1"
    },
    "code": "DK.HS"
  },
  "2827": {
    "gadm": {
      "name": "Midtjylland",
      "gid": "DNK.2_1"
    },
    "code": "DK.MJ"
  },
  "2828": {
    "gadm": {
      "name": "Nordjylland",
      "gid": "DNK.3_1"
    },
    "code": "DK.ND"
  },
  "2829": {
    "gadm": {
      "name": "Sj\u00e6lland",
      "gid": "DNK.4_1"
    },
    "code": "DK.SL"
  },
  "2830": {
    "gadm": {
      "name": "Syddanmark",
      "gid": "DNK.5_1"
    },
    "code": "DK.SD"
  },
  "2831": {
    "gadm": {
      "name": "Andaluc\u00eda",
      "gid": "ESP.1_1"
    },
    "code": "ES.AN"
  },
  "2832": {
    "gadm": {
      "name": "Arag\u00f3n",
      "gid": "ESP.2_1"
    },
    "code": "ES.AR"
  },
  "2833": {
    "gadm": {
      "name": "Cantabria",
      "gid": "ESP.3_1"
    },
    "code": "ES.CB"
  },
  "2834": {
    "gadm": {
      "name": "Castilla-La Mancha",
      "gid": "ESP.4_1"
    },
    "code": "ES.CM"
  },
  "2835": {
    "gadm": {
      "name": "Castilla y Le\u00f3n",
      "gid": "ESP.5_1"
    },
    "code": "ES.CL"
  },
  "2836": {
    "gadm": {
      "name": "Catalu\u00f1a",
      "gid": "ESP.6_1"
    },
    "code": "ES.CT"
  },
  "2837": {
    "gadm": {
      "name": "Ceuta y Melilla",
      "gid": "ESP.7_1"
    },
    "code": "ES.ML"
  },
  "2838": {
    "gadm": {
      "name": "Comunidad de Madrid",
      "gid": "ESP.8_1"
    },
    "code": "ES.MD"
  },
  "2839": {
    "gadm": {
      "name": "Comunidad Foral de Navarra",
      "gid": "ESP.9_1"
    },
    "code": "ES.NA"
  },
  "2840": {
    "gadm": {
      "name": "Comunidad Valenciana",
      "gid": "ESP.10_1"
    },
    "code": "ES.VC"
  },
  "2841": {
    "gadm": {
      "name": "Extremadura",
      "gid": "ESP.11_1"
    },
    "code": "ES.EX"
  },
  "2842": {
    "gadm": {
      "name": "Galicia",
      "gid": "ESP.12_1"
    },
    "code": "ES.GA"
  },
  "2843": {
    "gadm": {
      "name": "Islas Baleares",
      "gid": "ESP.13_1"
    },
    "code": "ES.PM"
  },
  "2844": {
    "gadm": {
      "name": "Islas Canarias",
      "gid": "ESP.14_1"
    },
    "code": "ES.CN"
  },
  "2845": {
    "gadm": {
      "name": "La Rioja",
      "gid": "ESP.15_1"
    },
    "code": "ES.LO"
  },
  "2846": {
    "gadm": {
      "name": "Pa\u00eds Vasco",
      "gid": "ESP.16_1"
    },
    "code": "ES.PV"
  },
  "2847": {
    "gadm": {
      "name": "Principado de Asturias",
      "gid": "ESP.17_1"
    },
    "code": "ES.AS"
  },
  "2848": {
    "gadm": {
      "name": "Regi\u00f3n de Murcia",
      "gid": "ESP.18_1"
    },
    "code": "ES.MU"
  },
  "2849": {
    "gadm": {
      "name": "Harju",
      "gid": "EST.1_1"
    },
    "code": "EE.HA"
  },
  "2850": {
    "gadm": {
      "name": "Hiiu",
      "gid": "EST.2_1"
    },
    "code": "EE.HI"
  },
  "2851": {
    "gadm": {
      "name": "Ida-Viru",
      "gid": "EST.3_1"
    },
    "code": "EE.IV"
  },
  "2852": {
    "gadm": {
      "name": "J\u00e4rva",
      "gid": "EST.4_1"
    },
    "code": "EE.JR"
  },
  "2853": {
    "gadm": {
      "name": "J\u00f5geva",
      "gid": "EST.5_1"
    },
    "code": "EE.JN"
  },
  "2854": {
    "gadm": {
      "name": "L\u00e4\u00e4ne",
      "gid": "EST.7_1"
    },
    "code": "EE.LN"
  },
  "2855": {
    "gadm": {
      "name": "L\u00e4\u00e4ne-Viru",
      "gid": "EST.6_1"
    },
    "code": "EE.LV"
  },
  "2856": {
    "gadm": {
      "name": "P\u00e4rnu",
      "gid": "EST.8_1"
    },
    "code": "EE.PR"
  },
  "2857": {
    "gadm": {
      "name": "Peipsi",
      "gid": "EST.9_1"
    },
    "code": null
  },
  "2858": {
    "gadm": {
      "name": "P\u00f5lva",
      "gid": "EST.10_1"
    },
    "code": "EE.PL"
  },
  "2859": {
    "gadm": {
      "name": "Rapla",
      "gid": "EST.11_1"
    },
    "code": "EE.RA"
  },
  "2860": {
    "gadm": {
      "name": "Saare",
      "gid": "EST.12_1"
    },
    "code": "EE.SA"
  },
  "2861": {
    "gadm": {
      "name": "Tartu",
      "gid": "EST.13_1"
    },
    "code": "EE.TA"
  },
  "2862": {
    "gadm": {
      "name": "Valga",
      "gid": "EST.14_1"
    },
    "code": "EE.VG"
  },
  "2863": {
    "gadm": {
      "name": "Viljandi",
      "gid": "EST.15_1"
    },
    "code": "EE.VD"
  },
  "2864": {
    "gadm": {
      "name": "V\u00f5ru",
      "gid": "EST.16_1"
    },
    "code": "EE.VR"
  },
  "2865": {
    "gadm": {
      "name": "Eastern Finland",
      "gid": "FIN.1_1"
    },
    "code": "FI.IS"
  },
  "2866": {
    "gadm": {
      "name": "Lapland",
      "gid": "FIN.2_1"
    },
    "code": "FI.LP"
  },
  "2867": {
    "gadm": {
      "name": "Oulu",
      "gid": "FIN.3_1"
    },
    "code": "FI.OU"
  },
  "2868": {
    "gadm": {
      "name": "Southern Finland",
      "gid": "FIN.4_1"
    },
    "code": "FI.ES"
  },
  "2869": {
    "gadm": {
      "name": "Western Finland",
      "gid": "FIN.5_1"
    },
    "code": "FI.LS"
  },
  "2870": {
    "gadm": {
      "name": "Auvergne-Rh\u00f4ne-Alpes",
      "gid": "FRA.1_1"
    },
    "code": "FR.AR"
  },
  "2871": {
    "gadm": {
      "name": "Bourgogne-Franche-Comt\u00e9",
      "gid": "FRA.2_1"
    },
    "code": "FR.BF"
  },
  "2872": {
    "gadm": {
      "name": "Bretagne",
      "gid": "FRA.3_1"
    },
    "code": "FR.BT"
  },
  "2873": {
    "gadm": {
      "name": "Centre-Val de Loire",
      "gid": "FRA.4_1"
    },
    "code": "FR.CN"
  },
  "2874": {
    "gadm": {
      "name": "Corse",
      "gid": "FRA.5_1"
    },
    "code": "FR.CE"
  },
  "2875": {
    "gadm": {
      "name": "Grand Est",
      "gid": "FRA.6_1"
    },
    "code": "FR.AO"
  },
  "2876": {
    "gadm": {
      "name": "Hauts-de-France",
      "gid": "FRA.7_1"
    },
    "code": "FR.NC"
  },
  "2877": {
    "gadm": {
      "name": "\u00cele-de-France",
      "gid": "FRA.8_1"
    },
    "code": "FR.IF"
  },
  "2878": {
    "gadm": {
      "name": "Normandie",
      "gid": "FRA.9_1"
    },
    "code": "FR.ND"
  },
  "2879": {
    "gadm": {
      "name": "Nouvelle-Aquitaine",
      "gid": "FRA.10_1"
    },
    "code": "FR.AC"
  },
  "2880": {
    "gadm": {
      "name": "Occitanie",
      "gid": "FRA.11_1"
    },
    "code": "FR.LP"
  },
  "2881": {
    "gadm": {
      "name": "Pays de la Loire",
      "gid": "FRA.12_1"
    },
    "code": "FR.PL"
  },
  "2882": {
    "gadm": {
      "name": "Provence-Alpes-C\u00f4te d'Azur",
      "gid": "FRA.13_1"
    },
    "code": "FR.PR"
  },
  "2883": {
    "gadm": {
      "name": "Eysturoyar",
      "gid": "FRO.1_1"
    },
    "code": "FO.OS"
  },
  "2884": {
    "gadm": {
      "name": "Norder\u00f8erne",
      "gid": "FRO.2_1"
    },
    "code": "FO.NO"
  },
  "2885": {
    "gadm": {
      "name": "Sandoyar",
      "gid": "FRO.3_1"
    },
    "code": "FO.SA"
  },
  "2886": {
    "gadm": {
      "name": "Streymoyar",
      "gid": "FRO.4_1"
    },
    "code": "FO.ST"
  },
  "2887": {
    "gadm": {
      "name": "Su\u00f0uroyar",
      "gid": "FRO.5_1"
    },
    "code": "FO.SN|FO.SS"
  },
  "2888": {
    "gadm": {
      "name": "V\u00e5g\u00f8",
      "gid": "FRO.6_1"
    },
    "code": "FO.VG"
  },
  "2889": {
    "gadm": {
      "name": "Alderney",
      "gid": "GGY.1_1"
    },
    "code": "GG.AL"
  },
  "2890": {
    "gadm": {
      "name": "Brecqhou",
      "gid": "GGY.2_1"
    },
    "code": "GG.BQ"
  },
  "2891": {
    "gadm": {
      "name": "Castel",
      "gid": "GGY.3_1"
    },
    "code": "GG.CA"
  },
  "2892": {
    "gadm": {
      "name": "Forest",
      "gid": "GGY.4_1"
    },
    "code": "GG.FO"
  },
  "2893": {
    "gadm": {
      "name": "Herm",
      "gid": "GGY.5_1"
    },
    "code": "GG.HM"
  },
  "2894": {
    "gadm": {
      "name": "Jethou",
      "gid": "GGY.6_1"
    },
    "code": "GG.JT"
  },
  "2895": {
    "gadm": {
      "name": "Saint Andrew",
      "gid": "GGY.7_1"
    },
    "code": "GG.AN"
  },
  "2896": {
    "gadm": {
      "name": "Saint Martin",
      "gid": "GGY.8_1"
    },
    "code": "GG.MA"
  },
  "2897": {
    "gadm": {
      "name": "Saint Peter Port",
      "gid": "GGY.9_1"
    },
    "code": "GG.PP"
  },
  "2898": {
    "gadm": {
      "name": "Saint Pierre du Bois",
      "gid": "GGY.10_1"
    },
    "code": "GG.SB"
  },
  "2899": {
    "gadm": {
      "name": "Saint Sampson",
      "gid": "GGY.11_1"
    },
    "code": "GG.SM"
  },
  "2900": {
    "gadm": {
      "name": "Saint Saviour",
      "gid": "GGY.12_1"
    },
    "code": "GG.SV"
  },
  "2901": {
    "gadm": {
      "name": "Sark",
      "gid": "GGY.13_1"
    },
    "code": "GG.SK"
  },
  "2902": {
    "gadm": {
      "name": "Torteval",
      "gid": "GGY.14_1"
    },
    "code": "GG.TV"
  },
  "2903": {
    "gadm": {
      "name": "Vale",
      "gid": "GGY.15_1"
    },
    "code": "GG.VA"
  },
  "2904": {
    "gadm": {
      "name": "Basse-Terre",
      "gid": "GLP.1_1"
    },
    "code": "GP.BT"
  },
  "2905": {
    "gadm": {
      "name": "Pointe-\u00e0-Pitre",
      "gid": "GLP.2_1"
    },
    "code": "GP.PP"
  },
  "2906": {
    "gadm": {
      "name": "Aegean",
      "gid": "GRC.1_1"
    },
    "code": "GR.AI"
  },
  "2907": {
    "gadm": {
      "name": "Athos",
      "gid": "GRC.2_1"
    },
    "code": "GR.MA"
  },
  "2908": {
    "gadm": {
      "name": "Attica",
      "gid": "GRC.3_1"
    },
    "code": "GR.AT"
  },
  "2909": {
    "gadm": {
      "name": "Crete",
      "gid": "GRC.4_1"
    },
    "code": "GR.CR"
  },
  "2910": {
    "gadm": {
      "name": "Epirus and Western Macedonia",
      "gid": "GRC.5_1"
    },
    "code": "GR.EM"
  },
  "2911": {
    "gadm": {
      "name": "Macedonia and Thrace",
      "gid": "GRC.6_1"
    },
    "code": "GR.MH"
  },
  "2912": {
    "gadm": {
      "name": "Peloponnese, Western Greece and the Ionian Islands",
      "gid": "GRC.7_1"
    },
    "code": "GR.PW"
  },
  "2913": {
    "gadm": {
      "name": "Thessaly and Central Greece",
      "gid": "GRC.8_1"
    },
    "code": "GR.TC"
  },
  "2914": {
    "gadm": {
      "name": "Kujalleq",
      "gid": "GRL.1_1"
    },
    "code": "GL.KU"
  },
  "2915": {
    "gadm": {
      "name": "Northeast Greenland National Park",
      "gid": "GRL.2_1"
    },
    "code": "GL.UO"
  },
  "2916": {
    "gadm": {
      "name": "Qaasuitsup",
      "gid": "GRL.3_1"
    },
    "code": "GL.QS"
  },
  "2917": {
    "gadm": {
      "name": "Qeqqata",
      "gid": "GRL.4_1"
    },
    "code": "GL.QT"
  },
  "2918": {
    "gadm": {
      "name": "Sermersooq",
      "gid": "GRL.5_1"
    },
    "code": "GL.SE"
  },
  "2919": {
    "gadm": {
      "name": "Cayenne",
      "gid": "GUF.1_1"
    },
    "code": "GF.CY"
  },
  "2920": {
    "gadm": {
      "name": "Saint-Laurent-du-Maroni",
      "gid": "GUF.2_1"
    },
    "code": "GF.SL"
  },
  "2921": {
    "gadm": {
      "name": "Agana Heights",
      "gid": "GUM.1_1"
    },
    "code": "GU.AH"
  },
  "2922": {
    "gadm": {
      "name": "Agat",
      "gid": "GUM.2_1"
    },
    "code": "GU.AT"
  },
  "2923": {
    "gadm": {
      "name": "Asan",
      "gid": "GUM.3_1"
    },
    "code": "GU.AS"
  },
  "2924": {
    "gadm": {
      "name": "Barrigada",
      "gid": "GUM.4_1"
    },
    "code": "GU.BA"
  },
  "2925": {
    "gadm": {
      "name": "Chalan-Pago-Ordot",
      "gid": "GUM.5_1"
    },
    "code": "GU.CP"
  },
  "2926": {
    "gadm": {
      "name": "Dededo",
      "gid": "GUM.6_1"
    },
    "code": "GU.DD"
  },
  "2927": {
    "gadm": {
      "name": "Hag\u00e5t\u00f1a",
      "gid": "GUM.7_1"
    },
    "code": "GU.AN"
  },
  "2928": {
    "gadm": {
      "name": "Inarajan",
      "gid": "GUM.8_1"
    },
    "code": "GU.IN"
  },
  "2929": {
    "gadm": {
      "name": "Mangilao",
      "gid": "GUM.9_1"
    },
    "code": "GU.MA"
  },
  "2930": {
    "gadm": {
      "name": "Merizo",
      "gid": "GUM.10_1"
    },
    "code": "GU.ME"
  },
  "2931": {
    "gadm": {
      "name": "Mongmong-Toto-Maite",
      "gid": "GUM.11_1"
    },
    "code": "GU.MT"
  },
  "2932": {
    "gadm": {
      "name": "Piti",
      "gid": "GUM.12_1"
    },
    "code": "GU.PI"
  },
  "2933": {
    "gadm": {
      "name": "Santa Rita",
      "gid": "GUM.13_1"
    },
    "code": "GU.SR"
  },
  "2934": {
    "gadm": {
      "name": "Sinajana",
      "gid": "GUM.14_1"
    },
    "code": "GU.SJ"
  },
  "2935": {
    "gadm": {
      "name": "Talofofo",
      "gid": "GUM.15_1"
    },
    "code": "GU.TF"
  },
  "2936": {
    "gadm": {
      "name": "Tamuning",
      "gid": "GUM.16_1"
    },
    "code": "GU.TM"
  },
  "2937": {
    "gadm": {
      "name": "Umatac",
      "gid": "GUM.17_1"
    },
    "code": "GU.UM"
  },
  "2938": {
    "gadm": {
      "name": "Yigo",
      "gid": "GUM.18_1"
    },
    "code": "GU.YG"
  },
  "2939": {
    "gadm": {
      "name": "Yona",
      "gid": "GUM.19_1"
    },
    "code": "GU.YN"
  },
  "2940": {
    "gadm": {
      "name": "Bjelovarska-Bilogorska",
      "gid": "HRV.1_1"
    },
    "code": "HR.BB"
  },
  "2941": {
    "gadm": {
      "name": "Brodsko-Posavska",
      "gid": "HRV.2_1"
    },
    "code": "HR.SP"
  },
  "2942": {
    "gadm": {
      "name": "Dubrovacko-Neretvanska",
      "gid": "HRV.3_1"
    },
    "code": "HR.DN"
  },
  "2943": {
    "gadm": {
      "name": "Grad Zagreb",
      "gid": "HRV.4_1"
    },
    "code": "HR.GZ"
  },
  "2944": {
    "gadm": {
      "name": "Istarska",
      "gid": "HRV.5_1"
    },
    "code": "HR.IS"
  },
  "2945": {
    "gadm": {
      "name": "Karlovacka",
      "gid": "HRV.6_1"
    },
    "code": "HR.KA"
  },
  "2946": {
    "gadm": {
      "name": "Koprivni\u010dko-Kri\u017eeva\u010dka",
      "gid": "HRV.7_1"
    },
    "code": "HR.KK"
  },
  "2947": {
    "gadm": {
      "name": "Krapinsko-Zagorska",
      "gid": "HRV.8_1"
    },
    "code": "HR.KZ"
  },
  "2948": {
    "gadm": {
      "name": "Licko-Senjska",
      "gid": "HRV.9_1"
    },
    "code": "HR.LS"
  },
  "2949": {
    "gadm": {
      "name": "Medimurska",
      "gid": "HRV.10_1"
    },
    "code": "HR.ME"
  },
  "2950": {
    "gadm": {
      "name": "Osjecko-Baranjska",
      "gid": "HRV.11_1"
    },
    "code": "HR.OB"
  },
  "2951": {
    "gadm": {
      "name": "Po\u017ee\u0161ko-Slavonska",
      "gid": "HRV.12_1"
    },
    "code": "HR.PS"
  },
  "2952": {
    "gadm": {
      "name": "Primorsko-Goranska",
      "gid": "HRV.13_1"
    },
    "code": "HR.PG"
  },
  "2953": {
    "gadm": {
      "name": "\u0160ibensko-Kninska",
      "gid": "HRV.14_1"
    },
    "code": "HR.SB"
  },
  "2954": {
    "gadm": {
      "name": "Sisacko-Moslavacka",
      "gid": "HRV.15_1"
    },
    "code": "HR.SM"
  },
  "2955": {
    "gadm": {
      "name": "Splitsko-Dalmatinska",
      "gid": "HRV.16_1"
    },
    "code": "HR.SD"
  },
  "2956": {
    "gadm": {
      "name": "Vara\u017edinska",
      "gid": "HRV.17_1"
    },
    "code": "HR.VA"
  },
  "2957": {
    "gadm": {
      "name": "Viroviticko-Podravska",
      "gid": "HRV.18_1"
    },
    "code": "HR.VP"
  },
  "2958": {
    "gadm": {
      "name": "Vukovarsko-Srijemska",
      "gid": "HRV.19_1"
    },
    "code": "HR.VS"
  },
  "2959": {
    "gadm": {
      "name": "Zadarska",
      "gid": "HRV.20_1"
    },
    "code": "HR.ZD"
  },
  "2960": {
    "gadm": {
      "name": "Zagreba\u010dka",
      "gid": "HRV.21_1"
    },
    "code": "HR.ZG"
  },
  "2961": {
    "gadm": {
      "name": "B\u00e1cs-Kiskun",
      "gid": "HUN.1_1"
    },
    "code": "HU.BK"
  },
  "2962": {
    "gadm": {
      "name": "Baranya",
      "gid": "HUN.2_1"
    },
    "code": "HU.BA"
  },
  "2963": {
    "gadm": {
      "name": "B\u00e9k\u00e9s",
      "gid": "HUN.3_1"
    },
    "code": "HU.BE"
  },
  "2964": {
    "gadm": {
      "name": "Borsod-Aba\u00faj-Zempl\u00e9n",
      "gid": "HUN.4_1"
    },
    "code": "HU.BZ"
  },
  "2965": {
    "gadm": {
      "name": "Budapest",
      "gid": "HUN.5_1"
    },
    "code": "HU.BU"
  },
  "2966": {
    "gadm": {
      "name": "Csongr\u00e1d",
      "gid": "HUN.6_1"
    },
    "code": "HU.CS"
  },
  "2967": {
    "gadm": {
      "name": "Fej\u00e9r",
      "gid": "HUN.7_1"
    },
    "code": "HU.FE"
  },
  "2968": {
    "gadm": {
      "name": "Gyor-Moson-Sopron",
      "gid": "HUN.8_1"
    },
    "code": "HU.GS"
  },
  "2969": {
    "gadm": {
      "name": "Hajd\u00fa-Bihar",
      "gid": "HUN.9_1"
    },
    "code": "HU.HB"
  },
  "2970": {
    "gadm": {
      "name": "Heves",
      "gid": "HUN.10_1"
    },
    "code": "HU.HE"
  },
  "2971": {
    "gadm": {
      "name": "J\u00e1sz-Nagykun-Szolnok",
      "gid": "HUN.11_1"
    },
    "code": "HU.JN"
  },
  "2972": {
    "gadm": {
      "name": "Kom\u00e1rom-Esztergom",
      "gid": "HUN.12_1"
    },
    "code": "HU.KE"
  },
  "2973": {
    "gadm": {
      "name": "N\u00f3gr\u00e1d",
      "gid": "HUN.13_1"
    },
    "code": "HU.NO"
  },
  "2974": {
    "gadm": {
      "name": "Pest",
      "gid": "HUN.14_1"
    },
    "code": "HU.PE"
  },
  "2975": {
    "gadm": {
      "name": "Somogy",
      "gid": "HUN.15_1"
    },
    "code": "HU.SO"
  },
  "2976": {
    "gadm": {
      "name": "Szabolcs-Szatm\u00e1r-Bereg",
      "gid": "HUN.16_1"
    },
    "code": "HU.SZ"
  },
  "2977": {
    "gadm": {
      "name": "Tolna",
      "gid": "HUN.17_1"
    },
    "code": "HU.TO"
  },
  "2978": {
    "gadm": {
      "name": "Vas",
      "gid": "HUN.18_1"
    },
    "code": "HU.VA"
  },
  "2979": {
    "gadm": {
      "name": "Veszpr\u00e9m",
      "gid": "HUN.19_1"
    },
    "code": "HU.VE"
  },
  "2980": {
    "gadm": {
      "name": "Zala",
      "gid": "HUN.20_1"
    },
    "code": "HU.ZA"
  },
  "2981": {
    "gadm": {
      "name": "Ayre",
      "gid": "IMN.1_1"
    },
    "code": "IM.AY"
  },
  "2982": {
    "gadm": {
      "name": "Garff",
      "gid": "IMN.2_1"
    },
    "code": "IM.GR"
  },
  "2983": {
    "gadm": {
      "name": "Glenfaba",
      "gid": "IMN.3_1"
    },
    "code": "IM.GB"
  },
  "2984": {
    "gadm": {
      "name": "Michael",
      "gid": "IMN.4_1"
    },
    "code": "IM.MC"
  },
  "2985": {
    "gadm": {
      "name": "Middle",
      "gid": "IMN.5_1"
    },
    "code": "IM.MD"
  },
  "2986": {
    "gadm": {
      "name": "Rushen",
      "gid": "IMN.6_1"
    },
    "code": "IM.RU"
  },
  "2987": {
    "gadm": {
      "name": "Carlow",
      "gid": "IRL.1_1"
    },
    "code": "IE.CW"
  },
  "2988": {
    "gadm": {
      "name": "Cavan",
      "gid": "IRL.2_1"
    },
    "code": "IE.CN"
  },
  "2989": {
    "gadm": {
      "name": "Clare",
      "gid": "IRL.3_1"
    },
    "code": "IE.CE"
  },
  "2990": {
    "gadm": {
      "name": "Cork",
      "gid": "IRL.4_1"
    },
    "code": "IE.CK"
  },
  "2991": {
    "gadm": {
      "name": "Donegal",
      "gid": "IRL.5_1"
    },
    "code": "IE.DL"
  },
  "2992": {
    "gadm": {
      "name": "Dublin",
      "gid": "IRL.6_1"
    },
    "code": "IE.DN"
  },
  "2993": {
    "gadm": {
      "name": "Galway",
      "gid": "IRL.7_1"
    },
    "code": "IE.GY"
  },
  "2994": {
    "gadm": {
      "name": "Kerry",
      "gid": "IRL.8_1"
    },
    "code": "IE.KY"
  },
  "2995": {
    "gadm": {
      "name": "Kildare",
      "gid": "IRL.9_1"
    },
    "code": "IE.KE"
  },
  "2996": {
    "gadm": {
      "name": "Kilkenny",
      "gid": "IRL.10_1"
    },
    "code": "IE.KK"
  },
  "2997": {
    "gadm": {
      "name": "Laoighis",
      "gid": "IRL.11_1"
    },
    "code": "IE.LS"
  },
  "2998": {
    "gadm": {
      "name": "Leitrim",
      "gid": "IRL.12_1"
    },
    "code": "IE.LM"
  },
  "2999": {
    "gadm": {
      "name": "Limerick",
      "gid": "IRL.13_1"
    },
    "code": "IE.LK"
  },
  "3000": {
    "gadm": {
      "name": "Longford",
      "gid": "IRL.14_1"
    },
    "code": "IE.LD"
  },
  "3001": {
    "gadm": {
      "name": "Louth",
      "gid": "IRL.15_1"
    },
    "code": "IE.LH"
  },
  "3002": {
    "gadm": {
      "name": "Mayo",
      "gid": "IRL.16_1"
    },
    "code": "IE.MO"
  },
  "3003": {
    "gadm": {
      "name": "Meath",
      "gid": "IRL.17_1"
    },
    "code": "IE.MH"
  },
  "3004": {
    "gadm": {
      "name": "Monaghan",
      "gid": "IRL.18_1"
    },
    "code": "IE.MN"
  },
  "3005": {
    "gadm": {
      "name": "Offaly",
      "gid": "IRL.19_1"
    },
    "code": "IE.OY"
  },
  "3006": {
    "gadm": {
      "name": "Roscommon",
      "gid": "IRL.20_1"
    },
    "code": "IE.RN"
  },
  "3007": {
    "gadm": {
      "name": "Sligo",
      "gid": "IRL.21_1"
    },
    "code": "IE.SO"
  },
  "3008": {
    "gadm": {
      "name": "Tipperary",
      "gid": "IRL.22_1"
    },
    "code": "IE.TY"
  },
  "3009": {
    "gadm": {
      "name": "Waterford",
      "gid": "IRL.23_1"
    },
    "code": "IE.WD"
  },
  "3010": {
    "gadm": {
      "name": "Westmeath",
      "gid": "IRL.24_1"
    },
    "code": "IE.WH"
  },
  "3011": {
    "gadm": {
      "name": "Wexford",
      "gid": "IRL.25_1"
    },
    "code": "IE.WX"
  },
  "3012": {
    "gadm": {
      "name": "Wicklow",
      "gid": "IRL.26_1"
    },
    "code": "IE.WW"
  },
  "3013": {
    "gadm": {
      "name": "Abruzzo",
      "gid": "ITA.1_1"
    },
    "code": null
  },
  "3014": {
    "gadm": {
      "name": "Apulia",
      "gid": "ITA.2_1"
    },
    "code": null
  },
  "3015": {
    "gadm": {
      "name": "Basilicata",
      "gid": "ITA.3_1"
    },
    "code": null
  },
  "3016": {
    "gadm": {
      "name": "Calabria",
      "gid": "ITA.4_1"
    },
    "code": null
  },
  "3017": {
    "gadm": {
      "name": "Campania",
      "gid": "ITA.5_1"
    },
    "code": null
  },
  "3018": {
    "gadm": {
      "name": "Emilia-Romagna",
      "gid": "ITA.6_1"
    },
    "code": null
  },
  "3019": {
    "gadm": {
      "name": "Friuli-Venezia Giulia",
      "gid": "ITA.7_1"
    },
    "code": null
  },
  "3020": {
    "gadm": {
      "name": "Lazio",
      "gid": "ITA.8_1"
    },
    "code": null
  },
  "3021": {
    "gadm": {
      "name": "Liguria",
      "gid": "ITA.9_1"
    },
    "code": null
  },
  "3022": {
    "gadm": {
      "name": "Lombardia",
      "gid": "ITA.10_1"
    },
    "code": null
  },
  "3023": {
    "gadm": {
      "name": "Marche",
      "gid": "ITA.11_1"
    },
    "code": null
  },
  "3024": {
    "gadm": {
      "name": "Molise",
      "gid": "ITA.12_1"
    },
    "code": null
  },
  "3025": {
    "gadm": {
      "name": "Piemonte",
      "gid": "ITA.13_1"
    },
    "code": null
  },
  "3026": {
    "gadm": {
      "name": "Sardegna",
      "gid": "ITA.14_1"
    },
    "code": null
  },
  "3027": {
    "gadm": {
      "name": "Sicily",
      "gid": "ITA.15_1"
    },
    "code": null
  },
  "3028": {
    "gadm": {
      "name": "Toscana",
      "gid": "ITA.16_1"
    },
    "code": null
  },
  "3029": {
    "gadm": {
      "name": "Trentino-Alto Adige",
      "gid": "ITA.17_1"
    },
    "code": null
  },
  "3030": {
    "gadm": {
      "name": "Umbria",
      "gid": "ITA.18_1"
    },
    "code": null
  },
  "3031": {
    "gadm": {
      "name": "Valle d'Aosta",
      "gid": "ITA.19_1"
    },
    "code": null
  },
  "3032": {
    "gadm": {
      "name": "Veneto",
      "gid": "ITA.20_1"
    },
    "code": null
  },
  "3033": {
    "gadm": {
      "name": "Grouville",
      "gid": "JEY.1_1"
    },
    "code": "JE.GR"
  },
  "3034": {
    "gadm": {
      "name": "Saint Berlade",
      "gid": "JEY.2_1"
    },
    "code": "JE.BR"
  },
  "3035": {
    "gadm": {
      "name": "Saint Clement",
      "gid": "JEY.3_1"
    },
    "code": "GR.CL"
  },
  "3036": {
    "gadm": {
      "name": "Saint Helier",
      "gid": "JEY.4_1"
    },
    "code": "JE.HE"
  },
  "3037": {
    "gadm": {
      "name": "Saint John",
      "gid": "JEY.5_1"
    },
    "code": "JE.JO"
  },
  "3038": {
    "gadm": {
      "name": "Saint Lawrence",
      "gid": "JEY.6_1"
    },
    "code": "JE.LA"
  },
  "3039": {
    "gadm": {
      "name": "Saint Martin",
      "gid": "JEY.7_1"
    },
    "code": "JE.MT"
  },
  "3040": {
    "gadm": {
      "name": "Saint Mary",
      "gid": "JEY.8_1"
    },
    "code": "JE.MY"
  },
  "3041": {
    "gadm": {
      "name": "Saint Ouen",
      "gid": "JEY.9_1"
    },
    "code": "JE.OU"
  },
  "3042": {
    "gadm": {
      "name": "Saint Peter",
      "gid": "JEY.10_1"
    },
    "code": "JE.PE"
  },
  "3043": {
    "gadm": {
      "name": "Saint Saviour",
      "gid": "JEY.11_1"
    },
    "code": "JE.SA"
  },
  "3044": {
    "gadm": {
      "name": "Trinity",
      "gid": "JEY.12_1"
    },
    "code": "JE.TR"
  },
  "3045": {
    "gadm": {
      "name": "Alytaus",
      "gid": "LTU.1_1"
    },
    "code": "LT.AS"
  },
  "3046": {
    "gadm": {
      "name": "Kauno",
      "gid": "LTU.2_1"
    },
    "code": "LT.KS"
  },
  "3047": {
    "gadm": {
      "name": "Klaipedos",
      "gid": "LTU.3_1"
    },
    "code": "LT.KP"
  },
  "3048": {
    "gadm": {
      "name": "Marijampoles",
      "gid": "LTU.4_1"
    },
    "code": "LT.MA"
  },
  "3049": {
    "gadm": {
      "name": "Panevezio",
      "gid": "LTU.5_1"
    },
    "code": "LT.PA"
  },
  "3050": {
    "gadm": {
      "name": "\u0160iauliai",
      "gid": "LTU.6_1"
    },
    "code": "LT.SH"
  },
  "3051": {
    "gadm": {
      "name": "Taurages",
      "gid": "LTU.7_1"
    },
    "code": "LT.TG"
  },
  "3052": {
    "gadm": {
      "name": "Tel\u0161iai",
      "gid": "LTU.8_1"
    },
    "code": "LT.TL"
  },
  "3053": {
    "gadm": {
      "name": "Utenos",
      "gid": "LTU.9_1"
    },
    "code": "LT.UN"
  },
  "3054": {
    "gadm": {
      "name": "Vilniaus",
      "gid": "LTU.10_1"
    },
    "code": "LT.VI"
  },
  "3055": {
    "gadm": {
      "name": "Diekirch",
      "gid": "LUX.1_1"
    },
    "code": "LU.DI"
  },
  "3056": {
    "gadm": {
      "name": "Grevenmacher",
      "gid": "LUX.2_1"
    },
    "code": "LU.GR"
  },
  "3057": {
    "gadm": {
      "name": "Luxembourg",
      "gid": "LUX.3_1"
    },
    "code": "LU.LU"
  },
  "3058": {
    "gadm": {
      "name": "Kurzeme",
      "gid": "LVA.1_1"
    },
    "code": "K"
  },
  "3059": {
    "gadm": {
      "name": "Latgale",
      "gid": "LVA.2_1"
    },
    "code": "L"
  },
  "3060": {
    "gadm": {
      "name": "Riga",
      "gid": "LVA.3_1"
    },
    "code": "R"
  },
  "3061": {
    "gadm": {
      "name": "Vidzeme",
      "gid": "LVA.4_1"
    },
    "code": "V"
  },
  "3062": {
    "gadm": {
      "name": "Zemgale",
      "gid": "LVA.5_1"
    },
    "code": "Z"
  },
  "3063": {
    "gadm": {
      "name": "Ilhas",
      "gid": "MAC.1_1"
    },
    "code": "MO.IL"
  },
  "3064": {
    "gadm": {
      "name": "Lake Ohrid",
      "gid": "MKD.42_1"
    },
    "code": null
  },
  "3065": {
    "gadm": {
      "name": "\u010aentrali",
      "gid": "MLT.1_1"
    },
    "code": "MT.CE"
  },
  "3066": {
    "gadm": {
      "name": "G\u0127awdex",
      "gid": "MLT.2_1"
    },
    "code": "MT.GO"
  },
  "3067": {
    "gadm": {
      "name": "Nofsinhar",
      "gid": "MLT.3_1"
    },
    "code": "MT.SO"
  },
  "3068": {
    "gadm": {
      "name": "Tramuntana",
      "gid": "MLT.4_1"
    },
    "code": "MT.NO"
  },
  "3069": {
    "gadm": {
      "name": "Xlokk",
      "gid": "MLT.5_1"
    },
    "code": "MT.SE"
  },
  "3070": {
    "gadm": {
      "name": "Northern Islands",
      "gid": "MNP.1_1"
    },
    "code": "MP.NI"
  },
  "3071": {
    "gadm": {
      "name": "Rota",
      "gid": "MNP.2_1"
    },
    "code": "MP.RO"
  },
  "3072": {
    "gadm": {
      "name": "Saipan",
      "gid": "MNP.3_1"
    },
    "code": "MP.SA"
  },
  "3073": {
    "gadm": {
      "name": "Tinian",
      "gid": "MNP.4_1"
    },
    "code": "MP.TI"
  },
  "3074": {
    "gadm": {
      "name": "Fort-de-France",
      "gid": "MTQ.1_1"
    },
    "code": "MQ.FF"
  },
  "3075": {
    "gadm": {
      "name": "Le Marin",
      "gid": "MTQ.2_1"
    },
    "code": "MQ.MA"
  },
  "3076": {
    "gadm": {
      "name": "Le Trinit\u00e9",
      "gid": "MTQ.3_1"
    },
    "code": "MQ.TR"
  },
  "3077": {
    "gadm": {
      "name": "Saint-Pierre",
      "gid": "MTQ.4_1"
    },
    "code": "MQ.SP"
  },
  "3078": {
    "gadm": {
      "name": "Acoua",
      "gid": "MYT.1_1"
    },
    "code": null
  },
  "3079": {
    "gadm": {
      "name": "Bandraboua",
      "gid": "MYT.2_1"
    },
    "code": null
  },
  "3080": {
    "gadm": {
      "name": "Bandrele",
      "gid": "MYT.3_1"
    },
    "code": null
  },
  "3081": {
    "gadm": {
      "name": "Boueni",
      "gid": "MYT.4_1"
    },
    "code": null
  },
  "3082": {
    "gadm": {
      "name": "Chiconi",
      "gid": "MYT.5_1"
    },
    "code": null
  },
  "3083": {
    "gadm": {
      "name": "Chirongui",
      "gid": "MYT.6_1"
    },
    "code": null
  },
  "3084": {
    "gadm": {
      "name": "Dembeni",
      "gid": "MYT.7_1"
    },
    "code": null
  },
  "3085": {
    "gadm": {
      "name": "Dzaoudzi",
      "gid": "MYT.8_1"
    },
    "code": null
  },
  "3086": {
    "gadm": {
      "name": "Kani-Keli",
      "gid": "MYT.9_1"
    },
    "code": null
  },
  "3087": {
    "gadm": {
      "name": "Koungou",
      "gid": "MYT.10_1"
    },
    "code": null
  },
  "3088": {
    "gadm": {
      "name": "M'tsangamouji",
      "gid": "MYT.11_1"
    },
    "code": null
  },
  "3089": {
    "gadm": {
      "name": "Mamoudzou",
      "gid": "MYT.12_1"
    },
    "code": null
  },
  "3090": {
    "gadm": {
      "name": "Mtsamboro",
      "gid": "MYT.13_1"
    },
    "code": null
  },
  "3091": {
    "gadm": {
      "name": "Ouangani",
      "gid": "MYT.14_1"
    },
    "code": null
  },
  "3092": {
    "gadm": {
      "name": "Pamandzi",
      "gid": "MYT.15_1"
    },
    "code": null
  },
  "3093": {
    "gadm": {
      "name": "Sada",
      "gid": "MYT.16_1"
    },
    "code": null
  },
  "3094": {
    "gadm": {
      "name": "Tsingoni",
      "gid": "MYT.17_1"
    },
    "code": null
  },
  "3095": {
    "gadm": {
      "name": "\u00celes Loyaut\u00e9",
      "gid": "NCL.1_1"
    },
    "code": "NC.IL"
  },
  "3096": {
    "gadm": {
      "name": "Nord",
      "gid": "NCL.2_1"
    },
    "code": "NC.NO"
  },
  "3097": {
    "gadm": {
      "name": "Sud",
      "gid": "NCL.3_1"
    },
    "code": "NC.SU"
  },
  "3098": {
    "gadm": {
      "name": "Lago Nicaragua",
      "gid": "NIC.10_1"
    },
    "code": "lake"
  },
  "3099": {
    "gadm": {
      "name": "Drenthe",
      "gid": "NLD.1_1"
    },
    "code": "NL.DR"
  },
  "3100": {
    "gadm": {
      "name": "Flevoland",
      "gid": "NLD.2_1"
    },
    "code": "NL.FL"
  },
  "3101": {
    "gadm": {
      "name": "Friesland",
      "gid": "NLD.3_1"
    },
    "code": "NL.FR"
  },
  "3102": {
    "gadm": {
      "name": "Gelderland",
      "gid": "NLD.4_1"
    },
    "code": "NL.GE"
  },
  "3103": {
    "gadm": {
      "name": "Groningen",
      "gid": "NLD.5_1"
    },
    "code": "NL.GR"
  },
  "3104": {
    "gadm": {
      "name": "IJsselmeer",
      "gid": "NLD.6_1"
    },
    "code": null
  },
  "3105": {
    "gadm": {
      "name": "Limburg",
      "gid": "NLD.7_1"
    },
    "code": "NL.LI"
  },
  "3106": {
    "gadm": {
      "name": "Noord-Brabant",
      "gid": "NLD.8_1"
    },
    "code": "NL.NB"
  },
  "3107": {
    "gadm": {
      "name": "Noord-Holland",
      "gid": "NLD.9_1"
    },
    "code": "NL.NH"
  },
  "3108": {
    "gadm": {
      "name": "Overijssel",
      "gid": "NLD.10_1"
    },
    "code": "NL.OV"
  },
  "3109": {
    "gadm": {
      "name": "Utrecht",
      "gid": "NLD.11_1"
    },
    "code": "NL.UT"
  },
  "3110": {
    "gadm": {
      "name": "Zeeland",
      "gid": "NLD.12_1"
    },
    "code": "NL.ZE"
  },
  "3111": {
    "gadm": {
      "name": "Zeeuwse meren",
      "gid": "NLD.13_1"
    },
    "code": null
  },
  "3112": {
    "gadm": {
      "name": "Zuid-Holland",
      "gid": "NLD.14_1"
    },
    "code": "NL.ZH"
  },
  "3113": {
    "gadm": {
      "name": "Marlborough",
      "gid": "NZL.8_1"
    },
    "code": "NZ.MA"
  },
  "3114": {
    "gadm": {
      "name": "Waikato",
      "gid": "NZL.17_1"
    },
    "code": "NZ.WK"
  },
  "3115": {
    "gadm": {
      "name": "Wellington",
      "gid": "NZL.18_1"
    },
    "code": "NZ.WG"
  },
  "3116": {
    "gadm": {
      "name": "West Coast",
      "gid": "NZL.19_1"
    },
    "code": "NZ.WC"
  },
  "3117": {
    "gadm": {
      "name": "Dolno\u015bl\u0105skie",
      "gid": "POL.1_1"
    },
    "code": null
  },
  "3118": {
    "gadm": {
      "name": "Kujawsko-Pomorskie",
      "gid": "POL.2_1"
    },
    "code": null
  },
  "3119": {
    "gadm": {
      "name": "\u0141\u00f3dzkie",
      "gid": "POL.3_1"
    },
    "code": null
  },
  "3120": {
    "gadm": {
      "name": "Lubelskie",
      "gid": "POL.4_1"
    },
    "code": null
  },
  "3121": {
    "gadm": {
      "name": "Lubuskie",
      "gid": "POL.5_1"
    },
    "code": null
  },
  "3122": {
    "gadm": {
      "name": "Ma\u0142opolskie",
      "gid": "POL.6_1"
    },
    "code": null
  },
  "3123": {
    "gadm": {
      "name": "Mazowieckie",
      "gid": "POL.7_1"
    },
    "code": null
  },
  "3124": {
    "gadm": {
      "name": "Opolskie",
      "gid": "POL.8_1"
    },
    "code": null
  },
  "3125": {
    "gadm": {
      "name": "Podkarpackie",
      "gid": "POL.9_1"
    },
    "code": null
  },
  "3126": {
    "gadm": {
      "name": "Podlaskie",
      "gid": "POL.10_1"
    },
    "code": null
  },
  "3127": {
    "gadm": {
      "name": "Pomorskie",
      "gid": "POL.11_1"
    },
    "code": null
  },
  "3128": {
    "gadm": {
      "name": "\u015al\u0105skie",
      "gid": "POL.12_1"
    },
    "code": null
  },
  "3129": {
    "gadm": {
      "name": "\u015awi\u0119tokrzyskie",
      "gid": "POL.13_1"
    },
    "code": null
  },
  "3130": {
    "gadm": {
      "name": "Warmi\u0144sko-Mazurskie",
      "gid": "POL.14_1"
    },
    "code": null
  },
  "3131": {
    "gadm": {
      "name": "Wielkopolskie",
      "gid": "POL.15_1"
    },
    "code": null
  },
  "3132": {
    "gadm": {
      "name": "Zachodniopomorskie",
      "gid": "POL.16_1"
    },
    "code": null
  },
  "3133": {
    "gadm": {
      "name": "Adjuntas",
      "gid": "PRI.1_1"
    },
    "code": "PR.AJ"
  },
  "3134": {
    "gadm": {
      "name": "Aguadilla",
      "gid": "PRI.3_1"
    },
    "code": "PR.AL"
  },
  "3135": {
    "gadm": {
      "name": "Arroyo",
      "gid": "PRI.8_1"
    },
    "code": "PR.AR"
  },
  "3136": {
    "gadm": {
      "name": "Barceloneta",
      "gid": "PRI.9_1"
    },
    "code": "PR.BC"
  },
  "3137": {
    "gadm": {
      "name": "Barranquitas",
      "gid": "PRI.10_1"
    },
    "code": "PR.BQ"
  },
  "3138": {
    "gadm": {
      "name": "Camuy",
      "gid": "PRI.14_1"
    },
    "code": "PR.CA"
  },
  "3139": {
    "gadm": {
      "name": "Ciales",
      "gid": "PRI.20_1"
    },
    "code": "PR.CL"
  },
  "3140": {
    "gadm": {
      "name": "Comer\u00edo",
      "gid": "PRI.23_1"
    },
    "code": "PR.CM"
  },
  "3141": {
    "gadm": {
      "name": "Corozal",
      "gid": "PRI.24_1"
    },
    "code": "PR.CZ"
  },
  "3142": {
    "gadm": {
      "name": "Culebra",
      "gid": "PRI.25_1"
    },
    "code": "PR.CU"
  },
  "3143": {
    "gadm": {
      "name": "Florida",
      "gid": "PRI.28_1"
    },
    "code": "PR.FL"
  },
  "3144": {
    "gadm": {
      "name": "Gu\u00e1nica",
      "gid": "PRI.29_1"
    },
    "code": "PR.GC"
  },
  "3145": {
    "gadm": {
      "name": "Hormigueros",
      "gid": "PRI.35_1"
    },
    "code": "PR.HO"
  },
  "3146": {
    "gadm": {
      "name": "Isabela",
      "gid": "PRI.37_1"
    },
    "code": "PR.IS"
  },
  "3147": {
    "gadm": {
      "name": "Lajas",
      "gid": "PRI.41_1"
    },
    "code": "PR.LJ"
  },
  "3148": {
    "gadm": {
      "name": "Lares",
      "gid": "PRI.42_1"
    },
    "code": "PR.LR"
  },
  "3149": {
    "gadm": {
      "name": "Las Mar\u00edas",
      "gid": "PRI.43_1"
    },
    "code": "PR.LM"
  },
  "3150": {
    "gadm": {
      "name": "Maricao",
      "gid": "PRI.48_1"
    },
    "code": "PR.MR"
  },
  "3151": {
    "gadm": {
      "name": "Maunabo",
      "gid": "PRI.49_1"
    },
    "code": "PR.MB"
  },
  "3152": {
    "gadm": {
      "name": "Naranjito",
      "gid": "PRI.54_1"
    },
    "code": "PR.NR"
  },
  "3153": {
    "gadm": {
      "name": "Orocovis",
      "gid": "PRI.55_1"
    },
    "code": "PR.OR"
  },
  "3154": {
    "gadm": {
      "name": "Patillas",
      "gid": "PRI.56_1"
    },
    "code": "PR.PT"
  },
  "3155": {
    "gadm": {
      "name": "Pe\u00f1uelas",
      "gid": "PRI.57_1"
    },
    "code": "PR.PN"
  },
  "3156": {
    "gadm": {
      "name": "Quebradillas",
      "gid": "PRI.59_1"
    },
    "code": "PR.QB"
  },
  "3157": {
    "gadm": {
      "name": "Rinc\u00f3n",
      "gid": "PRI.60_1"
    },
    "code": "PR.RC"
  },
  "3158": {
    "gadm": {
      "name": "Sabana Grande",
      "gid": "PRI.62_1"
    },
    "code": "PR.SB"
  },
  "3159": {
    "gadm": {
      "name": "Utuado",
      "gid": "PRI.72_1"
    },
    "code": "PR.UT"
  },
  "3160": {
    "gadm": {
      "name": "Vega Alta",
      "gid": "PRI.73_1"
    },
    "code": "PR.VA"
  },
  "3161": {
    "gadm": {
      "name": "Villalba",
      "gid": "PRI.76_1"
    },
    "code": "PR.VL"
  },
  "3162": {
    "gadm": {
      "name": "Aveiro",
      "gid": "PRT.1_1"
    },
    "code": "PT.AV"
  },
  "3163": {
    "gadm": {
      "name": "Azores",
      "gid": "PRT.2_1"
    },
    "code": "PT.AC"
  },
  "3164": {
    "gadm": {
      "name": "Beja",
      "gid": "PRT.3_1"
    },
    "code": "PT.BE"
  },
  "3165": {
    "gadm": {
      "name": "Braga",
      "gid": "PRT.4_1"
    },
    "code": "PT.BR"
  },
  "3166": {
    "gadm": {
      "name": "Bragan\u00e7a",
      "gid": "PRT.5_1"
    },
    "code": "PT.BA"
  },
  "3167": {
    "gadm": {
      "name": "Castelo Branco",
      "gid": "PRT.6_1"
    },
    "code": "PT.CB"
  },
  "3168": {
    "gadm": {
      "name": "Coimbra",
      "gid": "PRT.7_1"
    },
    "code": "PT.CO"
  },
  "3169": {
    "gadm": {
      "name": "\u00c9vora",
      "gid": "PRT.8_1"
    },
    "code": "PT.EV"
  },
  "3170": {
    "gadm": {
      "name": "Faro",
      "gid": "PRT.9_1"
    },
    "code": "PT.FA"
  },
  "3171": {
    "gadm": {
      "name": "Guarda",
      "gid": "PRT.10_1"
    },
    "code": "PT.GU"
  },
  "3172": {
    "gadm": {
      "name": "Leiria",
      "gid": "PRT.11_1"
    },
    "code": "PT.LE"
  },
  "3173": {
    "gadm": {
      "name": "Lisboa",
      "gid": "PRT.12_1"
    },
    "code": "PT.LI"
  },
  "3174": {
    "gadm": {
      "name": "Madeira",
      "gid": "PRT.13_1"
    },
    "code": null
  },
  "3175": {
    "gadm": {
      "name": "Portalegre",
      "gid": "PRT.14_1"
    },
    "code": "PT.PA"
  },
  "3176": {
    "gadm": {
      "name": "Porto",
      "gid": "PRT.15_1"
    },
    "code": "PT.PO"
  },
  "3177": {
    "gadm": {
      "name": "Santar\u00e9m",
      "gid": "PRT.16_1"
    },
    "code": "PT.SA"
  },
  "3178": {
    "gadm": {
      "name": "Set\u00fabal",
      "gid": "PRT.17_1"
    },
    "code": "PT.SE"
  },
  "3179": {
    "gadm": {
      "name": "Viana do Castelo",
      "gid": "PRT.18_1"
    },
    "code": "PT.VC"
  },
  "3180": {
    "gadm": {
      "name": "Vila Real",
      "gid": "PRT.19_1"
    },
    "code": "PT.VR"
  },
  "3181": {
    "gadm": {
      "name": "Viseu",
      "gid": "PRT.20_1"
    },
    "code": "PT.VI"
  },
  "3182": {
    "gadm": {
      "name": "\u00celes Australes",
      "gid": "PYF.1_1"
    },
    "code": "PF.TI"
  },
  "3183": {
    "gadm": {
      "name": "\u00celes du Vent",
      "gid": "PYF.2_1"
    },
    "code": "PF.WI"
  },
  "3184": {
    "gadm": {
      "name": "\u00celes Marquises",
      "gid": "PYF.3_1"
    },
    "code": "PF.MI"
  },
  "3185": {
    "gadm": {
      "name": "\u00celes Sous-le-Vent",
      "gid": "PYF.4_1"
    },
    "code": "PF.LI"
  },
  "3186": {
    "gadm": {
      "name": "\u00celes Tuamotu-Gambier",
      "gid": "PYF.5_1"
    },
    "code": "PF.TG"
  },
  "3187": {
    "gadm": {
      "name": "Saint-Beno\u00eet",
      "gid": "REU.1_1"
    },
    "code": "RE.BN"
  },
  "3188": {
    "gadm": {
      "name": "Saint-Denis",
      "gid": "REU.2_1"
    },
    "code": "RE.DN"
  },
  "3189": {
    "gadm": {
      "name": "Saint-Paul",
      "gid": "REU.3_1"
    },
    "code": "RE.PL"
  },
  "3190": {
    "gadm": {
      "name": "Saint-Pierre",
      "gid": "REU.4_1"
    },
    "code": "RE.PR"
  },
  "3191": {
    "gadm": {
      "name": "Alba",
      "gid": "ROU.1_1"
    },
    "code": "RO.AB"
  },
  "3192": {
    "gadm": {
      "name": "Arad",
      "gid": "ROU.2_1"
    },
    "code": "RO.AR"
  },
  "3193": {
    "gadm": {
      "name": "Arge\u0219",
      "gid": "ROU.3_1"
    },
    "code": "RO.AG"
  },
  "3194": {
    "gadm": {
      "name": "Bac\u0103u",
      "gid": "ROU.4_1"
    },
    "code": "RO.BC"
  },
  "3195": {
    "gadm": {
      "name": "Bihor",
      "gid": "ROU.5_1"
    },
    "code": "RO.BH"
  },
  "3196": {
    "gadm": {
      "name": "Bistri\u021ba-N\u0103s\u0103ud",
      "gid": "ROU.6_1"
    },
    "code": "RO.BN"
  },
  "3197": {
    "gadm": {
      "name": "Boto\u0219ani",
      "gid": "ROU.7_1"
    },
    "code": "RO.BT"
  },
  "3198": {
    "gadm": {
      "name": "Bra\u0219ov",
      "gid": "ROU.8_1"
    },
    "code": "RO.BV"
  },
  "3199": {
    "gadm": {
      "name": "Br\u0103ila",
      "gid": "ROU.9_1"
    },
    "code": "RO.BR"
  },
  "3200": {
    "gadm": {
      "name": "Bucharest",
      "gid": "ROU.10_1"
    },
    "code": "RO.BI"
  },
  "3201": {
    "gadm": {
      "name": "Buz\u0103u",
      "gid": "ROU.11_1"
    },
    "code": "RO.BZ"
  },
  "3202": {
    "gadm": {
      "name": "C\u0103l\u0103ra\u0219i",
      "gid": "ROU.12_1"
    },
    "code": "RO.CL"
  },
  "3203": {
    "gadm": {
      "name": "Cara\u0219-Severin",
      "gid": "ROU.13_1"
    },
    "code": "RO.CS"
  },
  "3204": {
    "gadm": {
      "name": "Cluj",
      "gid": "ROU.14_1"
    },
    "code": "RO.CJ"
  },
  "3205": {
    "gadm": {
      "name": "Constan\u021ba",
      "gid": "ROU.15_1"
    },
    "code": "RO.CT"
  },
  "3206": {
    "gadm": {
      "name": "Covasna",
      "gid": "ROU.16_1"
    },
    "code": "RO.CV"
  },
  "3207": {
    "gadm": {
      "name": "D\u00e2mbovi\u021ba",
      "gid": "ROU.17_1"
    },
    "code": "RO.DB"
  },
  "3208": {
    "gadm": {
      "name": "Dolj",
      "gid": "ROU.18_1"
    },
    "code": "RO.DJ"
  },
  "3209": {
    "gadm": {
      "name": "Gala\u021bi",
      "gid": "ROU.19_1"
    },
    "code": "RO.GL"
  },
  "3210": {
    "gadm": {
      "name": "Giurgiu",
      "gid": "ROU.20_1"
    },
    "code": "RO.GR"
  },
  "3211": {
    "gadm": {
      "name": "Gorj",
      "gid": "ROU.21_1"
    },
    "code": "RO.GJ"
  },
  "3212": {
    "gadm": {
      "name": "Harghita",
      "gid": "ROU.22_1"
    },
    "code": "RO.HR"
  },
  "3213": {
    "gadm": {
      "name": "Hunedoara",
      "gid": "ROU.23_1"
    },
    "code": "RO.HD"
  },
  "3214": {
    "gadm": {
      "name": "Ia\u0219i",
      "gid": "ROU.24_1"
    },
    "code": "RO.IS"
  },
  "3215": {
    "gadm": {
      "name": "Ialomi\u021ba",
      "gid": "ROU.25_1"
    },
    "code": "RO.IL"
  },
  "3216": {
    "gadm": {
      "name": "Ilfov",
      "gid": "ROU.26_1"
    },
    "code": "RO.IF"
  },
  "3217": {
    "gadm": {
      "name": "Maramure\u0219",
      "gid": "ROU.27_1"
    },
    "code": "RO.MM"
  },
  "3218": {
    "gadm": {
      "name": "Mehedin\u021bi",
      "gid": "ROU.28_1"
    },
    "code": "RO.MH"
  },
  "3219": {
    "gadm": {
      "name": "Mure\u0219",
      "gid": "ROU.29_1"
    },
    "code": "RO.MS"
  },
  "3220": {
    "gadm": {
      "name": "Neam\u021b",
      "gid": "ROU.30_1"
    },
    "code": "RO.NT"
  },
  "3221": {
    "gadm": {
      "name": "Olt",
      "gid": "ROU.31_1"
    },
    "code": "RO.OT"
  },
  "3222": {
    "gadm": {
      "name": "Prahova",
      "gid": "ROU.32_1"
    },
    "code": "RO.PH"
  },
  "3223": {
    "gadm": {
      "name": "S\u0103laj",
      "gid": "ROU.33_1"
    },
    "code": "RO.SJ"
  },
  "3224": {
    "gadm": {
      "name": "Satu Mare",
      "gid": "ROU.34_1"
    },
    "code": "RO.SM"
  },
  "3225": {
    "gadm": {
      "name": "Sibiu",
      "gid": "ROU.35_1"
    },
    "code": "RO.SB"
  },
  "3226": {
    "gadm": {
      "name": "Suceava",
      "gid": "ROU.36_1"
    },
    "code": "RO.SV"
  },
  "3227": {
    "gadm": {
      "name": "Teleorman",
      "gid": "ROU.37_1"
    },
    "code": "RO.TR"
  },
  "3228": {
    "gadm": {
      "name": "Timi\u0219",
      "gid": "ROU.38_1"
    },
    "code": "RO.TM"
  },
  "3229": {
    "gadm": {
      "name": "Tulcea",
      "gid": "ROU.39_1"
    },
    "code": "RO.TL"
  },
  "3230": {
    "gadm": {
      "name": "V\u00e2lcea",
      "gid": "ROU.40_1"
    },
    "code": "RO.VL"
  },
  "3231": {
    "gadm": {
      "name": "Vaslui",
      "gid": "ROU.41_1"
    },
    "code": "RO.VS"
  },
  "3232": {
    "gadm": {
      "name": "Vrancea",
      "gid": "ROU.42_1"
    },
    "code": "RO.VN"
  },
  "3233": {
    "gadm": {
      "name": "Jan Mayen",
      "gid": "SJM.1_1"
    },
    "code": "SJ.JN"
  },
  "3234": {
    "gadm": {
      "name": "Svalbard",
      "gid": "SJM.2_1"
    },
    "code": "SJ.SV"
  },
  "3235": {
    "gadm": {
      "name": "Miquelon-Langlade",
      "gid": "SPM.1_1"
    },
    "code": "PM.ML"
  },
  "3236": {
    "gadm": {
      "name": "Saint-Pierre",
      "gid": "SPM.2_1"
    },
    "code": "PM.SP"
  },
  "3237": {
    "gadm": {
      "name": "Banskobystrick\u00fd",
      "gid": "SVK.1_1"
    },
    "code": "SK.BC"
  },
  "3238": {
    "gadm": {
      "name": "Bratislavsk\u00fd",
      "gid": "SVK.2_1"
    },
    "code": "SK.BL"
  },
  "3239": {
    "gadm": {
      "name": "Ko\u0161ick\u00fd",
      "gid": "SVK.3_1"
    },
    "code": "SK.KI"
  },
  "3240": {
    "gadm": {
      "name": "Nitriansky",
      "gid": "SVK.4_1"
    },
    "code": "SK.NI"
  },
  "3241": {
    "gadm": {
      "name": "Pre\u0161ovsk\u00fd",
      "gid": "SVK.5_1"
    },
    "code": "SK.PV"
  },
  "3242": {
    "gadm": {
      "name": "Tren\u010diansky",
      "gid": "SVK.6_1"
    },
    "code": "SK.TC"
  },
  "3243": {
    "gadm": {
      "name": "Trnavsk\u00fd",
      "gid": "SVK.7_1"
    },
    "code": "SK.TA"
  },
  "3244": {
    "gadm": {
      "name": "\u017dilinsk\u00fd",
      "gid": "SVK.8_1"
    },
    "code": "SK.ZI"
  },
  "3245": {
    "gadm": {
      "name": "Gorenjska",
      "gid": "SVN.1_1"
    },
    "code": "SI.GO"
  },
  "3246": {
    "gadm": {
      "name": "Gori\u0161ka",
      "gid": "SVN.2_1"
    },
    "code": "SI.SP"
  },
  "3247": {
    "gadm": {
      "name": "Jugovzhodna Slovenija",
      "gid": "SVN.3_1"
    },
    "code": null
  },
  "3248": {
    "gadm": {
      "name": "Koro\u0161ka",
      "gid": "SVN.4_1"
    },
    "code": "SI.KO"
  },
  "3249": {
    "gadm": {
      "name": "Notranjsko-kra\u0161ka",
      "gid": "SVN.5_1"
    },
    "code": "SI.NO"
  },
  "3250": {
    "gadm": {
      "name": "Obalno-kra\u0161ka",
      "gid": "SVN.6_1"
    },
    "code": "SI.JP"
  },
  "3251": {
    "gadm": {
      "name": "Osrednjeslovenska",
      "gid": "SVN.7_1"
    },
    "code": "SI.LJ"
  },
  "3252": {
    "gadm": {
      "name": "Podravska",
      "gid": "SVN.8_1"
    },
    "code": "SI.PD"
  },
  "3253": {
    "gadm": {
      "name": "Pomurska",
      "gid": "SVN.9_1"
    },
    "code": "SI.PM"
  },
  "3254": {
    "gadm": {
      "name": "Savinjska",
      "gid": "SVN.10_1"
    },
    "code": "SI.SA"
  },
  "3255": {
    "gadm": {
      "name": "Spodnjeposavska",
      "gid": "SVN.11_1"
    },
    "code": "SI.PS"
  },
  "3256": {
    "gadm": {
      "name": "Zasavska",
      "gid": "SVN.12_1"
    },
    "code": "SI.ZS"
  },
  "3257": {
    "gadm": {
      "name": "Blekinge",
      "gid": "SWE.1_1"
    },
    "code": "SE.BL"
  },
  "3258": {
    "gadm": {
      "name": "Dalarna",
      "gid": "SWE.2_1"
    },
    "code": "SE.KO"
  },
  "3259": {
    "gadm": {
      "name": "G\u00e4vleborg",
      "gid": "SWE.3_1"
    },
    "code": "SE.GV"
  },
  "3260": {
    "gadm": {
      "name": "Gotland",
      "gid": "SWE.4_1"
    },
    "code": "SE.GT"
  },
  "3261": {
    "gadm": {
      "name": "Halland",
      "gid": "SWE.5_1"
    },
    "code": "SE.HA"
  },
  "3262": {
    "gadm": {
      "name": "J\u00e4mtland",
      "gid": "SWE.6_1"
    },
    "code": "SE.JA"
  },
  "3263": {
    "gadm": {
      "name": "J\u00f6nk\u00f6ping",
      "gid": "SWE.7_1"
    },
    "code": "SE.JO"
  },
  "3264": {
    "gadm": {
      "name": "Kalmar",
      "gid": "SWE.8_1"
    },
    "code": "SE.KA"
  },
  "3265": {
    "gadm": {
      "name": "Kronoberg",
      "gid": "SWE.9_1"
    },
    "code": "SE.KR"
  },
  "3266": {
    "gadm": {
      "name": "Norrbotten",
      "gid": "SWE.10_1"
    },
    "code": "SE.NB"
  },
  "3267": {
    "gadm": {
      "name": "Orebro",
      "gid": "SWE.11_1"
    },
    "code": "SE.OR"
  },
  "3268": {
    "gadm": {
      "name": "\u00d6sterg\u00f6tland",
      "gid": "SWE.12_1"
    },
    "code": "SE.OG"
  },
  "3269": {
    "gadm": {
      "name": "Sk\u00e5ne",
      "gid": "SWE.13_1"
    },
    "code": "SE.SN"
  },
  "3270": {
    "gadm": {
      "name": "S\u00f6dermanland",
      "gid": "SWE.14_1"
    },
    "code": "SE.SD"
  },
  "3271": {
    "gadm": {
      "name": "Stockholm",
      "gid": "SWE.15_1"
    },
    "code": "SE.ST"
  },
  "3272": {
    "gadm": {
      "name": "Uppsala",
      "gid": "SWE.16_1"
    },
    "code": "SE.UP"
  },
  "3273": {
    "gadm": {
      "name": "V\u00e4rmland",
      "gid": "SWE.17_1"
    },
    "code": "SE.VR"
  },
  "3274": {
    "gadm": {
      "name": "V\u00e4sterbotten",
      "gid": "SWE.18_1"
    },
    "code": "SE.VB"
  },
  "3275": {
    "gadm": {
      "name": "V\u00e4sternorrland",
      "gid": "SWE.19_1"
    },
    "code": "SE.VN"
  },
  "3276": {
    "gadm": {
      "name": "V\u00e4stmanland",
      "gid": "SWE.20_1"
    },
    "code": "SE.VM"
  },
  "3277": {
    "gadm": {
      "name": "V\u00e4stra G\u00f6taland",
      "gid": "SWE.21_1"
    },
    "code": "SE.VG"
  },
  "3278": {
    "gadm": {
      "name": "Anafu",
      "gid": "TKL.1_1"
    },
    "code": "TK.AT"
  },
  "3279": {
    "gadm": {
      "name": "Fakaofo",
      "gid": "TKL.2_1"
    },
    "code": "TK.FA"
  },
  "3280": {
    "gadm": {
      "name": "Nukunonu",
      "gid": "TKL.3_1"
    },
    "code": "TK.NU"
  },
  "3281": {
    "gadm": {
      "name": "Niulakita",
      "gid": "TUV.4_1"
    },
    "code": "TV.NK"
  },
  "3282": {
    "gadm": {
      "name": "Baker",
      "gid": "UMI.1_1"
    },
    "code": null
  },
  "3283": {
    "gadm": {
      "name": "Howland",
      "gid": "UMI.2_1"
    },
    "code": null
  },
  "3284": {
    "gadm": {
      "name": "Jarvis island",
      "gid": "UMI.3_1"
    },
    "code": null
  },
  "3285": {
    "gadm": {
      "name": "Johnston",
      "gid": "UMI.4_1"
    },
    "code": null
  },
  "3286": {
    "gadm": {
      "name": "Kingman Reef",
      "gid": "UMI.5_1"
    },
    "code": null
  },
  "3287": {
    "gadm": {
      "name": "Midway",
      "gid": "UMI.6_1"
    },
    "code": null
  },
  "3288": {
    "gadm": {
      "name": "Navassa",
      "gid": "UMI.7_1"
    },
    "code": null
  },
  "3289": {
    "gadm": {
      "name": "Palmyra",
      "gid": "UMI.8_1"
    },
    "code": null
  },
  "3290": {
    "gadm": {
      "name": "Wake",
      "gid": "UMI.9_1"
    },
    "code": null
  },
  "3291": {
    "gadm": {
      "name": "Alo",
      "gid": "WLF.1_1"
    },
    "code": "WF.AL"
  },
  "3292": {
    "gadm": {
      "name": "Singave",
      "gid": "WLF.2_1"
    },
    "code": "WF.SI"
  },
  "3293": {
    "gadm": {
      "name": "Uv\u00e9a",
      "gid": "WLF.3_1"
    },
    "code": "WF.UV"
  },
  "3294": {
    "gadm": {
      "name": "Akrotiri",
      "gid": "XAD.1_1"
    },
    "code": null
  },
  "3295": {
    "gadm": {
      "name": "Dhekelia",
      "gid": "XAD.2_1"
    },
    "code": null
  },
  "3296": {
    "gadm": {
      "name": "Gazima\u011fusa",
      "gid": "XNC.1_1"
    },
    "code": null
  },
  "3297": {
    "gadm": {
      "name": "Girne",
      "gid": "XNC.2_1"
    },
    "code": null
  },
  "3298": {
    "gadm": {
      "name": "G\u00fczelyurt",
      "gid": "XNC.3_1"
    },
    "code": null
  },
  "3299": {
    "gadm": {
      "name": "Iskele",
      "gid": "XNC.4_1"
    },
    "code": null
  },
  "3300": {
    "gadm": {
      "name": "Nicosia",
      "gid": "XNC.5_1"
    },
    "code": null
  },
  "3301": {
    "gadm": {
      "name": "Aruba",
      "gid": "ABW"
    },
    "code": "ABW"
  },
  "3302": {
    "gadm": {
      "name": "Anguilla",
      "gid": "AIA"
    },
    "code": "AIA"
  },
  "3303": {
    "gadm": {
      "name": "Antarctica",
      "gid": "ATA"
    },
    "code": "ATA"
  },
  "3304": {
    "gadm": {
      "name": "Saint-Barth\u00e9lemy",
      "gid": "BLM"
    },
    "code": "BLM"
  },
  "3305": {
    "gadm": {
      "name": "Bouvet Island",
      "gid": "BVT"
    },
    "code": "BVT"
  },
  "3306": {
    "gadm": {
      "name": "Cocos Islands",
      "gid": "CCK"
    },
    "code": "CCK"
  },
  "3307": {
    "gadm": {
      "name": "Cook Islands",
      "gid": "COK"
    },
    "code": "COK"
  },
  "3308": {
    "gadm": {
      "name": "Cura\u00e7ao",
      "gid": "CUW"
    },
    "code": "CUW"
  },
  "3309": {
    "gadm": {
      "name": "Christmas Island",
      "gid": "CXR"
    },
    "code": "CXR"
  },
  "3310": {
    "gadm": {
      "name": "Falkland Islands",
      "gid": "FLK"
    },
    "code": "FLK"
  },
  "3311": {
    "gadm": {
      "name": "Gibraltar",
      "gid": "GIB"
    },
    "code": "GIB"
  },
  "3312": {
    "gadm": {
      "name": "Heard Island and McDonald Islands",
      "gid": "HMD"
    },
    "code": "HMD"
  },
  "3313": {
    "gadm": {
      "name": "British Indian Ocean Territory",
      "gid": "IOT"
    },
    "code": "IOT"
  },
  "3314": {
    "gadm": {
      "name": "Kiribati",
      "gid": "KIR"
    },
    "code": "KIR"
  },
  "3315": {
    "gadm": {
      "name": "Saint-Martin",
      "gid": "MAF"
    },
    "code": "MAF"
  },
  "3316": {
    "gadm": {
      "name": "Monaco",
      "gid": "MCO"
    },
    "code": "MCO"
  },
  "3317": {
    "gadm": {
      "name": "Maldives",
      "gid": "MDV"
    },
    "code": "MDV"
  },
  "3318": {
    "gadm": {
      "name": "Marshall Islands",
      "gid": "MHL"
    },
    "code": "MHL"
  },
  "3319": {
    "gadm": {
      "name": "Norfolk Island",
      "gid": "NFK"
    },
    "code": "NFK"
  },
  "3320": {
    "gadm": {
      "name": "Niue",
      "gid": "NIU"
    },
    "code": "NIU"
  },
  "3321": {
    "gadm": {
      "name": "Pitcairn Islands",
      "gid": "PCN"
    },
    "code": "PCN"
  },
  "3322": {
    "gadm": {
      "name": "South Georgia and the South Sandwich Islands",
      "gid": "SGS"
    },
    "code": "SGS"
  },
  "3323": {
    "gadm": {
      "name": "Sint Maarten",
      "gid": "SXM"
    },
    "code": "SXM"
  },
  "3324": {
    "gadm": {
      "name": "Vatican City",
      "gid": "VAT"
    },
    "code": "VAT"
  },
  "3325": {
    "gadm": {
      "name": "Caspian Sea",
      "gid": "XCA"
    },
    "code": "XCA"
  },
  "3326": {
    "gadm": {
      "name": "Clipperton Island",
      "gid": "XCL"
    },
    "code": "XCL"
  },
  "3327": {
    "gadm": {
      "name": "Paracel Islands",
      "gid": "XPI"
    },
    "code": "XPI"
  },
  "3328": {
    "gadm": {
      "name": "Spratly Islands",
      "gid": "XSP"
    },
    "code": "XSP"
  }
}